// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptInvitation, acceptProjectWorkstreamCodeTuningVersion, acceptPromotionCandidate, acceptRiskBreach, acknowledgeOrgModule, activateEntityVersion, activateRiskHalt, addEvaluationTemplateVersion, addMarketplaceBundleEntity, addOrgMember, addProjectMember, addProjectTeamMember, addTeamMember, addToWatchlist, addWidget, addWorkflowStep, addWorkstreamMember, amendStrategyDefinitionParameters, analyzeConfluence, analyzeConfluenceFromSignals, analyzeOrderBook, analyzeTickerAdHoc, apiApproveDecision, apiCancelDecision, apiCompareBacktests, apiCreateBacktest, apiGetBacktest, apiGetBacktestAnalytics, apiGetCandles, apiGetDashboardData, apiGetStrategy, apiGetStrategyBucket, apiGetWorkflowRunPart, apiListBacktests, apiListBacktestSeries, apiListDecisions, apiListIntelSourceItems, apiListIntelSources, apiListMarketRegimes, apiListStrategies, apiListStrategyBuckets, apiRejectDecision, applyContractResolution, applyEvaluationTemplate, applyFinanceBucketDecision, applyFinanceIndicatorPromotion, applyMarketplaceUpdates, approveDaemonDecision, approveDecision, approveRecommendation, approveTaskAction, approveWorkflowGate, archiveProject, archiveWorkflow, archiveWorkstream, assignDaemonWorkflow, assignEmployeeWorkflow, assignUserRole, attachToConversation, backfillIntelSourceSubscription, batchDeactivateIntelSources, batchFetchIntelSources, bindMarketplaceEntityConnection, bulkCreateIntelSources, bulkUpdateUserStatus, calculateOrb, callAiWorkerMcp, callPlatformMcp, cancelAllOrders, cancelExecutionAlgo, cancelOrder, cancelTask, cancelWorkerRun, certifyShadowModeDaemon, checkAlertPrice, checkDeploymentReadiness, checkMarketData, checkPortCompatibility, claimActionQueueItem, clearOrganizationRuntimePolicySurfaceRule, cloneAnalysisTemplate, closeContextPanel, closePosition, closeProject, commitFinanceStrategyLifecycleTransition, compareAgentTemplateVersions, comparePortfolios, completeTask, configureProjectCodeClientDatabase, connectMcpConnection, createActiveStrategy, createAdjustment, createAgentTemplateVersion, createAlert, createAlertRule, createAnalysisTemplate, createApiKey, createApproverDelegation, createArtifact, createBackfill, createBrokerCredential, createBucketForwardRun, createConversation, createConversationGroup, createDaemon, createDaemonTrigger, createDashboard, createDeposit, createDiscretionaryRun, createDynamicFanOutPolicy, createEmployee, createEmployeeTrigger, createEntityVersionDraft, createEvaluationCase, createEvaluationDataset, createEvaluationTemplate, createExchangeCredential, createExecutionAlgo, createExecutionDeployment, createFinanceStrategyCostModel, createFinanceStrategyLifecycleTransition, createFinanceStrategyRun, createFinanceStrategyRunRequest, createHolding, createHostMetrics, createIntelPlatform, createIntelSource, createIntelSourceMonitor, createIntelSourceSubscription, createIntervention, createInvitation, createLogin, createLogout, createMarketDataGrants, createMarketEventReaction, createMarketplaceBundle, createMcpConnection, createMemory, createModelRuntimePolicy, createOrder, createOrganization, createOrUpdateTemplate, createOrUpdateTool, createPortfolio, createProject, createProjectChange, createProjectChangeRevision, createProjectCodeRepositoryConnection, createProjectTeam, createProjectThread, createProjectWorkstreamCodeGenerationRun, createProjectWorkstreamCodePreviewSession, createProjectWorkstreamCodeReviewRequest, createRiskLimit, createSignup, createSnapshot, createSource, createStrategyAdapterResolution, createStrategyBucketEvaluation, createStrategyDefinitionEvaluation, createStrategyDefinitionRun, createStrategyDefinitionValidationRun, createSystematicForwardRun, createTask, createTeam, createTemplate, createTemplateUpgradeProposal, createTickerResearchNote, createTool, createToolLibrary, createWalletWatch, createWidget, createWithdrawal, createWorkerRun, createWorkflow, createWorkflowInstance, createWorkstream, decideGate, decideImprovementProposal, decideImprovementProposalDesign, decideProjectWorkstreamCodeReviewRequest, deferCatalogCandidate, deferDaemonDecision, deleteAlert, deleteAlertRule, deleteAnalysisTemplate, deleteArtifact, deleteBrokerCredential, deleteConversation, deleteConversationGroup, deleteDaemon, deleteDaemonTrigger, deleteDashboard, deleteDocument, deleteEmployee, deleteEmployeeTrigger, deleteEvaluationCase, deleteEvaluationDataset, deleteExchangeCredential, deleteHolding, deleteIntelSource, deleteMarketEventReaction, deleteMarketplaceListing, deleteMcpConnection, deleteMemory, deleteProjectTeam, deleteProjectWorkstreamCodePreviewSession, deleteRiskLimit, deleteSnapshot, deleteTask, deleteTemplate, deleteTool, deleteToolLibrary, deleteUpload, deleteWalletWatch, deployStrategy, detachFromConversation, diffAgentTemplateVersions, diffWorkflowVersions, disableConversationIntent, disableDaemon, disableEmployee, disambiguateConversationIntent, disconnectMcpConnection, discoverIntelSource, dispatchStrategyBucketBacktest, downloadOutput, dtiOperatorKillSwitch, dtiOperatorResume, enableConversationIntent, enableDaemon, enableEmployee, enableProjectCodeWorkspace, enableProjectWorkstreamCodeWorkforce, enqueueFinanceIndicatorDecision, enqueueFinanceStrategyTemplateRun, escalateRiskBreach, evaluateFinanceStrategyDecision, evaluateFinanceStrategyDefinition, executeAgent, executeStep, expandImprovementTier, exportInstructions, exportWorkflowInstructions, extendApprovalTimeout, fetchAiWorkerDataResult, fetchIntelSource, fetchIntelSourceMonitor, fillTemplate, finalizeUpload, followUpWorkerRun, forkMarketplaceListing, forkStrategyDefinition, generateOrderBookHeatmap, generatePineScript, generateStrategyDocs, getAccountFxCash, getActiveRun, getActiveStrategy, getAdminUser, getAgentHealth, getAgentStatus, getAgentTemplateVersionComparison, getAgentWorkflowRun, getAgentWorkflowRunDebugger, getAlertRule, getAnalysis, getAnalysisTemplate, getApiKey, getArtifact, getAssetSentiment, getAttributionRun, getBrokerCredential, getCapacityCurve, getCapitalAllocation, getCatalogCandidate, getContentDetails, getContentStats, getContractHealth, getConversation, getConversationContext, getConversationMessageById, getCurrentSession, getDaemon, getDaemonDecision, getDaemonReadiness, getDaemonRun, getDaemonRunAudit, getDaemonsSummary, getDaemonTrend, getDashboard, getDebugStepOutputs, getDecision, getDecisionStats, getDiscoveredStrategy, getDiscoverySummary, getDocument, getDynamicFanOutPolicy, getEmployee, getEmployeeReadiness, getEmployeeRun, getEmployeeRunAudit, getEmployeeTrend, getEvaluationRun, getEvaluationTemplate, getExecutionAlgo, getExecutionDeployment, getExecutionStatus, getFinanceArtifactPreview, getFinanceAuditLedgerChain, getFinanceAuditLedgerHead, getFinanceAuditLedgerOrderHistory, getFinanceBucketComposition, getFinanceIndicatorDecision, getFinanceKgNodeEdges, getFinanceKgRegimeProfile, getFinanceModelLineage, getFinanceModelLineageGraph, getFinanceModelLineageHistory, getFinanceOperationsSummary, getFinanceProviderUnlockPrompt, getFinanceStrategyCostModel, getFinanceStrategyDecision, getFinanceStrategyRun, getFinanceStrategyRunRequest, getFinanceStrategyTemplate, getForwardRun, getImprovementMetrics, getImprovementProposal, getImprovementTierStatus, getIntelPlatformUsage, getIntelSource, getIntelSourceHarvested, getIntelSourceStyleProfile, getIntelSourceViewConfirmation, getIntervention, getLatestOutput, getMarketDataBackup, getMarketDataCoverage, getMarketDataStatus, getMarketplaceBundle, getMarketplaceEntityVersions, getMcpConnection, getMe, getMemory, getMlHealth, getMlRegime, getMlStrategyScores, getModel, getModelRuntimePolicy, getMyOrganizations, getMyTeamsInOrg, getNotificationConfig, getOrder, getOrderBook, getOrganization, getOutput, getOutputMetrics, getPerformanceMetrics, getPortfolio, getPortfolioSnapshot, getPortfolioValuation, getPortType, getPortTypeColors, getPosition, getPositionValuation, getPrice, getProject, getProjectChange, getProjectCodeClientDatabase, getProjectCodeOperationalMetrics, getProjectCodeWorkspace, getProjectCommandCenter, getProjectLog, getProjectState, getProjectSummary, getProjectTeam, getProjectWorkstreamCodeReviewRequest, getProjectWorkstreamCodeTuningView, getPromotionCandidate, getReasoningCallSummary, getReasoningPrincipleSummary, getRecentMessages, getRecommendation, getRiskProfiles, getRiskStatus, getRunHealthAggregates, getSessionStats, getSessionTimes, getShadowModeDaemon, getSignalAccuracy, getSignalActivity, getSkill, getSnapshot, getSource, getStepBuilderContext, getStrategy, getStrategyBucketDefinition, getStrategyDefinition, getStrategyDeploymentStatus, getStrategyDiscoveryStats, getStrategyRunAnalytics, getStrategyRunArtifact, getStrategyRunResult, getStressResult, getStressScenario, getSubjectEvaluations, getSystemDatabase, getSystemDatabaseSeries, getSystemHealth, getSystemHost, getSystemHostSeries, getSystemOverview, getSystemRedis, getSystemRedisSeries, getTask, getTemplate, getTool, getToolGaps, getToolLibrary, getTradeStats, getTradingAccount, getTradingViewConfig, getUploadContent, getUserAuditLog, getVarEstimate, getWaitingOnMe, getWalletWatch, getWatchlistEntry, getWidget, getWorkerRun, getWorkflow, getWorkflowCloseSummary, getWorkflowGate, getWorkflowInstance, getWorkflowVersion, getWorkforceSummary, getWorkstream, graduateShadowModeDaemon, grantDaemonRunExecutionEnvelopePermission, grantEmployeeRunExecutionEnvelopePermission, handleGitHubCodeWorkspaceWebhook, heartbeatAiWorker, heartbeatProjectWorkstreamCodePreviewSession, importFinanceStrategyCorpus, installMarketplaceListing, inviteToConversation, linkAccount, linkProjectThreadResource, listActionQueue, listActiveAgents, listActiveStrategies, listAdminDaemonFindings, listAdminUsers, listAgentTemplateVersions, listAgentWorkflowRuns, listAgentWorkflows, listAlertRules, listAlerts, listAlertsBySymbol, listAnalyses, listAnalysisTemplates, listApiKeyGrantablePermissions, listApiKeys, listApprovedStrategies, listApproverDelegations, listArtifacts, listAttributionEffects, listAttributionRuns, listBookSnapshots, listBrokerCredentials, listCandles, listCapacityCurves, listCapitalAllocations, listCapitalAllocationSleeves, listCatalogCandidates, listCatalogItemVersions, listCatalogReviewQueue, listCatalogSources, listCatalogVersionAdoptions, listContractEvents, listConversationArtifacts, listConversationAttachments, listConversationEntities, listConversationGroups, listConversationIntents, listConversationMembers, listConversationMessages, listConversations, listCrowdingScores, listDaemonFindings, listDaemonPermissionGrants, listDaemonReflections, listDaemonRunDecisions, listDaemonRunExecutionEnvelopes, listDaemonRunReports, listDaemonRuns, listDaemons, listDaemonsAssignments, listDaemonsEventCatalog, listDaemonTriggers, listDaemonWorkflows, listDashboards, listDeadLetterEntries, listDepartments, listDiscoveredStrategies, listDocuments, listDynamicFanOutPolicies, listEconomicEvents, listEmployeeFindings, listEmployeePermissionGrants, listEmployeeReflections, listEmployeeRunDecisions, listEmployeeRunExecutionEnvelopes, listEmployeeRunReports, listEmployeeRuns, listEmployees, listEmployeeTriggers, listEmployeeWorkflows, listEntityVersions, listEvaluationCases, listEvaluationDatasets, listEvaluationTemplates, listExchangeCredentials, listExecutionAlgos, listExecutionDeployments, listFinanceConversationPersonas, listFinanceDataBlockers, listFinanceIndicatorDecisions, listFinanceIndicators, listFinanceModelLineage, listFinancePlannerRecommendations, listFinanceProviderUnlockPrompts, listFinanceResearchWorkflows, listFinanceStrategyCostModels, listFinanceStrategyDecisions, listFinanceStrategyLifecycleTransitions, listFinanceStrategyRunRequests, listFinanceStrategyRuns, listFinanceStrategyTemplates, listForwardRuns, listHarvestedContent, listHoldings, listImprovementProposals, listIngestionJobs, listIntelPlatforms, listIntelSourceFetchRuns, listIntelSourceItemInsights, listIntelSourceMonitorFetchRuns, listIntelSourceMonitors, listIntelSources, listIntelSourceSubscriptions, listInterventions, listJourneyEvents, listJourneyRawEvents, listJourneys, listLinkedAccounts, listLlmCallCostOutliers, listLlmCallLatencyOutliers, listLotDisposals, listMarketEventReactions, listMarketEventReactionTypes, listMarketplaceInstallations, listMarketplaceListings, listMarketplaceNeedsSetup, listMarketplaceUpdates, listMcpConnections, listMcpConnectionTools, listMemories, listModelRuntimePolicies, listModels, listMyModules, listOrders, listOrganizationRuntimeFlags, listOrganizations, listOrgInvitations, listOrgMembers, listOutputPartKinds, listPendingDecisions, listPinnedWidgets, listPlatformRuntimeFlags, listPortfolios, listPortfolioSnapshots, listPortTypes, listPositionLots, listPositions, listPrices, listProjectChanges, listProjectCodeCheckpoints, listProjectCodeRepositoryConnections, listProjectCodeWorkspaceOperations, listProjectMembers, listProjects, listProjectStateEvents, listProjectTeamMembers, listProjectTeams, listProjectThreads, listProjectWorkModeTemplates, listProjectWorkstreamCodeReviewRequests, listPromotionCandidates, listPromptTemplates, listReasoningEvaluations, listRiskBreaches, listRiskHalts, listRiskLimits, listRuns, listRuntimePolicyOptions, listRuntimePolicySurfaceRules, listShadowModeDaemons, listSignals, listSkills, listSnapshots, listSources, listStrategies, listStrategyAdapterResolutions, listStrategyBucketDefinitions, listStrategyBucketEvaluations, listStrategyDefinitionEvaluations, listStrategyDefinitionGroups, listStrategyDefinitionRuns, listStrategyDefinitions, listStrategyDefinitionSummaries, listStrategyExtensionDescriptors, listStressResults, listStressScenarios, listSystemDatabaseStatements, listTaskDecisions, listTasks, listTcaScorecards, listTeamMembers, listTeams, listTemplates, listToolLibraries, listToolLibraryTools, listTools, listTopSources, listTrades, listVarBacktests, listVarComponents, listVarEstimates, listWalletWatches, listWatchlist, listWidgets, listWorkflowExecutionObservations, listWorkflowGates, listWorkflowInstances, listWorkflowRuns, listWorkflows, listWorkflowVersions, listWorkforceAssignments, listWorkforceEventCatalog, listWorkstreamDecisions, listWorkstreamMembers, listWorkstreams, lookupFinanceCommandOptions, materializeProjectChangeCode, modifyDecision, openProjectChangeCodeReview, optimizePrompt, type Options, patchConversationSettings, patchStrategyBucketDefinition, pauseExecution, pauseExecutionAlgo, pinDashboard, pinWidget, pollAiWorkerCommands, pollAiWorkerControlCommands, preflightTemplateUpgrade, presignUpload, previewFinanceIndicatorImport, previewFinanceStrategyTemplate, previewInvitation, previewPrompt, processCatalogReviewQueue, promoteAgentTemplateVersion, promoteCatalogCandidate, promoteMemory, proposeFinanceBucketReweight, publishAiWorkerEvents, publishEvaluationTemplateVersion, publishMarketplaceListing, purgeSnapshots, queryAiWorkerData, queryOutputs, reactivateProject, reassignTask, receiveTradingViewAlert, recommendAgentTemplates, recommendDaemons, recommendWorkflowDefinitions, recommendWorkforce, recordIntelSourceConsent, refreshToken, registerAiWorker, rejectCatalogCandidate, rejectDaemonDecision, rejectDecision, rejectIntervention, rejectPromotionCandidate, rejectRecommendation, rejectTaskAction, rejectWorkflowGate, removeActiveStrategy, removeConversationMember, removeDaemonWorkflow, removeEmployeeWorkflow, removeFromWatchlist, removeMarketplaceBundleEntity, removeProjectMember, removeProjectTeamMember, removeTeamMember, removeUserRole, removeWidget, removeWorkflowStep, removeWorkstreamMember, reorderWidgets, reorderWorkflowSteps, replaceProjectWorkModeTemplates, replayDeadLetterEntry, replyToConversation, resendInvitation, resetAlert, resetDaemonGovernance, resetEmployeeGovernance, resetPassword, resetUserPassword, resolveActionQueueItem, resolveDynamicFanOutPolicy, resolveIntervention, resolveModelRuntimePolicy, resolveRiskBreach, resolveStrategyAdapters, restoreCatalogItemVersion, restoreWorkflow, restoreWorkflowVersion, resumeAllDaemons, resumeAllEmployees, resumeExecution, resumeExecutionAlgo, resumeRiskHalt, retryCatalogCandidateReview, retryCatalogReviewQueue, retryCatalogReviewQueueItem, retryTask, revertCatalogVersionAdoption, reviewDaemonsFinding, reviewIntelSourceApproval, reviewWorkforceFinding, revokeApiKey, revokeApproverDelegation, revokeDaemonPermissionGrant, revokeEmployeePermissionGrant, revokeInvitation, rollbackAgentTemplateVersion, rollbackProjectCodeCheckpoint, rotateApiKey, rotateTradingViewToken, routeIntervention, runAgentWorkflowRunAction, runAiWorkerDataset, runAnalysisAgents, runBacktest, runDaemon, runEmployee, runEvaluationDataset, runIngestionJob, runStrategyDiscoveryWorkflow, saveDebugStepOutput, saveWorkflowDefinitionGraph, searchAgentTemplates, searchArtifacts, searchDaemons, searchFinanceKg, searchMemories, searchWorkflowDefinitions, searchWorkforce, sendNotification, setAgentEnabled, setAlertEnabled, setConversationLead, setConversationRuntimePolicy, setConversationTyping, setDaemonRuntimePolicy, setDecisionRuntimePolicy, setEmployeeRuntimePolicy, setOrganizationRuntimeFlag, setOrganizationRuntimePolicySurfaceRule, setPlatformRuntimeFlag, setSystemRuntimePolicySurfaceRule, setTemplateAutoUpgrade, setTemplateStatus, setToolStatus, setWorkflowRuntimePolicy, setWorkflowSchedule, softDeleteProject, spawnAgent, startConversationFromMessage, startFinanceResearchWorkflowRun, startMarketData, startStrategy, startTask, stopExecution, stopMarketData, stopStrategy, submitCapitalAllocation, submitConversationInteraction, suggestConnections, switchAccount, syncToolLibrary, terminateAgent, terminateAllDaemons, terminateAllEmployees, testAgentTemplateVersion, testIntelPlatform, testMcpConnection, testNotification, testTradingViewWebhook, transferTaskTeam, transitionBlocker, transitionHandoff, transpileFinanceIndicatorImport, triggerAgentWorkflow, triggerWorkflow, triggerWorkflowInstance, unbindMarketplaceEntityConnection, undeployStrategy, unlinkAccount, unpinDashboard, unpinWidget, updateAdminUser, updateAlertRule, updateAnalysisTemplate, updateApiKey, updateArtifact, updateBrokerCredential, updateConversation, updateDaemon, updateDaemonTrigger, updateDashboard, updateDiscoveredStrategyStatus, updateDynamicFanOutPolicy, updateEmployee, updateEmployeeTrigger, updateEvaluationTemplate, updateHolding, updateIntelPlatform, updateIntelSource, updateIntelSourceMonitor, updateIntelSourceSubscription, updateMarketplaceEntity, updateMcpConnection, updateMe, updateMemory, updateModelRuntimePolicy, updateNotificationConfig, updateOrganization, updatePinnedWidget, updatePortfolio, updateProject, updateProjectChange, updateProjectMemberRole, updateProjectTeam, updateProjectTeamMember, updateProjectThread, updateRiskLimit, updateShadowModeDaemonEnrollment, updateSnapshot, updateStrategyParameters, updateTask, updateToolLibrary, updateWidget, updateWorkflow, updateWorkflowInstance, updateWorkflowStep, updateWorkstream, upgradeCatalogVersionAdoption, uploadDocument, upsertFinanceDataBlocker, upsertStrategyBucketDefinition, upsertStrategyDefinition, upsertStrategyExtensionDescriptor, validateStep, validateStrategyBucketDefinition, validateStrategyDefinition, validateStrategyExtensionDescriptor, validateWorkflow, verifyBrokerCredential, verifyEmail, verifyFinanceAuditLedgerChain, verifyUser, viewProjectWorkstreamCodePreviewSession } from '../sdk.gen';
import type { AcceptInvitationData, AcceptInvitationResponse, AcceptProjectWorkstreamCodeTuningVersionData, AcceptProjectWorkstreamCodeTuningVersionError, AcceptProjectWorkstreamCodeTuningVersionResponse, AcceptPromotionCandidateData, AcceptPromotionCandidateResponse, AcceptRiskBreachData, AcceptRiskBreachResponse, AcknowledgeOrgModuleData, AcknowledgeOrgModuleResponse, ActivateEntityVersionData, ActivateEntityVersionResponse, ActivateRiskHaltData, ActivateRiskHaltResponse, AddEvaluationTemplateVersionData, AddEvaluationTemplateVersionResponse, AddMarketplaceBundleEntityData, AddMarketplaceBundleEntityResponse, AddOrgMemberData, AddOrgMemberResponse, AddProjectMemberData, AddProjectMemberResponse, AddProjectTeamMemberData, AddProjectTeamMemberResponse, AddTeamMemberData, AddTeamMemberResponse, AddToWatchlistData, AddToWatchlistResponse, AddWidgetData, AddWidgetResponse, AddWorkflowStepData, AddWorkflowStepResponse, AddWorkstreamMemberData, AddWorkstreamMemberResponse, AmendStrategyDefinitionParametersData, AmendStrategyDefinitionParametersResponse, AnalyzeConfluenceData, AnalyzeConfluenceFromSignalsData, AnalyzeConfluenceFromSignalsResponse, AnalyzeConfluenceResponse, AnalyzeOrderBookData, AnalyzeOrderBookResponse, AnalyzeTickerAdHocData, AnalyzeTickerAdHocResponse, ApiApproveDecisionData, ApiApproveDecisionError, ApiApproveDecisionResponse, ApiCancelDecisionData, ApiCancelDecisionError, ApiCancelDecisionResponse, ApiCompareBacktestsData, ApiCompareBacktestsError, ApiCompareBacktestsResponse, ApiCreateBacktestData, ApiCreateBacktestError, ApiCreateBacktestResponse, ApiGetBacktestAnalyticsData, ApiGetBacktestAnalyticsError, ApiGetBacktestAnalyticsResponse, ApiGetBacktestData, ApiGetBacktestError, ApiGetBacktestResponse, ApiGetCandlesData, ApiGetCandlesError, ApiGetCandlesResponse, ApiGetDashboardDataData, ApiGetDashboardDataError, ApiGetDashboardDataResponse, ApiGetStrategyBucketData, ApiGetStrategyBucketError, ApiGetStrategyBucketResponse, ApiGetStrategyData, ApiGetStrategyError, ApiGetStrategyResponse, ApiGetWorkflowRunPartData, ApiGetWorkflowRunPartError, ApiGetWorkflowRunPartResponse, ApiListBacktestsData, ApiListBacktestSeriesData, ApiListBacktestSeriesError, ApiListBacktestSeriesResponse, ApiListBacktestsError, ApiListBacktestsResponse, ApiListDecisionsData, ApiListDecisionsError, ApiListDecisionsResponse, ApiListIntelSourceItemsData, ApiListIntelSourceItemsError, ApiListIntelSourceItemsResponse, ApiListIntelSourcesData, ApiListIntelSourcesError, ApiListIntelSourcesResponse, ApiListMarketRegimesData, ApiListMarketRegimesError, ApiListMarketRegimesResponse, ApiListStrategiesData, ApiListStrategiesError, ApiListStrategiesResponse, ApiListStrategyBucketsData, ApiListStrategyBucketsError, ApiListStrategyBucketsResponse, ApiRejectDecisionData, ApiRejectDecisionError, ApiRejectDecisionResponse, ApplyContractResolutionData, ApplyContractResolutionResponse, ApplyEvaluationTemplateData, ApplyEvaluationTemplateResponse, ApplyFinanceBucketDecisionData, ApplyFinanceBucketDecisionResponse, ApplyFinanceIndicatorPromotionData, ApplyFinanceIndicatorPromotionResponse, ApplyMarketplaceUpdatesData, ApplyMarketplaceUpdatesResponse, ApproveDaemonDecisionData, ApproveDaemonDecisionResponse, ApproveDecisionData, ApproveDecisionResponse, ApproveRecommendationData, ApproveRecommendationResponse, ApproveTaskActionData, ApproveTaskActionResponse, ApproveWorkflowGateData, ApproveWorkflowGateResponse, ArchiveProjectData, ArchiveProjectResponse, ArchiveWorkflowData, ArchiveWorkflowResponse, ArchiveWorkstreamData, ArchiveWorkstreamResponse, AssignDaemonWorkflowData, AssignDaemonWorkflowResponse, AssignEmployeeWorkflowData, AssignEmployeeWorkflowResponse, AssignUserRoleData, AssignUserRoleResponse, AttachToConversationData, AttachToConversationResponse, BackfillIntelSourceSubscriptionData, BackfillIntelSourceSubscriptionResponse, BatchDeactivateIntelSourcesData, BatchDeactivateIntelSourcesResponse, BatchFetchIntelSourcesData, BatchFetchIntelSourcesResponse, BindMarketplaceEntityConnectionData, BindMarketplaceEntityConnectionResponse, BulkCreateIntelSourcesData, BulkCreateIntelSourcesError, BulkCreateIntelSourcesResponse, BulkUpdateUserStatusData, BulkUpdateUserStatusResponse, CalculateOrbData, CalculateOrbResponse, CallAiWorkerMcpData, CallAiWorkerMcpResponse, CallPlatformMcpData, CallPlatformMcpResponse, CancelAllOrdersData, CancelAllOrdersResponse, CancelExecutionAlgoData, CancelExecutionAlgoResponse, CancelOrderData, CancelOrderResponse, CancelTaskData, CancelTaskResponse, CancelWorkerRunData, CancelWorkerRunResponse, CertifyShadowModeDaemonData, CertifyShadowModeDaemonResponse, CheckAlertPriceData, CheckAlertPriceResponse, CheckDeploymentReadinessData, CheckDeploymentReadinessResponse, CheckMarketDataData, CheckMarketDataResponse, CheckPortCompatibilityData, CheckPortCompatibilityResponse, ClaimActionQueueItemData, ClaimActionQueueItemResponse, ClearOrganizationRuntimePolicySurfaceRuleData, ClearOrganizationRuntimePolicySurfaceRuleResponse, CloneAnalysisTemplateData, CloneAnalysisTemplateResponse, CloseContextPanelData, CloseContextPanelResponse, ClosePositionData, ClosePositionResponse, CloseProjectData, CloseProjectResponse, CommitFinanceStrategyLifecycleTransitionData, CommitFinanceStrategyLifecycleTransitionResponse, CompareAgentTemplateVersionsData, CompareAgentTemplateVersionsResponse, ComparePortfoliosData, ComparePortfoliosResponse, CompleteTaskData, CompleteTaskResponse, ConfigureProjectCodeClientDatabaseData, ConfigureProjectCodeClientDatabaseResponse, ConnectMcpConnectionData, ConnectMcpConnectionResponse, CreateActiveStrategyData, CreateActiveStrategyResponse, CreateAdjustmentData, CreateAdjustmentResponse, CreateAgentTemplateVersionData, CreateAgentTemplateVersionResponse, CreateAlertData, CreateAlertResponse, CreateAlertRuleData, CreateAlertRuleResponse, CreateAnalysisTemplateData, CreateAnalysisTemplateResponse, CreateApiKeyData, CreateApiKeyResponse, CreateApproverDelegationData, CreateApproverDelegationResponse, CreateArtifactData, CreateArtifactResponse, CreateBackfillData, CreateBrokerCredentialData, CreateBrokerCredentialResponse, CreateBucketForwardRunData, CreateBucketForwardRunResponse, CreateConversationData, CreateConversationGroupData, CreateConversationGroupResponse, CreateConversationResponse, CreateDaemonData, CreateDaemonResponse, CreateDaemonTriggerData, CreateDaemonTriggerResponse, CreateDashboardData, CreateDashboardResponse, CreateDepositData, CreateDepositResponse, CreateDiscretionaryRunData, CreateDiscretionaryRunResponse, CreateDynamicFanOutPolicyData, CreateDynamicFanOutPolicyResponse, CreateEmployeeData, CreateEmployeeResponse, CreateEmployeeTriggerData, CreateEmployeeTriggerResponse, CreateEntityVersionDraftData, CreateEntityVersionDraftResponse, CreateEvaluationCaseData, CreateEvaluationCaseResponse, CreateEvaluationDatasetData, CreateEvaluationDatasetResponse, CreateEvaluationTemplateData, CreateEvaluationTemplateResponse, CreateExchangeCredentialData, CreateExchangeCredentialResponse, CreateExecutionAlgoData, CreateExecutionAlgoResponse, CreateExecutionDeploymentData, CreateExecutionDeploymentResponse, CreateFinanceStrategyCostModelData, CreateFinanceStrategyCostModelResponse, CreateFinanceStrategyLifecycleTransitionData, CreateFinanceStrategyLifecycleTransitionResponse, CreateFinanceStrategyRunData, CreateFinanceStrategyRunRequestData, CreateFinanceStrategyRunRequestResponse, CreateFinanceStrategyRunResponse, CreateHoldingData, CreateHoldingResponse, CreateHostMetricsData, CreateHostMetricsError, CreateHostMetricsResponse, CreateIntelPlatformData, CreateIntelPlatformResponse, CreateIntelSourceData, CreateIntelSourceError, CreateIntelSourceMonitorData, CreateIntelSourceMonitorResponse, CreateIntelSourceResponse, CreateIntelSourceSubscriptionData, CreateIntelSourceSubscriptionResponse, CreateInterventionData, CreateInterventionError, CreateInterventionResponse, CreateInvitationData, CreateInvitationResponse, CreateLoginData, CreateLoginResponse, CreateLogoutData, CreateLogoutResponse, CreateMarketDataGrantsData, CreateMarketDataGrantsError, CreateMarketDataGrantsResponse, CreateMarketEventReactionData, CreateMarketEventReactionResponse, CreateMarketplaceBundleData, CreateMarketplaceBundleResponse, CreateMcpConnectionData, CreateMcpConnectionResponse, CreateMemoryData, CreateMemoryResponse, CreateModelRuntimePolicyData, CreateModelRuntimePolicyResponse, CreateOrderData, CreateOrderResponse, CreateOrganizationData, CreateOrganizationResponse, CreateOrUpdateTemplateData, CreateOrUpdateTemplateResponse, CreateOrUpdateToolData, CreateOrUpdateToolResponse, CreatePortfolioData, CreatePortfolioResponse, CreateProjectChangeData, CreateProjectChangeResponse, CreateProjectChangeRevisionData, CreateProjectChangeRevisionResponse, CreateProjectCodeRepositoryConnectionData, CreateProjectCodeRepositoryConnectionResponse, CreateProjectData, CreateProjectResponse, CreateProjectTeamData, CreateProjectTeamResponse, CreateProjectThreadData, CreateProjectThreadResponse, CreateProjectWorkstreamCodeGenerationRunData, CreateProjectWorkstreamCodeGenerationRunResponse, CreateProjectWorkstreamCodePreviewSessionData, CreateProjectWorkstreamCodePreviewSessionError, CreateProjectWorkstreamCodePreviewSessionResponse, CreateProjectWorkstreamCodeReviewRequestData, CreateProjectWorkstreamCodeReviewRequestError, CreateProjectWorkstreamCodeReviewRequestResponse, CreateRiskLimitData, CreateRiskLimitResponse, CreateSignupData, CreateSignupResponse, CreateSnapshotData, CreateSnapshotError, CreateSnapshotResponse, CreateSourceData, CreateSourceResponse, CreateStrategyAdapterResolutionData, CreateStrategyAdapterResolutionResponse, CreateStrategyBucketEvaluationData, CreateStrategyBucketEvaluationResponse, CreateStrategyDefinitionEvaluationData, CreateStrategyDefinitionEvaluationResponse, CreateStrategyDefinitionRunData, CreateStrategyDefinitionRunError, CreateStrategyDefinitionRunResponse, CreateStrategyDefinitionValidationRunData, CreateStrategyDefinitionValidationRunResponse, CreateSystematicForwardRunData, CreateSystematicForwardRunResponse, CreateTaskData, CreateTaskResponse, CreateTeamData, CreateTeamResponse, CreateTemplateData, CreateTemplateResponse, CreateTemplateUpgradeProposalData, CreateTemplateUpgradeProposalError, CreateTemplateUpgradeProposalResponse, CreateTickerResearchNoteData, CreateTickerResearchNoteResponse, CreateToolData, CreateToolLibraryData, CreateToolLibraryResponse, CreateToolResponse, CreateWalletWatchData, CreateWalletWatchResponse, CreateWidgetData, CreateWidgetResponse, CreateWithdrawalData, CreateWithdrawalResponse, CreateWorkerRunData, CreateWorkerRunResponse, CreateWorkflowData, CreateWorkflowInstanceData, CreateWorkflowInstanceResponse, CreateWorkflowResponse, CreateWorkstreamData, CreateWorkstreamResponse, DecideGateData, DecideGateResponse, DecideImprovementProposalData, DecideImprovementProposalDesignData, DecideImprovementProposalDesignResponse, DecideImprovementProposalResponse, DecideProjectWorkstreamCodeReviewRequestData, DecideProjectWorkstreamCodeReviewRequestError, DecideProjectWorkstreamCodeReviewRequestResponse, DeferCatalogCandidateData, DeferCatalogCandidateError, DeferCatalogCandidateResponse, DeferDaemonDecisionData, DeferDaemonDecisionResponse, DeleteAlertData, DeleteAlertResponse, DeleteAlertRuleData, DeleteAlertRuleResponse, DeleteAnalysisTemplateData, DeleteAnalysisTemplateResponse, DeleteArtifactData, DeleteArtifactResponse, DeleteBrokerCredentialData, DeleteBrokerCredentialResponse, DeleteConversationData, DeleteConversationGroupData, DeleteConversationGroupResponse, DeleteConversationResponse, DeleteDaemonData, DeleteDaemonResponse, DeleteDaemonTriggerData, DeleteDaemonTriggerResponse, DeleteDashboardData, DeleteDashboardResponse, DeleteDocumentData, DeleteDocumentResponse, DeleteEmployeeData, DeleteEmployeeResponse, DeleteEmployeeTriggerData, DeleteEmployeeTriggerResponse, DeleteEvaluationCaseData, DeleteEvaluationCaseResponse, DeleteEvaluationDatasetData, DeleteEvaluationDatasetResponse, DeleteExchangeCredentialData, DeleteExchangeCredentialResponse, DeleteHoldingData, DeleteHoldingResponse, DeleteIntelSourceData, DeleteIntelSourceError, DeleteIntelSourceResponse, DeleteMarketEventReactionData, DeleteMarketEventReactionResponse, DeleteMarketplaceListingData, DeleteMarketplaceListingResponse, DeleteMcpConnectionData, DeleteMcpConnectionResponse, DeleteMemoryData, DeleteMemoryResponse, DeleteProjectTeamData, DeleteProjectTeamResponse, DeleteProjectWorkstreamCodePreviewSessionData, DeleteProjectWorkstreamCodePreviewSessionResponse, DeleteRiskLimitData, DeleteRiskLimitResponse, DeleteSnapshotData, DeleteSnapshotError, DeleteSnapshotResponse, DeleteTaskData, DeleteTaskResponse, DeleteTemplateData, DeleteTemplateError, DeleteTemplateResponse, DeleteToolData, DeleteToolError, DeleteToolLibraryData, DeleteToolLibraryResponse, DeleteToolResponse, DeleteUploadData, DeleteUploadResponse, DeleteWalletWatchData, DeleteWalletWatchResponse, DeployStrategyData, DeployStrategyResponse, DetachFromConversationData, DetachFromConversationResponse, DiffAgentTemplateVersionsData, DiffAgentTemplateVersionsResponse, DiffWorkflowVersionsData, DiffWorkflowVersionsResponse, DisableConversationIntentData, DisableConversationIntentResponse, DisableDaemonData, DisableDaemonResponse, DisableEmployeeData, DisableEmployeeResponse, DisambiguateConversationIntentData, DisambiguateConversationIntentResponse, DisconnectMcpConnectionData, DisconnectMcpConnectionResponse, DiscoverIntelSourceData, DiscoverIntelSourceResponse, DispatchStrategyBucketBacktestData, DispatchStrategyBucketBacktestResponse, DownloadOutputData, DownloadOutputResponse, DtiOperatorKillSwitchData, DtiOperatorKillSwitchResponse, DtiOperatorResumeData, DtiOperatorResumeResponse, EnableConversationIntentData, EnableConversationIntentResponse, EnableDaemonData, EnableDaemonResponse, EnableEmployeeData, EnableEmployeeResponse, EnableProjectCodeWorkspaceData, EnableProjectCodeWorkspaceResponse, EnableProjectWorkstreamCodeWorkforceData, EnableProjectWorkstreamCodeWorkforceResponse, EnqueueFinanceIndicatorDecisionData, EnqueueFinanceIndicatorDecisionResponse, EnqueueFinanceStrategyTemplateRunData, EnqueueFinanceStrategyTemplateRunResponse, EscalateRiskBreachData, EscalateRiskBreachResponse, EvaluateFinanceStrategyDecisionData, EvaluateFinanceStrategyDecisionResponse, EvaluateFinanceStrategyDefinitionData, EvaluateFinanceStrategyDefinitionResponse, ExecuteAgentData, ExecuteAgentResponse, ExecuteStepData, ExecuteStepResponse, ExpandImprovementTierData, ExpandImprovementTierResponse, ExportInstructionsData, ExportInstructionsResponse, ExportWorkflowInstructionsData, ExportWorkflowInstructionsResponse, ExtendApprovalTimeoutData, ExtendApprovalTimeoutResponse, FetchAiWorkerDataResultData, FetchAiWorkerDataResultResponse, FetchIntelSourceData, FetchIntelSourceMonitorData, FetchIntelSourceMonitorResponse, FetchIntelSourceResponse, FillTemplateData, FillTemplateResponse, FinalizeUploadData, FinalizeUploadResponse, FollowUpWorkerRunData, FollowUpWorkerRunResponse, ForkMarketplaceListingData, ForkMarketplaceListingResponse, ForkStrategyDefinitionData, ForkStrategyDefinitionResponse, GenerateOrderBookHeatmapData, GenerateOrderBookHeatmapResponse, GeneratePineScriptData, GeneratePineScriptResponse, GenerateStrategyDocsData, GenerateStrategyDocsResponse, GetAccountFxCashData, GetAccountFxCashResponse, GetActiveRunData, GetActiveRunResponse, GetActiveStrategyData, GetActiveStrategyResponse, GetAdminUserData, GetAdminUserResponse, GetAgentHealthData, GetAgentHealthResponse, GetAgentStatusData, GetAgentStatusResponse, GetAgentTemplateVersionComparisonData, GetAgentTemplateVersionComparisonResponse, GetAgentWorkflowRunData, GetAgentWorkflowRunDebuggerData, GetAgentWorkflowRunDebuggerResponse, GetAgentWorkflowRunResponse, GetAlertRuleData, GetAlertRuleResponse, GetAnalysisData, GetAnalysisResponse, GetAnalysisTemplateData, GetAnalysisTemplateResponse, GetApiKeyData, GetApiKeyResponse, GetArtifactData, GetArtifactResponse, GetAssetSentimentData, GetAssetSentimentResponse, GetAttributionRunData, GetAttributionRunResponse, GetBrokerCredentialData, GetBrokerCredentialResponse, GetCapacityCurveData, GetCapacityCurveResponse, GetCapitalAllocationData, GetCapitalAllocationResponse, GetCatalogCandidateData, GetCatalogCandidateError, GetCatalogCandidateResponse, GetContentDetailsData, GetContentDetailsResponse, GetContentStatsData, GetContentStatsResponse, GetContractHealthData, GetContractHealthResponse, GetConversationContextData, GetConversationContextResponse, GetConversationData, GetConversationMessageByIdData, GetConversationMessageByIdResponse, GetConversationResponse, GetCurrentSessionData, GetCurrentSessionResponse, GetDaemonData, GetDaemonDecisionData, GetDaemonDecisionResponse, GetDaemonReadinessData, GetDaemonReadinessResponse, GetDaemonResponse, GetDaemonRunAuditData, GetDaemonRunAuditResponse, GetDaemonRunData, GetDaemonRunResponse, GetDaemonsSummaryData, GetDaemonsSummaryResponse, GetDaemonTrendData, GetDaemonTrendResponse, GetDashboardData, GetDashboardResponse, GetDebugStepOutputsData, GetDebugStepOutputsResponse, GetDecisionData, GetDecisionResponse, GetDecisionStatsData, GetDecisionStatsResponse, GetDiscoveredStrategyData, GetDiscoveredStrategyResponse, GetDiscoverySummaryData, GetDiscoverySummaryResponse, GetDocumentData, GetDocumentResponse, GetDynamicFanOutPolicyData, GetDynamicFanOutPolicyResponse, GetEmployeeData, GetEmployeeReadinessData, GetEmployeeReadinessResponse, GetEmployeeResponse, GetEmployeeRunAuditData, GetEmployeeRunAuditResponse, GetEmployeeRunData, GetEmployeeRunResponse, GetEmployeeTrendData, GetEmployeeTrendResponse, GetEvaluationRunData, GetEvaluationRunResponse, GetEvaluationTemplateData, GetEvaluationTemplateResponse, GetExecutionAlgoData, GetExecutionAlgoResponse, GetExecutionDeploymentData, GetExecutionDeploymentResponse, GetExecutionStatusData, GetExecutionStatusResponse, GetFinanceArtifactPreviewData, GetFinanceArtifactPreviewResponse, GetFinanceAuditLedgerChainData, GetFinanceAuditLedgerChainResponse, GetFinanceAuditLedgerHeadData, GetFinanceAuditLedgerHeadResponse, GetFinanceAuditLedgerOrderHistoryData, GetFinanceAuditLedgerOrderHistoryResponse, GetFinanceBucketCompositionData, GetFinanceBucketCompositionResponse, GetFinanceIndicatorDecisionData, GetFinanceIndicatorDecisionResponse, GetFinanceKgNodeEdgesData, GetFinanceKgNodeEdgesResponse, GetFinanceKgRegimeProfileData, GetFinanceKgRegimeProfileResponse, GetFinanceModelLineageData, GetFinanceModelLineageGraphData, GetFinanceModelLineageGraphResponse, GetFinanceModelLineageHistoryData, GetFinanceModelLineageHistoryResponse, GetFinanceModelLineageResponse, GetFinanceOperationsSummaryData, GetFinanceOperationsSummaryResponse, GetFinanceProviderUnlockPromptData, GetFinanceProviderUnlockPromptResponse, GetFinanceStrategyCostModelData, GetFinanceStrategyCostModelResponse, GetFinanceStrategyDecisionData, GetFinanceStrategyDecisionResponse, GetFinanceStrategyRunData, GetFinanceStrategyRunRequestData, GetFinanceStrategyRunRequestResponse, GetFinanceStrategyRunResponse, GetFinanceStrategyTemplateData, GetFinanceStrategyTemplateResponse, GetForwardRunData, GetForwardRunResponse, GetImprovementMetricsData, GetImprovementMetricsResponse, GetImprovementProposalData, GetImprovementProposalResponse, GetImprovementTierStatusData, GetImprovementTierStatusResponse, GetIntelPlatformUsageData, GetIntelPlatformUsageResponse, GetIntelSourceData, GetIntelSourceError, GetIntelSourceHarvestedData, GetIntelSourceHarvestedError, GetIntelSourceHarvestedResponse, GetIntelSourceResponse, GetIntelSourceStyleProfileData, GetIntelSourceStyleProfileResponse, GetIntelSourceViewConfirmationData, GetIntelSourceViewConfirmationResponse, GetInterventionData, GetInterventionError, GetInterventionResponse, GetLatestOutputData, GetLatestOutputResponse, GetMarketDataBackupData, GetMarketDataBackupError, GetMarketDataBackupResponse, GetMarketDataCoverageData, GetMarketDataCoverageError, GetMarketDataCoverageResponse, GetMarketDataStatusData, GetMarketplaceBundleData, GetMarketplaceBundleResponse, GetMarketplaceEntityVersionsData, GetMarketplaceEntityVersionsResponse, GetMcpConnectionData, GetMcpConnectionResponse, GetMeData, GetMemoryData, GetMemoryResponse, GetMeResponse, GetMlHealthData, GetMlHealthResponse, GetMlRegimeData, GetMlRegimeResponse, GetMlStrategyScoresData, GetMlStrategyScoresResponse, GetModelData, GetModelResponse, GetModelRuntimePolicyData, GetModelRuntimePolicyResponse, GetMyOrganizationsData, GetMyOrganizationsResponse, GetMyTeamsInOrgData, GetMyTeamsInOrgResponse, GetNotificationConfigData, GetNotificationConfigResponse, GetOrderBookData, GetOrderBookResponse, GetOrderData, GetOrderResponse, GetOrganizationData, GetOrganizationResponse, GetOutputData, GetOutputMetricsData, GetOutputMetricsResponse, GetOutputResponse, GetPerformanceMetricsData, GetPerformanceMetricsResponse, GetPortfolioData, GetPortfolioResponse, GetPortfolioSnapshotData, GetPortfolioSnapshotResponse, GetPortfolioValuationData, GetPortfolioValuationResponse, GetPortTypeColorsData, GetPortTypeColorsResponse, GetPortTypeData, GetPortTypeResponse, GetPositionData, GetPositionResponse, GetPositionValuationData, GetPositionValuationResponse, GetPriceData, GetPriceResponse, GetProjectChangeData, GetProjectChangeResponse, GetProjectCodeClientDatabaseData, GetProjectCodeClientDatabaseResponse, GetProjectCodeOperationalMetricsData, GetProjectCodeOperationalMetricsResponse, GetProjectCodeWorkspaceData, GetProjectCodeWorkspaceResponse, GetProjectCommandCenterData, GetProjectCommandCenterResponse, GetProjectData, GetProjectLogData, GetProjectLogResponse, GetProjectResponse, GetProjectStateData, GetProjectStateResponse, GetProjectSummaryData, GetProjectSummaryResponse, GetProjectTeamData, GetProjectTeamResponse, GetProjectWorkstreamCodeReviewRequestData, GetProjectWorkstreamCodeReviewRequestResponse, GetProjectWorkstreamCodeTuningViewData, GetProjectWorkstreamCodeTuningViewResponse, GetPromotionCandidateData, GetPromotionCandidateResponse, GetReasoningCallSummaryData, GetReasoningCallSummaryResponse, GetReasoningPrincipleSummaryData, GetReasoningPrincipleSummaryResponse, GetRecentMessagesData, GetRecentMessagesResponse, GetRecommendationData, GetRecommendationResponse, GetRiskProfilesData, GetRiskProfilesResponse, GetRiskStatusData, GetRiskStatusResponse, GetRunHealthAggregatesData, GetRunHealthAggregatesResponse, GetSessionStatsData, GetSessionStatsResponse, GetSessionTimesData, GetSessionTimesResponse, GetShadowModeDaemonData, GetShadowModeDaemonResponse, GetSignalAccuracyData, GetSignalAccuracyResponse, GetSignalActivityData, GetSignalActivityResponse, GetSkillData, GetSkillResponse, GetSnapshotData, GetSnapshotError, GetSnapshotResponse, GetSourceData, GetSourceResponse, GetStepBuilderContextData, GetStepBuilderContextResponse, GetStrategyBucketDefinitionData, GetStrategyBucketDefinitionResponse, GetStrategyData, GetStrategyDefinitionData, GetStrategyDefinitionResponse, GetStrategyDeploymentStatusData, GetStrategyDeploymentStatusResponse, GetStrategyDiscoveryStatsData, GetStrategyDiscoveryStatsResponse, GetStrategyResponse, GetStrategyRunAnalyticsData, GetStrategyRunAnalyticsResponse, GetStrategyRunArtifactData, GetStrategyRunArtifactResponse, GetStrategyRunResultData, GetStrategyRunResultResponse, GetStressResultData, GetStressResultResponse, GetStressScenarioData, GetStressScenarioResponse, GetSubjectEvaluationsData, GetSubjectEvaluationsResponse, GetSystemDatabaseData, GetSystemDatabaseError, GetSystemDatabaseResponse, GetSystemDatabaseSeriesData, GetSystemDatabaseSeriesError, GetSystemDatabaseSeriesResponse, GetSystemHealthData, GetSystemHealthError, GetSystemHealthResponse, GetSystemHostData, GetSystemHostError, GetSystemHostResponse, GetSystemHostSeriesData, GetSystemHostSeriesError, GetSystemHostSeriesResponse, GetSystemOverviewData, GetSystemOverviewResponse, GetSystemRedisData, GetSystemRedisResponse, GetSystemRedisSeriesData, GetSystemRedisSeriesError, GetSystemRedisSeriesResponse, GetTaskData, GetTaskResponse, GetTemplateData, GetTemplateResponse, GetToolData, GetToolGapsData, GetToolGapsResponse, GetToolLibraryData, GetToolLibraryResponse, GetToolResponse, GetTradeStatsData, GetTradeStatsResponse, GetTradingAccountData, GetTradingAccountResponse, GetTradingViewConfigData, GetTradingViewConfigResponse, GetUploadContentData, GetUploadContentResponse, GetUserAuditLogData, GetUserAuditLogResponse, GetVarEstimateData, GetVarEstimateResponse, GetWaitingOnMeData, GetWaitingOnMeResponse, GetWalletWatchData, GetWalletWatchResponse, GetWatchlistEntryData, GetWatchlistEntryResponse, GetWidgetData, GetWidgetResponse, GetWorkerRunData, GetWorkerRunResponse, GetWorkflowCloseSummaryData, GetWorkflowCloseSummaryResponse, GetWorkflowData, GetWorkflowGateData, GetWorkflowGateResponse, GetWorkflowInstanceData, GetWorkflowInstanceResponse, GetWorkflowResponse, GetWorkflowVersionData, GetWorkflowVersionResponse, GetWorkforceSummaryData, GetWorkforceSummaryResponse, GetWorkstreamData, GetWorkstreamResponse, GraduateShadowModeDaemonData, GraduateShadowModeDaemonResponse, GrantDaemonRunExecutionEnvelopePermissionData, GrantDaemonRunExecutionEnvelopePermissionResponse, GrantEmployeeRunExecutionEnvelopePermissionData, GrantEmployeeRunExecutionEnvelopePermissionResponse, HandleGitHubCodeWorkspaceWebhookData, HandleGitHubCodeWorkspaceWebhookResponse, HeartbeatAiWorkerData, HeartbeatAiWorkerResponse, HeartbeatProjectWorkstreamCodePreviewSessionData, HeartbeatProjectWorkstreamCodePreviewSessionError, HeartbeatProjectWorkstreamCodePreviewSessionResponse, ImportFinanceStrategyCorpusData, ImportFinanceStrategyCorpusResponse, InstallMarketplaceListingData, InstallMarketplaceListingResponse, InviteToConversationData, InviteToConversationResponse, LinkAccountData, LinkAccountResponse, LinkProjectThreadResourceData, LinkProjectThreadResourceResponse, ListActionQueueData, ListActionQueueResponse, ListActiveAgentsData, ListActiveAgentsResponse, ListActiveStrategiesData, ListActiveStrategiesResponse, ListAdminDaemonFindingsData, ListAdminDaemonFindingsResponse, ListAdminUsersData, ListAdminUsersResponse, ListAgentTemplateVersionsData, ListAgentTemplateVersionsResponse, ListAgentWorkflowRunsData, ListAgentWorkflowRunsResponse, ListAgentWorkflowsData, ListAgentWorkflowsResponse, ListAlertRulesData, ListAlertRulesResponse, ListAlertsBySymbolData, ListAlertsBySymbolResponse, ListAlertsData, ListAlertsResponse, ListAnalysesData, ListAnalysesResponse, ListAnalysisTemplatesData, ListAnalysisTemplatesResponse, ListApiKeyGrantablePermissionsData, ListApiKeyGrantablePermissionsResponse, ListApiKeysData, ListApiKeysResponse, ListApprovedStrategiesData, ListApprovedStrategiesResponse, ListApproverDelegationsData, ListApproverDelegationsResponse, ListArtifactsData, ListArtifactsResponse, ListAttributionEffectsData, ListAttributionEffectsResponse, ListAttributionRunsData, ListAttributionRunsResponse, ListBookSnapshotsData, ListBookSnapshotsResponse, ListBrokerCredentialsData, ListBrokerCredentialsResponse, ListCandlesData, ListCandlesResponse, ListCapacityCurvesData, ListCapacityCurvesResponse, ListCapitalAllocationsData, ListCapitalAllocationSleevesData, ListCapitalAllocationSleevesResponse, ListCapitalAllocationsResponse, ListCatalogCandidatesData, ListCatalogCandidatesError, ListCatalogCandidatesResponse, ListCatalogItemVersionsData, ListCatalogItemVersionsError, ListCatalogItemVersionsResponse, ListCatalogReviewQueueData, ListCatalogReviewQueueError, ListCatalogReviewQueueResponse, ListCatalogSourcesData, ListCatalogSourcesError, ListCatalogSourcesResponse, ListCatalogVersionAdoptionsData, ListCatalogVersionAdoptionsError, ListCatalogVersionAdoptionsResponse, ListContractEventsData, ListContractEventsResponse, ListConversationArtifactsData, ListConversationArtifactsResponse, ListConversationAttachmentsData, ListConversationAttachmentsResponse, ListConversationEntitiesData, ListConversationEntitiesResponse, ListConversationGroupsData, ListConversationGroupsResponse, ListConversationIntentsData, ListConversationIntentsResponse, ListConversationMembersData, ListConversationMembersResponse, ListConversationMessagesData, ListConversationMessagesResponse, ListConversationsData, ListConversationsResponse, ListCrowdingScoresData, ListCrowdingScoresResponse, ListDaemonFindingsData, ListDaemonFindingsResponse, ListDaemonPermissionGrantsData, ListDaemonPermissionGrantsResponse, ListDaemonReflectionsData, ListDaemonReflectionsResponse, ListDaemonRunDecisionsData, ListDaemonRunDecisionsResponse, ListDaemonRunExecutionEnvelopesData, ListDaemonRunExecutionEnvelopesResponse, ListDaemonRunReportsData, ListDaemonRunReportsResponse, ListDaemonRunsData, ListDaemonRunsResponse, ListDaemonsAssignmentsData, ListDaemonsAssignmentsResponse, ListDaemonsData, ListDaemonsEventCatalogData, ListDaemonsEventCatalogResponse, ListDaemonsResponse, ListDaemonTriggersData, ListDaemonTriggersResponse, ListDaemonWorkflowsData, ListDaemonWorkflowsResponse, ListDashboardsData, ListDashboardsResponse, ListDeadLetterEntriesData, ListDeadLetterEntriesResponse, ListDepartmentsData, ListDepartmentsResponse, ListDiscoveredStrategiesData, ListDiscoveredStrategiesResponse, ListDocumentsData, ListDocumentsResponse, ListDynamicFanOutPoliciesData, ListDynamicFanOutPoliciesResponse, ListEconomicEventsData, ListEconomicEventsResponse, ListEmployeeFindingsData, ListEmployeeFindingsResponse, ListEmployeePermissionGrantsData, ListEmployeePermissionGrantsResponse, ListEmployeeReflectionsData, ListEmployeeReflectionsResponse, ListEmployeeRunDecisionsData, ListEmployeeRunDecisionsResponse, ListEmployeeRunExecutionEnvelopesData, ListEmployeeRunExecutionEnvelopesResponse, ListEmployeeRunReportsData, ListEmployeeRunReportsResponse, ListEmployeeRunsData, ListEmployeeRunsResponse, ListEmployeesData, ListEmployeesResponse, ListEmployeeTriggersData, ListEmployeeTriggersResponse, ListEmployeeWorkflowsData, ListEmployeeWorkflowsResponse, ListEntityVersionsData, ListEntityVersionsResponse, ListEvaluationCasesData, ListEvaluationCasesResponse, ListEvaluationDatasetsData, ListEvaluationDatasetsResponse, ListEvaluationTemplatesData, ListEvaluationTemplatesResponse, ListExchangeCredentialsData, ListExchangeCredentialsResponse, ListExecutionAlgosData, ListExecutionAlgosResponse, ListExecutionDeploymentsData, ListExecutionDeploymentsResponse, ListFinanceConversationPersonasData, ListFinanceConversationPersonasResponse, ListFinanceDataBlockersData, ListFinanceDataBlockersResponse, ListFinanceIndicatorDecisionsData, ListFinanceIndicatorDecisionsResponse, ListFinanceIndicatorsData, ListFinanceIndicatorsResponse, ListFinanceModelLineageData, ListFinanceModelLineageResponse, ListFinancePlannerRecommendationsData, ListFinancePlannerRecommendationsResponse, ListFinanceProviderUnlockPromptsData, ListFinanceProviderUnlockPromptsResponse, ListFinanceResearchWorkflowsData, ListFinanceResearchWorkflowsResponse, ListFinanceStrategyCostModelsData, ListFinanceStrategyCostModelsResponse, ListFinanceStrategyDecisionsData, ListFinanceStrategyDecisionsResponse, ListFinanceStrategyLifecycleTransitionsData, ListFinanceStrategyLifecycleTransitionsResponse, ListFinanceStrategyRunRequestsData, ListFinanceStrategyRunRequestsResponse, ListFinanceStrategyRunsData, ListFinanceStrategyRunsResponse, ListFinanceStrategyTemplatesData, ListFinanceStrategyTemplatesResponse, ListForwardRunsData, ListForwardRunsResponse, ListHarvestedContentData, ListHarvestedContentResponse, ListHoldingsData, ListHoldingsResponse, ListImprovementProposalsData, ListImprovementProposalsResponse, ListIngestionJobsData, ListIngestionJobsResponse, ListIntelPlatformsData, ListIntelPlatformsResponse, ListIntelSourceFetchRunsData, ListIntelSourceFetchRunsResponse, ListIntelSourceItemInsightsData, ListIntelSourceItemInsightsResponse, ListIntelSourceMonitorFetchRunsData, ListIntelSourceMonitorFetchRunsResponse, ListIntelSourceMonitorsData, ListIntelSourceMonitorsResponse, ListIntelSourcesData, ListIntelSourcesResponse, ListIntelSourceSubscriptionsData, ListIntelSourceSubscriptionsResponse, ListInterventionsData, ListInterventionsResponse, ListJourneyEventsData, ListJourneyEventsResponse, ListJourneyRawEventsData, ListJourneyRawEventsResponse, ListJourneysData, ListJourneysResponse, ListLinkedAccountsData, ListLinkedAccountsResponse, ListLlmCallCostOutliersData, ListLlmCallCostOutliersResponse, ListLlmCallLatencyOutliersData, ListLlmCallLatencyOutliersResponse, ListLotDisposalsData, ListLotDisposalsResponse, ListMarketEventReactionsData, ListMarketEventReactionsResponse, ListMarketEventReactionTypesData, ListMarketEventReactionTypesResponse, ListMarketplaceInstallationsData, ListMarketplaceInstallationsResponse, ListMarketplaceListingsData, ListMarketplaceListingsResponse, ListMarketplaceNeedsSetupData, ListMarketplaceNeedsSetupResponse, ListMarketplaceUpdatesData, ListMarketplaceUpdatesResponse, ListMcpConnectionsData, ListMcpConnectionsResponse, ListMcpConnectionToolsData, ListMcpConnectionToolsResponse, ListMemoriesData, ListMemoriesResponse, ListModelRuntimePoliciesData, ListModelRuntimePoliciesResponse, ListModelsData, ListModelsResponse, ListMyModulesData, ListMyModulesResponse, ListOrdersData, ListOrdersResponse, ListOrganizationRuntimeFlagsData, ListOrganizationRuntimeFlagsResponse, ListOrganizationsData, ListOrganizationsResponse, ListOrgInvitationsData, ListOrgInvitationsResponse, ListOrgMembersData, ListOrgMembersResponse, ListOutputPartKindsData, ListOutputPartKindsResponse, ListPendingDecisionsData, ListPendingDecisionsResponse, ListPinnedWidgetsData, ListPinnedWidgetsResponse, ListPlatformRuntimeFlagsData, ListPlatformRuntimeFlagsResponse, ListPortfoliosData, ListPortfolioSnapshotsData, ListPortfolioSnapshotsResponse, ListPortfoliosResponse, ListPortTypesData, ListPortTypesResponse, ListPositionLotsData, ListPositionLotsResponse, ListPositionsData, ListPositionsResponse, ListPricesData, ListPricesResponse, ListProjectChangesData, ListProjectChangesResponse, ListProjectCodeCheckpointsData, ListProjectCodeCheckpointsResponse, ListProjectCodeRepositoryConnectionsData, ListProjectCodeRepositoryConnectionsResponse, ListProjectCodeWorkspaceOperationsData, ListProjectCodeWorkspaceOperationsResponse, ListProjectMembersData, ListProjectMembersResponse, ListProjectsData, ListProjectsResponse, ListProjectStateEventsData, ListProjectStateEventsResponse, ListProjectTeamMembersData, ListProjectTeamMembersResponse, ListProjectTeamsData, ListProjectTeamsResponse, ListProjectThreadsData, ListProjectThreadsResponse, ListProjectWorkModeTemplatesData, ListProjectWorkModeTemplatesResponse, ListProjectWorkstreamCodeReviewRequestsData, ListProjectWorkstreamCodeReviewRequestsResponse, ListPromotionCandidatesData, ListPromotionCandidatesResponse, ListPromptTemplatesData, ListPromptTemplatesResponse, ListReasoningEvaluationsData, ListReasoningEvaluationsResponse, ListRiskBreachesData, ListRiskBreachesResponse, ListRiskHaltsData, ListRiskHaltsResponse, ListRiskLimitsData, ListRiskLimitsResponse, ListRunsData, ListRunsResponse, ListRuntimePolicyOptionsData, ListRuntimePolicyOptionsResponse, ListRuntimePolicySurfaceRulesData, ListRuntimePolicySurfaceRulesResponse, ListShadowModeDaemonsData, ListShadowModeDaemonsResponse, ListSignalsData, ListSignalsResponse, ListSkillsData, ListSkillsResponse, ListSnapshotsData, ListSnapshotsError, ListSnapshotsResponse, ListSourcesData, ListSourcesResponse, ListStrategiesData, ListStrategiesResponse, ListStrategyAdapterResolutionsData, ListStrategyAdapterResolutionsResponse, ListStrategyBucketDefinitionsData, ListStrategyBucketDefinitionsResponse, ListStrategyBucketEvaluationsData, ListStrategyBucketEvaluationsResponse, ListStrategyDefinitionEvaluationsData, ListStrategyDefinitionEvaluationsResponse, ListStrategyDefinitionGroupsData, ListStrategyDefinitionGroupsResponse, ListStrategyDefinitionRunsData, ListStrategyDefinitionRunsResponse, ListStrategyDefinitionsData, ListStrategyDefinitionsResponse, ListStrategyDefinitionSummariesData, ListStrategyDefinitionSummariesResponse, ListStrategyExtensionDescriptorsData, ListStrategyExtensionDescriptorsResponse, ListStressResultsData, ListStressResultsResponse, ListStressScenariosData, ListStressScenariosResponse, ListSystemDatabaseStatementsData, ListSystemDatabaseStatementsError, ListSystemDatabaseStatementsResponse, ListTaskDecisionsData, ListTaskDecisionsResponse, ListTasksData, ListTasksResponse, ListTcaScorecardsData, ListTcaScorecardsResponse, ListTeamMembersData, ListTeamMembersResponse, ListTeamsData, ListTeamsResponse, ListTemplatesData, ListTemplatesResponse, ListToolLibrariesData, ListToolLibrariesResponse, ListToolLibraryToolsData, ListToolLibraryToolsResponse, ListToolsData, ListToolsResponse, ListTopSourcesData, ListTopSourcesResponse, ListTradesData, ListTradesResponse, ListVarBacktestsData, ListVarBacktestsResponse, ListVarComponentsData, ListVarComponentsResponse, ListVarEstimatesData, ListVarEstimatesResponse, ListWalletWatchesData, ListWalletWatchesResponse, ListWatchlistData, ListWatchlistResponse, ListWidgetsData, ListWidgetsResponse, ListWorkflowExecutionObservationsData, ListWorkflowExecutionObservationsResponse, ListWorkflowGatesData, ListWorkflowGatesResponse, ListWorkflowInstancesData, ListWorkflowInstancesResponse, ListWorkflowRunsData, ListWorkflowRunsResponse, ListWorkflowsData, ListWorkflowsResponse, ListWorkflowVersionsData, ListWorkflowVersionsResponse, ListWorkforceAssignmentsData, ListWorkforceAssignmentsResponse, ListWorkforceEventCatalogData, ListWorkforceEventCatalogResponse, ListWorkstreamDecisionsData, ListWorkstreamDecisionsResponse, ListWorkstreamMembersData, ListWorkstreamMembersResponse, ListWorkstreamsData, ListWorkstreamsResponse, LookupFinanceCommandOptionsData, LookupFinanceCommandOptionsResponse, MaterializeProjectChangeCodeData, MaterializeProjectChangeCodeResponse, ModifyDecisionData, ModifyDecisionResponse, OpenProjectChangeCodeReviewData, OpenProjectChangeCodeReviewResponse, OptimizePromptData, OptimizePromptResponse, PatchConversationSettingsData, PatchConversationSettingsResponse, PatchStrategyBucketDefinitionData, PatchStrategyBucketDefinitionResponse, PauseExecutionAlgoData, PauseExecutionAlgoResponse, PauseExecutionData, PauseExecutionResponse, PinDashboardData, PinDashboardResponse, PinWidgetData, PinWidgetError, PinWidgetResponse, PollAiWorkerCommandsData, PollAiWorkerCommandsResponse, PollAiWorkerControlCommandsData, PollAiWorkerControlCommandsResponse, PreflightTemplateUpgradeData, PreflightTemplateUpgradeError, PreflightTemplateUpgradeResponse, PresignUploadData, PresignUploadResponse, PreviewFinanceIndicatorImportData, PreviewFinanceIndicatorImportResponse, PreviewFinanceStrategyTemplateData, PreviewFinanceStrategyTemplateResponse, PreviewInvitationData, PreviewInvitationResponse, PreviewPromptData, PreviewPromptResponse, ProcessCatalogReviewQueueData, ProcessCatalogReviewQueueError, ProcessCatalogReviewQueueResponse, PromoteAgentTemplateVersionData, PromoteAgentTemplateVersionResponse, PromoteCatalogCandidateData, PromoteCatalogCandidateError, PromoteCatalogCandidateResponse, PromoteMemoryData, PromoteMemoryResponse, ProposeFinanceBucketReweightData, ProposeFinanceBucketReweightResponse, PublishAiWorkerEventsData, PublishAiWorkerEventsResponse, PublishEvaluationTemplateVersionData, PublishEvaluationTemplateVersionResponse, PublishMarketplaceListingData, PublishMarketplaceListingResponse, PurgeSnapshotsData, PurgeSnapshotsError, PurgeSnapshotsResponse, QueryAiWorkerDataData, QueryAiWorkerDataResponse, QueryOutputsData, QueryOutputsResponse, ReactivateProjectData, ReactivateProjectResponse, ReassignTaskData, ReassignTaskResponse, ReceiveTradingViewAlertData, ReceiveTradingViewAlertResponse, RecommendAgentTemplatesData, RecommendAgentTemplatesResponse, RecommendDaemonsData, RecommendDaemonsResponse, RecommendWorkflowDefinitionsData, RecommendWorkflowDefinitionsResponse, RecommendWorkforceData, RecommendWorkforceResponse, RecordIntelSourceConsentData, RecordIntelSourceConsentResponse, RefreshTokenData, RefreshTokenResponse, RegisterAiWorkerData, RegisterAiWorkerResponse, RejectCatalogCandidateData, RejectCatalogCandidateError, RejectCatalogCandidateResponse, RejectDaemonDecisionData, RejectDaemonDecisionResponse, RejectDecisionData, RejectDecisionResponse, RejectInterventionData, RejectInterventionError, RejectInterventionResponse, RejectPromotionCandidateData, RejectPromotionCandidateResponse, RejectRecommendationData, RejectRecommendationResponse, RejectTaskActionData, RejectTaskActionResponse, RejectWorkflowGateData, RejectWorkflowGateResponse, RemoveActiveStrategyData, RemoveActiveStrategyResponse, RemoveConversationMemberData, RemoveConversationMemberResponse, RemoveDaemonWorkflowData, RemoveDaemonWorkflowResponse, RemoveEmployeeWorkflowData, RemoveEmployeeWorkflowResponse, RemoveFromWatchlistData, RemoveFromWatchlistResponse, RemoveMarketplaceBundleEntityData, RemoveMarketplaceBundleEntityResponse, RemoveProjectMemberData, RemoveProjectMemberResponse, RemoveProjectTeamMemberData, RemoveProjectTeamMemberResponse, RemoveTeamMemberData, RemoveTeamMemberResponse, RemoveUserRoleData, RemoveUserRoleResponse, RemoveWidgetData, RemoveWidgetResponse, RemoveWorkflowStepData, RemoveWorkflowStepResponse, RemoveWorkstreamMemberData, RemoveWorkstreamMemberResponse, ReorderWidgetsData, ReorderWidgetsResponse, ReorderWorkflowStepsData, ReorderWorkflowStepsResponse, ReplaceProjectWorkModeTemplatesData, ReplaceProjectWorkModeTemplatesResponse, ReplayDeadLetterEntryData, ReplayDeadLetterEntryResponse, ReplyToConversationData, ReplyToConversationResponse, ResendInvitationData, ResendInvitationResponse, ResetAlertData, ResetAlertResponse, ResetDaemonGovernanceData, ResetDaemonGovernanceResponse, ResetEmployeeGovernanceData, ResetEmployeeGovernanceResponse, ResetPasswordData, ResetPasswordResponse, ResetUserPasswordData, ResetUserPasswordResponse, ResolveActionQueueItemData, ResolveActionQueueItemResponse, ResolveDynamicFanOutPolicyData, ResolveDynamicFanOutPolicyResponse, ResolveInterventionData, ResolveInterventionError, ResolveInterventionResponse, ResolveModelRuntimePolicyData, ResolveModelRuntimePolicyResponse, ResolveRiskBreachData, ResolveRiskBreachResponse, ResolveStrategyAdaptersData, ResolveStrategyAdaptersResponse, RestoreCatalogItemVersionData, RestoreCatalogItemVersionError, RestoreCatalogItemVersionResponse, RestoreWorkflowData, RestoreWorkflowResponse, RestoreWorkflowVersionData, RestoreWorkflowVersionResponse, ResumeAllDaemonsData, ResumeAllDaemonsResponse, ResumeAllEmployeesData, ResumeAllEmployeesResponse, ResumeExecutionAlgoData, ResumeExecutionAlgoResponse, ResumeExecutionData, ResumeExecutionResponse, ResumeRiskHaltData, ResumeRiskHaltResponse, RetryCatalogCandidateReviewData, RetryCatalogCandidateReviewError, RetryCatalogCandidateReviewResponse, RetryCatalogReviewQueueData, RetryCatalogReviewQueueError, RetryCatalogReviewQueueItemData, RetryCatalogReviewQueueItemError, RetryCatalogReviewQueueItemResponse, RetryCatalogReviewQueueResponse, RetryTaskData, RetryTaskResponse, RevertCatalogVersionAdoptionData, RevertCatalogVersionAdoptionError, RevertCatalogVersionAdoptionResponse, ReviewDaemonsFindingData, ReviewDaemonsFindingResponse, ReviewIntelSourceApprovalData, ReviewIntelSourceApprovalResponse, ReviewWorkforceFindingData, ReviewWorkforceFindingResponse, RevokeApiKeyData, RevokeApiKeyResponse, RevokeApproverDelegationData, RevokeApproverDelegationResponse, RevokeDaemonPermissionGrantData, RevokeDaemonPermissionGrantResponse, RevokeEmployeePermissionGrantData, RevokeEmployeePermissionGrantResponse, RevokeInvitationData, RevokeInvitationResponse, RollbackAgentTemplateVersionData, RollbackAgentTemplateVersionResponse, RollbackProjectCodeCheckpointData, RollbackProjectCodeCheckpointResponse, RotateApiKeyData, RotateApiKeyResponse, RotateTradingViewTokenData, RotateTradingViewTokenResponse, RouteInterventionData, RouteInterventionError, RouteInterventionResponse, RunAgentWorkflowRunActionData, RunAgentWorkflowRunActionResponse, RunAiWorkerDatasetData, RunAiWorkerDatasetResponse, RunAnalysisAgentsData, RunAnalysisAgentsResponse, RunBacktestData, RunBacktestResponse, RunDaemonData, RunDaemonResponse, RunEmployeeData, RunEmployeeResponse, RunEvaluationDatasetData, RunEvaluationDatasetResponse, RunIngestionJobData, RunIngestionJobResponse, RunStrategyDiscoveryWorkflowData, RunStrategyDiscoveryWorkflowResponse, SaveDebugStepOutputData, SaveDebugStepOutputResponse, SaveWorkflowDefinitionGraphData, SaveWorkflowDefinitionGraphResponse, SearchAgentTemplatesData, SearchAgentTemplatesResponse, SearchArtifactsData, SearchArtifactsResponse, SearchDaemonsData, SearchDaemonsResponse, SearchFinanceKgData, SearchFinanceKgResponse, SearchMemoriesData, SearchMemoriesResponse, SearchWorkflowDefinitionsData, SearchWorkflowDefinitionsResponse, SearchWorkforceData, SearchWorkforceResponse, SendNotificationData, SendNotificationResponse, SetAgentEnabledData, SetAgentEnabledResponse, SetAlertEnabledData, SetAlertEnabledResponse, SetConversationLeadData, SetConversationLeadResponse, SetConversationRuntimePolicyData, SetConversationRuntimePolicyResponse, SetConversationTypingData, SetConversationTypingResponse, SetDaemonRuntimePolicyData, SetDaemonRuntimePolicyResponse, SetDecisionRuntimePolicyData, SetDecisionRuntimePolicyResponse, SetEmployeeRuntimePolicyData, SetEmployeeRuntimePolicyResponse, SetOrganizationRuntimeFlagData, SetOrganizationRuntimeFlagResponse, SetOrganizationRuntimePolicySurfaceRuleData, SetOrganizationRuntimePolicySurfaceRuleResponse, SetPlatformRuntimeFlagData, SetPlatformRuntimeFlagResponse, SetSystemRuntimePolicySurfaceRuleData, SetSystemRuntimePolicySurfaceRuleResponse, SetTemplateAutoUpgradeData, SetTemplateAutoUpgradeResponse, SetTemplateStatusData, SetTemplateStatusResponse, SetToolStatusData, SetToolStatusResponse, SetWorkflowRuntimePolicyData, SetWorkflowRuntimePolicyResponse, SetWorkflowScheduleData, SetWorkflowScheduleResponse, SoftDeleteProjectData, SoftDeleteProjectResponse, SpawnAgentData, SpawnAgentResponse, StartConversationFromMessageData, StartConversationFromMessageResponse, StartFinanceResearchWorkflowRunData, StartFinanceResearchWorkflowRunResponse, StartMarketDataData, StartStrategyData, StartStrategyResponse, StartTaskData, StartTaskResponse, StopExecutionData, StopExecutionResponse, StopMarketDataData, StopStrategyData, StopStrategyResponse, SubmitCapitalAllocationData, SubmitCapitalAllocationResponse, SubmitConversationInteractionData, SubmitConversationInteractionResponse, SuggestConnectionsData, SuggestConnectionsResponse, SwitchAccountData, SwitchAccountResponse, SyncToolLibraryData, SyncToolLibraryResponse, TerminateAgentData, TerminateAgentResponse, TerminateAllDaemonsData, TerminateAllDaemonsResponse, TerminateAllEmployeesData, TerminateAllEmployeesResponse, TestAgentTemplateVersionData, TestAgentTemplateVersionResponse, TestIntelPlatformData, TestIntelPlatformResponse, TestMcpConnectionData, TestMcpConnectionResponse, TestNotificationData, TestNotificationResponse, TestTradingViewWebhookData, TestTradingViewWebhookResponse, TransferTaskTeamData, TransferTaskTeamResponse, TransitionBlockerData, TransitionBlockerResponse, TransitionHandoffData, TransitionHandoffResponse, TranspileFinanceIndicatorImportData, TranspileFinanceIndicatorImportResponse, TriggerAgentWorkflowData, TriggerAgentWorkflowResponse, TriggerWorkflowData, TriggerWorkflowInstanceData, TriggerWorkflowInstanceResponse, TriggerWorkflowResponse, UnbindMarketplaceEntityConnectionData, UnbindMarketplaceEntityConnectionResponse, UndeployStrategyData, UndeployStrategyResponse, UnlinkAccountData, UnlinkAccountResponse, UnpinDashboardData, UnpinDashboardResponse, UnpinWidgetData, UnpinWidgetResponse, UpdateAdminUserData, UpdateAdminUserResponse, UpdateAlertRuleData, UpdateAlertRuleResponse, UpdateAnalysisTemplateData, UpdateAnalysisTemplateResponse, UpdateApiKeyData, UpdateApiKeyResponse, UpdateArtifactData, UpdateArtifactResponse, UpdateBrokerCredentialData, UpdateBrokerCredentialResponse, UpdateConversationData, UpdateConversationResponse, UpdateDaemonData, UpdateDaemonResponse, UpdateDaemonTriggerData, UpdateDaemonTriggerResponse, UpdateDashboardData, UpdateDashboardResponse, UpdateDiscoveredStrategyStatusData, UpdateDiscoveredStrategyStatusResponse, UpdateDynamicFanOutPolicyData, UpdateDynamicFanOutPolicyResponse, UpdateEmployeeData, UpdateEmployeeResponse, UpdateEmployeeTriggerData, UpdateEmployeeTriggerResponse, UpdateEvaluationTemplateData, UpdateEvaluationTemplateResponse, UpdateHoldingData, UpdateHoldingResponse, UpdateIntelPlatformData, UpdateIntelPlatformResponse, UpdateIntelSourceData, UpdateIntelSourceError, UpdateIntelSourceMonitorData, UpdateIntelSourceMonitorResponse, UpdateIntelSourceResponse, UpdateIntelSourceSubscriptionData, UpdateIntelSourceSubscriptionResponse, UpdateMarketplaceEntityData, UpdateMarketplaceEntityResponse, UpdateMcpConnectionData, UpdateMcpConnectionResponse, UpdateMeData, UpdateMemoryData, UpdateMemoryResponse, UpdateMeResponse, UpdateModelRuntimePolicyData, UpdateModelRuntimePolicyResponse, UpdateNotificationConfigData, UpdateNotificationConfigResponse, UpdateOrganizationData, UpdateOrganizationResponse, UpdatePinnedWidgetData, UpdatePinnedWidgetResponse, UpdatePortfolioData, UpdatePortfolioResponse, UpdateProjectChangeData, UpdateProjectChangeResponse, UpdateProjectData, UpdateProjectMemberRoleData, UpdateProjectMemberRoleResponse, UpdateProjectResponse, UpdateProjectTeamData, UpdateProjectTeamMemberData, UpdateProjectTeamMemberResponse, UpdateProjectTeamResponse, UpdateProjectThreadData, UpdateProjectThreadResponse, UpdateRiskLimitData, UpdateRiskLimitResponse, UpdateShadowModeDaemonEnrollmentData, UpdateShadowModeDaemonEnrollmentResponse, UpdateSnapshotData, UpdateSnapshotError, UpdateSnapshotResponse, UpdateStrategyParametersData, UpdateStrategyParametersResponse, UpdateTaskData, UpdateTaskResponse, UpdateToolLibraryData, UpdateToolLibraryResponse, UpdateWidgetData, UpdateWidgetResponse, UpdateWorkflowData, UpdateWorkflowInstanceData, UpdateWorkflowInstanceResponse, UpdateWorkflowResponse, UpdateWorkflowStepData, UpdateWorkflowStepResponse, UpdateWorkstreamData, UpdateWorkstreamResponse, UpgradeCatalogVersionAdoptionData, UpgradeCatalogVersionAdoptionError, UpgradeCatalogVersionAdoptionResponse, UploadDocumentData, UploadDocumentResponse, UpsertFinanceDataBlockerData, UpsertFinanceDataBlockerResponse, UpsertStrategyBucketDefinitionData, UpsertStrategyBucketDefinitionResponse, UpsertStrategyDefinitionData, UpsertStrategyDefinitionResponse, UpsertStrategyExtensionDescriptorData, UpsertStrategyExtensionDescriptorResponse, ValidateStepData, ValidateStepResponse, ValidateStrategyBucketDefinitionData, ValidateStrategyBucketDefinitionResponse, ValidateStrategyDefinitionData, ValidateStrategyDefinitionResponse, ValidateStrategyExtensionDescriptorData, ValidateStrategyExtensionDescriptorResponse, ValidateWorkflowData, ValidateWorkflowResponse, VerifyBrokerCredentialData, VerifyBrokerCredentialResponse, VerifyEmailData, VerifyEmailResponse, VerifyFinanceAuditLedgerChainData, VerifyFinanceAuditLedgerChainResponse, VerifyUserData, VerifyUserResponse, ViewProjectWorkstreamCodePreviewSessionData, ViewProjectWorkstreamCodePreviewSessionError, ViewProjectWorkstreamCodePreviewSessionResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getSystemHealthQueryKey = (options?: Options<GetSystemHealthData>) => createQueryKey('getSystemHealth', options);

/**
 * System health (readiness: database and Redis)
 */
export const getSystemHealthOptions = (options?: Options<GetSystemHealthData>) => queryOptions<GetSystemHealthResponse, GetSystemHealthError, GetSystemHealthResponse, ReturnType<typeof getSystemHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemHealthQueryKey(options)
});

export const createSignupMutation = (options?: Partial<Options<CreateSignupData>>): UseMutationOptions<CreateSignupResponse, DefaultError, Options<CreateSignupData>> => {
    const mutationOptions: UseMutationOptions<CreateSignupResponse, DefaultError, Options<CreateSignupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSignup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createLoginMutation = (options?: Partial<Options<CreateLoginData>>): UseMutationOptions<CreateLoginResponse, DefaultError, Options<CreateLoginData>> => {
    const mutationOptions: UseMutationOptions<CreateLoginResponse, DefaultError, Options<CreateLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, DefaultError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const updateMeMutation = (options?: Partial<Options<UpdateMeData>>): UseMutationOptions<UpdateMeResponse, DefaultError, Options<UpdateMeData>> => {
    const mutationOptions: UseMutationOptions<UpdateMeResponse, DefaultError, Options<UpdateMeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createLogoutMutation = (options?: Partial<Options<CreateLogoutData>>): UseMutationOptions<CreateLogoutResponse, DefaultError, Options<CreateLogoutData>> => {
    const mutationOptions: UseMutationOptions<CreateLogoutResponse, DefaultError, Options<CreateLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const refreshTokenMutation = (options?: Partial<Options<RefreshTokenData>>): UseMutationOptions<RefreshTokenResponse, DefaultError, Options<RefreshTokenData>> => {
    const mutationOptions: UseMutationOptions<RefreshTokenResponse, DefaultError, Options<RefreshTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const verifyEmailMutation = (options?: Partial<Options<VerifyEmailData>>): UseMutationOptions<VerifyEmailResponse, DefaultError, Options<VerifyEmailData>> => {
    const mutationOptions: UseMutationOptions<VerifyEmailResponse, DefaultError, Options<VerifyEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resetPasswordMutation = (options?: Partial<Options<ResetPasswordData>>): UseMutationOptions<ResetPasswordResponse, DefaultError, Options<ResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<ResetPasswordResponse, DefaultError, Options<ResetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const unlinkAccountMutation = (options?: Partial<Options<UnlinkAccountData>>): UseMutationOptions<UnlinkAccountResponse, DefaultError, Options<UnlinkAccountData>> => {
    const mutationOptions: UseMutationOptions<UnlinkAccountResponse, DefaultError, Options<UnlinkAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unlinkAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listLinkedAccountsQueryKey = (options?: Options<ListLinkedAccountsData>) => createQueryKey('listLinkedAccounts', options);

export const listLinkedAccountsOptions = (options?: Options<ListLinkedAccountsData>) => queryOptions<ListLinkedAccountsResponse, DefaultError, ListLinkedAccountsResponse, ReturnType<typeof listLinkedAccountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listLinkedAccounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listLinkedAccountsQueryKey(options)
});

export const linkAccountMutation = (options?: Partial<Options<LinkAccountData>>): UseMutationOptions<LinkAccountResponse, DefaultError, Options<LinkAccountData>> => {
    const mutationOptions: UseMutationOptions<LinkAccountResponse, DefaultError, Options<LinkAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await linkAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const switchAccountMutation = (options?: Partial<Options<SwitchAccountData>>): UseMutationOptions<SwitchAccountResponse, DefaultError, Options<SwitchAccountData>> => {
    const mutationOptions: UseMutationOptions<SwitchAccountResponse, DefaultError, Options<SwitchAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await switchAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const previewInvitationQueryKey = (options: Options<PreviewInvitationData>) => createQueryKey('previewInvitation', options);

export const previewInvitationOptions = (options: Options<PreviewInvitationData>) => queryOptions<PreviewInvitationResponse, DefaultError, PreviewInvitationResponse, ReturnType<typeof previewInvitationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await previewInvitation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: previewInvitationQueryKey(options)
});

export const acceptInvitationMutation = (options?: Partial<Options<AcceptInvitationData>>): UseMutationOptions<AcceptInvitationResponse, DefaultError, Options<AcceptInvitationData>> => {
    const mutationOptions: UseMutationOptions<AcceptInvitationResponse, DefaultError, Options<AcceptInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resendInvitationMutation = (options?: Partial<Options<ResendInvitationData>>): UseMutationOptions<ResendInvitationResponse, DefaultError, Options<ResendInvitationData>> => {
    const mutationOptions: UseMutationOptions<ResendInvitationResponse, DefaultError, Options<ResendInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resendInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const revokeInvitationMutation = (options?: Partial<Options<RevokeInvitationData>>): UseMutationOptions<RevokeInvitationResponse, DefaultError, Options<RevokeInvitationData>> => {
    const mutationOptions: UseMutationOptions<RevokeInvitationResponse, DefaultError, Options<RevokeInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAdminUsersQueryKey = (options?: Options<ListAdminUsersData>) => createQueryKey('listAdminUsers', options);

export const listAdminUsersOptions = (options?: Options<ListAdminUsersData>) => queryOptions<ListAdminUsersResponse, DefaultError, ListAdminUsersResponse, ReturnType<typeof listAdminUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAdminUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAdminUsersQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listAdminUsersInfiniteQueryKey = (options?: Options<ListAdminUsersData>): QueryKey<Options<ListAdminUsersData>> => createQueryKey('listAdminUsers', options, true);

export const listAdminUsersInfiniteOptions = (options?: Options<ListAdminUsersData>) => {
    const opts = infiniteQueryOptions<ListAdminUsersResponse, DefaultError, InfiniteData<ListAdminUsersResponse>, QueryKey<Options<ListAdminUsersData>>, number | null | Pick<QueryKey<Options<ListAdminUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAdminUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAdminUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAdminUsersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const bulkUpdateUserStatusMutation = (options?: Partial<Options<BulkUpdateUserStatusData>>): UseMutationOptions<BulkUpdateUserStatusResponse, DefaultError, Options<BulkUpdateUserStatusData>> => {
    const mutationOptions: UseMutationOptions<BulkUpdateUserStatusResponse, DefaultError, Options<BulkUpdateUserStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkUpdateUserStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAdminUserQueryKey = (options: Options<GetAdminUserData>) => createQueryKey('getAdminUser', options);

export const getAdminUserOptions = (options: Options<GetAdminUserData>) => queryOptions<GetAdminUserResponse, DefaultError, GetAdminUserResponse, ReturnType<typeof getAdminUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAdminUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminUserQueryKey(options)
});

export const updateAdminUserMutation = (options?: Partial<Options<UpdateAdminUserData>>): UseMutationOptions<UpdateAdminUserResponse, DefaultError, Options<UpdateAdminUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateAdminUserResponse, DefaultError, Options<UpdateAdminUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAdminUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resetUserPasswordMutation = (options?: Partial<Options<ResetUserPasswordData>>): UseMutationOptions<ResetUserPasswordResponse, DefaultError, Options<ResetUserPasswordData>> => {
    const mutationOptions: UseMutationOptions<ResetUserPasswordResponse, DefaultError, Options<ResetUserPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetUserPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const verifyUserMutation = (options?: Partial<Options<VerifyUserData>>): UseMutationOptions<VerifyUserResponse, DefaultError, Options<VerifyUserData>> => {
    const mutationOptions: UseMutationOptions<VerifyUserResponse, DefaultError, Options<VerifyUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assignUserRoleMutation = (options?: Partial<Options<AssignUserRoleData>>): UseMutationOptions<AssignUserRoleResponse, DefaultError, Options<AssignUserRoleData>> => {
    const mutationOptions: UseMutationOptions<AssignUserRoleResponse, DefaultError, Options<AssignUserRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignUserRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeUserRoleMutation = (options?: Partial<Options<RemoveUserRoleData>>): UseMutationOptions<RemoveUserRoleResponse, DefaultError, Options<RemoveUserRoleData>> => {
    const mutationOptions: UseMutationOptions<RemoveUserRoleResponse, DefaultError, Options<RemoveUserRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeUserRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserAuditLogQueryKey = (options: Options<GetUserAuditLogData>) => createQueryKey('getUserAuditLog', options);

export const getUserAuditLogOptions = (options: Options<GetUserAuditLogData>) => queryOptions<GetUserAuditLogResponse, DefaultError, GetUserAuditLogResponse, ReturnType<typeof getUserAuditLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserAuditLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserAuditLogQueryKey(options)
});

export const getUserAuditLogInfiniteQueryKey = (options: Options<GetUserAuditLogData>): QueryKey<Options<GetUserAuditLogData>> => createQueryKey('getUserAuditLog', options, true);

export const getUserAuditLogInfiniteOptions = (options: Options<GetUserAuditLogData>) => {
    const opts = infiniteQueryOptions<GetUserAuditLogResponse, DefaultError, InfiniteData<GetUserAuditLogResponse>, QueryKey<Options<GetUserAuditLogData>>, number | null | Pick<QueryKey<Options<GetUserAuditLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetUserAuditLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getUserAuditLog({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserAuditLogInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listExchangeCredentialsQueryKey = (options?: Options<ListExchangeCredentialsData>) => createQueryKey('listExchangeCredentials', options);

export const listExchangeCredentialsOptions = (options?: Options<ListExchangeCredentialsData>) => queryOptions<ListExchangeCredentialsResponse, DefaultError, ListExchangeCredentialsResponse, ReturnType<typeof listExchangeCredentialsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExchangeCredentials({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExchangeCredentialsQueryKey(options)
});

export const createExchangeCredentialMutation = (options?: Partial<Options<CreateExchangeCredentialData>>): UseMutationOptions<CreateExchangeCredentialResponse, DefaultError, Options<CreateExchangeCredentialData>> => {
    const mutationOptions: UseMutationOptions<CreateExchangeCredentialResponse, DefaultError, Options<CreateExchangeCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExchangeCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteExchangeCredentialMutation = (options?: Partial<Options<DeleteExchangeCredentialData>>): UseMutationOptions<DeleteExchangeCredentialResponse, DefaultError, Options<DeleteExchangeCredentialData>> => {
    const mutationOptions: UseMutationOptions<DeleteExchangeCredentialResponse, DefaultError, Options<DeleteExchangeCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteExchangeCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNotificationConfigQueryKey = (options?: Options<GetNotificationConfigData>) => createQueryKey('getNotificationConfig', options);

export const getNotificationConfigOptions = (options?: Options<GetNotificationConfigData>) => queryOptions<GetNotificationConfigResponse, DefaultError, GetNotificationConfigResponse, ReturnType<typeof getNotificationConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNotificationConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNotificationConfigQueryKey(options)
});

export const updateNotificationConfigMutation = (options?: Partial<Options<UpdateNotificationConfigData>>): UseMutationOptions<UpdateNotificationConfigResponse, DefaultError, Options<UpdateNotificationConfigData>> => {
    const mutationOptions: UseMutationOptions<UpdateNotificationConfigResponse, DefaultError, Options<UpdateNotificationConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateNotificationConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sendNotificationMutation = (options?: Partial<Options<SendNotificationData>>): UseMutationOptions<SendNotificationResponse, DefaultError, Options<SendNotificationData>> => {
    const mutationOptions: UseMutationOptions<SendNotificationResponse, DefaultError, Options<SendNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const testNotificationMutation = (options?: Partial<Options<TestNotificationData>>): UseMutationOptions<TestNotificationResponse, DefaultError, Options<TestNotificationData>> => {
    const mutationOptions: UseMutationOptions<TestNotificationResponse, DefaultError, Options<TestNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listActiveAgentsQueryKey = (options?: Options<ListActiveAgentsData>) => createQueryKey('listActiveAgents', options);

export const listActiveAgentsOptions = (options?: Options<ListActiveAgentsData>) => queryOptions<ListActiveAgentsResponse, DefaultError, ListActiveAgentsResponse, ReturnType<typeof listActiveAgentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActiveAgents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActiveAgentsQueryKey(options)
});

export const spawnAgentMutation = (options?: Partial<Options<SpawnAgentData>>): UseMutationOptions<SpawnAgentResponse, DefaultError, Options<SpawnAgentData>> => {
    const mutationOptions: UseMutationOptions<SpawnAgentResponse, DefaultError, Options<SpawnAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await spawnAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const terminateAgentMutation = (options?: Partial<Options<TerminateAgentData>>): UseMutationOptions<TerminateAgentResponse, DefaultError, Options<TerminateAgentData>> => {
    const mutationOptions: UseMutationOptions<TerminateAgentResponse, DefaultError, Options<TerminateAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await terminateAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const executeAgentMutation = (options?: Partial<Options<ExecuteAgentData>>): UseMutationOptions<ExecuteAgentResponse, DefaultError, Options<ExecuteAgentData>> => {
    const mutationOptions: UseMutationOptions<ExecuteAgentResponse, DefaultError, Options<ExecuteAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAgentHealthQueryKey = (options?: Options<GetAgentHealthData>) => createQueryKey('getAgentHealth', options);

export const getAgentHealthOptions = (options?: Options<GetAgentHealthData>) => queryOptions<GetAgentHealthResponse, DefaultError, GetAgentHealthResponse, ReturnType<typeof getAgentHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAgentHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAgentHealthQueryKey(options)
});

export const listPendingDecisionsQueryKey = (options?: Options<ListPendingDecisionsData>) => createQueryKey('listPendingDecisions', options);

export const listPendingDecisionsOptions = (options?: Options<ListPendingDecisionsData>) => queryOptions<ListPendingDecisionsResponse, DefaultError, ListPendingDecisionsResponse, ReturnType<typeof listPendingDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPendingDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPendingDecisionsQueryKey(options)
});

export const getDecisionStatsQueryKey = (options?: Options<GetDecisionStatsData>) => createQueryKey('getDecisionStats', options);

export const getDecisionStatsOptions = (options?: Options<GetDecisionStatsData>) => queryOptions<GetDecisionStatsResponse, DefaultError, GetDecisionStatsResponse, ReturnType<typeof getDecisionStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDecisionStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDecisionStatsQueryKey(options)
});

export const getDecisionQueryKey = (options: Options<GetDecisionData>) => createQueryKey('getDecision', options);

export const getDecisionOptions = (options: Options<GetDecisionData>) => queryOptions<GetDecisionResponse, DefaultError, GetDecisionResponse, ReturnType<typeof getDecisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDecision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDecisionQueryKey(options)
});

export const approveDecisionMutation = (options?: Partial<Options<ApproveDecisionData>>): UseMutationOptions<ApproveDecisionResponse, DefaultError, Options<ApproveDecisionData>> => {
    const mutationOptions: UseMutationOptions<ApproveDecisionResponse, DefaultError, Options<ApproveDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approveDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectDecisionMutation = (options?: Partial<Options<RejectDecisionData>>): UseMutationOptions<RejectDecisionResponse, DefaultError, Options<RejectDecisionData>> => {
    const mutationOptions: UseMutationOptions<RejectDecisionResponse, DefaultError, Options<RejectDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const modifyDecisionMutation = (options?: Partial<Options<ModifyDecisionData>>): UseMutationOptions<ModifyDecisionResponse, DefaultError, Options<ModifyDecisionData>> => {
    const mutationOptions: UseMutationOptions<ModifyDecisionResponse, DefaultError, Options<ModifyDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await modifyDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecentMessagesQueryKey = (options?: Options<GetRecentMessagesData>) => createQueryKey('getRecentMessages', options);

export const getRecentMessagesOptions = (options?: Options<GetRecentMessagesData>) => queryOptions<GetRecentMessagesResponse, DefaultError, GetRecentMessagesResponse, ReturnType<typeof getRecentMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentMessagesQueryKey(options)
});

export const previewPromptMutation = (options?: Partial<Options<PreviewPromptData>>): UseMutationOptions<PreviewPromptResponse, DefaultError, Options<PreviewPromptData>> => {
    const mutationOptions: UseMutationOptions<PreviewPromptResponse, DefaultError, Options<PreviewPromptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewPrompt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const executeStepMutation = (options?: Partial<Options<ExecuteStepData>>): UseMutationOptions<ExecuteStepResponse, DefaultError, Options<ExecuteStepData>> => {
    const mutationOptions: UseMutationOptions<ExecuteStepResponse, DefaultError, Options<ExecuteStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getActiveRunQueryKey = (options?: Options<GetActiveRunData>) => createQueryKey('getActiveRun', options);

export const getActiveRunOptions = (options?: Options<GetActiveRunData>) => queryOptions<GetActiveRunResponse, DefaultError, GetActiveRunResponse, ReturnType<typeof getActiveRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActiveRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActiveRunQueryKey(options)
});

export const listRunsQueryKey = (options?: Options<ListRunsData>) => createQueryKey('listRuns', options);

export const listRunsOptions = (options?: Options<ListRunsData>) => queryOptions<ListRunsResponse, DefaultError, ListRunsResponse, ReturnType<typeof listRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRunsQueryKey(options)
});

export const stopExecutionMutation = (options?: Partial<Options<StopExecutionData>>): UseMutationOptions<StopExecutionResponse, DefaultError, Options<StopExecutionData>> => {
    const mutationOptions: UseMutationOptions<StopExecutionResponse, DefaultError, Options<StopExecutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopExecution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pauseExecutionMutation = (options?: Partial<Options<PauseExecutionData>>): UseMutationOptions<PauseExecutionResponse, DefaultError, Options<PauseExecutionData>> => {
    const mutationOptions: UseMutationOptions<PauseExecutionResponse, DefaultError, Options<PauseExecutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pauseExecution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resumeExecutionMutation = (options?: Partial<Options<ResumeExecutionData>>): UseMutationOptions<ResumeExecutionResponse, DefaultError, Options<ResumeExecutionData>> => {
    const mutationOptions: UseMutationOptions<ResumeExecutionResponse, DefaultError, Options<ResumeExecutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resumeExecution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutionStatusQueryKey = (options?: Options<GetExecutionStatusData>) => createQueryKey('getExecutionStatus', options);

export const getExecutionStatusOptions = (options?: Options<GetExecutionStatusData>) => queryOptions<GetExecutionStatusResponse, DefaultError, GetExecutionStatusResponse, ReturnType<typeof getExecutionStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutionStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutionStatusQueryKey(options)
});

export const saveDebugStepOutputMutation = (options?: Partial<Options<SaveDebugStepOutputData>>): UseMutationOptions<SaveDebugStepOutputResponse, DefaultError, Options<SaveDebugStepOutputData>> => {
    const mutationOptions: UseMutationOptions<SaveDebugStepOutputResponse, DefaultError, Options<SaveDebugStepOutputData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveDebugStepOutput({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDebugStepOutputsQueryKey = (options: Options<GetDebugStepOutputsData>) => createQueryKey('getDebugStepOutputs', options);

export const getDebugStepOutputsOptions = (options: Options<GetDebugStepOutputsData>) => queryOptions<GetDebugStepOutputsResponse, DefaultError, GetDebugStepOutputsResponse, ReturnType<typeof getDebugStepOutputsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDebugStepOutputs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDebugStepOutputsQueryKey(options)
});

export const getStepBuilderContextQueryKey = (options?: Options<GetStepBuilderContextData>) => createQueryKey('getStepBuilderContext', options);

export const getStepBuilderContextOptions = (options?: Options<GetStepBuilderContextData>) => queryOptions<GetStepBuilderContextResponse, DefaultError, GetStepBuilderContextResponse, ReturnType<typeof getStepBuilderContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStepBuilderContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStepBuilderContextQueryKey(options)
});

export const validateStepMutation = (options?: Partial<Options<ValidateStepData>>): UseMutationOptions<ValidateStepResponse, DefaultError, Options<ValidateStepData>> => {
    const mutationOptions: UseMutationOptions<ValidateStepResponse, DefaultError, Options<ValidateStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const suggestConnectionsMutation = (options?: Partial<Options<SuggestConnectionsData>>): UseMutationOptions<SuggestConnectionsResponse, DefaultError, Options<SuggestConnectionsData>> => {
    const mutationOptions: UseMutationOptions<SuggestConnectionsResponse, DefaultError, Options<SuggestConnectionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await suggestConnections({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const optimizePromptMutation = (options?: Partial<Options<OptimizePromptData>>): UseMutationOptions<OptimizePromptResponse, DefaultError, Options<OptimizePromptData>> => {
    const mutationOptions: UseMutationOptions<OptimizePromptResponse, DefaultError, Options<OptimizePromptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await optimizePrompt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPromptTemplatesQueryKey = (options?: Options<ListPromptTemplatesData>) => createQueryKey('listPromptTemplates', options);

export const listPromptTemplatesOptions = (options?: Options<ListPromptTemplatesData>) => queryOptions<ListPromptTemplatesResponse, DefaultError, ListPromptTemplatesResponse, ReturnType<typeof listPromptTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPromptTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPromptTemplatesQueryKey(options)
});

export const fillTemplateMutation = (options?: Partial<Options<FillTemplateData>>): UseMutationOptions<FillTemplateResponse, DefaultError, Options<FillTemplateData>> => {
    const mutationOptions: UseMutationOptions<FillTemplateResponse, DefaultError, Options<FillTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fillTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getToolGapsQueryKey = (options?: Options<GetToolGapsData>) => createQueryKey('getToolGaps', options);

export const getToolGapsOptions = (options?: Options<GetToolGapsData>) => queryOptions<GetToolGapsResponse, DefaultError, GetToolGapsResponse, ReturnType<typeof getToolGapsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getToolGaps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getToolGapsQueryKey(options)
});

export const searchAgentTemplatesQueryKey = (options: Options<SearchAgentTemplatesData>) => createQueryKey('searchAgentTemplates', options);

export const searchAgentTemplatesOptions = (options: Options<SearchAgentTemplatesData>) => queryOptions<SearchAgentTemplatesResponse, DefaultError, SearchAgentTemplatesResponse, ReturnType<typeof searchAgentTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchAgentTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchAgentTemplatesQueryKey(options)
});

export const recommendAgentTemplatesQueryKey = (options: Options<RecommendAgentTemplatesData>) => createQueryKey('recommendAgentTemplates', options);

export const recommendAgentTemplatesOptions = (options: Options<RecommendAgentTemplatesData>) => queryOptions<RecommendAgentTemplatesResponse, DefaultError, RecommendAgentTemplatesResponse, ReturnType<typeof recommendAgentTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await recommendAgentTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: recommendAgentTemplatesQueryKey(options)
});

export const listAgentTemplateVersionsQueryKey = (options: Options<ListAgentTemplateVersionsData>) => createQueryKey('listAgentTemplateVersions', options);

export const listAgentTemplateVersionsOptions = (options: Options<ListAgentTemplateVersionsData>) => queryOptions<ListAgentTemplateVersionsResponse, DefaultError, ListAgentTemplateVersionsResponse, ReturnType<typeof listAgentTemplateVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentTemplateVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentTemplateVersionsQueryKey(options)
});

export const createAgentTemplateVersionMutation = (options?: Partial<Options<CreateAgentTemplateVersionData>>): UseMutationOptions<CreateAgentTemplateVersionResponse, DefaultError, Options<CreateAgentTemplateVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateAgentTemplateVersionResponse, DefaultError, Options<CreateAgentTemplateVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAgentTemplateVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promoteAgentTemplateVersionMutation = (options?: Partial<Options<PromoteAgentTemplateVersionData>>): UseMutationOptions<PromoteAgentTemplateVersionResponse, DefaultError, Options<PromoteAgentTemplateVersionData>> => {
    const mutationOptions: UseMutationOptions<PromoteAgentTemplateVersionResponse, DefaultError, Options<PromoteAgentTemplateVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promoteAgentTemplateVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rollbackAgentTemplateVersionMutation = (options?: Partial<Options<RollbackAgentTemplateVersionData>>): UseMutationOptions<RollbackAgentTemplateVersionResponse, DefaultError, Options<RollbackAgentTemplateVersionData>> => {
    const mutationOptions: UseMutationOptions<RollbackAgentTemplateVersionResponse, DefaultError, Options<RollbackAgentTemplateVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rollbackAgentTemplateVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const diffAgentTemplateVersionsQueryKey = (options: Options<DiffAgentTemplateVersionsData>) => createQueryKey('diffAgentTemplateVersions', options);

export const diffAgentTemplateVersionsOptions = (options: Options<DiffAgentTemplateVersionsData>) => queryOptions<DiffAgentTemplateVersionsResponse, DefaultError, DiffAgentTemplateVersionsResponse, ReturnType<typeof diffAgentTemplateVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diffAgentTemplateVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diffAgentTemplateVersionsQueryKey(options)
});

export const testAgentTemplateVersionMutation = (options?: Partial<Options<TestAgentTemplateVersionData>>): UseMutationOptions<TestAgentTemplateVersionResponse, DefaultError, Options<TestAgentTemplateVersionData>> => {
    const mutationOptions: UseMutationOptions<TestAgentTemplateVersionResponse, DefaultError, Options<TestAgentTemplateVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testAgentTemplateVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const compareAgentTemplateVersionsMutation = (options?: Partial<Options<CompareAgentTemplateVersionsData>>): UseMutationOptions<CompareAgentTemplateVersionsResponse, DefaultError, Options<CompareAgentTemplateVersionsData>> => {
    const mutationOptions: UseMutationOptions<CompareAgentTemplateVersionsResponse, DefaultError, Options<CompareAgentTemplateVersionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await compareAgentTemplateVersions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAgentTemplateVersionComparisonQueryKey = (options: Options<GetAgentTemplateVersionComparisonData>) => createQueryKey('getAgentTemplateVersionComparison', options);

export const getAgentTemplateVersionComparisonOptions = (options: Options<GetAgentTemplateVersionComparisonData>) => queryOptions<GetAgentTemplateVersionComparisonResponse, DefaultError, GetAgentTemplateVersionComparisonResponse, ReturnType<typeof getAgentTemplateVersionComparisonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAgentTemplateVersionComparison({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAgentTemplateVersionComparisonQueryKey(options)
});

export const preflightTemplateUpgradeMutation = (options?: Partial<Options<PreflightTemplateUpgradeData>>): UseMutationOptions<PreflightTemplateUpgradeResponse, PreflightTemplateUpgradeError, Options<PreflightTemplateUpgradeData>> => {
    const mutationOptions: UseMutationOptions<PreflightTemplateUpgradeResponse, PreflightTemplateUpgradeError, Options<PreflightTemplateUpgradeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await preflightTemplateUpgrade({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createTemplateUpgradeProposalMutation = (options?: Partial<Options<CreateTemplateUpgradeProposalData>>): UseMutationOptions<CreateTemplateUpgradeProposalResponse, CreateTemplateUpgradeProposalError, Options<CreateTemplateUpgradeProposalData>> => {
    const mutationOptions: UseMutationOptions<CreateTemplateUpgradeProposalResponse, CreateTemplateUpgradeProposalError, Options<CreateTemplateUpgradeProposalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTemplateUpgradeProposal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTemplatesQueryKey = (options?: Options<ListTemplatesData>) => createQueryKey('listTemplates', options);

export const listTemplatesOptions = (options?: Options<ListTemplatesData>) => queryOptions<ListTemplatesResponse, DefaultError, ListTemplatesResponse, ReturnType<typeof listTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTemplatesQueryKey(options)
});

export const listTemplatesInfiniteQueryKey = (options?: Options<ListTemplatesData>): QueryKey<Options<ListTemplatesData>> => createQueryKey('listTemplates', options, true);

export const listTemplatesInfiniteOptions = (options?: Options<ListTemplatesData>) => {
    const opts = infiniteQueryOptions<ListTemplatesResponse, DefaultError, InfiniteData<ListTemplatesResponse>, QueryKey<Options<ListTemplatesData>>, string | Pick<QueryKey<Options<ListTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTemplates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTemplatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createTemplateMutation = (options?: Partial<Options<CreateTemplateData>>): UseMutationOptions<CreateTemplateResponse, DefaultError, Options<CreateTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateTemplateResponse, DefaultError, Options<CreateTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteTemplateMutation = (options?: Partial<Options<DeleteTemplateData>>): UseMutationOptions<DeleteTemplateResponse, DeleteTemplateError, Options<DeleteTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteTemplateResponse, DeleteTemplateError, Options<DeleteTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTemplateQueryKey = (options: Options<GetTemplateData>) => createQueryKey('getTemplate', options);

export const getTemplateOptions = (options: Options<GetTemplateData>) => queryOptions<GetTemplateResponse, DefaultError, GetTemplateResponse, ReturnType<typeof getTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTemplateQueryKey(options)
});

export const createOrUpdateTemplateMutation = (options?: Partial<Options<CreateOrUpdateTemplateData>>): UseMutationOptions<CreateOrUpdateTemplateResponse, DefaultError, Options<CreateOrUpdateTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateOrUpdateTemplateResponse, DefaultError, Options<CreateOrUpdateTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrUpdateTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setTemplateStatusMutation = (options?: Partial<Options<SetTemplateStatusData>>): UseMutationOptions<SetTemplateStatusResponse, DefaultError, Options<SetTemplateStatusData>> => {
    const mutationOptions: UseMutationOptions<SetTemplateStatusResponse, DefaultError, Options<SetTemplateStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setTemplateStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setTemplateAutoUpgradeMutation = (options?: Partial<Options<SetTemplateAutoUpgradeData>>): UseMutationOptions<SetTemplateAutoUpgradeResponse, DefaultError, Options<SetTemplateAutoUpgradeData>> => {
    const mutationOptions: UseMutationOptions<SetTemplateAutoUpgradeResponse, DefaultError, Options<SetTemplateAutoUpgradeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setTemplateAutoUpgrade({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSkillsQueryKey = (options?: Options<ListSkillsData>) => createQueryKey('listSkills', options);

export const listSkillsOptions = (options?: Options<ListSkillsData>) => queryOptions<ListSkillsResponse, DefaultError, ListSkillsResponse, ReturnType<typeof listSkillsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSkills({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSkillsQueryKey(options)
});

export const getSkillQueryKey = (options: Options<GetSkillData>) => createQueryKey('getSkill', options);

export const getSkillOptions = (options: Options<GetSkillData>) => queryOptions<GetSkillResponse, DefaultError, GetSkillResponse, ReturnType<typeof getSkillQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSkill({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSkillQueryKey(options)
});

export const listToolLibrariesQueryKey = (options?: Options<ListToolLibrariesData>) => createQueryKey('listToolLibraries', options);

export const listToolLibrariesOptions = (options?: Options<ListToolLibrariesData>) => queryOptions<ListToolLibrariesResponse, DefaultError, ListToolLibrariesResponse, ReturnType<typeof listToolLibrariesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listToolLibraries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listToolLibrariesQueryKey(options)
});

export const createToolLibraryMutation = (options?: Partial<Options<CreateToolLibraryData>>): UseMutationOptions<CreateToolLibraryResponse, DefaultError, Options<CreateToolLibraryData>> => {
    const mutationOptions: UseMutationOptions<CreateToolLibraryResponse, DefaultError, Options<CreateToolLibraryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createToolLibrary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteToolLibraryMutation = (options?: Partial<Options<DeleteToolLibraryData>>): UseMutationOptions<DeleteToolLibraryResponse, DefaultError, Options<DeleteToolLibraryData>> => {
    const mutationOptions: UseMutationOptions<DeleteToolLibraryResponse, DefaultError, Options<DeleteToolLibraryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteToolLibrary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getToolLibraryQueryKey = (options: Options<GetToolLibraryData>) => createQueryKey('getToolLibrary', options);

export const getToolLibraryOptions = (options: Options<GetToolLibraryData>) => queryOptions<GetToolLibraryResponse, DefaultError, GetToolLibraryResponse, ReturnType<typeof getToolLibraryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getToolLibrary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getToolLibraryQueryKey(options)
});

export const updateToolLibraryMutation = (options?: Partial<Options<UpdateToolLibraryData>>): UseMutationOptions<UpdateToolLibraryResponse, DefaultError, Options<UpdateToolLibraryData>> => {
    const mutationOptions: UseMutationOptions<UpdateToolLibraryResponse, DefaultError, Options<UpdateToolLibraryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateToolLibrary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const syncToolLibraryMutation = (options?: Partial<Options<SyncToolLibraryData>>): UseMutationOptions<SyncToolLibraryResponse, DefaultError, Options<SyncToolLibraryData>> => {
    const mutationOptions: UseMutationOptions<SyncToolLibraryResponse, DefaultError, Options<SyncToolLibraryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncToolLibrary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listToolLibraryToolsQueryKey = (options: Options<ListToolLibraryToolsData>) => createQueryKey('listToolLibraryTools', options);

export const listToolLibraryToolsOptions = (options: Options<ListToolLibraryToolsData>) => queryOptions<ListToolLibraryToolsResponse, DefaultError, ListToolLibraryToolsResponse, ReturnType<typeof listToolLibraryToolsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listToolLibraryTools({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listToolLibraryToolsQueryKey(options)
});

export const listToolsQueryKey = (options?: Options<ListToolsData>) => createQueryKey('listTools', options);

export const listToolsOptions = (options?: Options<ListToolsData>) => queryOptions<ListToolsResponse, DefaultError, ListToolsResponse, ReturnType<typeof listToolsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTools({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listToolsQueryKey(options)
});

export const createToolMutation = (options?: Partial<Options<CreateToolData>>): UseMutationOptions<CreateToolResponse, DefaultError, Options<CreateToolData>> => {
    const mutationOptions: UseMutationOptions<CreateToolResponse, DefaultError, Options<CreateToolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteToolMutation = (options?: Partial<Options<DeleteToolData>>): UseMutationOptions<DeleteToolResponse, DeleteToolError, Options<DeleteToolData>> => {
    const mutationOptions: UseMutationOptions<DeleteToolResponse, DeleteToolError, Options<DeleteToolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getToolQueryKey = (options: Options<GetToolData>) => createQueryKey('getTool', options);

export const getToolOptions = (options: Options<GetToolData>) => queryOptions<GetToolResponse, DefaultError, GetToolResponse, ReturnType<typeof getToolQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTool({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getToolQueryKey(options)
});

export const createOrUpdateToolMutation = (options?: Partial<Options<CreateOrUpdateToolData>>): UseMutationOptions<CreateOrUpdateToolResponse, DefaultError, Options<CreateOrUpdateToolData>> => {
    const mutationOptions: UseMutationOptions<CreateOrUpdateToolResponse, DefaultError, Options<CreateOrUpdateToolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrUpdateTool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setToolStatusMutation = (options?: Partial<Options<SetToolStatusData>>): UseMutationOptions<SetToolStatusResponse, DefaultError, Options<SetToolStatusData>> => {
    const mutationOptions: UseMutationOptions<SetToolStatusResponse, DefaultError, Options<SetToolStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setToolStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAgentWorkflowsQueryKey = (options?: Options<ListAgentWorkflowsData>) => createQueryKey('listAgentWorkflows', options);

export const listAgentWorkflowsOptions = (options?: Options<ListAgentWorkflowsData>) => queryOptions<ListAgentWorkflowsResponse, DefaultError, ListAgentWorkflowsResponse, ReturnType<typeof listAgentWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentWorkflows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentWorkflowsQueryKey(options)
});

export const triggerAgentWorkflowMutation = (options?: Partial<Options<TriggerAgentWorkflowData>>): UseMutationOptions<TriggerAgentWorkflowResponse, DefaultError, Options<TriggerAgentWorkflowData>> => {
    const mutationOptions: UseMutationOptions<TriggerAgentWorkflowResponse, DefaultError, Options<TriggerAgentWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerAgentWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAgentWorkflowRunQueryKey = (options: Options<GetAgentWorkflowRunData>) => createQueryKey('getAgentWorkflowRun', options);

export const getAgentWorkflowRunOptions = (options: Options<GetAgentWorkflowRunData>) => queryOptions<GetAgentWorkflowRunResponse, DefaultError, GetAgentWorkflowRunResponse, ReturnType<typeof getAgentWorkflowRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAgentWorkflowRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAgentWorkflowRunQueryKey(options)
});

export const getAgentWorkflowRunDebuggerQueryKey = (options: Options<GetAgentWorkflowRunDebuggerData>) => createQueryKey('getAgentWorkflowRunDebugger', options);

export const getAgentWorkflowRunDebuggerOptions = (options: Options<GetAgentWorkflowRunDebuggerData>) => queryOptions<GetAgentWorkflowRunDebuggerResponse, DefaultError, GetAgentWorkflowRunDebuggerResponse, ReturnType<typeof getAgentWorkflowRunDebuggerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAgentWorkflowRunDebugger({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAgentWorkflowRunDebuggerQueryKey(options)
});

export const runAgentWorkflowRunActionMutation = (options?: Partial<Options<RunAgentWorkflowRunActionData>>): UseMutationOptions<RunAgentWorkflowRunActionResponse, DefaultError, Options<RunAgentWorkflowRunActionData>> => {
    const mutationOptions: UseMutationOptions<RunAgentWorkflowRunActionResponse, DefaultError, Options<RunAgentWorkflowRunActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runAgentWorkflowRunAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAgentWorkflowRunsQueryKey = (options?: Options<ListAgentWorkflowRunsData>) => createQueryKey('listAgentWorkflowRuns', options);

export const listAgentWorkflowRunsOptions = (options?: Options<ListAgentWorkflowRunsData>) => queryOptions<ListAgentWorkflowRunsResponse, DefaultError, ListAgentWorkflowRunsResponse, ReturnType<typeof listAgentWorkflowRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentWorkflowRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentWorkflowRunsQueryKey(options)
});

export const listLlmCallCostOutliersQueryKey = (options?: Options<ListLlmCallCostOutliersData>) => createQueryKey('listLlmCallCostOutliers', options);

export const listLlmCallCostOutliersOptions = (options?: Options<ListLlmCallCostOutliersData>) => queryOptions<ListLlmCallCostOutliersResponse, DefaultError, ListLlmCallCostOutliersResponse, ReturnType<typeof listLlmCallCostOutliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listLlmCallCostOutliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listLlmCallCostOutliersQueryKey(options)
});

export const listLlmCallCostOutliersInfiniteQueryKey = (options?: Options<ListLlmCallCostOutliersData>): QueryKey<Options<ListLlmCallCostOutliersData>> => createQueryKey('listLlmCallCostOutliers', options, true);

export const listLlmCallCostOutliersInfiniteOptions = (options?: Options<ListLlmCallCostOutliersData>) => {
    const opts = infiniteQueryOptions<ListLlmCallCostOutliersResponse, DefaultError, InfiniteData<ListLlmCallCostOutliersResponse>, QueryKey<Options<ListLlmCallCostOutliersData>>, string | Pick<QueryKey<Options<ListLlmCallCostOutliersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListLlmCallCostOutliersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listLlmCallCostOutliers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLlmCallCostOutliersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listLlmCallLatencyOutliersQueryKey = (options?: Options<ListLlmCallLatencyOutliersData>) => createQueryKey('listLlmCallLatencyOutliers', options);

export const listLlmCallLatencyOutliersOptions = (options?: Options<ListLlmCallLatencyOutliersData>) => queryOptions<ListLlmCallLatencyOutliersResponse, DefaultError, ListLlmCallLatencyOutliersResponse, ReturnType<typeof listLlmCallLatencyOutliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listLlmCallLatencyOutliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listLlmCallLatencyOutliersQueryKey(options)
});

export const listLlmCallLatencyOutliersInfiniteQueryKey = (options?: Options<ListLlmCallLatencyOutliersData>): QueryKey<Options<ListLlmCallLatencyOutliersData>> => createQueryKey('listLlmCallLatencyOutliers', options, true);

export const listLlmCallLatencyOutliersInfiniteOptions = (options?: Options<ListLlmCallLatencyOutliersData>) => {
    const opts = infiniteQueryOptions<ListLlmCallLatencyOutliersResponse, DefaultError, InfiniteData<ListLlmCallLatencyOutliersResponse>, QueryKey<Options<ListLlmCallLatencyOutliersData>>, string | Pick<QueryKey<Options<ListLlmCallLatencyOutliersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListLlmCallLatencyOutliersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listLlmCallLatencyOutliers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLlmCallLatencyOutliersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getRunHealthAggregatesQueryKey = (options?: Options<GetRunHealthAggregatesData>) => createQueryKey('getRunHealthAggregates', options);

export const getRunHealthAggregatesOptions = (options?: Options<GetRunHealthAggregatesData>) => queryOptions<GetRunHealthAggregatesResponse, DefaultError, GetRunHealthAggregatesResponse, ReturnType<typeof getRunHealthAggregatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRunHealthAggregates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRunHealthAggregatesQueryKey(options)
});

export const listModelsQueryKey = (options?: Options<ListModelsData>) => createQueryKey('listModels', options);

export const listModelsOptions = (options?: Options<ListModelsData>) => queryOptions<ListModelsResponse, DefaultError, ListModelsResponse, ReturnType<typeof listModelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listModels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listModelsQueryKey(options)
});

export const getModelQueryKey = (options: Options<GetModelData>) => createQueryKey('getModel', options);

export const getModelOptions = (options: Options<GetModelData>) => queryOptions<GetModelResponse, DefaultError, GetModelResponse, ReturnType<typeof getModelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getModel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getModelQueryKey(options)
});

export const listModelRuntimePoliciesQueryKey = (options?: Options<ListModelRuntimePoliciesData>) => createQueryKey('listModelRuntimePolicies', options);

export const listModelRuntimePoliciesOptions = (options?: Options<ListModelRuntimePoliciesData>) => queryOptions<ListModelRuntimePoliciesResponse, DefaultError, ListModelRuntimePoliciesResponse, ReturnType<typeof listModelRuntimePoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listModelRuntimePolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listModelRuntimePoliciesQueryKey(options)
});

export const createModelRuntimePolicyMutation = (options?: Partial<Options<CreateModelRuntimePolicyData>>): UseMutationOptions<CreateModelRuntimePolicyResponse, DefaultError, Options<CreateModelRuntimePolicyData>> => {
    const mutationOptions: UseMutationOptions<CreateModelRuntimePolicyResponse, DefaultError, Options<CreateModelRuntimePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createModelRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveModelRuntimePolicyMutation = (options?: Partial<Options<ResolveModelRuntimePolicyData>>): UseMutationOptions<ResolveModelRuntimePolicyResponse, DefaultError, Options<ResolveModelRuntimePolicyData>> => {
    const mutationOptions: UseMutationOptions<ResolveModelRuntimePolicyResponse, DefaultError, Options<ResolveModelRuntimePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveModelRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getModelRuntimePolicyQueryKey = (options: Options<GetModelRuntimePolicyData>) => createQueryKey('getModelRuntimePolicy', options);

export const getModelRuntimePolicyOptions = (options: Options<GetModelRuntimePolicyData>) => queryOptions<GetModelRuntimePolicyResponse, DefaultError, GetModelRuntimePolicyResponse, ReturnType<typeof getModelRuntimePolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getModelRuntimePolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getModelRuntimePolicyQueryKey(options)
});

export const updateModelRuntimePolicyMutation = (options?: Partial<Options<UpdateModelRuntimePolicyData>>): UseMutationOptions<UpdateModelRuntimePolicyResponse, DefaultError, Options<UpdateModelRuntimePolicyData>> => {
    const mutationOptions: UseMutationOptions<UpdateModelRuntimePolicyResponse, DefaultError, Options<UpdateModelRuntimePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateModelRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRuntimePolicySurfaceRulesQueryKey = (options?: Options<ListRuntimePolicySurfaceRulesData>) => createQueryKey('listRuntimePolicySurfaceRules', options);

export const listRuntimePolicySurfaceRulesOptions = (options?: Options<ListRuntimePolicySurfaceRulesData>) => queryOptions<ListRuntimePolicySurfaceRulesResponse, DefaultError, ListRuntimePolicySurfaceRulesResponse, ReturnType<typeof listRuntimePolicySurfaceRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRuntimePolicySurfaceRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRuntimePolicySurfaceRulesQueryKey(options)
});

export const listRuntimePolicyOptionsQueryKey = (options: Options<ListRuntimePolicyOptionsData>) => createQueryKey('listRuntimePolicyOptions', options);

export const listRuntimePolicyOptionsOptions = (options: Options<ListRuntimePolicyOptionsData>) => queryOptions<ListRuntimePolicyOptionsResponse, DefaultError, ListRuntimePolicyOptionsResponse, ReturnType<typeof listRuntimePolicyOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRuntimePolicyOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRuntimePolicyOptionsQueryKey(options)
});

export const setSystemRuntimePolicySurfaceRuleMutation = (options?: Partial<Options<SetSystemRuntimePolicySurfaceRuleData>>): UseMutationOptions<SetSystemRuntimePolicySurfaceRuleResponse, DefaultError, Options<SetSystemRuntimePolicySurfaceRuleData>> => {
    const mutationOptions: UseMutationOptions<SetSystemRuntimePolicySurfaceRuleResponse, DefaultError, Options<SetSystemRuntimePolicySurfaceRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setSystemRuntimePolicySurfaceRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clearOrganizationRuntimePolicySurfaceRuleMutation = (options?: Partial<Options<ClearOrganizationRuntimePolicySurfaceRuleData>>): UseMutationOptions<ClearOrganizationRuntimePolicySurfaceRuleResponse, DefaultError, Options<ClearOrganizationRuntimePolicySurfaceRuleData>> => {
    const mutationOptions: UseMutationOptions<ClearOrganizationRuntimePolicySurfaceRuleResponse, DefaultError, Options<ClearOrganizationRuntimePolicySurfaceRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearOrganizationRuntimePolicySurfaceRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setOrganizationRuntimePolicySurfaceRuleMutation = (options?: Partial<Options<SetOrganizationRuntimePolicySurfaceRuleData>>): UseMutationOptions<SetOrganizationRuntimePolicySurfaceRuleResponse, DefaultError, Options<SetOrganizationRuntimePolicySurfaceRuleData>> => {
    const mutationOptions: UseMutationOptions<SetOrganizationRuntimePolicySurfaceRuleResponse, DefaultError, Options<SetOrganizationRuntimePolicySurfaceRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setOrganizationRuntimePolicySurfaceRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDynamicFanOutPoliciesQueryKey = (options?: Options<ListDynamicFanOutPoliciesData>) => createQueryKey('listDynamicFanOutPolicies', options);

export const listDynamicFanOutPoliciesOptions = (options?: Options<ListDynamicFanOutPoliciesData>) => queryOptions<ListDynamicFanOutPoliciesResponse, DefaultError, ListDynamicFanOutPoliciesResponse, ReturnType<typeof listDynamicFanOutPoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDynamicFanOutPolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDynamicFanOutPoliciesQueryKey(options)
});

export const createDynamicFanOutPolicyMutation = (options?: Partial<Options<CreateDynamicFanOutPolicyData>>): UseMutationOptions<CreateDynamicFanOutPolicyResponse, DefaultError, Options<CreateDynamicFanOutPolicyData>> => {
    const mutationOptions: UseMutationOptions<CreateDynamicFanOutPolicyResponse, DefaultError, Options<CreateDynamicFanOutPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDynamicFanOutPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveDynamicFanOutPolicyMutation = (options?: Partial<Options<ResolveDynamicFanOutPolicyData>>): UseMutationOptions<ResolveDynamicFanOutPolicyResponse, DefaultError, Options<ResolveDynamicFanOutPolicyData>> => {
    const mutationOptions: UseMutationOptions<ResolveDynamicFanOutPolicyResponse, DefaultError, Options<ResolveDynamicFanOutPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveDynamicFanOutPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDynamicFanOutPolicyQueryKey = (options: Options<GetDynamicFanOutPolicyData>) => createQueryKey('getDynamicFanOutPolicy', options);

export const getDynamicFanOutPolicyOptions = (options: Options<GetDynamicFanOutPolicyData>) => queryOptions<GetDynamicFanOutPolicyResponse, DefaultError, GetDynamicFanOutPolicyResponse, ReturnType<typeof getDynamicFanOutPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDynamicFanOutPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDynamicFanOutPolicyQueryKey(options)
});

export const updateDynamicFanOutPolicyMutation = (options?: Partial<Options<UpdateDynamicFanOutPolicyData>>): UseMutationOptions<UpdateDynamicFanOutPolicyResponse, DefaultError, Options<UpdateDynamicFanOutPolicyData>> => {
    const mutationOptions: UseMutationOptions<UpdateDynamicFanOutPolicyResponse, DefaultError, Options<UpdateDynamicFanOutPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDynamicFanOutPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const callAiWorkerMcpMutation = (options?: Partial<Options<CallAiWorkerMcpData>>): UseMutationOptions<CallAiWorkerMcpResponse, DefaultError, Options<CallAiWorkerMcpData>> => {
    const mutationOptions: UseMutationOptions<CallAiWorkerMcpResponse, DefaultError, Options<CallAiWorkerMcpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await callAiWorkerMcp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const queryAiWorkerDataMutation = (options?: Partial<Options<QueryAiWorkerDataData>>): UseMutationOptions<QueryAiWorkerDataResponse, DefaultError, Options<QueryAiWorkerDataData>> => {
    const mutationOptions: UseMutationOptions<QueryAiWorkerDataResponse, DefaultError, Options<QueryAiWorkerDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await queryAiWorkerData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const runAiWorkerDatasetMutation = (options?: Partial<Options<RunAiWorkerDatasetData>>): UseMutationOptions<RunAiWorkerDatasetResponse, DefaultError, Options<RunAiWorkerDatasetData>> => {
    const mutationOptions: UseMutationOptions<RunAiWorkerDatasetResponse, DefaultError, Options<RunAiWorkerDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runAiWorkerDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fetchAiWorkerDataResultQueryKey = (options: Options<FetchAiWorkerDataResultData>) => createQueryKey('fetchAiWorkerDataResult', options);

export const fetchAiWorkerDataResultOptions = (options: Options<FetchAiWorkerDataResultData>) => queryOptions<FetchAiWorkerDataResultResponse, DefaultError, FetchAiWorkerDataResultResponse, ReturnType<typeof fetchAiWorkerDataResultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fetchAiWorkerDataResult({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fetchAiWorkerDataResultQueryKey(options)
});

export const registerAiWorkerMutation = (options?: Partial<Options<RegisterAiWorkerData>>): UseMutationOptions<RegisterAiWorkerResponse, DefaultError, Options<RegisterAiWorkerData>> => {
    const mutationOptions: UseMutationOptions<RegisterAiWorkerResponse, DefaultError, Options<RegisterAiWorkerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerAiWorker({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const heartbeatAiWorkerMutation = (options?: Partial<Options<HeartbeatAiWorkerData>>): UseMutationOptions<HeartbeatAiWorkerResponse, DefaultError, Options<HeartbeatAiWorkerData>> => {
    const mutationOptions: UseMutationOptions<HeartbeatAiWorkerResponse, DefaultError, Options<HeartbeatAiWorkerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await heartbeatAiWorker({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pollAiWorkerCommandsMutation = (options?: Partial<Options<PollAiWorkerCommandsData>>): UseMutationOptions<PollAiWorkerCommandsResponse, DefaultError, Options<PollAiWorkerCommandsData>> => {
    const mutationOptions: UseMutationOptions<PollAiWorkerCommandsResponse, DefaultError, Options<PollAiWorkerCommandsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pollAiWorkerCommands({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pollAiWorkerControlCommandsMutation = (options?: Partial<Options<PollAiWorkerControlCommandsData>>): UseMutationOptions<PollAiWorkerControlCommandsResponse, DefaultError, Options<PollAiWorkerControlCommandsData>> => {
    const mutationOptions: UseMutationOptions<PollAiWorkerControlCommandsResponse, DefaultError, Options<PollAiWorkerControlCommandsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pollAiWorkerControlCommands({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publishAiWorkerEventsMutation = (options?: Partial<Options<PublishAiWorkerEventsData>>): UseMutationOptions<PublishAiWorkerEventsResponse, DefaultError, Options<PublishAiWorkerEventsData>> => {
    const mutationOptions: UseMutationOptions<PublishAiWorkerEventsResponse, DefaultError, Options<PublishAiWorkerEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishAiWorkerEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Push one batch of a box's host metrics (OTLP/HTTP, JSON encoding)
 *
 * Called by the monitoring agent on each box with its host_reporter key. The body is an OTLP ExportMetricsServiceRequest in JSON, optionally gzip-encoded (Content-Encoding: gzip).
 */
export const createHostMetricsMutation = (options?: Partial<Options<CreateHostMetricsData>>): UseMutationOptions<CreateHostMetricsResponse, CreateHostMetricsError, Options<CreateHostMetricsData>> => {
    const mutationOptions: UseMutationOptions<CreateHostMetricsResponse, CreateHostMetricsError, Options<CreateHostMetricsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createHostMetrics({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSnapshotsQueryKey = (options: Options<ListSnapshotsData>) => createQueryKey('listSnapshots', options);

export const listSnapshotsOptions = (options: Options<ListSnapshotsData>) => queryOptions<ListSnapshotsResponse, ListSnapshotsError, ListSnapshotsResponse, ReturnType<typeof listSnapshotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSnapshots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSnapshotsQueryKey(options)
});

export const listSnapshotsInfiniteQueryKey = (options: Options<ListSnapshotsData>): QueryKey<Options<ListSnapshotsData>> => createQueryKey('listSnapshots', options, true);

export const listSnapshotsInfiniteOptions = (options: Options<ListSnapshotsData>) => {
    const opts = infiniteQueryOptions<ListSnapshotsResponse, ListSnapshotsError, InfiniteData<ListSnapshotsResponse>, QueryKey<Options<ListSnapshotsData>>, number | null | Pick<QueryKey<Options<ListSnapshotsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSnapshotsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSnapshots({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSnapshotsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createSnapshotMutation = (options?: Partial<Options<CreateSnapshotData>>): UseMutationOptions<CreateSnapshotResponse, CreateSnapshotError, Options<CreateSnapshotData>> => {
    const mutationOptions: UseMutationOptions<CreateSnapshotResponse, CreateSnapshotError, Options<CreateSnapshotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const purgeSnapshotsMutation = (options?: Partial<Options<PurgeSnapshotsData>>): UseMutationOptions<PurgeSnapshotsResponse, PurgeSnapshotsError, Options<PurgeSnapshotsData>> => {
    const mutationOptions: UseMutationOptions<PurgeSnapshotsResponse, PurgeSnapshotsError, Options<PurgeSnapshotsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await purgeSnapshots({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteSnapshotMutation = (options?: Partial<Options<DeleteSnapshotData>>): UseMutationOptions<DeleteSnapshotResponse, DeleteSnapshotError, Options<DeleteSnapshotData>> => {
    const mutationOptions: UseMutationOptions<DeleteSnapshotResponse, DeleteSnapshotError, Options<DeleteSnapshotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSnapshotQueryKey = (options: Options<GetSnapshotData>) => createQueryKey('getSnapshot', options);

export const getSnapshotOptions = (options: Options<GetSnapshotData>) => queryOptions<GetSnapshotResponse, GetSnapshotError, GetSnapshotResponse, ReturnType<typeof getSnapshotQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSnapshot({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSnapshotQueryKey(options)
});

export const updateSnapshotMutation = (options?: Partial<Options<UpdateSnapshotData>>): UseMutationOptions<UpdateSnapshotResponse, UpdateSnapshotError, Options<UpdateSnapshotData>> => {
    const mutationOptions: UseMutationOptions<UpdateSnapshotResponse, UpdateSnapshotError, Options<UpdateSnapshotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEvaluationDatasetsQueryKey = (options?: Options<ListEvaluationDatasetsData>) => createQueryKey('listEvaluationDatasets', options);

export const listEvaluationDatasetsOptions = (options?: Options<ListEvaluationDatasetsData>) => queryOptions<ListEvaluationDatasetsResponse, DefaultError, ListEvaluationDatasetsResponse, ReturnType<typeof listEvaluationDatasetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEvaluationDatasets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEvaluationDatasetsQueryKey(options)
});

export const createEvaluationDatasetMutation = (options?: Partial<Options<CreateEvaluationDatasetData>>): UseMutationOptions<CreateEvaluationDatasetResponse, DefaultError, Options<CreateEvaluationDatasetData>> => {
    const mutationOptions: UseMutationOptions<CreateEvaluationDatasetResponse, DefaultError, Options<CreateEvaluationDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEvaluationDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteEvaluationDatasetMutation = (options?: Partial<Options<DeleteEvaluationDatasetData>>): UseMutationOptions<DeleteEvaluationDatasetResponse, DefaultError, Options<DeleteEvaluationDatasetData>> => {
    const mutationOptions: UseMutationOptions<DeleteEvaluationDatasetResponse, DefaultError, Options<DeleteEvaluationDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEvaluationDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEvaluationCasesQueryKey = (options: Options<ListEvaluationCasesData>) => createQueryKey('listEvaluationCases', options);

export const listEvaluationCasesOptions = (options: Options<ListEvaluationCasesData>) => queryOptions<ListEvaluationCasesResponse, DefaultError, ListEvaluationCasesResponse, ReturnType<typeof listEvaluationCasesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEvaluationCases({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEvaluationCasesQueryKey(options)
});

export const createEvaluationCaseMutation = (options?: Partial<Options<CreateEvaluationCaseData>>): UseMutationOptions<CreateEvaluationCaseResponse, DefaultError, Options<CreateEvaluationCaseData>> => {
    const mutationOptions: UseMutationOptions<CreateEvaluationCaseResponse, DefaultError, Options<CreateEvaluationCaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEvaluationCase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteEvaluationCaseMutation = (options?: Partial<Options<DeleteEvaluationCaseData>>): UseMutationOptions<DeleteEvaluationCaseResponse, DefaultError, Options<DeleteEvaluationCaseData>> => {
    const mutationOptions: UseMutationOptions<DeleteEvaluationCaseResponse, DefaultError, Options<DeleteEvaluationCaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEvaluationCase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const runEvaluationDatasetMutation = (options?: Partial<Options<RunEvaluationDatasetData>>): UseMutationOptions<RunEvaluationDatasetResponse, DefaultError, Options<RunEvaluationDatasetData>> => {
    const mutationOptions: UseMutationOptions<RunEvaluationDatasetResponse, DefaultError, Options<RunEvaluationDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runEvaluationDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEvaluationRunQueryKey = (options: Options<GetEvaluationRunData>) => createQueryKey('getEvaluationRun', options);

export const getEvaluationRunOptions = (options: Options<GetEvaluationRunData>) => queryOptions<GetEvaluationRunResponse, DefaultError, GetEvaluationRunResponse, ReturnType<typeof getEvaluationRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEvaluationRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEvaluationRunQueryKey(options)
});

export const listReasoningEvaluationsQueryKey = (options?: Options<ListReasoningEvaluationsData>) => createQueryKey('listReasoningEvaluations', options);

export const listReasoningEvaluationsOptions = (options?: Options<ListReasoningEvaluationsData>) => queryOptions<ListReasoningEvaluationsResponse, DefaultError, ListReasoningEvaluationsResponse, ReturnType<typeof listReasoningEvaluationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listReasoningEvaluations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReasoningEvaluationsQueryKey(options)
});

export const listReasoningEvaluationsInfiniteQueryKey = (options?: Options<ListReasoningEvaluationsData>): QueryKey<Options<ListReasoningEvaluationsData>> => createQueryKey('listReasoningEvaluations', options, true);

export const listReasoningEvaluationsInfiniteOptions = (options?: Options<ListReasoningEvaluationsData>) => {
    const opts = infiniteQueryOptions<ListReasoningEvaluationsResponse, DefaultError, InfiniteData<ListReasoningEvaluationsResponse>, QueryKey<Options<ListReasoningEvaluationsData>>, string | Pick<QueryKey<Options<ListReasoningEvaluationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListReasoningEvaluationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listReasoningEvaluations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listReasoningEvaluationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getReasoningCallSummaryQueryKey = (options?: Options<GetReasoningCallSummaryData>) => createQueryKey('getReasoningCallSummary', options);

export const getReasoningCallSummaryOptions = (options?: Options<GetReasoningCallSummaryData>) => queryOptions<GetReasoningCallSummaryResponse, DefaultError, GetReasoningCallSummaryResponse, ReturnType<typeof getReasoningCallSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReasoningCallSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReasoningCallSummaryQueryKey(options)
});

export const getReasoningPrincipleSummaryQueryKey = (options?: Options<GetReasoningPrincipleSummaryData>) => createQueryKey('getReasoningPrincipleSummary', options);

export const getReasoningPrincipleSummaryOptions = (options?: Options<GetReasoningPrincipleSummaryData>) => queryOptions<GetReasoningPrincipleSummaryResponse, DefaultError, GetReasoningPrincipleSummaryResponse, ReturnType<typeof getReasoningPrincipleSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReasoningPrincipleSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReasoningPrincipleSummaryQueryKey(options)
});

export const listEvaluationTemplatesQueryKey = (options?: Options<ListEvaluationTemplatesData>) => createQueryKey('listEvaluationTemplates', options);

export const listEvaluationTemplatesOptions = (options?: Options<ListEvaluationTemplatesData>) => queryOptions<ListEvaluationTemplatesResponse, DefaultError, ListEvaluationTemplatesResponse, ReturnType<typeof listEvaluationTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEvaluationTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEvaluationTemplatesQueryKey(options)
});

export const listEvaluationTemplatesInfiniteQueryKey = (options?: Options<ListEvaluationTemplatesData>): QueryKey<Options<ListEvaluationTemplatesData>> => createQueryKey('listEvaluationTemplates', options, true);

export const listEvaluationTemplatesInfiniteOptions = (options?: Options<ListEvaluationTemplatesData>) => {
    const opts = infiniteQueryOptions<ListEvaluationTemplatesResponse, DefaultError, InfiniteData<ListEvaluationTemplatesResponse>, QueryKey<Options<ListEvaluationTemplatesData>>, string | Pick<QueryKey<Options<ListEvaluationTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListEvaluationTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listEvaluationTemplates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEvaluationTemplatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createEvaluationTemplateMutation = (options?: Partial<Options<CreateEvaluationTemplateData>>): UseMutationOptions<CreateEvaluationTemplateResponse, DefaultError, Options<CreateEvaluationTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateEvaluationTemplateResponse, DefaultError, Options<CreateEvaluationTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEvaluationTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEvaluationTemplateQueryKey = (options: Options<GetEvaluationTemplateData>) => createQueryKey('getEvaluationTemplate', options);

export const getEvaluationTemplateOptions = (options: Options<GetEvaluationTemplateData>) => queryOptions<GetEvaluationTemplateResponse, DefaultError, GetEvaluationTemplateResponse, ReturnType<typeof getEvaluationTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEvaluationTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEvaluationTemplateQueryKey(options)
});

export const updateEvaluationTemplateMutation = (options?: Partial<Options<UpdateEvaluationTemplateData>>): UseMutationOptions<UpdateEvaluationTemplateResponse, DefaultError, Options<UpdateEvaluationTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateEvaluationTemplateResponse, DefaultError, Options<UpdateEvaluationTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEvaluationTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addEvaluationTemplateVersionMutation = (options?: Partial<Options<AddEvaluationTemplateVersionData>>): UseMutationOptions<AddEvaluationTemplateVersionResponse, DefaultError, Options<AddEvaluationTemplateVersionData>> => {
    const mutationOptions: UseMutationOptions<AddEvaluationTemplateVersionResponse, DefaultError, Options<AddEvaluationTemplateVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addEvaluationTemplateVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publishEvaluationTemplateVersionMutation = (options?: Partial<Options<PublishEvaluationTemplateVersionData>>): UseMutationOptions<PublishEvaluationTemplateVersionResponse, DefaultError, Options<PublishEvaluationTemplateVersionData>> => {
    const mutationOptions: UseMutationOptions<PublishEvaluationTemplateVersionResponse, DefaultError, Options<PublishEvaluationTemplateVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishEvaluationTemplateVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const applyEvaluationTemplateMutation = (options?: Partial<Options<ApplyEvaluationTemplateData>>): UseMutationOptions<ApplyEvaluationTemplateResponse, DefaultError, Options<ApplyEvaluationTemplateData>> => {
    const mutationOptions: UseMutationOptions<ApplyEvaluationTemplateResponse, DefaultError, Options<ApplyEvaluationTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await applyEvaluationTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSubjectEvaluationsQueryKey = (options: Options<GetSubjectEvaluationsData>) => createQueryKey('getSubjectEvaluations', options);

export const getSubjectEvaluationsOptions = (options: Options<GetSubjectEvaluationsData>) => queryOptions<GetSubjectEvaluationsResponse, DefaultError, GetSubjectEvaluationsResponse, ReturnType<typeof getSubjectEvaluationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSubjectEvaluations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSubjectEvaluationsQueryKey(options)
});

export const listCatalogSourcesQueryKey = (options?: Options<ListCatalogSourcesData>) => createQueryKey('listCatalogSources', options);

export const listCatalogSourcesOptions = (options?: Options<ListCatalogSourcesData>) => queryOptions<ListCatalogSourcesResponse, ListCatalogSourcesError, ListCatalogSourcesResponse, ReturnType<typeof listCatalogSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCatalogSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogSourcesQueryKey(options)
});

export const listCatalogCandidatesQueryKey = (options?: Options<ListCatalogCandidatesData>) => createQueryKey('listCatalogCandidates', options);

export const listCatalogCandidatesOptions = (options?: Options<ListCatalogCandidatesData>) => queryOptions<ListCatalogCandidatesResponse, ListCatalogCandidatesError, ListCatalogCandidatesResponse, ReturnType<typeof listCatalogCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCatalogCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogCandidatesQueryKey(options)
});

export const getCatalogCandidateQueryKey = (options: Options<GetCatalogCandidateData>) => createQueryKey('getCatalogCandidate', options);

export const getCatalogCandidateOptions = (options: Options<GetCatalogCandidateData>) => queryOptions<GetCatalogCandidateResponse, GetCatalogCandidateError, GetCatalogCandidateResponse, ReturnType<typeof getCatalogCandidateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCatalogCandidate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCatalogCandidateQueryKey(options)
});

export const listCatalogReviewQueueQueryKey = (options?: Options<ListCatalogReviewQueueData>) => createQueryKey('listCatalogReviewQueue', options);

export const listCatalogReviewQueueOptions = (options?: Options<ListCatalogReviewQueueData>) => queryOptions<ListCatalogReviewQueueResponse, ListCatalogReviewQueueError, ListCatalogReviewQueueResponse, ReturnType<typeof listCatalogReviewQueueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCatalogReviewQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogReviewQueueQueryKey(options)
});

export const processCatalogReviewQueueMutation = (options?: Partial<Options<ProcessCatalogReviewQueueData>>): UseMutationOptions<ProcessCatalogReviewQueueResponse, ProcessCatalogReviewQueueError, Options<ProcessCatalogReviewQueueData>> => {
    const mutationOptions: UseMutationOptions<ProcessCatalogReviewQueueResponse, ProcessCatalogReviewQueueError, Options<ProcessCatalogReviewQueueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processCatalogReviewQueue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const revertCatalogVersionAdoptionMutation = (options?: Partial<Options<RevertCatalogVersionAdoptionData>>): UseMutationOptions<RevertCatalogVersionAdoptionResponse, RevertCatalogVersionAdoptionError, Options<RevertCatalogVersionAdoptionData>> => {
    const mutationOptions: UseMutationOptions<RevertCatalogVersionAdoptionResponse, RevertCatalogVersionAdoptionError, Options<RevertCatalogVersionAdoptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revertCatalogVersionAdoption({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const retryCatalogReviewQueueMutation = (options?: Partial<Options<RetryCatalogReviewQueueData>>): UseMutationOptions<RetryCatalogReviewQueueResponse, RetryCatalogReviewQueueError, Options<RetryCatalogReviewQueueData>> => {
    const mutationOptions: UseMutationOptions<RetryCatalogReviewQueueResponse, RetryCatalogReviewQueueError, Options<RetryCatalogReviewQueueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryCatalogReviewQueue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const retryCatalogReviewQueueItemMutation = (options?: Partial<Options<RetryCatalogReviewQueueItemData>>): UseMutationOptions<RetryCatalogReviewQueueItemResponse, RetryCatalogReviewQueueItemError, Options<RetryCatalogReviewQueueItemData>> => {
    const mutationOptions: UseMutationOptions<RetryCatalogReviewQueueItemResponse, RetryCatalogReviewQueueItemError, Options<RetryCatalogReviewQueueItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryCatalogReviewQueueItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCatalogItemVersionsQueryKey = (options?: Options<ListCatalogItemVersionsData>) => createQueryKey('listCatalogItemVersions', options);

export const listCatalogItemVersionsOptions = (options?: Options<ListCatalogItemVersionsData>) => queryOptions<ListCatalogItemVersionsResponse, ListCatalogItemVersionsError, ListCatalogItemVersionsResponse, ReturnType<typeof listCatalogItemVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCatalogItemVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogItemVersionsQueryKey(options)
});

export const listCatalogVersionAdoptionsQueryKey = (options?: Options<ListCatalogVersionAdoptionsData>) => createQueryKey('listCatalogVersionAdoptions', options);

export const listCatalogVersionAdoptionsOptions = (options?: Options<ListCatalogVersionAdoptionsData>) => queryOptions<ListCatalogVersionAdoptionsResponse, ListCatalogVersionAdoptionsError, ListCatalogVersionAdoptionsResponse, ReturnType<typeof listCatalogVersionAdoptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCatalogVersionAdoptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCatalogVersionAdoptionsQueryKey(options)
});

export const upgradeCatalogVersionAdoptionMutation = (options?: Partial<Options<UpgradeCatalogVersionAdoptionData>>): UseMutationOptions<UpgradeCatalogVersionAdoptionResponse, UpgradeCatalogVersionAdoptionError, Options<UpgradeCatalogVersionAdoptionData>> => {
    const mutationOptions: UseMutationOptions<UpgradeCatalogVersionAdoptionResponse, UpgradeCatalogVersionAdoptionError, Options<UpgradeCatalogVersionAdoptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upgradeCatalogVersionAdoption({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const restoreCatalogItemVersionMutation = (options?: Partial<Options<RestoreCatalogItemVersionData>>): UseMutationOptions<RestoreCatalogItemVersionResponse, RestoreCatalogItemVersionError, Options<RestoreCatalogItemVersionData>> => {
    const mutationOptions: UseMutationOptions<RestoreCatalogItemVersionResponse, RestoreCatalogItemVersionError, Options<RestoreCatalogItemVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await restoreCatalogItemVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectCatalogCandidateMutation = (options?: Partial<Options<RejectCatalogCandidateData>>): UseMutationOptions<RejectCatalogCandidateResponse, RejectCatalogCandidateError, Options<RejectCatalogCandidateData>> => {
    const mutationOptions: UseMutationOptions<RejectCatalogCandidateResponse, RejectCatalogCandidateError, Options<RejectCatalogCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectCatalogCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deferCatalogCandidateMutation = (options?: Partial<Options<DeferCatalogCandidateData>>): UseMutationOptions<DeferCatalogCandidateResponse, DeferCatalogCandidateError, Options<DeferCatalogCandidateData>> => {
    const mutationOptions: UseMutationOptions<DeferCatalogCandidateResponse, DeferCatalogCandidateError, Options<DeferCatalogCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deferCatalogCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const retryCatalogCandidateReviewMutation = (options?: Partial<Options<RetryCatalogCandidateReviewData>>): UseMutationOptions<RetryCatalogCandidateReviewResponse, RetryCatalogCandidateReviewError, Options<RetryCatalogCandidateReviewData>> => {
    const mutationOptions: UseMutationOptions<RetryCatalogCandidateReviewResponse, RetryCatalogCandidateReviewError, Options<RetryCatalogCandidateReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryCatalogCandidateReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promoteCatalogCandidateMutation = (options?: Partial<Options<PromoteCatalogCandidateData>>): UseMutationOptions<PromoteCatalogCandidateResponse, PromoteCatalogCandidateError, Options<PromoteCatalogCandidateData>> => {
    const mutationOptions: UseMutationOptions<PromoteCatalogCandidateResponse, PromoteCatalogCandidateError, Options<PromoteCatalogCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promoteCatalogCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWidgetsQueryKey = (options?: Options<ListWidgetsData>) => createQueryKey('listWidgets', options);

export const listWidgetsOptions = (options?: Options<ListWidgetsData>) => queryOptions<ListWidgetsResponse, DefaultError, ListWidgetsResponse, ReturnType<typeof listWidgetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWidgets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWidgetsQueryKey(options)
});

export const createWidgetMutation = (options?: Partial<Options<CreateWidgetData>>): UseMutationOptions<CreateWidgetResponse, DefaultError, Options<CreateWidgetData>> => {
    const mutationOptions: UseMutationOptions<CreateWidgetResponse, DefaultError, Options<CreateWidgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWidget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWidgetQueryKey = (options: Options<GetWidgetData>) => createQueryKey('getWidget', options);

export const getWidgetOptions = (options: Options<GetWidgetData>) => queryOptions<GetWidgetResponse, DefaultError, GetWidgetResponse, ReturnType<typeof getWidgetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWidget({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWidgetQueryKey(options)
});

export const listPinnedWidgetsQueryKey = (options: Options<ListPinnedWidgetsData>) => createQueryKey('listPinnedWidgets', options);

export const listPinnedWidgetsOptions = (options: Options<ListPinnedWidgetsData>) => queryOptions<ListPinnedWidgetsResponse, DefaultError, ListPinnedWidgetsResponse, ReturnType<typeof listPinnedWidgetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPinnedWidgets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPinnedWidgetsQueryKey(options)
});

export const pinWidgetMutation = (options?: Partial<Options<PinWidgetData>>): UseMutationOptions<PinWidgetResponse, PinWidgetError, Options<PinWidgetData>> => {
    const mutationOptions: UseMutationOptions<PinWidgetResponse, PinWidgetError, Options<PinWidgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pinWidget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const unpinWidgetMutation = (options?: Partial<Options<UnpinWidgetData>>): UseMutationOptions<UnpinWidgetResponse, DefaultError, Options<UnpinWidgetData>> => {
    const mutationOptions: UseMutationOptions<UnpinWidgetResponse, DefaultError, Options<UnpinWidgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unpinWidget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updatePinnedWidgetMutation = (options?: Partial<Options<UpdatePinnedWidgetData>>): UseMutationOptions<UpdatePinnedWidgetResponse, DefaultError, Options<UpdatePinnedWidgetData>> => {
    const mutationOptions: UseMutationOptions<UpdatePinnedWidgetResponse, DefaultError, Options<UpdatePinnedWidgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePinnedWidget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOutputPartKindsQueryKey = (options?: Options<ListOutputPartKindsData>) => createQueryKey('listOutputPartKinds', options);

export const listOutputPartKindsOptions = (options?: Options<ListOutputPartKindsData>) => queryOptions<ListOutputPartKindsResponse, DefaultError, ListOutputPartKindsResponse, ReturnType<typeof listOutputPartKindsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOutputPartKinds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOutputPartKindsQueryKey(options)
});

export const queryOutputsQueryKey = (options?: Options<QueryOutputsData>) => createQueryKey('queryOutputs', options);

export const queryOutputsOptions = (options?: Options<QueryOutputsData>) => queryOptions<QueryOutputsResponse, DefaultError, QueryOutputsResponse, ReturnType<typeof queryOutputsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await queryOutputs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: queryOutputsQueryKey(options)
});

export const getLatestOutputQueryKey = (options?: Options<GetLatestOutputData>) => createQueryKey('getLatestOutput', options);

export const getLatestOutputOptions = (options?: Options<GetLatestOutputData>) => queryOptions<GetLatestOutputResponse, DefaultError, GetLatestOutputResponse, ReturnType<typeof getLatestOutputQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLatestOutput({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLatestOutputQueryKey(options)
});

export const getOutputMetricsQueryKey = (options?: Options<GetOutputMetricsData>) => createQueryKey('getOutputMetrics', options);

export const getOutputMetricsOptions = (options?: Options<GetOutputMetricsData>) => queryOptions<GetOutputMetricsResponse, DefaultError, GetOutputMetricsResponse, ReturnType<typeof getOutputMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOutputMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOutputMetricsQueryKey(options)
});

export const getOutputQueryKey = (options: Options<GetOutputData>) => createQueryKey('getOutput', options);

export const getOutputOptions = (options: Options<GetOutputData>) => queryOptions<GetOutputResponse, DefaultError, GetOutputResponse, ReturnType<typeof getOutputQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOutput({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOutputQueryKey(options)
});

export const downloadOutputQueryKey = (options: Options<DownloadOutputData>) => createQueryKey('downloadOutput', options);

export const downloadOutputOptions = (options: Options<DownloadOutputData>) => queryOptions<DownloadOutputResponse, DefaultError, DownloadOutputResponse, ReturnType<typeof downloadOutputQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadOutput({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadOutputQueryKey(options)
});

export const getPortTypeColorsQueryKey = (options?: Options<GetPortTypeColorsData>) => createQueryKey('getPortTypeColors', options);

export const getPortTypeColorsOptions = (options?: Options<GetPortTypeColorsData>) => queryOptions<GetPortTypeColorsResponse, DefaultError, GetPortTypeColorsResponse, ReturnType<typeof getPortTypeColorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortTypeColors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortTypeColorsQueryKey(options)
});

export const checkPortCompatibilityQueryKey = (options: Options<CheckPortCompatibilityData>) => createQueryKey('checkPortCompatibility', options);

export const checkPortCompatibilityOptions = (options: Options<CheckPortCompatibilityData>) => queryOptions<CheckPortCompatibilityResponse, DefaultError, CheckPortCompatibilityResponse, ReturnType<typeof checkPortCompatibilityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkPortCompatibility({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkPortCompatibilityQueryKey(options)
});

export const listPortTypesQueryKey = (options?: Options<ListPortTypesData>) => createQueryKey('listPortTypes', options);

export const listPortTypesOptions = (options?: Options<ListPortTypesData>) => queryOptions<ListPortTypesResponse, DefaultError, ListPortTypesResponse, ReturnType<typeof listPortTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortTypesQueryKey(options)
});

export const getPortTypeQueryKey = (options: Options<GetPortTypeData>) => createQueryKey('getPortType', options);

export const getPortTypeOptions = (options: Options<GetPortTypeData>) => queryOptions<GetPortTypeResponse, DefaultError, GetPortTypeResponse, ReturnType<typeof getPortTypeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortType({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortTypeQueryKey(options)
});

export const listDocumentsQueryKey = (options: Options<ListDocumentsData>) => createQueryKey('listDocuments', options);

export const listDocumentsOptions = (options: Options<ListDocumentsData>) => queryOptions<ListDocumentsResponse, DefaultError, ListDocumentsResponse, ReturnType<typeof listDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDocumentsQueryKey(options)
});

export const uploadDocumentMutation = (options?: Partial<Options<UploadDocumentData>>): UseMutationOptions<UploadDocumentResponse, DefaultError, Options<UploadDocumentData>> => {
    const mutationOptions: UseMutationOptions<UploadDocumentResponse, DefaultError, Options<UploadDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteDocumentMutation = (options?: Partial<Options<DeleteDocumentData>>): UseMutationOptions<DeleteDocumentResponse, DefaultError, Options<DeleteDocumentData>> => {
    const mutationOptions: UseMutationOptions<DeleteDocumentResponse, DefaultError, Options<DeleteDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentQueryKey = (options: Options<GetDocumentData>) => createQueryKey('getDocument', options);

export const getDocumentOptions = (options: Options<GetDocumentData>) => queryOptions<GetDocumentResponse, DefaultError, GetDocumentResponse, ReturnType<typeof getDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDocumentQueryKey(options)
});

export const setWorkflowRuntimePolicyMutation = (options?: Partial<Options<SetWorkflowRuntimePolicyData>>): UseMutationOptions<SetWorkflowRuntimePolicyResponse, DefaultError, Options<SetWorkflowRuntimePolicyData>> => {
    const mutationOptions: UseMutationOptions<SetWorkflowRuntimePolicyResponse, DefaultError, Options<SetWorkflowRuntimePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setWorkflowRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exportInstructionsMutation = (options?: Partial<Options<ExportInstructionsData>>): UseMutationOptions<ExportInstructionsResponse, DefaultError, Options<ExportInstructionsData>> => {
    const mutationOptions: UseMutationOptions<ExportInstructionsResponse, DefaultError, Options<ExportInstructionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportInstructions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkflowsQueryKey = (options?: Options<ListWorkflowsData>) => createQueryKey('listWorkflows', options);

export const listWorkflowsOptions = (options?: Options<ListWorkflowsData>) => queryOptions<ListWorkflowsResponse, DefaultError, ListWorkflowsResponse, ReturnType<typeof listWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkflows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkflowsQueryKey(options)
});

export const listWorkflowsInfiniteQueryKey = (options?: Options<ListWorkflowsData>): QueryKey<Options<ListWorkflowsData>> => createQueryKey('listWorkflows', options, true);

export const listWorkflowsInfiniteOptions = (options?: Options<ListWorkflowsData>) => {
    const opts = infiniteQueryOptions<ListWorkflowsResponse, DefaultError, InfiniteData<ListWorkflowsResponse>, QueryKey<Options<ListWorkflowsData>>, string | Pick<QueryKey<Options<ListWorkflowsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListWorkflowsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listWorkflows({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkflowsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createWorkflowMutation = (options?: Partial<Options<CreateWorkflowData>>): UseMutationOptions<CreateWorkflowResponse, DefaultError, Options<CreateWorkflowData>> => {
    const mutationOptions: UseMutationOptions<CreateWorkflowResponse, DefaultError, Options<CreateWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exportWorkflowInstructionsMutation = (options?: Partial<Options<ExportWorkflowInstructionsData>>): UseMutationOptions<ExportWorkflowInstructionsResponse, DefaultError, Options<ExportWorkflowInstructionsData>> => {
    const mutationOptions: UseMutationOptions<ExportWorkflowInstructionsResponse, DefaultError, Options<ExportWorkflowInstructionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportWorkflowInstructions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const restoreWorkflowMutation = (options?: Partial<Options<RestoreWorkflowData>>): UseMutationOptions<RestoreWorkflowResponse, DefaultError, Options<RestoreWorkflowData>> => {
    const mutationOptions: UseMutationOptions<RestoreWorkflowResponse, DefaultError, Options<RestoreWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await restoreWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const validateWorkflowMutation = (options?: Partial<Options<ValidateWorkflowData>>): UseMutationOptions<ValidateWorkflowResponse, DefaultError, Options<ValidateWorkflowData>> => {
    const mutationOptions: UseMutationOptions<ValidateWorkflowResponse, DefaultError, Options<ValidateWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reorderWorkflowStepsMutation = (options?: Partial<Options<ReorderWorkflowStepsData>>): UseMutationOptions<ReorderWorkflowStepsResponse, DefaultError, Options<ReorderWorkflowStepsData>> => {
    const mutationOptions: UseMutationOptions<ReorderWorkflowStepsResponse, DefaultError, Options<ReorderWorkflowStepsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reorderWorkflowSteps({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addWorkflowStepMutation = (options?: Partial<Options<AddWorkflowStepData>>): UseMutationOptions<AddWorkflowStepResponse, DefaultError, Options<AddWorkflowStepData>> => {
    const mutationOptions: UseMutationOptions<AddWorkflowStepResponse, DefaultError, Options<AddWorkflowStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addWorkflowStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeWorkflowStepMutation = (options?: Partial<Options<RemoveWorkflowStepData>>): UseMutationOptions<RemoveWorkflowStepResponse, DefaultError, Options<RemoveWorkflowStepData>> => {
    const mutationOptions: UseMutationOptions<RemoveWorkflowStepResponse, DefaultError, Options<RemoveWorkflowStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeWorkflowStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateWorkflowStepMutation = (options?: Partial<Options<UpdateWorkflowStepData>>): UseMutationOptions<UpdateWorkflowStepResponse, DefaultError, Options<UpdateWorkflowStepData>> => {
    const mutationOptions: UseMutationOptions<UpdateWorkflowStepResponse, DefaultError, Options<UpdateWorkflowStepData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWorkflowStep({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setWorkflowScheduleMutation = (options?: Partial<Options<SetWorkflowScheduleData>>): UseMutationOptions<SetWorkflowScheduleResponse, DefaultError, Options<SetWorkflowScheduleData>> => {
    const mutationOptions: UseMutationOptions<SetWorkflowScheduleResponse, DefaultError, Options<SetWorkflowScheduleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setWorkflowSchedule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkflowExecutionObservationsQueryKey = (options: Options<ListWorkflowExecutionObservationsData>) => createQueryKey('listWorkflowExecutionObservations', options);

export const listWorkflowExecutionObservationsOptions = (options: Options<ListWorkflowExecutionObservationsData>) => queryOptions<ListWorkflowExecutionObservationsResponse, DefaultError, ListWorkflowExecutionObservationsResponse, ReturnType<typeof listWorkflowExecutionObservationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkflowExecutionObservations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkflowExecutionObservationsQueryKey(options)
});

export const listWorkflowRunsQueryKey = (options: Options<ListWorkflowRunsData>) => createQueryKey('listWorkflowRuns', options);

export const listWorkflowRunsOptions = (options: Options<ListWorkflowRunsData>) => queryOptions<ListWorkflowRunsResponse, DefaultError, ListWorkflowRunsResponse, ReturnType<typeof listWorkflowRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkflowRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkflowRunsQueryKey(options)
});

export const triggerWorkflowMutation = (options?: Partial<Options<TriggerWorkflowData>>): UseMutationOptions<TriggerWorkflowResponse, DefaultError, Options<TriggerWorkflowData>> => {
    const mutationOptions: UseMutationOptions<TriggerWorkflowResponse, DefaultError, Options<TriggerWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkflowVersionsQueryKey = (options: Options<ListWorkflowVersionsData>) => createQueryKey('listWorkflowVersions', options);

export const listWorkflowVersionsOptions = (options: Options<ListWorkflowVersionsData>) => queryOptions<ListWorkflowVersionsResponse, DefaultError, ListWorkflowVersionsResponse, ReturnType<typeof listWorkflowVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkflowVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkflowVersionsQueryKey(options)
});

export const getWorkflowVersionQueryKey = (options: Options<GetWorkflowVersionData>) => createQueryKey('getWorkflowVersion', options);

export const getWorkflowVersionOptions = (options: Options<GetWorkflowVersionData>) => queryOptions<GetWorkflowVersionResponse, DefaultError, GetWorkflowVersionResponse, ReturnType<typeof getWorkflowVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkflowVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkflowVersionQueryKey(options)
});

export const diffWorkflowVersionsQueryKey = (options: Options<DiffWorkflowVersionsData>) => createQueryKey('diffWorkflowVersions', options);

export const diffWorkflowVersionsOptions = (options: Options<DiffWorkflowVersionsData>) => queryOptions<DiffWorkflowVersionsResponse, DefaultError, DiffWorkflowVersionsResponse, ReturnType<typeof diffWorkflowVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await diffWorkflowVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: diffWorkflowVersionsQueryKey(options)
});

export const restoreWorkflowVersionMutation = (options?: Partial<Options<RestoreWorkflowVersionData>>): UseMutationOptions<RestoreWorkflowVersionResponse, DefaultError, Options<RestoreWorkflowVersionData>> => {
    const mutationOptions: UseMutationOptions<RestoreWorkflowVersionResponse, DefaultError, Options<RestoreWorkflowVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await restoreWorkflowVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const saveWorkflowDefinitionGraphMutation = (options?: Partial<Options<SaveWorkflowDefinitionGraphData>>): UseMutationOptions<SaveWorkflowDefinitionGraphResponse, DefaultError, Options<SaveWorkflowDefinitionGraphData>> => {
    const mutationOptions: UseMutationOptions<SaveWorkflowDefinitionGraphResponse, DefaultError, Options<SaveWorkflowDefinitionGraphData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveWorkflowDefinitionGraph({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const archiveWorkflowMutation = (options?: Partial<Options<ArchiveWorkflowData>>): UseMutationOptions<ArchiveWorkflowResponse, DefaultError, Options<ArchiveWorkflowData>> => {
    const mutationOptions: UseMutationOptions<ArchiveWorkflowResponse, DefaultError, Options<ArchiveWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkflowQueryKey = (options: Options<GetWorkflowData>) => createQueryKey('getWorkflow', options);

export const getWorkflowOptions = (options: Options<GetWorkflowData>) => queryOptions<GetWorkflowResponse, DefaultError, GetWorkflowResponse, ReturnType<typeof getWorkflowQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkflow({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkflowQueryKey(options)
});

export const updateWorkflowMutation = (options?: Partial<Options<UpdateWorkflowData>>): UseMutationOptions<UpdateWorkflowResponse, DefaultError, Options<UpdateWorkflowData>> => {
    const mutationOptions: UseMutationOptions<UpdateWorkflowResponse, DefaultError, Options<UpdateWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkflowCloseSummaryQueryKey = (options: Options<GetWorkflowCloseSummaryData>) => createQueryKey('getWorkflowCloseSummary', options);

export const getWorkflowCloseSummaryOptions = (options: Options<GetWorkflowCloseSummaryData>) => queryOptions<GetWorkflowCloseSummaryResponse, DefaultError, GetWorkflowCloseSummaryResponse, ReturnType<typeof getWorkflowCloseSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkflowCloseSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkflowCloseSummaryQueryKey(options)
});

export const listWorkflowInstancesQueryKey = (options?: Options<ListWorkflowInstancesData>) => createQueryKey('listWorkflowInstances', options);

export const listWorkflowInstancesOptions = (options?: Options<ListWorkflowInstancesData>) => queryOptions<ListWorkflowInstancesResponse, DefaultError, ListWorkflowInstancesResponse, ReturnType<typeof listWorkflowInstancesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkflowInstances({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkflowInstancesQueryKey(options)
});

export const createWorkflowInstanceMutation = (options?: Partial<Options<CreateWorkflowInstanceData>>): UseMutationOptions<CreateWorkflowInstanceResponse, DefaultError, Options<CreateWorkflowInstanceData>> => {
    const mutationOptions: UseMutationOptions<CreateWorkflowInstanceResponse, DefaultError, Options<CreateWorkflowInstanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWorkflowInstance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkflowInstanceQueryKey = (options: Options<GetWorkflowInstanceData>) => createQueryKey('getWorkflowInstance', options);

export const getWorkflowInstanceOptions = (options: Options<GetWorkflowInstanceData>) => queryOptions<GetWorkflowInstanceResponse, DefaultError, GetWorkflowInstanceResponse, ReturnType<typeof getWorkflowInstanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkflowInstance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkflowInstanceQueryKey(options)
});

export const updateWorkflowInstanceMutation = (options?: Partial<Options<UpdateWorkflowInstanceData>>): UseMutationOptions<UpdateWorkflowInstanceResponse, DefaultError, Options<UpdateWorkflowInstanceData>> => {
    const mutationOptions: UseMutationOptions<UpdateWorkflowInstanceResponse, DefaultError, Options<UpdateWorkflowInstanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWorkflowInstance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const triggerWorkflowInstanceMutation = (options?: Partial<Options<TriggerWorkflowInstanceData>>): UseMutationOptions<TriggerWorkflowInstanceResponse, DefaultError, Options<TriggerWorkflowInstanceData>> => {
    const mutationOptions: UseMutationOptions<TriggerWorkflowInstanceResponse, DefaultError, Options<TriggerWorkflowInstanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerWorkflowInstance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchWorkflowDefinitionsQueryKey = (options: Options<SearchWorkflowDefinitionsData>) => createQueryKey('searchWorkflowDefinitions', options);

export const searchWorkflowDefinitionsOptions = (options: Options<SearchWorkflowDefinitionsData>) => queryOptions<SearchWorkflowDefinitionsResponse, DefaultError, SearchWorkflowDefinitionsResponse, ReturnType<typeof searchWorkflowDefinitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchWorkflowDefinitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchWorkflowDefinitionsQueryKey(options)
});

export const recommendWorkflowDefinitionsQueryKey = (options: Options<RecommendWorkflowDefinitionsData>) => createQueryKey('recommendWorkflowDefinitions', options);

export const recommendWorkflowDefinitionsOptions = (options: Options<RecommendWorkflowDefinitionsData>) => queryOptions<RecommendWorkflowDefinitionsResponse, DefaultError, RecommendWorkflowDefinitionsResponse, ReturnType<typeof recommendWorkflowDefinitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await recommendWorkflowDefinitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: recommendWorkflowDefinitionsQueryKey(options)
});

export const listOrganizationsQueryKey = (options?: Options<ListOrganizationsData>) => createQueryKey('listOrganizations', options);

export const listOrganizationsOptions = (options?: Options<ListOrganizationsData>) => queryOptions<ListOrganizationsResponse, DefaultError, ListOrganizationsResponse, ReturnType<typeof listOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationsQueryKey(options)
});

export const createOrganizationMutation = (options?: Partial<Options<CreateOrganizationData>>): UseMutationOptions<CreateOrganizationResponse, DefaultError, Options<CreateOrganizationData>> => {
    const mutationOptions: UseMutationOptions<CreateOrganizationResponse, DefaultError, Options<CreateOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyOrganizationsQueryKey = (options?: Options<GetMyOrganizationsData>) => createQueryKey('getMyOrganizations', options);

export const getMyOrganizationsOptions = (options?: Options<GetMyOrganizationsData>) => queryOptions<GetMyOrganizationsResponse, DefaultError, GetMyOrganizationsResponse, ReturnType<typeof getMyOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyOrganizationsQueryKey(options)
});

export const getOrganizationQueryKey = (options: Options<GetOrganizationData>) => createQueryKey('getOrganization', options);

export const getOrganizationOptions = (options: Options<GetOrganizationData>) => queryOptions<GetOrganizationResponse, DefaultError, GetOrganizationResponse, ReturnType<typeof getOrganizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationQueryKey(options)
});

export const updateOrganizationMutation = (options?: Partial<Options<UpdateOrganizationData>>): UseMutationOptions<UpdateOrganizationResponse, DefaultError, Options<UpdateOrganizationData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationResponse, DefaultError, Options<UpdateOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrgMembersQueryKey = (options: Options<ListOrgMembersData>) => createQueryKey('listOrgMembers', options);

export const listOrgMembersOptions = (options: Options<ListOrgMembersData>) => queryOptions<ListOrgMembersResponse, DefaultError, ListOrgMembersResponse, ReturnType<typeof listOrgMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrgMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrgMembersQueryKey(options)
});

export const addOrgMemberMutation = (options?: Partial<Options<AddOrgMemberData>>): UseMutationOptions<AddOrgMemberResponse, DefaultError, Options<AddOrgMemberData>> => {
    const mutationOptions: UseMutationOptions<AddOrgMemberResponse, DefaultError, Options<AddOrgMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addOrgMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const acknowledgeOrgModuleMutation = (options?: Partial<Options<AcknowledgeOrgModuleData>>): UseMutationOptions<AcknowledgeOrgModuleResponse, DefaultError, Options<AcknowledgeOrgModuleData>> => {
    const mutationOptions: UseMutationOptions<AcknowledgeOrgModuleResponse, DefaultError, Options<AcknowledgeOrgModuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acknowledgeOrgModule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTeamsQueryKey = (options: Options<ListTeamsData>) => createQueryKey('listTeams', options);

export const listTeamsOptions = (options: Options<ListTeamsData>) => queryOptions<ListTeamsResponse, DefaultError, ListTeamsResponse, ReturnType<typeof listTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTeams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTeamsQueryKey(options)
});

export const createTeamMutation = (options?: Partial<Options<CreateTeamData>>): UseMutationOptions<CreateTeamResponse, DefaultError, Options<CreateTeamData>> => {
    const mutationOptions: UseMutationOptions<CreateTeamResponse, DefaultError, Options<CreateTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyTeamsInOrgQueryKey = (options: Options<GetMyTeamsInOrgData>) => createQueryKey('getMyTeamsInOrg', options);

export const getMyTeamsInOrgOptions = (options: Options<GetMyTeamsInOrgData>) => queryOptions<GetMyTeamsInOrgResponse, DefaultError, GetMyTeamsInOrgResponse, ReturnType<typeof getMyTeamsInOrgQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyTeamsInOrg({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyTeamsInOrgQueryKey(options)
});

export const listTeamMembersQueryKey = (options: Options<ListTeamMembersData>) => createQueryKey('listTeamMembers', options);

export const listTeamMembersOptions = (options: Options<ListTeamMembersData>) => queryOptions<ListTeamMembersResponse, DefaultError, ListTeamMembersResponse, ReturnType<typeof listTeamMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTeamMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTeamMembersQueryKey(options)
});

export const addTeamMemberMutation = (options?: Partial<Options<AddTeamMemberData>>): UseMutationOptions<AddTeamMemberResponse, DefaultError, Options<AddTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddTeamMemberResponse, DefaultError, Options<AddTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeTeamMemberMutation = (options?: Partial<Options<RemoveTeamMemberData>>): UseMutationOptions<RemoveTeamMemberResponse, DefaultError, Options<RemoveTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveTeamMemberResponse, DefaultError, Options<RemoveTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrgInvitationsQueryKey = (options: Options<ListOrgInvitationsData>) => createQueryKey('listOrgInvitations', options);

export const listOrgInvitationsOptions = (options: Options<ListOrgInvitationsData>) => queryOptions<ListOrgInvitationsResponse, DefaultError, ListOrgInvitationsResponse, ReturnType<typeof listOrgInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrgInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrgInvitationsQueryKey(options)
});

export const createInvitationMutation = (options?: Partial<Options<CreateInvitationData>>): UseMutationOptions<CreateInvitationResponse, DefaultError, Options<CreateInvitationData>> => {
    const mutationOptions: UseMutationOptions<CreateInvitationResponse, DefaultError, Options<CreateInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAnalysisTemplatesQueryKey = (options?: Options<ListAnalysisTemplatesData>) => createQueryKey('listAnalysisTemplates', options);

export const listAnalysisTemplatesOptions = (options?: Options<ListAnalysisTemplatesData>) => queryOptions<ListAnalysisTemplatesResponse, DefaultError, ListAnalysisTemplatesResponse, ReturnType<typeof listAnalysisTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAnalysisTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAnalysisTemplatesQueryKey(options)
});

export const createAnalysisTemplateMutation = (options?: Partial<Options<CreateAnalysisTemplateData>>): UseMutationOptions<CreateAnalysisTemplateResponse, DefaultError, Options<CreateAnalysisTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateAnalysisTemplateResponse, DefaultError, Options<CreateAnalysisTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAnalysisTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteAnalysisTemplateMutation = (options?: Partial<Options<DeleteAnalysisTemplateData>>): UseMutationOptions<DeleteAnalysisTemplateResponse, DefaultError, Options<DeleteAnalysisTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteAnalysisTemplateResponse, DefaultError, Options<DeleteAnalysisTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAnalysisTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAnalysisTemplateQueryKey = (options: Options<GetAnalysisTemplateData>) => createQueryKey('getAnalysisTemplate', options);

export const getAnalysisTemplateOptions = (options: Options<GetAnalysisTemplateData>) => queryOptions<GetAnalysisTemplateResponse, DefaultError, GetAnalysisTemplateResponse, ReturnType<typeof getAnalysisTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAnalysisTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAnalysisTemplateQueryKey(options)
});

export const updateAnalysisTemplateMutation = (options?: Partial<Options<UpdateAnalysisTemplateData>>): UseMutationOptions<UpdateAnalysisTemplateResponse, DefaultError, Options<UpdateAnalysisTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateAnalysisTemplateResponse, DefaultError, Options<UpdateAnalysisTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAnalysisTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cloneAnalysisTemplateMutation = (options?: Partial<Options<CloneAnalysisTemplateData>>): UseMutationOptions<CloneAnalysisTemplateResponse, DefaultError, Options<CloneAnalysisTemplateData>> => {
    const mutationOptions: UseMutationOptions<CloneAnalysisTemplateResponse, DefaultError, Options<CloneAnalysisTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cloneAnalysisTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listIntelPlatformsQueryKey = (options?: Options<ListIntelPlatformsData>) => createQueryKey('listIntelPlatforms', options);

export const listIntelPlatformsOptions = (options?: Options<ListIntelPlatformsData>) => queryOptions<ListIntelPlatformsResponse, DefaultError, ListIntelPlatformsResponse, ReturnType<typeof listIntelPlatformsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIntelPlatforms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIntelPlatformsQueryKey(options)
});

export const createIntelPlatformMutation = (options?: Partial<Options<CreateIntelPlatformData>>): UseMutationOptions<CreateIntelPlatformResponse, DefaultError, Options<CreateIntelPlatformData>> => {
    const mutationOptions: UseMutationOptions<CreateIntelPlatformResponse, DefaultError, Options<CreateIntelPlatformData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIntelPlatform({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const testIntelPlatformMutation = (options?: Partial<Options<TestIntelPlatformData>>): UseMutationOptions<TestIntelPlatformResponse, DefaultError, Options<TestIntelPlatformData>> => {
    const mutationOptions: UseMutationOptions<TestIntelPlatformResponse, DefaultError, Options<TestIntelPlatformData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testIntelPlatform({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIntelPlatformUsageQueryKey = (options: Options<GetIntelPlatformUsageData>) => createQueryKey('getIntelPlatformUsage', options);

export const getIntelPlatformUsageOptions = (options: Options<GetIntelPlatformUsageData>) => queryOptions<GetIntelPlatformUsageResponse, DefaultError, GetIntelPlatformUsageResponse, ReturnType<typeof getIntelPlatformUsageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIntelPlatformUsage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIntelPlatformUsageQueryKey(options)
});

export const updateIntelPlatformMutation = (options?: Partial<Options<UpdateIntelPlatformData>>): UseMutationOptions<UpdateIntelPlatformResponse, DefaultError, Options<UpdateIntelPlatformData>> => {
    const mutationOptions: UseMutationOptions<UpdateIntelPlatformResponse, DefaultError, Options<UpdateIntelPlatformData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateIntelPlatform({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listIntelSourcesQueryKey = (options?: Options<ListIntelSourcesData>) => createQueryKey('listIntelSources', options);

export const listIntelSourcesOptions = (options?: Options<ListIntelSourcesData>) => queryOptions<ListIntelSourcesResponse, DefaultError, ListIntelSourcesResponse, ReturnType<typeof listIntelSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIntelSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIntelSourcesQueryKey(options)
});

export const listIntelSourcesInfiniteQueryKey = (options?: Options<ListIntelSourcesData>): QueryKey<Options<ListIntelSourcesData>> => createQueryKey('listIntelSources', options, true);

export const listIntelSourcesInfiniteOptions = (options?: Options<ListIntelSourcesData>) => {
    const opts = infiniteQueryOptions<ListIntelSourcesResponse, DefaultError, InfiniteData<ListIntelSourcesResponse>, QueryKey<Options<ListIntelSourcesData>>, number | null | Pick<QueryKey<Options<ListIntelSourcesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListIntelSourcesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listIntelSources({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listIntelSourcesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createIntelSourceMutation = (options?: Partial<Options<CreateIntelSourceData>>): UseMutationOptions<CreateIntelSourceResponse, CreateIntelSourceError, Options<CreateIntelSourceData>> => {
    const mutationOptions: UseMutationOptions<CreateIntelSourceResponse, CreateIntelSourceError, Options<CreateIntelSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIntelSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const discoverIntelSourceMutation = (options?: Partial<Options<DiscoverIntelSourceData>>): UseMutationOptions<DiscoverIntelSourceResponse, DefaultError, Options<DiscoverIntelSourceData>> => {
    const mutationOptions: UseMutationOptions<DiscoverIntelSourceResponse, DefaultError, Options<DiscoverIntelSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await discoverIntelSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bulkCreateIntelSourcesMutation = (options?: Partial<Options<BulkCreateIntelSourcesData>>): UseMutationOptions<BulkCreateIntelSourcesResponse, BulkCreateIntelSourcesError, Options<BulkCreateIntelSourcesData>> => {
    const mutationOptions: UseMutationOptions<BulkCreateIntelSourcesResponse, BulkCreateIntelSourcesError, Options<BulkCreateIntelSourcesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkCreateIntelSources({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const batchFetchIntelSourcesMutation = (options?: Partial<Options<BatchFetchIntelSourcesData>>): UseMutationOptions<BatchFetchIntelSourcesResponse, DefaultError, Options<BatchFetchIntelSourcesData>> => {
    const mutationOptions: UseMutationOptions<BatchFetchIntelSourcesResponse, DefaultError, Options<BatchFetchIntelSourcesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchFetchIntelSources({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const batchDeactivateIntelSourcesMutation = (options?: Partial<Options<BatchDeactivateIntelSourcesData>>): UseMutationOptions<BatchDeactivateIntelSourcesResponse, DefaultError, Options<BatchDeactivateIntelSourcesData>> => {
    const mutationOptions: UseMutationOptions<BatchDeactivateIntelSourcesResponse, DefaultError, Options<BatchDeactivateIntelSourcesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchDeactivateIntelSources({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteIntelSourceMutation = (options?: Partial<Options<DeleteIntelSourceData>>): UseMutationOptions<DeleteIntelSourceResponse, DeleteIntelSourceError, Options<DeleteIntelSourceData>> => {
    const mutationOptions: UseMutationOptions<DeleteIntelSourceResponse, DeleteIntelSourceError, Options<DeleteIntelSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteIntelSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIntelSourceQueryKey = (options: Options<GetIntelSourceData>) => createQueryKey('getIntelSource', options);

export const getIntelSourceOptions = (options: Options<GetIntelSourceData>) => queryOptions<GetIntelSourceResponse, GetIntelSourceError, GetIntelSourceResponse, ReturnType<typeof getIntelSourceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIntelSource({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIntelSourceQueryKey(options)
});

export const updateIntelSourceMutation = (options?: Partial<Options<UpdateIntelSourceData>>): UseMutationOptions<UpdateIntelSourceResponse, UpdateIntelSourceError, Options<UpdateIntelSourceData>> => {
    const mutationOptions: UseMutationOptions<UpdateIntelSourceResponse, UpdateIntelSourceError, Options<UpdateIntelSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateIntelSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fetchIntelSourceMutation = (options?: Partial<Options<FetchIntelSourceData>>): UseMutationOptions<FetchIntelSourceResponse, DefaultError, Options<FetchIntelSourceData>> => {
    const mutationOptions: UseMutationOptions<FetchIntelSourceResponse, DefaultError, Options<FetchIntelSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fetchIntelSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIntelSourceHarvestedQueryKey = (options: Options<GetIntelSourceHarvestedData>) => createQueryKey('getIntelSourceHarvested', options);

export const getIntelSourceHarvestedOptions = (options: Options<GetIntelSourceHarvestedData>) => queryOptions<GetIntelSourceHarvestedResponse, GetIntelSourceHarvestedError, GetIntelSourceHarvestedResponse, ReturnType<typeof getIntelSourceHarvestedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIntelSourceHarvested({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIntelSourceHarvestedQueryKey(options)
});

export const createIntelSourceSubscriptionMutation = (options?: Partial<Options<CreateIntelSourceSubscriptionData>>): UseMutationOptions<CreateIntelSourceSubscriptionResponse, DefaultError, Options<CreateIntelSourceSubscriptionData>> => {
    const mutationOptions: UseMutationOptions<CreateIntelSourceSubscriptionResponse, DefaultError, Options<CreateIntelSourceSubscriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIntelSourceSubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reviewIntelSourceApprovalMutation = (options?: Partial<Options<ReviewIntelSourceApprovalData>>): UseMutationOptions<ReviewIntelSourceApprovalResponse, DefaultError, Options<ReviewIntelSourceApprovalData>> => {
    const mutationOptions: UseMutationOptions<ReviewIntelSourceApprovalResponse, DefaultError, Options<ReviewIntelSourceApprovalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reviewIntelSourceApproval({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const recordIntelSourceConsentMutation = (options?: Partial<Options<RecordIntelSourceConsentData>>): UseMutationOptions<RecordIntelSourceConsentResponse, DefaultError, Options<RecordIntelSourceConsentData>> => {
    const mutationOptions: UseMutationOptions<RecordIntelSourceConsentResponse, DefaultError, Options<RecordIntelSourceConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordIntelSourceConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createIntelSourceMonitorMutation = (options?: Partial<Options<CreateIntelSourceMonitorData>>): UseMutationOptions<CreateIntelSourceMonitorResponse, DefaultError, Options<CreateIntelSourceMonitorData>> => {
    const mutationOptions: UseMutationOptions<CreateIntelSourceMonitorResponse, DefaultError, Options<CreateIntelSourceMonitorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIntelSourceMonitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listIntelSourceItemInsightsQueryKey = (options: Options<ListIntelSourceItemInsightsData>) => createQueryKey('listIntelSourceItemInsights', options);

export const listIntelSourceItemInsightsOptions = (options: Options<ListIntelSourceItemInsightsData>) => queryOptions<ListIntelSourceItemInsightsResponse, DefaultError, ListIntelSourceItemInsightsResponse, ReturnType<typeof listIntelSourceItemInsightsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIntelSourceItemInsights({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIntelSourceItemInsightsQueryKey(options)
});

export const listIntelSourceSubscriptionsQueryKey = (options?: Options<ListIntelSourceSubscriptionsData>) => createQueryKey('listIntelSourceSubscriptions', options);

export const listIntelSourceSubscriptionsOptions = (options?: Options<ListIntelSourceSubscriptionsData>) => queryOptions<ListIntelSourceSubscriptionsResponse, DefaultError, ListIntelSourceSubscriptionsResponse, ReturnType<typeof listIntelSourceSubscriptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIntelSourceSubscriptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIntelSourceSubscriptionsQueryKey(options)
});

export const listIntelSourceSubscriptionsInfiniteQueryKey = (options?: Options<ListIntelSourceSubscriptionsData>): QueryKey<Options<ListIntelSourceSubscriptionsData>> => createQueryKey('listIntelSourceSubscriptions', options, true);

export const listIntelSourceSubscriptionsInfiniteOptions = (options?: Options<ListIntelSourceSubscriptionsData>) => {
    const opts = infiniteQueryOptions<ListIntelSourceSubscriptionsResponse, DefaultError, InfiniteData<ListIntelSourceSubscriptionsResponse>, QueryKey<Options<ListIntelSourceSubscriptionsData>>, number | null | Pick<QueryKey<Options<ListIntelSourceSubscriptionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListIntelSourceSubscriptionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listIntelSourceSubscriptions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listIntelSourceSubscriptionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const updateIntelSourceSubscriptionMutation = (options?: Partial<Options<UpdateIntelSourceSubscriptionData>>): UseMutationOptions<UpdateIntelSourceSubscriptionResponse, DefaultError, Options<UpdateIntelSourceSubscriptionData>> => {
    const mutationOptions: UseMutationOptions<UpdateIntelSourceSubscriptionResponse, DefaultError, Options<UpdateIntelSourceSubscriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateIntelSourceSubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listIntelSourceFetchRunsQueryKey = (options: Options<ListIntelSourceFetchRunsData>) => createQueryKey('listIntelSourceFetchRuns', options);

export const listIntelSourceFetchRunsOptions = (options: Options<ListIntelSourceFetchRunsData>) => queryOptions<ListIntelSourceFetchRunsResponse, DefaultError, ListIntelSourceFetchRunsResponse, ReturnType<typeof listIntelSourceFetchRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIntelSourceFetchRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIntelSourceFetchRunsQueryKey(options)
});

export const listIntelSourceFetchRunsInfiniteQueryKey = (options: Options<ListIntelSourceFetchRunsData>): QueryKey<Options<ListIntelSourceFetchRunsData>> => createQueryKey('listIntelSourceFetchRuns', options, true);

export const listIntelSourceFetchRunsInfiniteOptions = (options: Options<ListIntelSourceFetchRunsData>) => {
    const opts = infiniteQueryOptions<ListIntelSourceFetchRunsResponse, DefaultError, InfiniteData<ListIntelSourceFetchRunsResponse>, QueryKey<Options<ListIntelSourceFetchRunsData>>, number | null | Pick<QueryKey<Options<ListIntelSourceFetchRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListIntelSourceFetchRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listIntelSourceFetchRuns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listIntelSourceFetchRunsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const backfillIntelSourceSubscriptionMutation = (options?: Partial<Options<BackfillIntelSourceSubscriptionData>>): UseMutationOptions<BackfillIntelSourceSubscriptionResponse, DefaultError, Options<BackfillIntelSourceSubscriptionData>> => {
    const mutationOptions: UseMutationOptions<BackfillIntelSourceSubscriptionResponse, DefaultError, Options<BackfillIntelSourceSubscriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await backfillIntelSourceSubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listIntelSourceMonitorsQueryKey = (options?: Options<ListIntelSourceMonitorsData>) => createQueryKey('listIntelSourceMonitors', options);

export const listIntelSourceMonitorsOptions = (options?: Options<ListIntelSourceMonitorsData>) => queryOptions<ListIntelSourceMonitorsResponse, DefaultError, ListIntelSourceMonitorsResponse, ReturnType<typeof listIntelSourceMonitorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIntelSourceMonitors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIntelSourceMonitorsQueryKey(options)
});

export const listIntelSourceMonitorsInfiniteQueryKey = (options?: Options<ListIntelSourceMonitorsData>): QueryKey<Options<ListIntelSourceMonitorsData>> => createQueryKey('listIntelSourceMonitors', options, true);

export const listIntelSourceMonitorsInfiniteOptions = (options?: Options<ListIntelSourceMonitorsData>) => {
    const opts = infiniteQueryOptions<ListIntelSourceMonitorsResponse, DefaultError, InfiniteData<ListIntelSourceMonitorsResponse>, QueryKey<Options<ListIntelSourceMonitorsData>>, number | null | Pick<QueryKey<Options<ListIntelSourceMonitorsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListIntelSourceMonitorsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listIntelSourceMonitors({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listIntelSourceMonitorsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const updateIntelSourceMonitorMutation = (options?: Partial<Options<UpdateIntelSourceMonitorData>>): UseMutationOptions<UpdateIntelSourceMonitorResponse, DefaultError, Options<UpdateIntelSourceMonitorData>> => {
    const mutationOptions: UseMutationOptions<UpdateIntelSourceMonitorResponse, DefaultError, Options<UpdateIntelSourceMonitorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateIntelSourceMonitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fetchIntelSourceMonitorMutation = (options?: Partial<Options<FetchIntelSourceMonitorData>>): UseMutationOptions<FetchIntelSourceMonitorResponse, DefaultError, Options<FetchIntelSourceMonitorData>> => {
    const mutationOptions: UseMutationOptions<FetchIntelSourceMonitorResponse, DefaultError, Options<FetchIntelSourceMonitorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fetchIntelSourceMonitor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listIntelSourceMonitorFetchRunsQueryKey = (options: Options<ListIntelSourceMonitorFetchRunsData>) => createQueryKey('listIntelSourceMonitorFetchRuns', options);

export const listIntelSourceMonitorFetchRunsOptions = (options: Options<ListIntelSourceMonitorFetchRunsData>) => queryOptions<ListIntelSourceMonitorFetchRunsResponse, DefaultError, ListIntelSourceMonitorFetchRunsResponse, ReturnType<typeof listIntelSourceMonitorFetchRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIntelSourceMonitorFetchRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIntelSourceMonitorFetchRunsQueryKey(options)
});

export const listIntelSourceMonitorFetchRunsInfiniteQueryKey = (options: Options<ListIntelSourceMonitorFetchRunsData>): QueryKey<Options<ListIntelSourceMonitorFetchRunsData>> => createQueryKey('listIntelSourceMonitorFetchRuns', options, true);

export const listIntelSourceMonitorFetchRunsInfiniteOptions = (options: Options<ListIntelSourceMonitorFetchRunsData>) => {
    const opts = infiniteQueryOptions<ListIntelSourceMonitorFetchRunsResponse, DefaultError, InfiniteData<ListIntelSourceMonitorFetchRunsResponse>, QueryKey<Options<ListIntelSourceMonitorFetchRunsData>>, number | null | Pick<QueryKey<Options<ListIntelSourceMonitorFetchRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListIntelSourceMonitorFetchRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listIntelSourceMonitorFetchRuns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listIntelSourceMonitorFetchRunsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listDashboardsQueryKey = (options?: Options<ListDashboardsData>) => createQueryKey('listDashboards', options);

export const listDashboardsOptions = (options?: Options<ListDashboardsData>) => queryOptions<ListDashboardsResponse, DefaultError, ListDashboardsResponse, ReturnType<typeof listDashboardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDashboards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDashboardsQueryKey(options)
});

export const createDashboardMutation = (options?: Partial<Options<CreateDashboardData>>): UseMutationOptions<CreateDashboardResponse, DefaultError, Options<CreateDashboardData>> => {
    const mutationOptions: UseMutationOptions<CreateDashboardResponse, DefaultError, Options<CreateDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteDashboardMutation = (options?: Partial<Options<DeleteDashboardData>>): UseMutationOptions<DeleteDashboardResponse, DefaultError, Options<DeleteDashboardData>> => {
    const mutationOptions: UseMutationOptions<DeleteDashboardResponse, DefaultError, Options<DeleteDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDashboardQueryKey = (options: Options<GetDashboardData>) => createQueryKey('getDashboard', options);

export const getDashboardOptions = (options: Options<GetDashboardData>) => queryOptions<GetDashboardResponse, DefaultError, GetDashboardResponse, ReturnType<typeof getDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDashboardQueryKey(options)
});

export const updateDashboardMutation = (options?: Partial<Options<UpdateDashboardData>>): UseMutationOptions<UpdateDashboardResponse, DefaultError, Options<UpdateDashboardData>> => {
    const mutationOptions: UseMutationOptions<UpdateDashboardResponse, DefaultError, Options<UpdateDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addWidgetMutation = (options?: Partial<Options<AddWidgetData>>): UseMutationOptions<AddWidgetResponse, DefaultError, Options<AddWidgetData>> => {
    const mutationOptions: UseMutationOptions<AddWidgetResponse, DefaultError, Options<AddWidgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addWidget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reorderWidgetsMutation = (options?: Partial<Options<ReorderWidgetsData>>): UseMutationOptions<ReorderWidgetsResponse, DefaultError, Options<ReorderWidgetsData>> => {
    const mutationOptions: UseMutationOptions<ReorderWidgetsResponse, DefaultError, Options<ReorderWidgetsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reorderWidgets({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeWidgetMutation = (options?: Partial<Options<RemoveWidgetData>>): UseMutationOptions<RemoveWidgetResponse, DefaultError, Options<RemoveWidgetData>> => {
    const mutationOptions: UseMutationOptions<RemoveWidgetResponse, DefaultError, Options<RemoveWidgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeWidget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateWidgetMutation = (options?: Partial<Options<UpdateWidgetData>>): UseMutationOptions<UpdateWidgetResponse, DefaultError, Options<UpdateWidgetData>> => {
    const mutationOptions: UseMutationOptions<UpdateWidgetResponse, DefaultError, Options<UpdateWidgetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWidget({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a dashboard from the current user's landing rail
 */
export const unpinDashboardMutation = (options?: Partial<Options<UnpinDashboardData>>): UseMutationOptions<UnpinDashboardResponse, DefaultError, Options<UnpinDashboardData>> => {
    const mutationOptions: UseMutationOptions<UnpinDashboardResponse, DefaultError, Options<UnpinDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unpinDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pin a dashboard to the current user's landing rail
 */
export const pinDashboardMutation = (options?: Partial<Options<PinDashboardData>>): UseMutationOptions<PinDashboardResponse, DefaultError, Options<PinDashboardData>> => {
    const mutationOptions: UseMutationOptions<PinDashboardResponse, DefaultError, Options<PinDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pinDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMcpConnectionsQueryKey = (options?: Options<ListMcpConnectionsData>) => createQueryKey('listMcpConnections', options);

export const listMcpConnectionsOptions = (options?: Options<ListMcpConnectionsData>) => queryOptions<ListMcpConnectionsResponse, DefaultError, ListMcpConnectionsResponse, ReturnType<typeof listMcpConnectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMcpConnections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMcpConnectionsQueryKey(options)
});

export const createMcpConnectionMutation = (options?: Partial<Options<CreateMcpConnectionData>>): UseMutationOptions<CreateMcpConnectionResponse, DefaultError, Options<CreateMcpConnectionData>> => {
    const mutationOptions: UseMutationOptions<CreateMcpConnectionResponse, DefaultError, Options<CreateMcpConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMcpConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMcpConnectionMutation = (options?: Partial<Options<DeleteMcpConnectionData>>): UseMutationOptions<DeleteMcpConnectionResponse, DefaultError, Options<DeleteMcpConnectionData>> => {
    const mutationOptions: UseMutationOptions<DeleteMcpConnectionResponse, DefaultError, Options<DeleteMcpConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMcpConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMcpConnectionQueryKey = (options: Options<GetMcpConnectionData>) => createQueryKey('getMcpConnection', options);

export const getMcpConnectionOptions = (options: Options<GetMcpConnectionData>) => queryOptions<GetMcpConnectionResponse, DefaultError, GetMcpConnectionResponse, ReturnType<typeof getMcpConnectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMcpConnection({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMcpConnectionQueryKey(options)
});

export const updateMcpConnectionMutation = (options?: Partial<Options<UpdateMcpConnectionData>>): UseMutationOptions<UpdateMcpConnectionResponse, DefaultError, Options<UpdateMcpConnectionData>> => {
    const mutationOptions: UseMutationOptions<UpdateMcpConnectionResponse, DefaultError, Options<UpdateMcpConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMcpConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const connectMcpConnectionMutation = (options?: Partial<Options<ConnectMcpConnectionData>>): UseMutationOptions<ConnectMcpConnectionResponse, DefaultError, Options<ConnectMcpConnectionData>> => {
    const mutationOptions: UseMutationOptions<ConnectMcpConnectionResponse, DefaultError, Options<ConnectMcpConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectMcpConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const disconnectMcpConnectionMutation = (options?: Partial<Options<DisconnectMcpConnectionData>>): UseMutationOptions<DisconnectMcpConnectionResponse, DefaultError, Options<DisconnectMcpConnectionData>> => {
    const mutationOptions: UseMutationOptions<DisconnectMcpConnectionResponse, DefaultError, Options<DisconnectMcpConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disconnectMcpConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMcpConnectionToolsQueryKey = (options: Options<ListMcpConnectionToolsData>) => createQueryKey('listMcpConnectionTools', options);

export const listMcpConnectionToolsOptions = (options: Options<ListMcpConnectionToolsData>) => queryOptions<ListMcpConnectionToolsResponse, DefaultError, ListMcpConnectionToolsResponse, ReturnType<typeof listMcpConnectionToolsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMcpConnectionTools({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMcpConnectionToolsQueryKey(options)
});

export const testMcpConnectionMutation = (options?: Partial<Options<TestMcpConnectionData>>): UseMutationOptions<TestMcpConnectionResponse, DefaultError, Options<TestMcpConnectionData>> => {
    const mutationOptions: UseMutationOptions<TestMcpConnectionResponse, DefaultError, Options<TestMcpConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testMcpConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchDaemonsQueryKey = (options: Options<SearchDaemonsData>) => createQueryKey('searchDaemons', options);

export const searchDaemonsOptions = (options: Options<SearchDaemonsData>) => queryOptions<SearchDaemonsResponse, DefaultError, SearchDaemonsResponse, ReturnType<typeof searchDaemonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchDaemons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchDaemonsQueryKey(options)
});

export const recommendDaemonsQueryKey = (options: Options<RecommendDaemonsData>) => createQueryKey('recommendDaemons', options);

export const recommendDaemonsOptions = (options: Options<RecommendDaemonsData>) => queryOptions<RecommendDaemonsResponse, DefaultError, RecommendDaemonsResponse, ReturnType<typeof recommendDaemonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await recommendDaemons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: recommendDaemonsQueryKey(options)
});

export const searchWorkforceQueryKey = (options: Options<SearchWorkforceData>) => createQueryKey('searchWorkforce', options);

export const searchWorkforceOptions = (options: Options<SearchWorkforceData>) => queryOptions<SearchWorkforceResponse, DefaultError, SearchWorkforceResponse, ReturnType<typeof searchWorkforceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchWorkforce({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchWorkforceQueryKey(options)
});

export const recommendWorkforceQueryKey = (options: Options<RecommendWorkforceData>) => createQueryKey('recommendWorkforce', options);

export const recommendWorkforceOptions = (options: Options<RecommendWorkforceData>) => queryOptions<RecommendWorkforceResponse, DefaultError, RecommendWorkforceResponse, ReturnType<typeof recommendWorkforceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await recommendWorkforce({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: recommendWorkforceQueryKey(options)
});

export const listDaemonsEventCatalogQueryKey = (options?: Options<ListDaemonsEventCatalogData>) => createQueryKey('listDaemonsEventCatalog', options);

export const listDaemonsEventCatalogOptions = (options?: Options<ListDaemonsEventCatalogData>) => queryOptions<ListDaemonsEventCatalogResponse, DefaultError, ListDaemonsEventCatalogResponse, ReturnType<typeof listDaemonsEventCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonsEventCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonsEventCatalogQueryKey(options)
});

export const getDaemonsSummaryQueryKey = (options?: Options<GetDaemonsSummaryData>) => createQueryKey('getDaemonsSummary', options);

export const getDaemonsSummaryOptions = (options?: Options<GetDaemonsSummaryData>) => queryOptions<GetDaemonsSummaryResponse, DefaultError, GetDaemonsSummaryResponse, ReturnType<typeof getDaemonsSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDaemonsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDaemonsSummaryQueryKey(options)
});

export const listDaemonsAssignmentsQueryKey = (options?: Options<ListDaemonsAssignmentsData>) => createQueryKey('listDaemonsAssignments', options);

export const listDaemonsAssignmentsOptions = (options?: Options<ListDaemonsAssignmentsData>) => queryOptions<ListDaemonsAssignmentsResponse, DefaultError, ListDaemonsAssignmentsResponse, ReturnType<typeof listDaemonsAssignmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonsAssignments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonsAssignmentsQueryKey(options)
});

export const resumeAllDaemonsMutation = (options?: Partial<Options<ResumeAllDaemonsData>>): UseMutationOptions<ResumeAllDaemonsResponse, DefaultError, Options<ResumeAllDaemonsData>> => {
    const mutationOptions: UseMutationOptions<ResumeAllDaemonsResponse, DefaultError, Options<ResumeAllDaemonsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resumeAllDaemons({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const terminateAllDaemonsMutation = (options?: Partial<Options<TerminateAllDaemonsData>>): UseMutationOptions<TerminateAllDaemonsResponse, DefaultError, Options<TerminateAllDaemonsData>> => {
    const mutationOptions: UseMutationOptions<TerminateAllDaemonsResponse, DefaultError, Options<TerminateAllDaemonsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await terminateAllDaemons({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reviewDaemonsFindingMutation = (options?: Partial<Options<ReviewDaemonsFindingData>>): UseMutationOptions<ReviewDaemonsFindingResponse, DefaultError, Options<ReviewDaemonsFindingData>> => {
    const mutationOptions: UseMutationOptions<ReviewDaemonsFindingResponse, DefaultError, Options<ReviewDaemonsFindingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reviewDaemonsFinding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDaemonPermissionGrantsQueryKey = (options: Options<ListDaemonPermissionGrantsData>) => createQueryKey('listDaemonPermissionGrants', options);

export const listDaemonPermissionGrantsOptions = (options: Options<ListDaemonPermissionGrantsData>) => queryOptions<ListDaemonPermissionGrantsResponse, DefaultError, ListDaemonPermissionGrantsResponse, ReturnType<typeof listDaemonPermissionGrantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonPermissionGrants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonPermissionGrantsQueryKey(options)
});

export const revokeDaemonPermissionGrantMutation = (options?: Partial<Options<RevokeDaemonPermissionGrantData>>): UseMutationOptions<RevokeDaemonPermissionGrantResponse, DefaultError, Options<RevokeDaemonPermissionGrantData>> => {
    const mutationOptions: UseMutationOptions<RevokeDaemonPermissionGrantResponse, DefaultError, Options<RevokeDaemonPermissionGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeDaemonPermissionGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const runDaemonMutation = (options?: Partial<Options<RunDaemonData>>): UseMutationOptions<RunDaemonResponse, DefaultError, Options<RunDaemonData>> => {
    const mutationOptions: UseMutationOptions<RunDaemonResponse, DefaultError, Options<RunDaemonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runDaemon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDaemonRunsQueryKey = (options: Options<ListDaemonRunsData>) => createQueryKey('listDaemonRuns', options);

export const listDaemonRunsOptions = (options: Options<ListDaemonRunsData>) => queryOptions<ListDaemonRunsResponse, DefaultError, ListDaemonRunsResponse, ReturnType<typeof listDaemonRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonRunsQueryKey(options)
});

export const getDaemonRunQueryKey = (options: Options<GetDaemonRunData>) => createQueryKey('getDaemonRun', options);

export const getDaemonRunOptions = (options: Options<GetDaemonRunData>) => queryOptions<GetDaemonRunResponse, DefaultError, GetDaemonRunResponse, ReturnType<typeof getDaemonRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDaemonRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDaemonRunQueryKey(options)
});

export const listDaemonRunReportsQueryKey = (options: Options<ListDaemonRunReportsData>) => createQueryKey('listDaemonRunReports', options);

export const listDaemonRunReportsOptions = (options: Options<ListDaemonRunReportsData>) => queryOptions<ListDaemonRunReportsResponse, DefaultError, ListDaemonRunReportsResponse, ReturnType<typeof listDaemonRunReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonRunReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonRunReportsQueryKey(options)
});

export const listDaemonRunDecisionsQueryKey = (options: Options<ListDaemonRunDecisionsData>) => createQueryKey('listDaemonRunDecisions', options);

export const listDaemonRunDecisionsOptions = (options: Options<ListDaemonRunDecisionsData>) => queryOptions<ListDaemonRunDecisionsResponse, DefaultError, ListDaemonRunDecisionsResponse, ReturnType<typeof listDaemonRunDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonRunDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonRunDecisionsQueryKey(options)
});

export const listDaemonRunExecutionEnvelopesQueryKey = (options: Options<ListDaemonRunExecutionEnvelopesData>) => createQueryKey('listDaemonRunExecutionEnvelopes', options);

export const listDaemonRunExecutionEnvelopesOptions = (options: Options<ListDaemonRunExecutionEnvelopesData>) => queryOptions<ListDaemonRunExecutionEnvelopesResponse, DefaultError, ListDaemonRunExecutionEnvelopesResponse, ReturnType<typeof listDaemonRunExecutionEnvelopesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonRunExecutionEnvelopes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonRunExecutionEnvelopesQueryKey(options)
});

export const getDaemonRunAuditQueryKey = (options: Options<GetDaemonRunAuditData>) => createQueryKey('getDaemonRunAudit', options);

export const getDaemonRunAuditOptions = (options: Options<GetDaemonRunAuditData>) => queryOptions<GetDaemonRunAuditResponse, DefaultError, GetDaemonRunAuditResponse, ReturnType<typeof getDaemonRunAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDaemonRunAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDaemonRunAuditQueryKey(options)
});

export const grantDaemonRunExecutionEnvelopePermissionMutation = (options?: Partial<Options<GrantDaemonRunExecutionEnvelopePermissionData>>): UseMutationOptions<GrantDaemonRunExecutionEnvelopePermissionResponse, DefaultError, Options<GrantDaemonRunExecutionEnvelopePermissionData>> => {
    const mutationOptions: UseMutationOptions<GrantDaemonRunExecutionEnvelopePermissionResponse, DefaultError, Options<GrantDaemonRunExecutionEnvelopePermissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantDaemonRunExecutionEnvelopePermission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDaemonTriggersQueryKey = (options: Options<ListDaemonTriggersData>) => createQueryKey('listDaemonTriggers', options);

export const listDaemonTriggersOptions = (options: Options<ListDaemonTriggersData>) => queryOptions<ListDaemonTriggersResponse, DefaultError, ListDaemonTriggersResponse, ReturnType<typeof listDaemonTriggersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonTriggers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonTriggersQueryKey(options)
});

export const createDaemonTriggerMutation = (options?: Partial<Options<CreateDaemonTriggerData>>): UseMutationOptions<CreateDaemonTriggerResponse, DefaultError, Options<CreateDaemonTriggerData>> => {
    const mutationOptions: UseMutationOptions<CreateDaemonTriggerResponse, DefaultError, Options<CreateDaemonTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDaemonTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteDaemonTriggerMutation = (options?: Partial<Options<DeleteDaemonTriggerData>>): UseMutationOptions<DeleteDaemonTriggerResponse, DefaultError, Options<DeleteDaemonTriggerData>> => {
    const mutationOptions: UseMutationOptions<DeleteDaemonTriggerResponse, DefaultError, Options<DeleteDaemonTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDaemonTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateDaemonTriggerMutation = (options?: Partial<Options<UpdateDaemonTriggerData>>): UseMutationOptions<UpdateDaemonTriggerResponse, DefaultError, Options<UpdateDaemonTriggerData>> => {
    const mutationOptions: UseMutationOptions<UpdateDaemonTriggerResponse, DefaultError, Options<UpdateDaemonTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDaemonTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDaemonsQueryKey = (options?: Options<ListDaemonsData>) => createQueryKey('listDaemons', options);

export const listDaemonsOptions = (options?: Options<ListDaemonsData>) => queryOptions<ListDaemonsResponse, DefaultError, ListDaemonsResponse, ReturnType<typeof listDaemonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonsQueryKey(options)
});

export const listDaemonsInfiniteQueryKey = (options?: Options<ListDaemonsData>): QueryKey<Options<ListDaemonsData>> => createQueryKey('listDaemons', options, true);

export const listDaemonsInfiniteOptions = (options?: Options<ListDaemonsData>) => {
    const opts = infiniteQueryOptions<ListDaemonsResponse, DefaultError, InfiniteData<ListDaemonsResponse>, QueryKey<Options<ListDaemonsData>>, string | Pick<QueryKey<Options<ListDaemonsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListDaemonsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listDaemons({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDaemonsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createDaemonMutation = (options?: Partial<Options<CreateDaemonData>>): UseMutationOptions<CreateDaemonResponse, DefaultError, Options<CreateDaemonData>> => {
    const mutationOptions: UseMutationOptions<CreateDaemonResponse, DefaultError, Options<CreateDaemonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDaemon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDaemonReadinessQueryKey = (options: Options<GetDaemonReadinessData>) => createQueryKey('getDaemonReadiness', options);

export const getDaemonReadinessOptions = (options: Options<GetDaemonReadinessData>) => queryOptions<GetDaemonReadinessResponse, DefaultError, GetDaemonReadinessResponse, ReturnType<typeof getDaemonReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDaemonReadiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDaemonReadinessQueryKey(options)
});

export const deleteDaemonMutation = (options?: Partial<Options<DeleteDaemonData>>): UseMutationOptions<DeleteDaemonResponse, DefaultError, Options<DeleteDaemonData>> => {
    const mutationOptions: UseMutationOptions<DeleteDaemonResponse, DefaultError, Options<DeleteDaemonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDaemon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDaemonQueryKey = (options: Options<GetDaemonData>) => createQueryKey('getDaemon', options);

export const getDaemonOptions = (options: Options<GetDaemonData>) => queryOptions<GetDaemonResponse, DefaultError, GetDaemonResponse, ReturnType<typeof getDaemonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDaemon({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDaemonQueryKey(options)
});

export const updateDaemonMutation = (options?: Partial<Options<UpdateDaemonData>>): UseMutationOptions<UpdateDaemonResponse, DefaultError, Options<UpdateDaemonData>> => {
    const mutationOptions: UseMutationOptions<UpdateDaemonResponse, DefaultError, Options<UpdateDaemonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDaemon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enableDaemonMutation = (options?: Partial<Options<EnableDaemonData>>): UseMutationOptions<EnableDaemonResponse, DefaultError, Options<EnableDaemonData>> => {
    const mutationOptions: UseMutationOptions<EnableDaemonResponse, DefaultError, Options<EnableDaemonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableDaemon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const disableDaemonMutation = (options?: Partial<Options<DisableDaemonData>>): UseMutationOptions<DisableDaemonResponse, DefaultError, Options<DisableDaemonData>> => {
    const mutationOptions: UseMutationOptions<DisableDaemonResponse, DefaultError, Options<DisableDaemonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disableDaemon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resetDaemonGovernanceMutation = (options?: Partial<Options<ResetDaemonGovernanceData>>): UseMutationOptions<ResetDaemonGovernanceResponse, DefaultError, Options<ResetDaemonGovernanceData>> => {
    const mutationOptions: UseMutationOptions<ResetDaemonGovernanceResponse, DefaultError, Options<ResetDaemonGovernanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetDaemonGovernance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setDaemonRuntimePolicyMutation = (options?: Partial<Options<SetDaemonRuntimePolicyData>>): UseMutationOptions<SetDaemonRuntimePolicyResponse, DefaultError, Options<SetDaemonRuntimePolicyData>> => {
    const mutationOptions: UseMutationOptions<SetDaemonRuntimePolicyResponse, DefaultError, Options<SetDaemonRuntimePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDaemonRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDaemonReflectionsQueryKey = (options: Options<ListDaemonReflectionsData>) => createQueryKey('listDaemonReflections', options);

export const listDaemonReflectionsOptions = (options: Options<ListDaemonReflectionsData>) => queryOptions<ListDaemonReflectionsResponse, DefaultError, ListDaemonReflectionsResponse, ReturnType<typeof listDaemonReflectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonReflections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonReflectionsQueryKey(options)
});

export const getDaemonTrendQueryKey = (options: Options<GetDaemonTrendData>) => createQueryKey('getDaemonTrend', options);

export const getDaemonTrendOptions = (options: Options<GetDaemonTrendData>) => queryOptions<GetDaemonTrendResponse, DefaultError, GetDaemonTrendResponse, ReturnType<typeof getDaemonTrendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDaemonTrend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDaemonTrendQueryKey(options)
});

export const listDaemonFindingsQueryKey = (options: Options<ListDaemonFindingsData>) => createQueryKey('listDaemonFindings', options);

export const listDaemonFindingsOptions = (options: Options<ListDaemonFindingsData>) => queryOptions<ListDaemonFindingsResponse, DefaultError, ListDaemonFindingsResponse, ReturnType<typeof listDaemonFindingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonFindings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonFindingsQueryKey(options)
});

export const listDaemonWorkflowsQueryKey = (options: Options<ListDaemonWorkflowsData>) => createQueryKey('listDaemonWorkflows', options);

export const listDaemonWorkflowsOptions = (options: Options<ListDaemonWorkflowsData>) => queryOptions<ListDaemonWorkflowsResponse, DefaultError, ListDaemonWorkflowsResponse, ReturnType<typeof listDaemonWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDaemonWorkflows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDaemonWorkflowsQueryKey(options)
});

export const assignDaemonWorkflowMutation = (options?: Partial<Options<AssignDaemonWorkflowData>>): UseMutationOptions<AssignDaemonWorkflowResponse, DefaultError, Options<AssignDaemonWorkflowData>> => {
    const mutationOptions: UseMutationOptions<AssignDaemonWorkflowResponse, DefaultError, Options<AssignDaemonWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignDaemonWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeDaemonWorkflowMutation = (options?: Partial<Options<RemoveDaemonWorkflowData>>): UseMutationOptions<RemoveDaemonWorkflowResponse, DefaultError, Options<RemoveDaemonWorkflowData>> => {
    const mutationOptions: UseMutationOptions<RemoveDaemonWorkflowResponse, DefaultError, Options<RemoveDaemonWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeDaemonWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkforceEventCatalogQueryKey = (options?: Options<ListWorkforceEventCatalogData>) => createQueryKey('listWorkforceEventCatalog', options);

export const listWorkforceEventCatalogOptions = (options?: Options<ListWorkforceEventCatalogData>) => queryOptions<ListWorkforceEventCatalogResponse, DefaultError, ListWorkforceEventCatalogResponse, ReturnType<typeof listWorkforceEventCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkforceEventCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkforceEventCatalogQueryKey(options)
});

export const getWorkforceSummaryQueryKey = (options?: Options<GetWorkforceSummaryData>) => createQueryKey('getWorkforceSummary', options);

export const getWorkforceSummaryOptions = (options?: Options<GetWorkforceSummaryData>) => queryOptions<GetWorkforceSummaryResponse, DefaultError, GetWorkforceSummaryResponse, ReturnType<typeof getWorkforceSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkforceSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkforceSummaryQueryKey(options)
});

export const listWorkforceAssignmentsQueryKey = (options?: Options<ListWorkforceAssignmentsData>) => createQueryKey('listWorkforceAssignments', options);

export const listWorkforceAssignmentsOptions = (options?: Options<ListWorkforceAssignmentsData>) => queryOptions<ListWorkforceAssignmentsResponse, DefaultError, ListWorkforceAssignmentsResponse, ReturnType<typeof listWorkforceAssignmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkforceAssignments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkforceAssignmentsQueryKey(options)
});

export const resumeAllEmployeesMutation = (options?: Partial<Options<ResumeAllEmployeesData>>): UseMutationOptions<ResumeAllEmployeesResponse, DefaultError, Options<ResumeAllEmployeesData>> => {
    const mutationOptions: UseMutationOptions<ResumeAllEmployeesResponse, DefaultError, Options<ResumeAllEmployeesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resumeAllEmployees({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const terminateAllEmployeesMutation = (options?: Partial<Options<TerminateAllEmployeesData>>): UseMutationOptions<TerminateAllEmployeesResponse, DefaultError, Options<TerminateAllEmployeesData>> => {
    const mutationOptions: UseMutationOptions<TerminateAllEmployeesResponse, DefaultError, Options<TerminateAllEmployeesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await terminateAllEmployees({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reviewWorkforceFindingMutation = (options?: Partial<Options<ReviewWorkforceFindingData>>): UseMutationOptions<ReviewWorkforceFindingResponse, DefaultError, Options<ReviewWorkforceFindingData>> => {
    const mutationOptions: UseMutationOptions<ReviewWorkforceFindingResponse, DefaultError, Options<ReviewWorkforceFindingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reviewWorkforceFinding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEmployeePermissionGrantsQueryKey = (options: Options<ListEmployeePermissionGrantsData>) => createQueryKey('listEmployeePermissionGrants', options);

export const listEmployeePermissionGrantsOptions = (options: Options<ListEmployeePermissionGrantsData>) => queryOptions<ListEmployeePermissionGrantsResponse, DefaultError, ListEmployeePermissionGrantsResponse, ReturnType<typeof listEmployeePermissionGrantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeePermissionGrants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeePermissionGrantsQueryKey(options)
});

export const revokeEmployeePermissionGrantMutation = (options?: Partial<Options<RevokeEmployeePermissionGrantData>>): UseMutationOptions<RevokeEmployeePermissionGrantResponse, DefaultError, Options<RevokeEmployeePermissionGrantData>> => {
    const mutationOptions: UseMutationOptions<RevokeEmployeePermissionGrantResponse, DefaultError, Options<RevokeEmployeePermissionGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeEmployeePermissionGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const runEmployeeMutation = (options?: Partial<Options<RunEmployeeData>>): UseMutationOptions<RunEmployeeResponse, DefaultError, Options<RunEmployeeData>> => {
    const mutationOptions: UseMutationOptions<RunEmployeeResponse, DefaultError, Options<RunEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEmployeeRunsQueryKey = (options: Options<ListEmployeeRunsData>) => createQueryKey('listEmployeeRuns', options);

export const listEmployeeRunsOptions = (options: Options<ListEmployeeRunsData>) => queryOptions<ListEmployeeRunsResponse, DefaultError, ListEmployeeRunsResponse, ReturnType<typeof listEmployeeRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeeRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeeRunsQueryKey(options)
});

export const getEmployeeRunQueryKey = (options: Options<GetEmployeeRunData>) => createQueryKey('getEmployeeRun', options);

export const getEmployeeRunOptions = (options: Options<GetEmployeeRunData>) => queryOptions<GetEmployeeRunResponse, DefaultError, GetEmployeeRunResponse, ReturnType<typeof getEmployeeRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmployeeRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmployeeRunQueryKey(options)
});

export const listEmployeeRunReportsQueryKey = (options: Options<ListEmployeeRunReportsData>) => createQueryKey('listEmployeeRunReports', options);

export const listEmployeeRunReportsOptions = (options: Options<ListEmployeeRunReportsData>) => queryOptions<ListEmployeeRunReportsResponse, DefaultError, ListEmployeeRunReportsResponse, ReturnType<typeof listEmployeeRunReportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeeRunReports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeeRunReportsQueryKey(options)
});

export const listEmployeeRunDecisionsQueryKey = (options: Options<ListEmployeeRunDecisionsData>) => createQueryKey('listEmployeeRunDecisions', options);

export const listEmployeeRunDecisionsOptions = (options: Options<ListEmployeeRunDecisionsData>) => queryOptions<ListEmployeeRunDecisionsResponse, DefaultError, ListEmployeeRunDecisionsResponse, ReturnType<typeof listEmployeeRunDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeeRunDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeeRunDecisionsQueryKey(options)
});

export const listEmployeeRunExecutionEnvelopesQueryKey = (options: Options<ListEmployeeRunExecutionEnvelopesData>) => createQueryKey('listEmployeeRunExecutionEnvelopes', options);

export const listEmployeeRunExecutionEnvelopesOptions = (options: Options<ListEmployeeRunExecutionEnvelopesData>) => queryOptions<ListEmployeeRunExecutionEnvelopesResponse, DefaultError, ListEmployeeRunExecutionEnvelopesResponse, ReturnType<typeof listEmployeeRunExecutionEnvelopesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeeRunExecutionEnvelopes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeeRunExecutionEnvelopesQueryKey(options)
});

export const getEmployeeRunAuditQueryKey = (options: Options<GetEmployeeRunAuditData>) => createQueryKey('getEmployeeRunAudit', options);

export const getEmployeeRunAuditOptions = (options: Options<GetEmployeeRunAuditData>) => queryOptions<GetEmployeeRunAuditResponse, DefaultError, GetEmployeeRunAuditResponse, ReturnType<typeof getEmployeeRunAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmployeeRunAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmployeeRunAuditQueryKey(options)
});

export const grantEmployeeRunExecutionEnvelopePermissionMutation = (options?: Partial<Options<GrantEmployeeRunExecutionEnvelopePermissionData>>): UseMutationOptions<GrantEmployeeRunExecutionEnvelopePermissionResponse, DefaultError, Options<GrantEmployeeRunExecutionEnvelopePermissionData>> => {
    const mutationOptions: UseMutationOptions<GrantEmployeeRunExecutionEnvelopePermissionResponse, DefaultError, Options<GrantEmployeeRunExecutionEnvelopePermissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantEmployeeRunExecutionEnvelopePermission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEmployeeTriggersQueryKey = (options: Options<ListEmployeeTriggersData>) => createQueryKey('listEmployeeTriggers', options);

export const listEmployeeTriggersOptions = (options: Options<ListEmployeeTriggersData>) => queryOptions<ListEmployeeTriggersResponse, DefaultError, ListEmployeeTriggersResponse, ReturnType<typeof listEmployeeTriggersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeeTriggers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeeTriggersQueryKey(options)
});

export const createEmployeeTriggerMutation = (options?: Partial<Options<CreateEmployeeTriggerData>>): UseMutationOptions<CreateEmployeeTriggerResponse, DefaultError, Options<CreateEmployeeTriggerData>> => {
    const mutationOptions: UseMutationOptions<CreateEmployeeTriggerResponse, DefaultError, Options<CreateEmployeeTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEmployeeTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteEmployeeTriggerMutation = (options?: Partial<Options<DeleteEmployeeTriggerData>>): UseMutationOptions<DeleteEmployeeTriggerResponse, DefaultError, Options<DeleteEmployeeTriggerData>> => {
    const mutationOptions: UseMutationOptions<DeleteEmployeeTriggerResponse, DefaultError, Options<DeleteEmployeeTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEmployeeTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateEmployeeTriggerMutation = (options?: Partial<Options<UpdateEmployeeTriggerData>>): UseMutationOptions<UpdateEmployeeTriggerResponse, DefaultError, Options<UpdateEmployeeTriggerData>> => {
    const mutationOptions: UseMutationOptions<UpdateEmployeeTriggerResponse, DefaultError, Options<UpdateEmployeeTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEmployeeTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEmployeesQueryKey = (options?: Options<ListEmployeesData>) => createQueryKey('listEmployees', options);

export const listEmployeesOptions = (options?: Options<ListEmployeesData>) => queryOptions<ListEmployeesResponse, DefaultError, ListEmployeesResponse, ReturnType<typeof listEmployeesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployees({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeesQueryKey(options)
});

export const listEmployeesInfiniteQueryKey = (options?: Options<ListEmployeesData>): QueryKey<Options<ListEmployeesData>> => createQueryKey('listEmployees', options, true);

export const listEmployeesInfiniteOptions = (options?: Options<ListEmployeesData>) => {
    const opts = infiniteQueryOptions<ListEmployeesResponse, DefaultError, InfiniteData<ListEmployeesResponse>, QueryKey<Options<ListEmployeesData>>, string | Pick<QueryKey<Options<ListEmployeesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListEmployeesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listEmployees({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEmployeesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createEmployeeMutation = (options?: Partial<Options<CreateEmployeeData>>): UseMutationOptions<CreateEmployeeResponse, DefaultError, Options<CreateEmployeeData>> => {
    const mutationOptions: UseMutationOptions<CreateEmployeeResponse, DefaultError, Options<CreateEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEmployeeReadinessQueryKey = (options: Options<GetEmployeeReadinessData>) => createQueryKey('getEmployeeReadiness', options);

export const getEmployeeReadinessOptions = (options: Options<GetEmployeeReadinessData>) => queryOptions<GetEmployeeReadinessResponse, DefaultError, GetEmployeeReadinessResponse, ReturnType<typeof getEmployeeReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmployeeReadiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmployeeReadinessQueryKey(options)
});

export const deleteEmployeeMutation = (options?: Partial<Options<DeleteEmployeeData>>): UseMutationOptions<DeleteEmployeeResponse, DefaultError, Options<DeleteEmployeeData>> => {
    const mutationOptions: UseMutationOptions<DeleteEmployeeResponse, DefaultError, Options<DeleteEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEmployeeQueryKey = (options: Options<GetEmployeeData>) => createQueryKey('getEmployee', options);

export const getEmployeeOptions = (options: Options<GetEmployeeData>) => queryOptions<GetEmployeeResponse, DefaultError, GetEmployeeResponse, ReturnType<typeof getEmployeeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmployee({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmployeeQueryKey(options)
});

export const updateEmployeeMutation = (options?: Partial<Options<UpdateEmployeeData>>): UseMutationOptions<UpdateEmployeeResponse, DefaultError, Options<UpdateEmployeeData>> => {
    const mutationOptions: UseMutationOptions<UpdateEmployeeResponse, DefaultError, Options<UpdateEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enableEmployeeMutation = (options?: Partial<Options<EnableEmployeeData>>): UseMutationOptions<EnableEmployeeResponse, DefaultError, Options<EnableEmployeeData>> => {
    const mutationOptions: UseMutationOptions<EnableEmployeeResponse, DefaultError, Options<EnableEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const disableEmployeeMutation = (options?: Partial<Options<DisableEmployeeData>>): UseMutationOptions<DisableEmployeeResponse, DefaultError, Options<DisableEmployeeData>> => {
    const mutationOptions: UseMutationOptions<DisableEmployeeResponse, DefaultError, Options<DisableEmployeeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disableEmployee({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resetEmployeeGovernanceMutation = (options?: Partial<Options<ResetEmployeeGovernanceData>>): UseMutationOptions<ResetEmployeeGovernanceResponse, DefaultError, Options<ResetEmployeeGovernanceData>> => {
    const mutationOptions: UseMutationOptions<ResetEmployeeGovernanceResponse, DefaultError, Options<ResetEmployeeGovernanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetEmployeeGovernance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setEmployeeRuntimePolicyMutation = (options?: Partial<Options<SetEmployeeRuntimePolicyData>>): UseMutationOptions<SetEmployeeRuntimePolicyResponse, DefaultError, Options<SetEmployeeRuntimePolicyData>> => {
    const mutationOptions: UseMutationOptions<SetEmployeeRuntimePolicyResponse, DefaultError, Options<SetEmployeeRuntimePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setEmployeeRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEmployeeReflectionsQueryKey = (options: Options<ListEmployeeReflectionsData>) => createQueryKey('listEmployeeReflections', options);

export const listEmployeeReflectionsOptions = (options: Options<ListEmployeeReflectionsData>) => queryOptions<ListEmployeeReflectionsResponse, DefaultError, ListEmployeeReflectionsResponse, ReturnType<typeof listEmployeeReflectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeeReflections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeeReflectionsQueryKey(options)
});

export const getEmployeeTrendQueryKey = (options: Options<GetEmployeeTrendData>) => createQueryKey('getEmployeeTrend', options);

export const getEmployeeTrendOptions = (options: Options<GetEmployeeTrendData>) => queryOptions<GetEmployeeTrendResponse, DefaultError, GetEmployeeTrendResponse, ReturnType<typeof getEmployeeTrendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmployeeTrend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmployeeTrendQueryKey(options)
});

export const listEmployeeFindingsQueryKey = (options: Options<ListEmployeeFindingsData>) => createQueryKey('listEmployeeFindings', options);

export const listEmployeeFindingsOptions = (options: Options<ListEmployeeFindingsData>) => queryOptions<ListEmployeeFindingsResponse, DefaultError, ListEmployeeFindingsResponse, ReturnType<typeof listEmployeeFindingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeeFindings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeeFindingsQueryKey(options)
});

export const listEmployeeWorkflowsQueryKey = (options: Options<ListEmployeeWorkflowsData>) => createQueryKey('listEmployeeWorkflows', options);

export const listEmployeeWorkflowsOptions = (options: Options<ListEmployeeWorkflowsData>) => queryOptions<ListEmployeeWorkflowsResponse, DefaultError, ListEmployeeWorkflowsResponse, ReturnType<typeof listEmployeeWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEmployeeWorkflows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEmployeeWorkflowsQueryKey(options)
});

export const assignEmployeeWorkflowMutation = (options?: Partial<Options<AssignEmployeeWorkflowData>>): UseMutationOptions<AssignEmployeeWorkflowResponse, DefaultError, Options<AssignEmployeeWorkflowData>> => {
    const mutationOptions: UseMutationOptions<AssignEmployeeWorkflowResponse, DefaultError, Options<AssignEmployeeWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignEmployeeWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeEmployeeWorkflowMutation = (options?: Partial<Options<RemoveEmployeeWorkflowData>>): UseMutationOptions<RemoveEmployeeWorkflowResponse, DefaultError, Options<RemoveEmployeeWorkflowData>> => {
    const mutationOptions: UseMutationOptions<RemoveEmployeeWorkflowResponse, DefaultError, Options<RemoveEmployeeWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeEmployeeWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setDecisionRuntimePolicyMutation = (options?: Partial<Options<SetDecisionRuntimePolicyData>>): UseMutationOptions<SetDecisionRuntimePolicyResponse, DefaultError, Options<SetDecisionRuntimePolicyData>> => {
    const mutationOptions: UseMutationOptions<SetDecisionRuntimePolicyResponse, DefaultError, Options<SetDecisionRuntimePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDecisionRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDaemonDecisionQueryKey = (options: Options<GetDaemonDecisionData>) => createQueryKey('getDaemonDecision', options);

/**
 * Get a decision, with who raised it and whether the viewer may decide it
 */
export const getDaemonDecisionOptions = (options: Options<GetDaemonDecisionData>) => queryOptions<GetDaemonDecisionResponse, DefaultError, GetDaemonDecisionResponse, ReturnType<typeof getDaemonDecisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDaemonDecision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDaemonDecisionQueryKey(options)
});

/**
 * Approve a pending daemon decision
 */
export const approveDaemonDecisionMutation = (options?: Partial<Options<ApproveDaemonDecisionData>>): UseMutationOptions<ApproveDaemonDecisionResponse, DefaultError, Options<ApproveDaemonDecisionData>> => {
    const mutationOptions: UseMutationOptions<ApproveDaemonDecisionResponse, DefaultError, Options<ApproveDaemonDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approveDaemonDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject a pending daemon decision
 */
export const rejectDaemonDecisionMutation = (options?: Partial<Options<RejectDaemonDecisionData>>): UseMutationOptions<RejectDaemonDecisionResponse, DefaultError, Options<RejectDaemonDecisionData>> => {
    const mutationOptions: UseMutationOptions<RejectDaemonDecisionResponse, DefaultError, Options<RejectDaemonDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectDaemonDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Defer a pending daemon decision
 */
export const deferDaemonDecisionMutation = (options?: Partial<Options<DeferDaemonDecisionData>>): UseMutationOptions<DeferDaemonDecisionResponse, DefaultError, Options<DeferDaemonDecisionData>> => {
    const mutationOptions: UseMutationOptions<DeferDaemonDecisionResponse, DefaultError, Options<DeferDaemonDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deferDaemonDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listImprovementProposalsQueryKey = (options?: Options<ListImprovementProposalsData>) => createQueryKey('listImprovementProposals', options);

/**
 * List self-improvement proposals for the org
 */
export const listImprovementProposalsOptions = (options?: Options<ListImprovementProposalsData>) => queryOptions<ListImprovementProposalsResponse, DefaultError, ListImprovementProposalsResponse, ReturnType<typeof listImprovementProposalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listImprovementProposals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listImprovementProposalsQueryKey(options)
});

export const listImprovementProposalsInfiniteQueryKey = (options?: Options<ListImprovementProposalsData>): QueryKey<Options<ListImprovementProposalsData>> => createQueryKey('listImprovementProposals', options, true);

/**
 * List self-improvement proposals for the org
 */
export const listImprovementProposalsInfiniteOptions = (options?: Options<ListImprovementProposalsData>) => {
    const opts = infiniteQueryOptions<ListImprovementProposalsResponse, DefaultError, InfiniteData<ListImprovementProposalsResponse>, QueryKey<Options<ListImprovementProposalsData>>, number | null | Pick<QueryKey<Options<ListImprovementProposalsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListImprovementProposalsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listImprovementProposals({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listImprovementProposalsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getImprovementProposalQueryKey = (options: Options<GetImprovementProposalData>) => createQueryKey('getImprovementProposal', options);

/**
 * Get a self-improvement proposal (full detail)
 */
export const getImprovementProposalOptions = (options: Options<GetImprovementProposalData>) => queryOptions<GetImprovementProposalResponse, DefaultError, GetImprovementProposalResponse, ReturnType<typeof getImprovementProposalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImprovementProposal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImprovementProposalQueryKey(options)
});

/**
 * Approve or reject a self-improvement proposal at the human gate
 */
export const decideImprovementProposalMutation = (options?: Partial<Options<DecideImprovementProposalData>>): UseMutationOptions<DecideImprovementProposalResponse, DefaultError, Options<DecideImprovementProposalData>> => {
    const mutationOptions: UseMutationOptions<DecideImprovementProposalResponse, DefaultError, Options<DecideImprovementProposalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await decideImprovementProposal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve or reject the early design-review checkpoint of a high-risk specced proposal
 */
export const decideImprovementProposalDesignMutation = (options?: Partial<Options<DecideImprovementProposalDesignData>>): UseMutationOptions<DecideImprovementProposalDesignResponse, DefaultError, Options<DecideImprovementProposalDesignData>> => {
    const mutationOptions: UseMutationOptions<DecideImprovementProposalDesignResponse, DefaultError, Options<DecideImprovementProposalDesignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await decideImprovementProposalDesign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImprovementMetricsQueryKey = (options?: Options<GetImprovementMetricsData>) => createQueryKey('getImprovementMetrics', options);

/**
 * Self-improvement pipeline OBS metrics (flow/quality/learning/cost/human-load)
 */
export const getImprovementMetricsOptions = (options?: Options<GetImprovementMetricsData>) => queryOptions<GetImprovementMetricsResponse, DefaultError, GetImprovementMetricsResponse, ReturnType<typeof getImprovementMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImprovementMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImprovementMetricsQueryKey(options)
});

export const getImprovementTierStatusQueryKey = (options?: Options<GetImprovementTierStatusData>) => createQueryKey('getImprovementTierStatus', options);

/**
 * Per-lane autonomy tier + expand-eligibility (T0/T1/T2)
 */
export const getImprovementTierStatusOptions = (options?: Options<GetImprovementTierStatusData>) => queryOptions<GetImprovementTierStatusResponse, DefaultError, GetImprovementTierStatusResponse, ReturnType<typeof getImprovementTierStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImprovementTierStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImprovementTierStatusQueryKey(options)
});

/**
 * Apply a human autonomy-tier expansion (superadmin, re-verified at apply-time)
 */
export const expandImprovementTierMutation = (options?: Partial<Options<ExpandImprovementTierData>>): UseMutationOptions<ExpandImprovementTierResponse, DefaultError, Options<ExpandImprovementTierData>> => {
    const mutationOptions: UseMutationOptions<ExpandImprovementTierResponse, DefaultError, Options<ExpandImprovementTierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await expandImprovementTier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkflowGatesQueryKey = (options?: Options<ListWorkflowGatesData>) => createQueryKey('listWorkflowGates', options);

/**
 * List workflow human-gate decisions for the org
 */
export const listWorkflowGatesOptions = (options?: Options<ListWorkflowGatesData>) => queryOptions<ListWorkflowGatesResponse, DefaultError, ListWorkflowGatesResponse, ReturnType<typeof listWorkflowGatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkflowGates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkflowGatesQueryKey(options)
});

export const getWorkflowGateQueryKey = (options: Options<GetWorkflowGateData>) => createQueryKey('getWorkflowGate', options);

/**
 * Get a workflow gate decision by id
 */
export const getWorkflowGateOptions = (options: Options<GetWorkflowGateData>) => queryOptions<GetWorkflowGateResponse, DefaultError, GetWorkflowGateResponse, ReturnType<typeof getWorkflowGateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkflowGate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkflowGateQueryKey(options)
});

/**
 * Approve a pending workflow gate (resumes the paused run)
 */
export const approveWorkflowGateMutation = (options?: Partial<Options<ApproveWorkflowGateData>>): UseMutationOptions<ApproveWorkflowGateResponse, DefaultError, Options<ApproveWorkflowGateData>> => {
    const mutationOptions: UseMutationOptions<ApproveWorkflowGateResponse, DefaultError, Options<ApproveWorkflowGateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approveWorkflowGate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject a pending workflow gate (finalizes the run as failed)
 */
export const rejectWorkflowGateMutation = (options?: Partial<Options<RejectWorkflowGateData>>): UseMutationOptions<RejectWorkflowGateResponse, DefaultError, Options<RejectWorkflowGateData>> => {
    const mutationOptions: UseMutationOptions<RejectWorkflowGateResponse, DefaultError, Options<RejectWorkflowGateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectWorkflowGate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMarketplaceListingsQueryKey = (options?: Options<ListMarketplaceListingsData>) => createQueryKey('listMarketplaceListings', options);

export const listMarketplaceListingsOptions = (options?: Options<ListMarketplaceListingsData>) => queryOptions<ListMarketplaceListingsResponse, DefaultError, ListMarketplaceListingsResponse, ReturnType<typeof listMarketplaceListingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMarketplaceListings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMarketplaceListingsQueryKey(options)
});

export const publishMarketplaceListingMutation = (options?: Partial<Options<PublishMarketplaceListingData>>): UseMutationOptions<PublishMarketplaceListingResponse, DefaultError, Options<PublishMarketplaceListingData>> => {
    const mutationOptions: UseMutationOptions<PublishMarketplaceListingResponse, DefaultError, Options<PublishMarketplaceListingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishMarketplaceListing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMarketplaceListingMutation = (options?: Partial<Options<DeleteMarketplaceListingData>>): UseMutationOptions<DeleteMarketplaceListingResponse, DefaultError, Options<DeleteMarketplaceListingData>> => {
    const mutationOptions: UseMutationOptions<DeleteMarketplaceListingResponse, DefaultError, Options<DeleteMarketplaceListingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMarketplaceListing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const installMarketplaceListingMutation = (options?: Partial<Options<InstallMarketplaceListingData>>): UseMutationOptions<InstallMarketplaceListingResponse, DefaultError, Options<InstallMarketplaceListingData>> => {
    const mutationOptions: UseMutationOptions<InstallMarketplaceListingResponse, DefaultError, Options<InstallMarketplaceListingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await installMarketplaceListing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const forkMarketplaceListingMutation = (options?: Partial<Options<ForkMarketplaceListingData>>): UseMutationOptions<ForkMarketplaceListingResponse, DefaultError, Options<ForkMarketplaceListingData>> => {
    const mutationOptions: UseMutationOptions<ForkMarketplaceListingResponse, DefaultError, Options<ForkMarketplaceListingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await forkMarketplaceListing({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMarketplaceInstallationsQueryKey = (options?: Options<ListMarketplaceInstallationsData>) => createQueryKey('listMarketplaceInstallations', options);

export const listMarketplaceInstallationsOptions = (options?: Options<ListMarketplaceInstallationsData>) => queryOptions<ListMarketplaceInstallationsResponse, DefaultError, ListMarketplaceInstallationsResponse, ReturnType<typeof listMarketplaceInstallationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMarketplaceInstallations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMarketplaceInstallationsQueryKey(options)
});

export const listMarketplaceUpdatesQueryKey = (options?: Options<ListMarketplaceUpdatesData>) => createQueryKey('listMarketplaceUpdates', options);

export const listMarketplaceUpdatesOptions = (options?: Options<ListMarketplaceUpdatesData>) => queryOptions<ListMarketplaceUpdatesResponse, DefaultError, ListMarketplaceUpdatesResponse, ReturnType<typeof listMarketplaceUpdatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMarketplaceUpdates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMarketplaceUpdatesQueryKey(options)
});

export const applyMarketplaceUpdatesMutation = (options?: Partial<Options<ApplyMarketplaceUpdatesData>>): UseMutationOptions<ApplyMarketplaceUpdatesResponse, DefaultError, Options<ApplyMarketplaceUpdatesData>> => {
    const mutationOptions: UseMutationOptions<ApplyMarketplaceUpdatesResponse, DefaultError, Options<ApplyMarketplaceUpdatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await applyMarketplaceUpdates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketplaceEntityVersionsQueryKey = (options: Options<GetMarketplaceEntityVersionsData>) => createQueryKey('getMarketplaceEntityVersions', options);

export const getMarketplaceEntityVersionsOptions = (options: Options<GetMarketplaceEntityVersionsData>) => queryOptions<GetMarketplaceEntityVersionsResponse, DefaultError, GetMarketplaceEntityVersionsResponse, ReturnType<typeof getMarketplaceEntityVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketplaceEntityVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketplaceEntityVersionsQueryKey(options)
});

export const updateMarketplaceEntityMutation = (options?: Partial<Options<UpdateMarketplaceEntityData>>): UseMutationOptions<UpdateMarketplaceEntityResponse, DefaultError, Options<UpdateMarketplaceEntityData>> => {
    const mutationOptions: UseMutationOptions<UpdateMarketplaceEntityResponse, DefaultError, Options<UpdateMarketplaceEntityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMarketplaceEntity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMarketplaceNeedsSetupQueryKey = (options?: Options<ListMarketplaceNeedsSetupData>) => createQueryKey('listMarketplaceNeedsSetup', options);

export const listMarketplaceNeedsSetupOptions = (options?: Options<ListMarketplaceNeedsSetupData>) => queryOptions<ListMarketplaceNeedsSetupResponse, DefaultError, ListMarketplaceNeedsSetupResponse, ReturnType<typeof listMarketplaceNeedsSetupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMarketplaceNeedsSetup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMarketplaceNeedsSetupQueryKey(options)
});

export const unbindMarketplaceEntityConnectionMutation = (options?: Partial<Options<UnbindMarketplaceEntityConnectionData>>): UseMutationOptions<UnbindMarketplaceEntityConnectionResponse, DefaultError, Options<UnbindMarketplaceEntityConnectionData>> => {
    const mutationOptions: UseMutationOptions<UnbindMarketplaceEntityConnectionResponse, DefaultError, Options<UnbindMarketplaceEntityConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unbindMarketplaceEntityConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bindMarketplaceEntityConnectionMutation = (options?: Partial<Options<BindMarketplaceEntityConnectionData>>): UseMutationOptions<BindMarketplaceEntityConnectionResponse, DefaultError, Options<BindMarketplaceEntityConnectionData>> => {
    const mutationOptions: UseMutationOptions<BindMarketplaceEntityConnectionResponse, DefaultError, Options<BindMarketplaceEntityConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bindMarketplaceEntityConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketplaceBundleQueryKey = (options: Options<GetMarketplaceBundleData>) => createQueryKey('getMarketplaceBundle', options);

export const getMarketplaceBundleOptions = (options: Options<GetMarketplaceBundleData>) => queryOptions<GetMarketplaceBundleResponse, DefaultError, GetMarketplaceBundleResponse, ReturnType<typeof getMarketplaceBundleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketplaceBundle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketplaceBundleQueryKey(options)
});

export const createMarketplaceBundleMutation = (options?: Partial<Options<CreateMarketplaceBundleData>>): UseMutationOptions<CreateMarketplaceBundleResponse, DefaultError, Options<CreateMarketplaceBundleData>> => {
    const mutationOptions: UseMutationOptions<CreateMarketplaceBundleResponse, DefaultError, Options<CreateMarketplaceBundleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMarketplaceBundle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addMarketplaceBundleEntityMutation = (options?: Partial<Options<AddMarketplaceBundleEntityData>>): UseMutationOptions<AddMarketplaceBundleEntityResponse, DefaultError, Options<AddMarketplaceBundleEntityData>> => {
    const mutationOptions: UseMutationOptions<AddMarketplaceBundleEntityResponse, DefaultError, Options<AddMarketplaceBundleEntityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addMarketplaceBundleEntity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeMarketplaceBundleEntityMutation = (options?: Partial<Options<RemoveMarketplaceBundleEntityData>>): UseMutationOptions<RemoveMarketplaceBundleEntityResponse, DefaultError, Options<RemoveMarketplaceBundleEntityData>> => {
    const mutationOptions: UseMutationOptions<RemoveMarketplaceBundleEntityResponse, DefaultError, Options<RemoveMarketplaceBundleEntityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeMarketplaceBundleEntity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEntityVersionsQueryKey = (options: Options<ListEntityVersionsData>) => createQueryKey('listEntityVersions', options);

export const listEntityVersionsOptions = (options: Options<ListEntityVersionsData>) => queryOptions<ListEntityVersionsResponse, DefaultError, ListEntityVersionsResponse, ReturnType<typeof listEntityVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEntityVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEntityVersionsQueryKey(options)
});

export const createEntityVersionDraftMutation = (options?: Partial<Options<CreateEntityVersionDraftData>>): UseMutationOptions<CreateEntityVersionDraftResponse, DefaultError, Options<CreateEntityVersionDraftData>> => {
    const mutationOptions: UseMutationOptions<CreateEntityVersionDraftResponse, DefaultError, Options<CreateEntityVersionDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEntityVersionDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const activateEntityVersionMutation = (options?: Partial<Options<ActivateEntityVersionData>>): UseMutationOptions<ActivateEntityVersionResponse, DefaultError, Options<ActivateEntityVersionData>> => {
    const mutationOptions: UseMutationOptions<ActivateEntityVersionResponse, DefaultError, Options<ActivateEntityVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activateEntityVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMlHealthQueryKey = (options?: Options<GetMlHealthData>) => createQueryKey('getMlHealth', options);

export const getMlHealthOptions = (options?: Options<GetMlHealthData>) => queryOptions<GetMlHealthResponse, DefaultError, GetMlHealthResponse, ReturnType<typeof getMlHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMlHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMlHealthQueryKey(options)
});

export const getMlRegimeQueryKey = (options?: Options<GetMlRegimeData>) => createQueryKey('getMlRegime', options);

export const getMlRegimeOptions = (options?: Options<GetMlRegimeData>) => queryOptions<GetMlRegimeResponse, DefaultError, GetMlRegimeResponse, ReturnType<typeof getMlRegimeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMlRegime({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMlRegimeQueryKey(options)
});

export const getMlStrategyScoresQueryKey = (options?: Options<GetMlStrategyScoresData>) => createQueryKey('getMlStrategyScores', options);

export const getMlStrategyScoresOptions = (options?: Options<GetMlStrategyScoresData>) => queryOptions<GetMlStrategyScoresResponse, DefaultError, GetMlStrategyScoresResponse, ReturnType<typeof getMlStrategyScoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMlStrategyScores({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMlStrategyScoresQueryKey(options)
});

export const createWorkerRunMutation = (options?: Partial<Options<CreateWorkerRunData>>): UseMutationOptions<CreateWorkerRunResponse, DefaultError, Options<CreateWorkerRunData>> => {
    const mutationOptions: UseMutationOptions<CreateWorkerRunResponse, DefaultError, Options<CreateWorkerRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWorkerRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cancelWorkerRunMutation = (options?: Partial<Options<CancelWorkerRunData>>): UseMutationOptions<CancelWorkerRunResponse, DefaultError, Options<CancelWorkerRunData>> => {
    const mutationOptions: UseMutationOptions<CancelWorkerRunResponse, DefaultError, Options<CancelWorkerRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelWorkerRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkerRunQueryKey = (options: Options<GetWorkerRunData>) => createQueryKey('getWorkerRun', options);

export const getWorkerRunOptions = (options: Options<GetWorkerRunData>) => queryOptions<GetWorkerRunResponse, DefaultError, GetWorkerRunResponse, ReturnType<typeof getWorkerRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkerRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkerRunQueryKey(options)
});

export const followUpWorkerRunMutation = (options?: Partial<Options<FollowUpWorkerRunData>>): UseMutationOptions<FollowUpWorkerRunResponse, DefaultError, Options<FollowUpWorkerRunData>> => {
    const mutationOptions: UseMutationOptions<FollowUpWorkerRunResponse, DefaultError, Options<FollowUpWorkerRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await followUpWorkerRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const callPlatformMcpMutation = (options?: Partial<Options<CallPlatformMcpData>>): UseMutationOptions<CallPlatformMcpResponse, DefaultError, Options<CallPlatformMcpData>> => {
    const mutationOptions: UseMutationOptions<CallPlatformMcpResponse, DefaultError, Options<CallPlatformMcpData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await callPlatformMcp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listApiKeysQueryKey = (options?: Options<ListApiKeysData>) => createQueryKey('listApiKeys', options);

export const listApiKeysOptions = (options?: Options<ListApiKeysData>) => queryOptions<ListApiKeysResponse, DefaultError, ListApiKeysResponse, ReturnType<typeof listApiKeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listApiKeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listApiKeysQueryKey(options)
});

export const createApiKeyMutation = (options?: Partial<Options<CreateApiKeyData>>): UseMutationOptions<CreateApiKeyResponse, DefaultError, Options<CreateApiKeyData>> => {
    const mutationOptions: UseMutationOptions<CreateApiKeyResponse, DefaultError, Options<CreateApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listApiKeyGrantablePermissionsQueryKey = (options?: Options<ListApiKeyGrantablePermissionsData>) => createQueryKey('listApiKeyGrantablePermissions', options);

export const listApiKeyGrantablePermissionsOptions = (options?: Options<ListApiKeyGrantablePermissionsData>) => queryOptions<ListApiKeyGrantablePermissionsResponse, DefaultError, ListApiKeyGrantablePermissionsResponse, ReturnType<typeof listApiKeyGrantablePermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listApiKeyGrantablePermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listApiKeyGrantablePermissionsQueryKey(options)
});

export const getApiKeyQueryKey = (options: Options<GetApiKeyData>) => createQueryKey('getApiKey', options);

export const getApiKeyOptions = (options: Options<GetApiKeyData>) => queryOptions<GetApiKeyResponse, DefaultError, GetApiKeyResponse, ReturnType<typeof getApiKeyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiKey({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiKeyQueryKey(options)
});

export const updateApiKeyMutation = (options?: Partial<Options<UpdateApiKeyData>>): UseMutationOptions<UpdateApiKeyResponse, DefaultError, Options<UpdateApiKeyData>> => {
    const mutationOptions: UseMutationOptions<UpdateApiKeyResponse, DefaultError, Options<UpdateApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const revokeApiKeyMutation = (options?: Partial<Options<RevokeApiKeyData>>): UseMutationOptions<RevokeApiKeyResponse, DefaultError, Options<RevokeApiKeyData>> => {
    const mutationOptions: UseMutationOptions<RevokeApiKeyResponse, DefaultError, Options<RevokeApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rotateApiKeyMutation = (options?: Partial<Options<RotateApiKeyData>>): UseMutationOptions<RotateApiKeyResponse, DefaultError, Options<RotateApiKeyData>> => {
    const mutationOptions: UseMutationOptions<RotateApiKeyResponse, DefaultError, Options<RotateApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rotateApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listJourneysQueryKey = (options?: Options<ListJourneysData>) => createQueryKey('listJourneys', options);

export const listJourneysOptions = (options?: Options<ListJourneysData>) => queryOptions<ListJourneysResponse, DefaultError, ListJourneysResponse, ReturnType<typeof listJourneysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listJourneys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listJourneysQueryKey(options)
});

export const listJourneysInfiniteQueryKey = (options?: Options<ListJourneysData>): QueryKey<Options<ListJourneysData>> => createQueryKey('listJourneys', options, true);

export const listJourneysInfiniteOptions = (options?: Options<ListJourneysData>) => {
    const opts = infiniteQueryOptions<ListJourneysResponse, DefaultError, InfiniteData<ListJourneysResponse>, QueryKey<Options<ListJourneysData>>, string | Pick<QueryKey<Options<ListJourneysData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListJourneysData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listJourneys({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listJourneysInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listJourneyEventsQueryKey = (options: Options<ListJourneyEventsData>) => createQueryKey('listJourneyEvents', options);

export const listJourneyEventsOptions = (options: Options<ListJourneyEventsData>) => queryOptions<ListJourneyEventsResponse, DefaultError, ListJourneyEventsResponse, ReturnType<typeof listJourneyEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listJourneyEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listJourneyEventsQueryKey(options)
});

export const listJourneyEventsInfiniteQueryKey = (options: Options<ListJourneyEventsData>): QueryKey<Options<ListJourneyEventsData>> => createQueryKey('listJourneyEvents', options, true);

export const listJourneyEventsInfiniteOptions = (options: Options<ListJourneyEventsData>) => {
    const opts = infiniteQueryOptions<ListJourneyEventsResponse, DefaultError, InfiniteData<ListJourneyEventsResponse>, QueryKey<Options<ListJourneyEventsData>>, string | Pick<QueryKey<Options<ListJourneyEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListJourneyEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listJourneyEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listJourneyEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listJourneyRawEventsQueryKey = (options: Options<ListJourneyRawEventsData>) => createQueryKey('listJourneyRawEvents', options);

export const listJourneyRawEventsOptions = (options: Options<ListJourneyRawEventsData>) => queryOptions<ListJourneyRawEventsResponse, DefaultError, ListJourneyRawEventsResponse, ReturnType<typeof listJourneyRawEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listJourneyRawEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listJourneyRawEventsQueryKey(options)
});

export const listJourneyRawEventsInfiniteQueryKey = (options: Options<ListJourneyRawEventsData>): QueryKey<Options<ListJourneyRawEventsData>> => createQueryKey('listJourneyRawEvents', options, true);

export const listJourneyRawEventsInfiniteOptions = (options: Options<ListJourneyRawEventsData>) => {
    const opts = infiniteQueryOptions<ListJourneyRawEventsResponse, DefaultError, InfiniteData<ListJourneyRawEventsResponse>, QueryKey<Options<ListJourneyRawEventsData>>, string | Pick<QueryKey<Options<ListJourneyRawEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListJourneyRawEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listJourneyRawEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listJourneyRawEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listDepartmentsQueryKey = (options?: Options<ListDepartmentsData>) => createQueryKey('listDepartments', options);

export const listDepartmentsOptions = (options?: Options<ListDepartmentsData>) => queryOptions<ListDepartmentsResponse, DefaultError, ListDepartmentsResponse, ReturnType<typeof listDepartmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDepartments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDepartmentsQueryKey(options)
});

export const listMyModulesQueryKey = (options?: Options<ListMyModulesData>) => createQueryKey('listMyModules', options);

/**
 * List modules enabled for the current user's organization
 */
export const listMyModulesOptions = (options?: Options<ListMyModulesData>) => queryOptions<ListMyModulesResponse, DefaultError, ListMyModulesResponse, ReturnType<typeof listMyModulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMyModules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMyModulesQueryKey(options)
});

export const getWaitingOnMeQueryKey = (options?: Options<GetWaitingOnMeData>) => createQueryKey('getWaitingOnMe', options);

/**
 * Items waiting on the current user (conversations + reviewable decisions)
 */
export const getWaitingOnMeOptions = (options?: Options<GetWaitingOnMeData>) => queryOptions<GetWaitingOnMeResponse, DefaultError, GetWaitingOnMeResponse, ReturnType<typeof getWaitingOnMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWaitingOnMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWaitingOnMeQueryKey(options)
});

export const listConversationGroupsQueryKey = (options?: Options<ListConversationGroupsData>) => createQueryKey('listConversationGroups', options);

export const listConversationGroupsOptions = (options?: Options<ListConversationGroupsData>) => queryOptions<ListConversationGroupsResponse, DefaultError, ListConversationGroupsResponse, ReturnType<typeof listConversationGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversationGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationGroupsQueryKey(options)
});

export const createConversationGroupMutation = (options?: Partial<Options<CreateConversationGroupData>>): UseMutationOptions<CreateConversationGroupResponse, DefaultError, Options<CreateConversationGroupData>> => {
    const mutationOptions: UseMutationOptions<CreateConversationGroupResponse, DefaultError, Options<CreateConversationGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createConversationGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteConversationGroupMutation = (options?: Partial<Options<DeleteConversationGroupData>>): UseMutationOptions<DeleteConversationGroupResponse, DefaultError, Options<DeleteConversationGroupData>> => {
    const mutationOptions: UseMutationOptions<DeleteConversationGroupResponse, DefaultError, Options<DeleteConversationGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteConversationGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConversationsQueryKey = (options?: Options<ListConversationsData>) => createQueryKey('listConversations', options);

export const listConversationsOptions = (options?: Options<ListConversationsData>) => queryOptions<ListConversationsResponse, DefaultError, ListConversationsResponse, ReturnType<typeof listConversationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationsQueryKey(options)
});

export const listConversationsInfiniteQueryKey = (options?: Options<ListConversationsData>): QueryKey<Options<ListConversationsData>> => createQueryKey('listConversations', options, true);

export const listConversationsInfiniteOptions = (options?: Options<ListConversationsData>) => {
    const opts = infiniteQueryOptions<ListConversationsResponse, DefaultError, InfiniteData<ListConversationsResponse>, QueryKey<Options<ListConversationsData>>, string | Pick<QueryKey<Options<ListConversationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListConversationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listConversations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listConversationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createConversationMutation = (options?: Partial<Options<CreateConversationData>>): UseMutationOptions<CreateConversationResponse, DefaultError, Options<CreateConversationData>> => {
    const mutationOptions: UseMutationOptions<CreateConversationResponse, DefaultError, Options<CreateConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const startConversationFromMessageMutation = (options?: Partial<Options<StartConversationFromMessageData>>): UseMutationOptions<StartConversationFromMessageResponse, DefaultError, Options<StartConversationFromMessageData>> => {
    const mutationOptions: UseMutationOptions<StartConversationFromMessageResponse, DefaultError, Options<StartConversationFromMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startConversationFromMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteConversationMutation = (options?: Partial<Options<DeleteConversationData>>): UseMutationOptions<DeleteConversationResponse, DefaultError, Options<DeleteConversationData>> => {
    const mutationOptions: UseMutationOptions<DeleteConversationResponse, DefaultError, Options<DeleteConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConversationQueryKey = (options: Options<GetConversationData>) => createQueryKey('getConversation', options);

export const getConversationOptions = (options: Options<GetConversationData>) => queryOptions<GetConversationResponse, DefaultError, GetConversationResponse, ReturnType<typeof getConversationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConversation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConversationQueryKey(options)
});

export const updateConversationMutation = (options?: Partial<Options<UpdateConversationData>>): UseMutationOptions<UpdateConversationResponse, DefaultError, Options<UpdateConversationData>> => {
    const mutationOptions: UseMutationOptions<UpdateConversationResponse, DefaultError, Options<UpdateConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConversationMembersQueryKey = (options: Options<ListConversationMembersData>) => createQueryKey('listConversationMembers', options);

export const listConversationMembersOptions = (options: Options<ListConversationMembersData>) => queryOptions<ListConversationMembersResponse, DefaultError, ListConversationMembersResponse, ReturnType<typeof listConversationMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversationMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationMembersQueryKey(options)
});

export const inviteToConversationMutation = (options?: Partial<Options<InviteToConversationData>>): UseMutationOptions<InviteToConversationResponse, DefaultError, Options<InviteToConversationData>> => {
    const mutationOptions: UseMutationOptions<InviteToConversationResponse, DefaultError, Options<InviteToConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await inviteToConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeConversationMemberMutation = (options?: Partial<Options<RemoveConversationMemberData>>): UseMutationOptions<RemoveConversationMemberResponse, DefaultError, Options<RemoveConversationMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveConversationMemberResponse, DefaultError, Options<RemoveConversationMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeConversationMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setConversationLeadMutation = (options?: Partial<Options<SetConversationLeadData>>): UseMutationOptions<SetConversationLeadResponse, DefaultError, Options<SetConversationLeadData>> => {
    const mutationOptions: UseMutationOptions<SetConversationLeadResponse, DefaultError, Options<SetConversationLeadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setConversationLead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConversationEntitiesQueryKey = (options: Options<ListConversationEntitiesData>) => createQueryKey('listConversationEntities', options);

export const listConversationEntitiesOptions = (options: Options<ListConversationEntitiesData>) => queryOptions<ListConversationEntitiesResponse, DefaultError, ListConversationEntitiesResponse, ReturnType<typeof listConversationEntitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversationEntities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationEntitiesQueryKey(options)
});

export const listConversationAttachmentsQueryKey = (options: Options<ListConversationAttachmentsData>) => createQueryKey('listConversationAttachments', options);

export const listConversationAttachmentsOptions = (options: Options<ListConversationAttachmentsData>) => queryOptions<ListConversationAttachmentsResponse, DefaultError, ListConversationAttachmentsResponse, ReturnType<typeof listConversationAttachmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversationAttachments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationAttachmentsQueryKey(options)
});

export const attachToConversationMutation = (options?: Partial<Options<AttachToConversationData>>): UseMutationOptions<AttachToConversationResponse, DefaultError, Options<AttachToConversationData>> => {
    const mutationOptions: UseMutationOptions<AttachToConversationResponse, DefaultError, Options<AttachToConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attachToConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const detachFromConversationMutation = (options?: Partial<Options<DetachFromConversationData>>): UseMutationOptions<DetachFromConversationResponse, DefaultError, Options<DetachFromConversationData>> => {
    const mutationOptions: UseMutationOptions<DetachFromConversationResponse, DefaultError, Options<DetachFromConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await detachFromConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConversationIntentsQueryKey = (options: Options<ListConversationIntentsData>) => createQueryKey('listConversationIntents', options);

export const listConversationIntentsOptions = (options: Options<ListConversationIntentsData>) => queryOptions<ListConversationIntentsResponse, DefaultError, ListConversationIntentsResponse, ReturnType<typeof listConversationIntentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversationIntents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationIntentsQueryKey(options)
});

export const listConversationIntentsInfiniteQueryKey = (options: Options<ListConversationIntentsData>): QueryKey<Options<ListConversationIntentsData>> => createQueryKey('listConversationIntents', options, true);

export const listConversationIntentsInfiniteOptions = (options: Options<ListConversationIntentsData>) => {
    const opts = infiniteQueryOptions<ListConversationIntentsResponse, DefaultError, InfiniteData<ListConversationIntentsResponse>, QueryKey<Options<ListConversationIntentsData>>, string | Pick<QueryKey<Options<ListConversationIntentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListConversationIntentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listConversationIntents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listConversationIntentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const disambiguateConversationIntentMutation = (options?: Partial<Options<DisambiguateConversationIntentData>>): UseMutationOptions<DisambiguateConversationIntentResponse, DefaultError, Options<DisambiguateConversationIntentData>> => {
    const mutationOptions: UseMutationOptions<DisambiguateConversationIntentResponse, DefaultError, Options<DisambiguateConversationIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disambiguateConversationIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enableConversationIntentMutation = (options?: Partial<Options<EnableConversationIntentData>>): UseMutationOptions<EnableConversationIntentResponse, DefaultError, Options<EnableConversationIntentData>> => {
    const mutationOptions: UseMutationOptions<EnableConversationIntentResponse, DefaultError, Options<EnableConversationIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableConversationIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const disableConversationIntentMutation = (options?: Partial<Options<DisableConversationIntentData>>): UseMutationOptions<DisableConversationIntentResponse, DefaultError, Options<DisableConversationIntentData>> => {
    const mutationOptions: UseMutationOptions<DisableConversationIntentResponse, DefaultError, Options<DisableConversationIntentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disableConversationIntent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConversationMessageByIdQueryKey = (options: Options<GetConversationMessageByIdData>) => createQueryKey('getConversationMessageById', options);

export const getConversationMessageByIdOptions = (options: Options<GetConversationMessageByIdData>) => queryOptions<GetConversationMessageByIdResponse, DefaultError, GetConversationMessageByIdResponse, ReturnType<typeof getConversationMessageByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConversationMessageById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConversationMessageByIdQueryKey(options)
});

export const listConversationMessagesQueryKey = (options: Options<ListConversationMessagesData>) => createQueryKey('listConversationMessages', options);

export const listConversationMessagesOptions = (options: Options<ListConversationMessagesData>) => queryOptions<ListConversationMessagesResponse, DefaultError, ListConversationMessagesResponse, ReturnType<typeof listConversationMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversationMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationMessagesQueryKey(options)
});

export const listConversationMessagesInfiniteQueryKey = (options: Options<ListConversationMessagesData>): QueryKey<Options<ListConversationMessagesData>> => createQueryKey('listConversationMessages', options, true);

export const listConversationMessagesInfiniteOptions = (options: Options<ListConversationMessagesData>) => {
    const opts = infiniteQueryOptions<ListConversationMessagesResponse, DefaultError, InfiniteData<ListConversationMessagesResponse>, QueryKey<Options<ListConversationMessagesData>>, string | Pick<QueryKey<Options<ListConversationMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListConversationMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listConversationMessages({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listConversationMessagesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const replyToConversationMutation = (options?: Partial<Options<ReplyToConversationData>>): UseMutationOptions<ReplyToConversationResponse, DefaultError, Options<ReplyToConversationData>> => {
    const mutationOptions: UseMutationOptions<ReplyToConversationResponse, DefaultError, Options<ReplyToConversationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await replyToConversation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const submitConversationInteractionMutation = (options?: Partial<Options<SubmitConversationInteractionData>>): UseMutationOptions<SubmitConversationInteractionResponse, DefaultError, Options<SubmitConversationInteractionData>> => {
    const mutationOptions: UseMutationOptions<SubmitConversationInteractionResponse, DefaultError, Options<SubmitConversationInteractionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitConversationInteraction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const closeContextPanelMutation = (options?: Partial<Options<CloseContextPanelData>>): UseMutationOptions<CloseContextPanelResponse, DefaultError, Options<CloseContextPanelData>> => {
    const mutationOptions: UseMutationOptions<CloseContextPanelResponse, DefaultError, Options<CloseContextPanelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await closeContextPanel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setConversationTypingMutation = (options?: Partial<Options<SetConversationTypingData>>): UseMutationOptions<SetConversationTypingResponse, DefaultError, Options<SetConversationTypingData>> => {
    const mutationOptions: UseMutationOptions<SetConversationTypingResponse, DefaultError, Options<SetConversationTypingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setConversationTyping({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setConversationRuntimePolicyMutation = (options?: Partial<Options<SetConversationRuntimePolicyData>>): UseMutationOptions<SetConversationRuntimePolicyResponse, DefaultError, Options<SetConversationRuntimePolicyData>> => {
    const mutationOptions: UseMutationOptions<SetConversationRuntimePolicyResponse, DefaultError, Options<SetConversationRuntimePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setConversationRuntimePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchConversationSettingsMutation = (options?: Partial<Options<PatchConversationSettingsData>>): UseMutationOptions<PatchConversationSettingsResponse, DefaultError, Options<PatchConversationSettingsData>> => {
    const mutationOptions: UseMutationOptions<PatchConversationSettingsResponse, DefaultError, Options<PatchConversationSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchConversationSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConversationContextQueryKey = (options: Options<GetConversationContextData>) => createQueryKey('getConversationContext', options);

export const getConversationContextOptions = (options: Options<GetConversationContextData>) => queryOptions<GetConversationContextResponse, DefaultError, GetConversationContextResponse, ReturnType<typeof getConversationContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConversationContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConversationContextQueryKey(options)
});

export const listConversationArtifactsQueryKey = (options: Options<ListConversationArtifactsData>) => createQueryKey('listConversationArtifacts', options);

export const listConversationArtifactsOptions = (options: Options<ListConversationArtifactsData>) => queryOptions<ListConversationArtifactsResponse, DefaultError, ListConversationArtifactsResponse, ReturnType<typeof listConversationArtifactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversationArtifacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationArtifactsQueryKey(options)
});

export const listConversationArtifactsInfiniteQueryKey = (options: Options<ListConversationArtifactsData>): QueryKey<Options<ListConversationArtifactsData>> => createQueryKey('listConversationArtifacts', options, true);

export const listConversationArtifactsInfiniteOptions = (options: Options<ListConversationArtifactsData>) => {
    const opts = infiniteQueryOptions<ListConversationArtifactsResponse, DefaultError, InfiniteData<ListConversationArtifactsResponse>, QueryKey<Options<ListConversationArtifactsData>>, string | Pick<QueryKey<Options<ListConversationArtifactsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListConversationArtifactsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listConversationArtifacts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listConversationArtifactsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const presignUploadMutation = (options?: Partial<Options<PresignUploadData>>): UseMutationOptions<PresignUploadResponse, DefaultError, Options<PresignUploadData>> => {
    const mutationOptions: UseMutationOptions<PresignUploadResponse, DefaultError, Options<PresignUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await presignUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const finalizeUploadMutation = (options?: Partial<Options<FinalizeUploadData>>): UseMutationOptions<FinalizeUploadResponse, DefaultError, Options<FinalizeUploadData>> => {
    const mutationOptions: UseMutationOptions<FinalizeUploadResponse, DefaultError, Options<FinalizeUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await finalizeUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUploadContentQueryKey = (options: Options<GetUploadContentData>) => createQueryKey('getUploadContent', options);

export const getUploadContentOptions = (options: Options<GetUploadContentData>) => queryOptions<GetUploadContentResponse, DefaultError, GetUploadContentResponse, ReturnType<typeof getUploadContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUploadContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUploadContentQueryKey(options)
});

export const deleteUploadMutation = (options?: Partial<Options<DeleteUploadData>>): UseMutationOptions<DeleteUploadResponse, DefaultError, Options<DeleteUploadData>> => {
    const mutationOptions: UseMutationOptions<DeleteUploadResponse, DefaultError, Options<DeleteUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMemoriesQueryKey = (options?: Options<ListMemoriesData>) => createQueryKey('listMemories', options);

export const listMemoriesOptions = (options?: Options<ListMemoriesData>) => queryOptions<ListMemoriesResponse, DefaultError, ListMemoriesResponse, ReturnType<typeof listMemoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMemories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMemoriesQueryKey(options)
});

export const listMemoriesInfiniteQueryKey = (options?: Options<ListMemoriesData>): QueryKey<Options<ListMemoriesData>> => createQueryKey('listMemories', options, true);

export const listMemoriesInfiniteOptions = (options?: Options<ListMemoriesData>) => {
    const opts = infiniteQueryOptions<ListMemoriesResponse, DefaultError, InfiniteData<ListMemoriesResponse>, QueryKey<Options<ListMemoriesData>>, string | Pick<QueryKey<Options<ListMemoriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListMemoriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listMemories({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMemoriesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createMemoryMutation = (options?: Partial<Options<CreateMemoryData>>): UseMutationOptions<CreateMemoryResponse, DefaultError, Options<CreateMemoryData>> => {
    const mutationOptions: UseMutationOptions<CreateMemoryResponse, DefaultError, Options<CreateMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchMemoriesQueryKey = (options: Options<SearchMemoriesData>) => createQueryKey('searchMemories', options);

export const searchMemoriesOptions = (options: Options<SearchMemoriesData>) => queryOptions<SearchMemoriesResponse, DefaultError, SearchMemoriesResponse, ReturnType<typeof searchMemoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchMemories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchMemoriesQueryKey(options)
});

export const searchMemoriesInfiniteQueryKey = (options: Options<SearchMemoriesData>): QueryKey<Options<SearchMemoriesData>> => createQueryKey('searchMemories', options, true);

export const searchMemoriesInfiniteOptions = (options: Options<SearchMemoriesData>) => {
    const opts = infiniteQueryOptions<SearchMemoriesResponse, DefaultError, InfiniteData<SearchMemoriesResponse>, QueryKey<Options<SearchMemoriesData>>, string | Pick<QueryKey<Options<SearchMemoriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SearchMemoriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await searchMemories({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchMemoriesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const deleteMemoryMutation = (options?: Partial<Options<DeleteMemoryData>>): UseMutationOptions<DeleteMemoryResponse, DefaultError, Options<DeleteMemoryData>> => {
    const mutationOptions: UseMutationOptions<DeleteMemoryResponse, DefaultError, Options<DeleteMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMemoryQueryKey = (options: Options<GetMemoryData>) => createQueryKey('getMemory', options);

export const getMemoryOptions = (options: Options<GetMemoryData>) => queryOptions<GetMemoryResponse, DefaultError, GetMemoryResponse, ReturnType<typeof getMemoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMemory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMemoryQueryKey(options)
});

export const updateMemoryMutation = (options?: Partial<Options<UpdateMemoryData>>): UseMutationOptions<UpdateMemoryResponse, DefaultError, Options<UpdateMemoryData>> => {
    const mutationOptions: UseMutationOptions<UpdateMemoryResponse, DefaultError, Options<UpdateMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promoteMemoryMutation = (options?: Partial<Options<PromoteMemoryData>>): UseMutationOptions<PromoteMemoryResponse, DefaultError, Options<PromoteMemoryData>> => {
    const mutationOptions: UseMutationOptions<PromoteMemoryResponse, DefaultError, Options<PromoteMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promoteMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listArtifactsQueryKey = (options?: Options<ListArtifactsData>) => createQueryKey('listArtifacts', options);

export const listArtifactsOptions = (options?: Options<ListArtifactsData>) => queryOptions<ListArtifactsResponse, DefaultError, ListArtifactsResponse, ReturnType<typeof listArtifactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listArtifacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArtifactsQueryKey(options)
});

export const listArtifactsInfiniteQueryKey = (options?: Options<ListArtifactsData>): QueryKey<Options<ListArtifactsData>> => createQueryKey('listArtifacts', options, true);

export const listArtifactsInfiniteOptions = (options?: Options<ListArtifactsData>) => {
    const opts = infiniteQueryOptions<ListArtifactsResponse, DefaultError, InfiniteData<ListArtifactsResponse>, QueryKey<Options<ListArtifactsData>>, string | Pick<QueryKey<Options<ListArtifactsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListArtifactsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listArtifacts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listArtifactsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createArtifactMutation = (options?: Partial<Options<CreateArtifactData>>): UseMutationOptions<CreateArtifactResponse, DefaultError, Options<CreateArtifactData>> => {
    const mutationOptions: UseMutationOptions<CreateArtifactResponse, DefaultError, Options<CreateArtifactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createArtifact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchArtifactsQueryKey = (options: Options<SearchArtifactsData>) => createQueryKey('searchArtifacts', options);

export const searchArtifactsOptions = (options: Options<SearchArtifactsData>) => queryOptions<SearchArtifactsResponse, DefaultError, SearchArtifactsResponse, ReturnType<typeof searchArtifactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchArtifacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchArtifactsQueryKey(options)
});

export const searchArtifactsInfiniteQueryKey = (options: Options<SearchArtifactsData>): QueryKey<Options<SearchArtifactsData>> => createQueryKey('searchArtifacts', options, true);

export const searchArtifactsInfiniteOptions = (options: Options<SearchArtifactsData>) => {
    const opts = infiniteQueryOptions<SearchArtifactsResponse, DefaultError, InfiniteData<SearchArtifactsResponse>, QueryKey<Options<SearchArtifactsData>>, string | Pick<QueryKey<Options<SearchArtifactsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SearchArtifactsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await searchArtifacts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchArtifactsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const deleteArtifactMutation = (options?: Partial<Options<DeleteArtifactData>>): UseMutationOptions<DeleteArtifactResponse, DefaultError, Options<DeleteArtifactData>> => {
    const mutationOptions: UseMutationOptions<DeleteArtifactResponse, DefaultError, Options<DeleteArtifactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteArtifact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getArtifactQueryKey = (options: Options<GetArtifactData>) => createQueryKey('getArtifact', options);

export const getArtifactOptions = (options: Options<GetArtifactData>) => queryOptions<GetArtifactResponse, DefaultError, GetArtifactResponse, ReturnType<typeof getArtifactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getArtifact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getArtifactQueryKey(options)
});

export const updateArtifactMutation = (options?: Partial<Options<UpdateArtifactData>>): UseMutationOptions<UpdateArtifactResponse, DefaultError, Options<UpdateArtifactData>> => {
    const mutationOptions: UseMutationOptions<UpdateArtifactResponse, DefaultError, Options<UpdateArtifactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateArtifact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectTeamMembersQueryKey = (options: Options<ListProjectTeamMembersData>) => createQueryKey('listProjectTeamMembers', options);

export const listProjectTeamMembersOptions = (options: Options<ListProjectTeamMembersData>) => queryOptions<ListProjectTeamMembersResponse, DefaultError, ListProjectTeamMembersResponse, ReturnType<typeof listProjectTeamMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectTeamMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectTeamMembersQueryKey(options)
});

export const addProjectTeamMemberMutation = (options?: Partial<Options<AddProjectTeamMemberData>>): UseMutationOptions<AddProjectTeamMemberResponse, DefaultError, Options<AddProjectTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddProjectTeamMemberResponse, DefaultError, Options<AddProjectTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addProjectTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeProjectTeamMemberMutation = (options?: Partial<Options<RemoveProjectTeamMemberData>>): UseMutationOptions<RemoveProjectTeamMemberResponse, DefaultError, Options<RemoveProjectTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveProjectTeamMemberResponse, DefaultError, Options<RemoveProjectTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeProjectTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateProjectTeamMemberMutation = (options?: Partial<Options<UpdateProjectTeamMemberData>>): UseMutationOptions<UpdateProjectTeamMemberResponse, DefaultError, Options<UpdateProjectTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateProjectTeamMemberResponse, DefaultError, Options<UpdateProjectTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProjectTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectTeamsQueryKey = (options: Options<ListProjectTeamsData>) => createQueryKey('listProjectTeams', options);

export const listProjectTeamsOptions = (options: Options<ListProjectTeamsData>) => queryOptions<ListProjectTeamsResponse, DefaultError, ListProjectTeamsResponse, ReturnType<typeof listProjectTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectTeams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectTeamsQueryKey(options)
});

export const createProjectTeamMutation = (options?: Partial<Options<CreateProjectTeamData>>): UseMutationOptions<CreateProjectTeamResponse, DefaultError, Options<CreateProjectTeamData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectTeamResponse, DefaultError, Options<CreateProjectTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteProjectTeamMutation = (options?: Partial<Options<DeleteProjectTeamData>>): UseMutationOptions<DeleteProjectTeamResponse, DefaultError, Options<DeleteProjectTeamData>> => {
    const mutationOptions: UseMutationOptions<DeleteProjectTeamResponse, DefaultError, Options<DeleteProjectTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProjectTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectTeamQueryKey = (options: Options<GetProjectTeamData>) => createQueryKey('getProjectTeam', options);

export const getProjectTeamOptions = (options: Options<GetProjectTeamData>) => queryOptions<GetProjectTeamResponse, DefaultError, GetProjectTeamResponse, ReturnType<typeof getProjectTeamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectTeam({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectTeamQueryKey(options)
});

export const updateProjectTeamMutation = (options?: Partial<Options<UpdateProjectTeamData>>): UseMutationOptions<UpdateProjectTeamResponse, DefaultError, Options<UpdateProjectTeamData>> => {
    const mutationOptions: UseMutationOptions<UpdateProjectTeamResponse, DefaultError, Options<UpdateProjectTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProjectTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectMembersQueryKey = (options: Options<ListProjectMembersData>) => createQueryKey('listProjectMembers', options);

export const listProjectMembersOptions = (options: Options<ListProjectMembersData>) => queryOptions<ListProjectMembersResponse, DefaultError, ListProjectMembersResponse, ReturnType<typeof listProjectMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectMembersQueryKey(options)
});

export const addProjectMemberMutation = (options?: Partial<Options<AddProjectMemberData>>): UseMutationOptions<AddProjectMemberResponse, DefaultError, Options<AddProjectMemberData>> => {
    const mutationOptions: UseMutationOptions<AddProjectMemberResponse, DefaultError, Options<AddProjectMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addProjectMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeProjectMemberMutation = (options?: Partial<Options<RemoveProjectMemberData>>): UseMutationOptions<RemoveProjectMemberResponse, DefaultError, Options<RemoveProjectMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveProjectMemberResponse, DefaultError, Options<RemoveProjectMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeProjectMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateProjectMemberRoleMutation = (options?: Partial<Options<UpdateProjectMemberRoleData>>): UseMutationOptions<UpdateProjectMemberRoleResponse, DefaultError, Options<UpdateProjectMemberRoleData>> => {
    const mutationOptions: UseMutationOptions<UpdateProjectMemberRoleResponse, DefaultError, Options<UpdateProjectMemberRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProjectMemberRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectStateQueryKey = (options: Options<GetProjectStateData>) => createQueryKey('getProjectState', options);

export const getProjectStateOptions = (options: Options<GetProjectStateData>) => queryOptions<GetProjectStateResponse, DefaultError, GetProjectStateResponse, ReturnType<typeof getProjectStateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectState({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectStateQueryKey(options)
});

export const listProjectStateEventsQueryKey = (options: Options<ListProjectStateEventsData>) => createQueryKey('listProjectStateEvents', options);

export const listProjectStateEventsOptions = (options: Options<ListProjectStateEventsData>) => queryOptions<ListProjectStateEventsResponse, DefaultError, ListProjectStateEventsResponse, ReturnType<typeof listProjectStateEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectStateEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectStateEventsQueryKey(options)
});

export const listProjectsQueryKey = (options?: Options<ListProjectsData>) => createQueryKey('listProjects', options);

export const listProjectsOptions = (options?: Options<ListProjectsData>) => queryOptions<ListProjectsResponse, DefaultError, ListProjectsResponse, ReturnType<typeof listProjectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjects({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectsQueryKey(options)
});

export const listProjectsInfiniteQueryKey = (options?: Options<ListProjectsData>): QueryKey<Options<ListProjectsData>> => createQueryKey('listProjects', options, true);

export const listProjectsInfiniteOptions = (options?: Options<ListProjectsData>) => {
    const opts = infiniteQueryOptions<ListProjectsResponse, DefaultError, InfiniteData<ListProjectsResponse>, QueryKey<Options<ListProjectsData>>, string | Pick<QueryKey<Options<ListProjectsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListProjectsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listProjects({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listProjectsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createProjectMutation = (options?: Partial<Options<CreateProjectData>>): UseMutationOptions<CreateProjectResponse, DefaultError, Options<CreateProjectData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectResponse, DefaultError, Options<CreateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectCommandCenterQueryKey = (options: Options<GetProjectCommandCenterData>) => createQueryKey('getProjectCommandCenter', options);

export const getProjectCommandCenterOptions = (options: Options<GetProjectCommandCenterData>) => queryOptions<GetProjectCommandCenterResponse, DefaultError, GetProjectCommandCenterResponse, ReturnType<typeof getProjectCommandCenterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectCommandCenter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectCommandCenterQueryKey(options)
});

export const listProjectWorkModeTemplatesQueryKey = (options: Options<ListProjectWorkModeTemplatesData>) => createQueryKey('listProjectWorkModeTemplates', options);

export const listProjectWorkModeTemplatesOptions = (options: Options<ListProjectWorkModeTemplatesData>) => queryOptions<ListProjectWorkModeTemplatesResponse, DefaultError, ListProjectWorkModeTemplatesResponse, ReturnType<typeof listProjectWorkModeTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectWorkModeTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectWorkModeTemplatesQueryKey(options)
});

export const replaceProjectWorkModeTemplatesMutation = (options?: Partial<Options<ReplaceProjectWorkModeTemplatesData>>): UseMutationOptions<ReplaceProjectWorkModeTemplatesResponse, DefaultError, Options<ReplaceProjectWorkModeTemplatesData>> => {
    const mutationOptions: UseMutationOptions<ReplaceProjectWorkModeTemplatesResponse, DefaultError, Options<ReplaceProjectWorkModeTemplatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await replaceProjectWorkModeTemplates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectThreadsQueryKey = (options: Options<ListProjectThreadsData>) => createQueryKey('listProjectThreads', options);

export const listProjectThreadsOptions = (options: Options<ListProjectThreadsData>) => queryOptions<ListProjectThreadsResponse, DefaultError, ListProjectThreadsResponse, ReturnType<typeof listProjectThreadsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectThreads({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectThreadsQueryKey(options)
});

export const createProjectThreadMutation = (options?: Partial<Options<CreateProjectThreadData>>): UseMutationOptions<CreateProjectThreadResponse, DefaultError, Options<CreateProjectThreadData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectThreadResponse, DefaultError, Options<CreateProjectThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateProjectThreadMutation = (options?: Partial<Options<UpdateProjectThreadData>>): UseMutationOptions<UpdateProjectThreadResponse, DefaultError, Options<UpdateProjectThreadData>> => {
    const mutationOptions: UseMutationOptions<UpdateProjectThreadResponse, DefaultError, Options<UpdateProjectThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProjectThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectChangesQueryKey = (options: Options<ListProjectChangesData>) => createQueryKey('listProjectChanges', options);

export const listProjectChangesOptions = (options: Options<ListProjectChangesData>) => queryOptions<ListProjectChangesResponse, DefaultError, ListProjectChangesResponse, ReturnType<typeof listProjectChangesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectChanges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectChangesQueryKey(options)
});

export const createProjectChangeMutation = (options?: Partial<Options<CreateProjectChangeData>>): UseMutationOptions<CreateProjectChangeResponse, DefaultError, Options<CreateProjectChangeData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectChangeResponse, DefaultError, Options<CreateProjectChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectChangeQueryKey = (options: Options<GetProjectChangeData>) => createQueryKey('getProjectChange', options);

export const getProjectChangeOptions = (options: Options<GetProjectChangeData>) => queryOptions<GetProjectChangeResponse, DefaultError, GetProjectChangeResponse, ReturnType<typeof getProjectChangeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectChange({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectChangeQueryKey(options)
});

export const updateProjectChangeMutation = (options?: Partial<Options<UpdateProjectChangeData>>): UseMutationOptions<UpdateProjectChangeResponse, DefaultError, Options<UpdateProjectChangeData>> => {
    const mutationOptions: UseMutationOptions<UpdateProjectChangeResponse, DefaultError, Options<UpdateProjectChangeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProjectChange({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectLogQueryKey = (options: Options<GetProjectLogData>) => createQueryKey('getProjectLog', options);

export const getProjectLogOptions = (options: Options<GetProjectLogData>) => queryOptions<GetProjectLogResponse, DefaultError, GetProjectLogResponse, ReturnType<typeof getProjectLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectLogQueryKey(options)
});

export const createProjectChangeRevisionMutation = (options?: Partial<Options<CreateProjectChangeRevisionData>>): UseMutationOptions<CreateProjectChangeRevisionResponse, DefaultError, Options<CreateProjectChangeRevisionData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectChangeRevisionResponse, DefaultError, Options<CreateProjectChangeRevisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectChangeRevision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const linkProjectThreadResourceMutation = (options?: Partial<Options<LinkProjectThreadResourceData>>): UseMutationOptions<LinkProjectThreadResourceResponse, DefaultError, Options<LinkProjectThreadResourceData>> => {
    const mutationOptions: UseMutationOptions<LinkProjectThreadResourceResponse, DefaultError, Options<LinkProjectThreadResourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await linkProjectThreadResource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const softDeleteProjectMutation = (options?: Partial<Options<SoftDeleteProjectData>>): UseMutationOptions<SoftDeleteProjectResponse, DefaultError, Options<SoftDeleteProjectData>> => {
    const mutationOptions: UseMutationOptions<SoftDeleteProjectResponse, DefaultError, Options<SoftDeleteProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await softDeleteProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectQueryKey = (options: Options<GetProjectData>) => createQueryKey('getProject', options);

export const getProjectOptions = (options: Options<GetProjectData>) => queryOptions<GetProjectResponse, DefaultError, GetProjectResponse, ReturnType<typeof getProjectQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProject({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectQueryKey(options)
});

export const updateProjectMutation = (options?: Partial<Options<UpdateProjectData>>): UseMutationOptions<UpdateProjectResponse, DefaultError, Options<UpdateProjectData>> => {
    const mutationOptions: UseMutationOptions<UpdateProjectResponse, DefaultError, Options<UpdateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const archiveProjectMutation = (options?: Partial<Options<ArchiveProjectData>>): UseMutationOptions<ArchiveProjectResponse, DefaultError, Options<ArchiveProjectData>> => {
    const mutationOptions: UseMutationOptions<ArchiveProjectResponse, DefaultError, Options<ArchiveProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reactivateProjectMutation = (options?: Partial<Options<ReactivateProjectData>>): UseMutationOptions<ReactivateProjectResponse, DefaultError, Options<ReactivateProjectData>> => {
    const mutationOptions: UseMutationOptions<ReactivateProjectResponse, DefaultError, Options<ReactivateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reactivateProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const closeProjectMutation = (options?: Partial<Options<CloseProjectData>>): UseMutationOptions<CloseProjectResponse, DefaultError, Options<CloseProjectData>> => {
    const mutationOptions: UseMutationOptions<CloseProjectResponse, DefaultError, Options<CloseProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await closeProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectSummaryQueryKey = (options: Options<GetProjectSummaryData>) => createQueryKey('getProjectSummary', options);

export const getProjectSummaryOptions = (options: Options<GetProjectSummaryData>) => queryOptions<GetProjectSummaryResponse, DefaultError, GetProjectSummaryResponse, ReturnType<typeof getProjectSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectSummaryQueryKey(options)
});

export const listActionQueueQueryKey = (options?: Options<ListActionQueueData>) => createQueryKey('listActionQueue', options);

export const listActionQueueOptions = (options?: Options<ListActionQueueData>) => queryOptions<ListActionQueueResponse, DefaultError, ListActionQueueResponse, ReturnType<typeof listActionQueueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActionQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActionQueueQueryKey(options)
});

export const claimActionQueueItemMutation = (options?: Partial<Options<ClaimActionQueueItemData>>): UseMutationOptions<ClaimActionQueueItemResponse, DefaultError, Options<ClaimActionQueueItemData>> => {
    const mutationOptions: UseMutationOptions<ClaimActionQueueItemResponse, DefaultError, Options<ClaimActionQueueItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await claimActionQueueItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveActionQueueItemMutation = (options?: Partial<Options<ResolveActionQueueItemData>>): UseMutationOptions<ResolveActionQueueItemResponse, DefaultError, Options<ResolveActionQueueItemData>> => {
    const mutationOptions: UseMutationOptions<ResolveActionQueueItemResponse, DefaultError, Options<ResolveActionQueueItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveActionQueueItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const decideGateMutation = (options?: Partial<Options<DecideGateData>>): UseMutationOptions<DecideGateResponse, DefaultError, Options<DecideGateData>> => {
    const mutationOptions: UseMutationOptions<DecideGateResponse, DefaultError, Options<DecideGateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await decideGate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const transitionBlockerMutation = (options?: Partial<Options<TransitionBlockerData>>): UseMutationOptions<TransitionBlockerResponse, DefaultError, Options<TransitionBlockerData>> => {
    const mutationOptions: UseMutationOptions<TransitionBlockerResponse, DefaultError, Options<TransitionBlockerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transitionBlocker({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const transitionHandoffMutation = (options?: Partial<Options<TransitionHandoffData>>): UseMutationOptions<TransitionHandoffResponse, DefaultError, Options<TransitionHandoffData>> => {
    const mutationOptions: UseMutationOptions<TransitionHandoffResponse, DefaultError, Options<TransitionHandoffData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transitionHandoff({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTaskDecisionsQueryKey = (options: Options<ListTaskDecisionsData>) => createQueryKey('listTaskDecisions', options);

export const listTaskDecisionsOptions = (options: Options<ListTaskDecisionsData>) => queryOptions<ListTaskDecisionsResponse, DefaultError, ListTaskDecisionsResponse, ReturnType<typeof listTaskDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTaskDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTaskDecisionsQueryKey(options)
});

export const startTaskMutation = (options?: Partial<Options<StartTaskData>>): UseMutationOptions<StartTaskResponse, DefaultError, Options<StartTaskData>> => {
    const mutationOptions: UseMutationOptions<StartTaskResponse, DefaultError, Options<StartTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cancelTaskMutation = (options?: Partial<Options<CancelTaskData>>): UseMutationOptions<CancelTaskResponse, DefaultError, Options<CancelTaskData>> => {
    const mutationOptions: UseMutationOptions<CancelTaskResponse, DefaultError, Options<CancelTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const approveTaskActionMutation = (options?: Partial<Options<ApproveTaskActionData>>): UseMutationOptions<ApproveTaskActionResponse, DefaultError, Options<ApproveTaskActionData>> => {
    const mutationOptions: UseMutationOptions<ApproveTaskActionResponse, DefaultError, Options<ApproveTaskActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approveTaskAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectTaskActionMutation = (options?: Partial<Options<RejectTaskActionData>>): UseMutationOptions<RejectTaskActionResponse, DefaultError, Options<RejectTaskActionData>> => {
    const mutationOptions: UseMutationOptions<RejectTaskActionResponse, DefaultError, Options<RejectTaskActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectTaskAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const extendApprovalTimeoutMutation = (options?: Partial<Options<ExtendApprovalTimeoutData>>): UseMutationOptions<ExtendApprovalTimeoutResponse, DefaultError, Options<ExtendApprovalTimeoutData>> => {
    const mutationOptions: UseMutationOptions<ExtendApprovalTimeoutResponse, DefaultError, Options<ExtendApprovalTimeoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extendApprovalTimeout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const completeTaskMutation = (options?: Partial<Options<CompleteTaskData>>): UseMutationOptions<CompleteTaskResponse, DefaultError, Options<CompleteTaskData>> => {
    const mutationOptions: UseMutationOptions<CompleteTaskResponse, DefaultError, Options<CompleteTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const retryTaskMutation = (options?: Partial<Options<RetryTaskData>>): UseMutationOptions<RetryTaskResponse, DefaultError, Options<RetryTaskData>> => {
    const mutationOptions: UseMutationOptions<RetryTaskResponse, DefaultError, Options<RetryTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reassignTaskMutation = (options?: Partial<Options<ReassignTaskData>>): UseMutationOptions<ReassignTaskResponse, DefaultError, Options<ReassignTaskData>> => {
    const mutationOptions: UseMutationOptions<ReassignTaskResponse, DefaultError, Options<ReassignTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reassignTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const transferTaskTeamMutation = (options?: Partial<Options<TransferTaskTeamData>>): UseMutationOptions<TransferTaskTeamResponse, DefaultError, Options<TransferTaskTeamData>> => {
    const mutationOptions: UseMutationOptions<TransferTaskTeamResponse, DefaultError, Options<TransferTaskTeamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transferTaskTeam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTasksQueryKey = (options?: Options<ListTasksData>) => createQueryKey('listTasks', options);

export const listTasksOptions = (options?: Options<ListTasksData>) => queryOptions<ListTasksResponse, DefaultError, ListTasksResponse, ReturnType<typeof listTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTasksQueryKey(options)
});

export const listTasksInfiniteQueryKey = (options?: Options<ListTasksData>): QueryKey<Options<ListTasksData>> => createQueryKey('listTasks', options, true);

export const listTasksInfiniteOptions = (options?: Options<ListTasksData>) => {
    const opts = infiniteQueryOptions<ListTasksResponse, DefaultError, InfiniteData<ListTasksResponse>, QueryKey<Options<ListTasksData>>, string | Pick<QueryKey<Options<ListTasksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTasksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTasks({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTasksInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createTaskMutation = (options?: Partial<Options<CreateTaskData>>): UseMutationOptions<CreateTaskResponse, DefaultError, Options<CreateTaskData>> => {
    const mutationOptions: UseMutationOptions<CreateTaskResponse, DefaultError, Options<CreateTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteTaskMutation = (options?: Partial<Options<DeleteTaskData>>): UseMutationOptions<DeleteTaskResponse, DefaultError, Options<DeleteTaskData>> => {
    const mutationOptions: UseMutationOptions<DeleteTaskResponse, DefaultError, Options<DeleteTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskQueryKey = (options: Options<GetTaskData>) => createQueryKey('getTask', options);

export const getTaskOptions = (options: Options<GetTaskData>) => queryOptions<GetTaskResponse, DefaultError, GetTaskResponse, ReturnType<typeof getTaskQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTask({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskQueryKey(options)
});

export const updateTaskMutation = (options?: Partial<Options<UpdateTaskData>>): UseMutationOptions<UpdateTaskResponse, DefaultError, Options<UpdateTaskData>> => {
    const mutationOptions: UseMutationOptions<UpdateTaskResponse, DefaultError, Options<UpdateTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listInterventionsQueryKey = (options?: Options<ListInterventionsData>) => createQueryKey('listInterventions', options);

export const listInterventionsOptions = (options?: Options<ListInterventionsData>) => queryOptions<ListInterventionsResponse, DefaultError, ListInterventionsResponse, ReturnType<typeof listInterventionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInterventions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInterventionsQueryKey(options)
});

export const createInterventionMutation = (options?: Partial<Options<CreateInterventionData>>): UseMutationOptions<CreateInterventionResponse, CreateInterventionError, Options<CreateInterventionData>> => {
    const mutationOptions: UseMutationOptions<CreateInterventionResponse, CreateInterventionError, Options<CreateInterventionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIntervention({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInterventionQueryKey = (options: Options<GetInterventionData>) => createQueryKey('getIntervention', options);

export const getInterventionOptions = (options: Options<GetInterventionData>) => queryOptions<GetInterventionResponse, GetInterventionError, GetInterventionResponse, ReturnType<typeof getInterventionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIntervention({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInterventionQueryKey(options)
});

export const routeInterventionMutation = (options?: Partial<Options<RouteInterventionData>>): UseMutationOptions<RouteInterventionResponse, RouteInterventionError, Options<RouteInterventionData>> => {
    const mutationOptions: UseMutationOptions<RouteInterventionResponse, RouteInterventionError, Options<RouteInterventionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await routeIntervention({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveInterventionMutation = (options?: Partial<Options<ResolveInterventionData>>): UseMutationOptions<ResolveInterventionResponse, ResolveInterventionError, Options<ResolveInterventionData>> => {
    const mutationOptions: UseMutationOptions<ResolveInterventionResponse, ResolveInterventionError, Options<ResolveInterventionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveIntervention({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectInterventionMutation = (options?: Partial<Options<RejectInterventionData>>): UseMutationOptions<RejectInterventionResponse, RejectInterventionError, Options<RejectInterventionData>> => {
    const mutationOptions: UseMutationOptions<RejectInterventionResponse, RejectInterventionError, Options<RejectInterventionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectIntervention({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkstreamMembersQueryKey = (options: Options<ListWorkstreamMembersData>) => createQueryKey('listWorkstreamMembers', options);

export const listWorkstreamMembersOptions = (options: Options<ListWorkstreamMembersData>) => queryOptions<ListWorkstreamMembersResponse, DefaultError, ListWorkstreamMembersResponse, ReturnType<typeof listWorkstreamMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkstreamMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkstreamMembersQueryKey(options)
});

export const addWorkstreamMemberMutation = (options?: Partial<Options<AddWorkstreamMemberData>>): UseMutationOptions<AddWorkstreamMemberResponse, DefaultError, Options<AddWorkstreamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddWorkstreamMemberResponse, DefaultError, Options<AddWorkstreamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addWorkstreamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeWorkstreamMemberMutation = (options?: Partial<Options<RemoveWorkstreamMemberData>>): UseMutationOptions<RemoveWorkstreamMemberResponse, DefaultError, Options<RemoveWorkstreamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveWorkstreamMemberResponse, DefaultError, Options<RemoveWorkstreamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeWorkstreamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkstreamDecisionsQueryKey = (options: Options<ListWorkstreamDecisionsData>) => createQueryKey('listWorkstreamDecisions', options);

export const listWorkstreamDecisionsOptions = (options: Options<ListWorkstreamDecisionsData>) => queryOptions<ListWorkstreamDecisionsResponse, DefaultError, ListWorkstreamDecisionsResponse, ReturnType<typeof listWorkstreamDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkstreamDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkstreamDecisionsQueryKey(options)
});

export const listWorkstreamDecisionsInfiniteQueryKey = (options: Options<ListWorkstreamDecisionsData>): QueryKey<Options<ListWorkstreamDecisionsData>> => createQueryKey('listWorkstreamDecisions', options, true);

export const listWorkstreamDecisionsInfiniteOptions = (options: Options<ListWorkstreamDecisionsData>) => {
    const opts = infiniteQueryOptions<ListWorkstreamDecisionsResponse, DefaultError, InfiniteData<ListWorkstreamDecisionsResponse>, QueryKey<Options<ListWorkstreamDecisionsData>>, string | Pick<QueryKey<Options<ListWorkstreamDecisionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListWorkstreamDecisionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listWorkstreamDecisions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkstreamDecisionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listWorkstreamsQueryKey = (options?: Options<ListWorkstreamsData>) => createQueryKey('listWorkstreams', options);

export const listWorkstreamsOptions = (options?: Options<ListWorkstreamsData>) => queryOptions<ListWorkstreamsResponse, DefaultError, ListWorkstreamsResponse, ReturnType<typeof listWorkstreamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkstreams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkstreamsQueryKey(options)
});

export const listWorkstreamsInfiniteQueryKey = (options?: Options<ListWorkstreamsData>): QueryKey<Options<ListWorkstreamsData>> => createQueryKey('listWorkstreams', options, true);

export const listWorkstreamsInfiniteOptions = (options?: Options<ListWorkstreamsData>) => {
    const opts = infiniteQueryOptions<ListWorkstreamsResponse, DefaultError, InfiniteData<ListWorkstreamsResponse>, QueryKey<Options<ListWorkstreamsData>>, string | Pick<QueryKey<Options<ListWorkstreamsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListWorkstreamsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listWorkstreams({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkstreamsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createWorkstreamMutation = (options?: Partial<Options<CreateWorkstreamData>>): UseMutationOptions<CreateWorkstreamResponse, DefaultError, Options<CreateWorkstreamData>> => {
    const mutationOptions: UseMutationOptions<CreateWorkstreamResponse, DefaultError, Options<CreateWorkstreamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWorkstream({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const archiveWorkstreamMutation = (options?: Partial<Options<ArchiveWorkstreamData>>): UseMutationOptions<ArchiveWorkstreamResponse, DefaultError, Options<ArchiveWorkstreamData>> => {
    const mutationOptions: UseMutationOptions<ArchiveWorkstreamResponse, DefaultError, Options<ArchiveWorkstreamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveWorkstream({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkstreamQueryKey = (options: Options<GetWorkstreamData>) => createQueryKey('getWorkstream', options);

export const getWorkstreamOptions = (options: Options<GetWorkstreamData>) => queryOptions<GetWorkstreamResponse, DefaultError, GetWorkstreamResponse, ReturnType<typeof getWorkstreamQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWorkstream({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWorkstreamQueryKey(options)
});

export const updateWorkstreamMutation = (options?: Partial<Options<UpdateWorkstreamData>>): UseMutationOptions<UpdateWorkstreamResponse, DefaultError, Options<UpdateWorkstreamData>> => {
    const mutationOptions: UseMutationOptions<UpdateWorkstreamResponse, DefaultError, Options<UpdateWorkstreamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWorkstream({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listApproverDelegationsQueryKey = (options?: Options<ListApproverDelegationsData>) => createQueryKey('listApproverDelegations', options);

export const listApproverDelegationsOptions = (options?: Options<ListApproverDelegationsData>) => queryOptions<ListApproverDelegationsResponse, DefaultError, ListApproverDelegationsResponse, ReturnType<typeof listApproverDelegationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listApproverDelegations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listApproverDelegationsQueryKey(options)
});

export const createApproverDelegationMutation = (options?: Partial<Options<CreateApproverDelegationData>>): UseMutationOptions<CreateApproverDelegationResponse, DefaultError, Options<CreateApproverDelegationData>> => {
    const mutationOptions: UseMutationOptions<CreateApproverDelegationResponse, DefaultError, Options<CreateApproverDelegationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createApproverDelegation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const revokeApproverDelegationMutation = (options?: Partial<Options<RevokeApproverDelegationData>>): UseMutationOptions<RevokeApproverDelegationResponse, DefaultError, Options<RevokeApproverDelegationData>> => {
    const mutationOptions: UseMutationOptions<RevokeApproverDelegationResponse, DefaultError, Options<RevokeApproverDelegationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeApproverDelegation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPromotionCandidatesQueryKey = (options?: Options<ListPromotionCandidatesData>) => createQueryKey('listPromotionCandidates', options);

export const listPromotionCandidatesOptions = (options?: Options<ListPromotionCandidatesData>) => queryOptions<ListPromotionCandidatesResponse, DefaultError, ListPromotionCandidatesResponse, ReturnType<typeof listPromotionCandidatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPromotionCandidates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPromotionCandidatesQueryKey(options)
});

export const getPromotionCandidateQueryKey = (options: Options<GetPromotionCandidateData>) => createQueryKey('getPromotionCandidate', options);

export const getPromotionCandidateOptions = (options: Options<GetPromotionCandidateData>) => queryOptions<GetPromotionCandidateResponse, DefaultError, GetPromotionCandidateResponse, ReturnType<typeof getPromotionCandidateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPromotionCandidate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPromotionCandidateQueryKey(options)
});

export const acceptPromotionCandidateMutation = (options?: Partial<Options<AcceptPromotionCandidateData>>): UseMutationOptions<AcceptPromotionCandidateResponse, DefaultError, Options<AcceptPromotionCandidateData>> => {
    const mutationOptions: UseMutationOptions<AcceptPromotionCandidateResponse, DefaultError, Options<AcceptPromotionCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptPromotionCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectPromotionCandidateMutation = (options?: Partial<Options<RejectPromotionCandidateData>>): UseMutationOptions<RejectPromotionCandidateResponse, DefaultError, Options<RejectPromotionCandidateData>> => {
    const mutationOptions: UseMutationOptions<RejectPromotionCandidateResponse, DefaultError, Options<RejectPromotionCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectPromotionCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAdminDaemonFindingsQueryKey = (options?: Options<ListAdminDaemonFindingsData>) => createQueryKey('listAdminDaemonFindings', options);

export const listAdminDaemonFindingsOptions = (options?: Options<ListAdminDaemonFindingsData>) => queryOptions<ListAdminDaemonFindingsResponse, DefaultError, ListAdminDaemonFindingsResponse, ReturnType<typeof listAdminDaemonFindingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAdminDaemonFindings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAdminDaemonFindingsQueryKey(options)
});

export const listDeadLetterEntriesQueryKey = (options?: Options<ListDeadLetterEntriesData>) => createQueryKey('listDeadLetterEntries', options);

export const listDeadLetterEntriesOptions = (options?: Options<ListDeadLetterEntriesData>) => queryOptions<ListDeadLetterEntriesResponse, DefaultError, ListDeadLetterEntriesResponse, ReturnType<typeof listDeadLetterEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDeadLetterEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDeadLetterEntriesQueryKey(options)
});

export const listDeadLetterEntriesInfiniteQueryKey = (options?: Options<ListDeadLetterEntriesData>): QueryKey<Options<ListDeadLetterEntriesData>> => createQueryKey('listDeadLetterEntries', options, true);

export const listDeadLetterEntriesInfiniteOptions = (options?: Options<ListDeadLetterEntriesData>) => {
    const opts = infiniteQueryOptions<ListDeadLetterEntriesResponse, DefaultError, InfiniteData<ListDeadLetterEntriesResponse>, QueryKey<Options<ListDeadLetterEntriesData>>, number | null | Pick<QueryKey<Options<ListDeadLetterEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListDeadLetterEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listDeadLetterEntries({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDeadLetterEntriesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const replayDeadLetterEntryMutation = (options?: Partial<Options<ReplayDeadLetterEntryData>>): UseMutationOptions<ReplayDeadLetterEntryResponse, DefaultError, Options<ReplayDeadLetterEntryData>> => {
    const mutationOptions: UseMutationOptions<ReplayDeadLetterEntryResponse, DefaultError, Options<ReplayDeadLetterEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await replayDeadLetterEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPlatformRuntimeFlagsQueryKey = (options?: Options<ListPlatformRuntimeFlagsData>) => createQueryKey('listPlatformRuntimeFlags', options);

export const listPlatformRuntimeFlagsOptions = (options?: Options<ListPlatformRuntimeFlagsData>) => queryOptions<ListPlatformRuntimeFlagsResponse, DefaultError, ListPlatformRuntimeFlagsResponse, ReturnType<typeof listPlatformRuntimeFlagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPlatformRuntimeFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPlatformRuntimeFlagsQueryKey(options)
});

export const setPlatformRuntimeFlagMutation = (options?: Partial<Options<SetPlatformRuntimeFlagData>>): UseMutationOptions<SetPlatformRuntimeFlagResponse, DefaultError, Options<SetPlatformRuntimeFlagData>> => {
    const mutationOptions: UseMutationOptions<SetPlatformRuntimeFlagResponse, DefaultError, Options<SetPlatformRuntimeFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setPlatformRuntimeFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationRuntimeFlagsQueryKey = (options?: Options<ListOrganizationRuntimeFlagsData>) => createQueryKey('listOrganizationRuntimeFlags', options);

export const listOrganizationRuntimeFlagsOptions = (options?: Options<ListOrganizationRuntimeFlagsData>) => queryOptions<ListOrganizationRuntimeFlagsResponse, DefaultError, ListOrganizationRuntimeFlagsResponse, ReturnType<typeof listOrganizationRuntimeFlagsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationRuntimeFlags({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationRuntimeFlagsQueryKey(options)
});

export const setOrganizationRuntimeFlagMutation = (options?: Partial<Options<SetOrganizationRuntimeFlagData>>): UseMutationOptions<SetOrganizationRuntimeFlagResponse, DefaultError, Options<SetOrganizationRuntimeFlagData>> => {
    const mutationOptions: UseMutationOptions<SetOrganizationRuntimeFlagResponse, DefaultError, Options<SetOrganizationRuntimeFlagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setOrganizationRuntimeFlag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSystemOverviewQueryKey = (options?: Options<GetSystemOverviewData>) => createQueryKey('getSystemOverview', options);

export const getSystemOverviewOptions = (options?: Options<GetSystemOverviewData>) => queryOptions<GetSystemOverviewResponse, DefaultError, GetSystemOverviewResponse, ReturnType<typeof getSystemOverviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemOverviewQueryKey(options)
});

export const getSystemHostQueryKey = (options: Options<GetSystemHostData>) => createQueryKey('getSystemHost', options);

export const getSystemHostOptions = (options: Options<GetSystemHostData>) => queryOptions<GetSystemHostResponse, GetSystemHostError, GetSystemHostResponse, ReturnType<typeof getSystemHostQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemHost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemHostQueryKey(options)
});

export const getSystemHostSeriesQueryKey = (options: Options<GetSystemHostSeriesData>) => createQueryKey('getSystemHostSeries', options);

export const getSystemHostSeriesOptions = (options: Options<GetSystemHostSeriesData>) => queryOptions<GetSystemHostSeriesResponse, GetSystemHostSeriesError, GetSystemHostSeriesResponse, ReturnType<typeof getSystemHostSeriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemHostSeries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemHostSeriesQueryKey(options)
});

export const getSystemDatabaseQueryKey = (options: Options<GetSystemDatabaseData>) => createQueryKey('getSystemDatabase', options);

export const getSystemDatabaseOptions = (options: Options<GetSystemDatabaseData>) => queryOptions<GetSystemDatabaseResponse, GetSystemDatabaseError, GetSystemDatabaseResponse, ReturnType<typeof getSystemDatabaseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemDatabase({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemDatabaseQueryKey(options)
});

export const getSystemDatabaseSeriesQueryKey = (options: Options<GetSystemDatabaseSeriesData>) => createQueryKey('getSystemDatabaseSeries', options);

export const getSystemDatabaseSeriesOptions = (options: Options<GetSystemDatabaseSeriesData>) => queryOptions<GetSystemDatabaseSeriesResponse, GetSystemDatabaseSeriesError, GetSystemDatabaseSeriesResponse, ReturnType<typeof getSystemDatabaseSeriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemDatabaseSeries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemDatabaseSeriesQueryKey(options)
});

export const listSystemDatabaseStatementsQueryKey = (options: Options<ListSystemDatabaseStatementsData>) => createQueryKey('listSystemDatabaseStatements', options);

export const listSystemDatabaseStatementsOptions = (options: Options<ListSystemDatabaseStatementsData>) => queryOptions<ListSystemDatabaseStatementsResponse, ListSystemDatabaseStatementsError, ListSystemDatabaseStatementsResponse, ReturnType<typeof listSystemDatabaseStatementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSystemDatabaseStatements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSystemDatabaseStatementsQueryKey(options)
});

export const getSystemRedisQueryKey = (options?: Options<GetSystemRedisData>) => createQueryKey('getSystemRedis', options);

export const getSystemRedisOptions = (options?: Options<GetSystemRedisData>) => queryOptions<GetSystemRedisResponse, DefaultError, GetSystemRedisResponse, ReturnType<typeof getSystemRedisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemRedis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemRedisQueryKey(options)
});

export const getSystemRedisSeriesQueryKey = (options: Options<GetSystemRedisSeriesData>) => createQueryKey('getSystemRedisSeries', options);

export const getSystemRedisSeriesOptions = (options: Options<GetSystemRedisSeriesData>) => queryOptions<GetSystemRedisSeriesResponse, GetSystemRedisSeriesError, GetSystemRedisSeriesResponse, ReturnType<typeof getSystemRedisSeriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemRedisSeries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemRedisSeriesQueryKey(options)
});

export const cancelAllOrdersMutation = (options?: Partial<Options<CancelAllOrdersData>>): UseMutationOptions<CancelAllOrdersResponse, DefaultError, Options<CancelAllOrdersData>> => {
    const mutationOptions: UseMutationOptions<CancelAllOrdersResponse, DefaultError, Options<CancelAllOrdersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelAllOrders({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrdersQueryKey = (options?: Options<ListOrdersData>) => createQueryKey('listOrders', options);

export const listOrdersOptions = (options?: Options<ListOrdersData>) => queryOptions<ListOrdersResponse, DefaultError, ListOrdersResponse, ReturnType<typeof listOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrdersQueryKey(options)
});

export const createOrderMutation = (options?: Partial<Options<CreateOrderData>>): UseMutationOptions<CreateOrderResponse, DefaultError, Options<CreateOrderData>> => {
    const mutationOptions: UseMutationOptions<CreateOrderResponse, DefaultError, Options<CreateOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cancelOrderMutation = (options?: Partial<Options<CancelOrderData>>): UseMutationOptions<CancelOrderResponse, DefaultError, Options<CancelOrderData>> => {
    const mutationOptions: UseMutationOptions<CancelOrderResponse, DefaultError, Options<CancelOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrderQueryKey = (options: Options<GetOrderData>) => createQueryKey('getOrder', options);

export const getOrderOptions = (options: Options<GetOrderData>) => queryOptions<GetOrderResponse, DefaultError, GetOrderResponse, ReturnType<typeof getOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderQueryKey(options)
});

export const listTradesQueryKey = (options?: Options<ListTradesData>) => createQueryKey('listTrades', options);

export const listTradesOptions = (options?: Options<ListTradesData>) => queryOptions<ListTradesResponse, DefaultError, ListTradesResponse, ReturnType<typeof listTradesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTrades({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTradesQueryKey(options)
});

export const getTradeStatsQueryKey = (options?: Options<GetTradeStatsData>) => createQueryKey('getTradeStats', options);

export const getTradeStatsOptions = (options?: Options<GetTradeStatsData>) => queryOptions<GetTradeStatsResponse, DefaultError, GetTradeStatsResponse, ReturnType<typeof getTradeStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTradeStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTradeStatsQueryKey(options)
});

export const listPositionsQueryKey = (options?: Options<ListPositionsData>) => createQueryKey('listPositions', options);

export const listPositionsOptions = (options?: Options<ListPositionsData>) => queryOptions<ListPositionsResponse, DefaultError, ListPositionsResponse, ReturnType<typeof listPositionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPositions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPositionsQueryKey(options)
});

export const getPositionQueryKey = (options: Options<GetPositionData>) => createQueryKey('getPosition', options);

export const getPositionOptions = (options: Options<GetPositionData>) => queryOptions<GetPositionResponse, DefaultError, GetPositionResponse, ReturnType<typeof getPositionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPosition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPositionQueryKey(options)
});

export const closePositionMutation = (options?: Partial<Options<ClosePositionData>>): UseMutationOptions<ClosePositionResponse, DefaultError, Options<ClosePositionData>> => {
    const mutationOptions: UseMutationOptions<ClosePositionResponse, DefaultError, Options<ClosePositionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await closePosition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRiskLimitsQueryKey = (options?: Options<ListRiskLimitsData>) => createQueryKey('listRiskLimits', options);

export const listRiskLimitsOptions = (options?: Options<ListRiskLimitsData>) => queryOptions<ListRiskLimitsResponse, DefaultError, ListRiskLimitsResponse, ReturnType<typeof listRiskLimitsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRiskLimits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRiskLimitsQueryKey(options)
});

export const listRiskLimitsInfiniteQueryKey = (options?: Options<ListRiskLimitsData>): QueryKey<Options<ListRiskLimitsData>> => createQueryKey('listRiskLimits', options, true);

export const listRiskLimitsInfiniteOptions = (options?: Options<ListRiskLimitsData>) => {
    const opts = infiniteQueryOptions<ListRiskLimitsResponse, DefaultError, InfiniteData<ListRiskLimitsResponse>, QueryKey<Options<ListRiskLimitsData>>, string | Pick<QueryKey<Options<ListRiskLimitsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListRiskLimitsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listRiskLimits({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRiskLimitsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createRiskLimitMutation = (options?: Partial<Options<CreateRiskLimitData>>): UseMutationOptions<CreateRiskLimitResponse, DefaultError, Options<CreateRiskLimitData>> => {
    const mutationOptions: UseMutationOptions<CreateRiskLimitResponse, DefaultError, Options<CreateRiskLimitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createRiskLimit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteRiskLimitMutation = (options?: Partial<Options<DeleteRiskLimitData>>): UseMutationOptions<DeleteRiskLimitResponse, DefaultError, Options<DeleteRiskLimitData>> => {
    const mutationOptions: UseMutationOptions<DeleteRiskLimitResponse, DefaultError, Options<DeleteRiskLimitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteRiskLimit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateRiskLimitMutation = (options?: Partial<Options<UpdateRiskLimitData>>): UseMutationOptions<UpdateRiskLimitResponse, DefaultError, Options<UpdateRiskLimitData>> => {
    const mutationOptions: UseMutationOptions<UpdateRiskLimitResponse, DefaultError, Options<UpdateRiskLimitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateRiskLimit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRiskBreachesQueryKey = (options?: Options<ListRiskBreachesData>) => createQueryKey('listRiskBreaches', options);

export const listRiskBreachesOptions = (options?: Options<ListRiskBreachesData>) => queryOptions<ListRiskBreachesResponse, DefaultError, ListRiskBreachesResponse, ReturnType<typeof listRiskBreachesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRiskBreaches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRiskBreachesQueryKey(options)
});

export const listRiskBreachesInfiniteQueryKey = (options?: Options<ListRiskBreachesData>): QueryKey<Options<ListRiskBreachesData>> => createQueryKey('listRiskBreaches', options, true);

export const listRiskBreachesInfiniteOptions = (options?: Options<ListRiskBreachesData>) => {
    const opts = infiniteQueryOptions<ListRiskBreachesResponse, DefaultError, InfiniteData<ListRiskBreachesResponse>, QueryKey<Options<ListRiskBreachesData>>, string | Pick<QueryKey<Options<ListRiskBreachesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListRiskBreachesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listRiskBreaches({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRiskBreachesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const acceptRiskBreachMutation = (options?: Partial<Options<AcceptRiskBreachData>>): UseMutationOptions<AcceptRiskBreachResponse, DefaultError, Options<AcceptRiskBreachData>> => {
    const mutationOptions: UseMutationOptions<AcceptRiskBreachResponse, DefaultError, Options<AcceptRiskBreachData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptRiskBreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveRiskBreachMutation = (options?: Partial<Options<ResolveRiskBreachData>>): UseMutationOptions<ResolveRiskBreachResponse, DefaultError, Options<ResolveRiskBreachData>> => {
    const mutationOptions: UseMutationOptions<ResolveRiskBreachResponse, DefaultError, Options<ResolveRiskBreachData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveRiskBreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const escalateRiskBreachMutation = (options?: Partial<Options<EscalateRiskBreachData>>): UseMutationOptions<EscalateRiskBreachResponse, DefaultError, Options<EscalateRiskBreachData>> => {
    const mutationOptions: UseMutationOptions<EscalateRiskBreachResponse, DefaultError, Options<EscalateRiskBreachData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await escalateRiskBreach({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRiskHaltsQueryKey = (options?: Options<ListRiskHaltsData>) => createQueryKey('listRiskHalts', options);

export const listRiskHaltsOptions = (options?: Options<ListRiskHaltsData>) => queryOptions<ListRiskHaltsResponse, DefaultError, ListRiskHaltsResponse, ReturnType<typeof listRiskHaltsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRiskHalts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRiskHaltsQueryKey(options)
});

export const listRiskHaltsInfiniteQueryKey = (options?: Options<ListRiskHaltsData>): QueryKey<Options<ListRiskHaltsData>> => createQueryKey('listRiskHalts', options, true);

export const listRiskHaltsInfiniteOptions = (options?: Options<ListRiskHaltsData>) => {
    const opts = infiniteQueryOptions<ListRiskHaltsResponse, DefaultError, InfiniteData<ListRiskHaltsResponse>, QueryKey<Options<ListRiskHaltsData>>, string | Pick<QueryKey<Options<ListRiskHaltsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListRiskHaltsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listRiskHalts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRiskHaltsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const activateRiskHaltMutation = (options?: Partial<Options<ActivateRiskHaltData>>): UseMutationOptions<ActivateRiskHaltResponse, DefaultError, Options<ActivateRiskHaltData>> => {
    const mutationOptions: UseMutationOptions<ActivateRiskHaltResponse, DefaultError, Options<ActivateRiskHaltData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activateRiskHalt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resumeRiskHaltMutation = (options?: Partial<Options<ResumeRiskHaltData>>): UseMutationOptions<ResumeRiskHaltResponse, DefaultError, Options<ResumeRiskHaltData>> => {
    const mutationOptions: UseMutationOptions<ResumeRiskHaltResponse, DefaultError, Options<ResumeRiskHaltData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resumeRiskHalt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRiskStatusQueryKey = (options?: Options<GetRiskStatusData>) => createQueryKey('getRiskStatus', options);

export const getRiskStatusOptions = (options?: Options<GetRiskStatusData>) => queryOptions<GetRiskStatusResponse, DefaultError, GetRiskStatusResponse, ReturnType<typeof getRiskStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRiskStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRiskStatusQueryKey(options)
});

export const listActiveStrategiesQueryKey = (options?: Options<ListActiveStrategiesData>) => createQueryKey('listActiveStrategies', options);

export const listActiveStrategiesOptions = (options?: Options<ListActiveStrategiesData>) => queryOptions<ListActiveStrategiesResponse, DefaultError, ListActiveStrategiesResponse, ReturnType<typeof listActiveStrategiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActiveStrategies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActiveStrategiesQueryKey(options)
});

export const createActiveStrategyMutation = (options?: Partial<Options<CreateActiveStrategyData>>): UseMutationOptions<CreateActiveStrategyResponse, DefaultError, Options<CreateActiveStrategyData>> => {
    const mutationOptions: UseMutationOptions<CreateActiveStrategyResponse, DefaultError, Options<CreateActiveStrategyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createActiveStrategy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeActiveStrategyMutation = (options?: Partial<Options<RemoveActiveStrategyData>>): UseMutationOptions<RemoveActiveStrategyResponse, DefaultError, Options<RemoveActiveStrategyData>> => {
    const mutationOptions: UseMutationOptions<RemoveActiveStrategyResponse, DefaultError, Options<RemoveActiveStrategyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeActiveStrategy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getActiveStrategyQueryKey = (options: Options<GetActiveStrategyData>) => createQueryKey('getActiveStrategy', options);

export const getActiveStrategyOptions = (options: Options<GetActiveStrategyData>) => queryOptions<GetActiveStrategyResponse, DefaultError, GetActiveStrategyResponse, ReturnType<typeof getActiveStrategyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActiveStrategy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActiveStrategyQueryKey(options)
});

export const updateStrategyParametersMutation = (options?: Partial<Options<UpdateStrategyParametersData>>): UseMutationOptions<UpdateStrategyParametersResponse, DefaultError, Options<UpdateStrategyParametersData>> => {
    const mutationOptions: UseMutationOptions<UpdateStrategyParametersResponse, DefaultError, Options<UpdateStrategyParametersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStrategyParameters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const startStrategyMutation = (options?: Partial<Options<StartStrategyData>>): UseMutationOptions<StartStrategyResponse, DefaultError, Options<StartStrategyData>> => {
    const mutationOptions: UseMutationOptions<StartStrategyResponse, DefaultError, Options<StartStrategyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startStrategy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stopStrategyMutation = (options?: Partial<Options<StopStrategyData>>): UseMutationOptions<StopStrategyResponse, DefaultError, Options<StopStrategyData>> => {
    const mutationOptions: UseMutationOptions<StopStrategyResponse, DefaultError, Options<StopStrategyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopStrategy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deployStrategyMutation = (options?: Partial<Options<DeployStrategyData>>): UseMutationOptions<DeployStrategyResponse, DefaultError, Options<DeployStrategyData>> => {
    const mutationOptions: UseMutationOptions<DeployStrategyResponse, DefaultError, Options<DeployStrategyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deployStrategy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const undeployStrategyMutation = (options?: Partial<Options<UndeployStrategyData>>): UseMutationOptions<UndeployStrategyResponse, DefaultError, Options<UndeployStrategyData>> => {
    const mutationOptions: UseMutationOptions<UndeployStrategyResponse, DefaultError, Options<UndeployStrategyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await undeployStrategy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStrategyDeploymentStatusQueryKey = (options: Options<GetStrategyDeploymentStatusData>) => createQueryKey('getStrategyDeploymentStatus', options);

export const getStrategyDeploymentStatusOptions = (options: Options<GetStrategyDeploymentStatusData>) => queryOptions<GetStrategyDeploymentStatusResponse, DefaultError, GetStrategyDeploymentStatusResponse, ReturnType<typeof getStrategyDeploymentStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStrategyDeploymentStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStrategyDeploymentStatusQueryKey(options)
});

export const generateStrategyDocsMutation = (options?: Partial<Options<GenerateStrategyDocsData>>): UseMutationOptions<GenerateStrategyDocsResponse, DefaultError, Options<GenerateStrategyDocsData>> => {
    const mutationOptions: UseMutationOptions<GenerateStrategyDocsResponse, DefaultError, Options<GenerateStrategyDocsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateStrategyDocs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkDeploymentReadinessQueryKey = (options: Options<CheckDeploymentReadinessData>) => createQueryKey('checkDeploymentReadiness', options);

export const checkDeploymentReadinessOptions = (options: Options<CheckDeploymentReadinessData>) => queryOptions<CheckDeploymentReadinessResponse, DefaultError, CheckDeploymentReadinessResponse, ReturnType<typeof checkDeploymentReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkDeploymentReadiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkDeploymentReadinessQueryKey(options)
});

export const listStrategiesQueryKey = (options?: Options<ListStrategiesData>) => createQueryKey('listStrategies', options);

export const listStrategiesOptions = (options?: Options<ListStrategiesData>) => queryOptions<ListStrategiesResponse, DefaultError, ListStrategiesResponse, ReturnType<typeof listStrategiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategiesQueryKey(options)
});

export const runBacktestMutation = (options?: Partial<Options<RunBacktestData>>): UseMutationOptions<RunBacktestResponse, DefaultError, Options<RunBacktestData>> => {
    const mutationOptions: UseMutationOptions<RunBacktestResponse, DefaultError, Options<RunBacktestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runBacktest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStrategyQueryKey = (options: Options<GetStrategyData>) => createQueryKey('getStrategy', options);

export const getStrategyOptions = (options: Options<GetStrategyData>) => queryOptions<GetStrategyResponse, DefaultError, GetStrategyResponse, ReturnType<typeof getStrategyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStrategy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStrategyQueryKey(options)
});

export const listIngestionJobsQueryKey = (options?: Options<ListIngestionJobsData>) => createQueryKey('listIngestionJobs', options);

export const listIngestionJobsOptions = (options?: Options<ListIngestionJobsData>) => queryOptions<ListIngestionJobsResponse, DefaultError, ListIngestionJobsResponse, ReturnType<typeof listIngestionJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIngestionJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIngestionJobsQueryKey(options)
});

export const runIngestionJobMutation = (options?: Partial<Options<RunIngestionJobData>>): UseMutationOptions<RunIngestionJobResponse, DefaultError, Options<RunIngestionJobData>> => {
    const mutationOptions: UseMutationOptions<RunIngestionJobResponse, DefaultError, Options<RunIngestionJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runIngestionJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCandlesQueryKey = (options: Options<ListCandlesData>) => createQueryKey('listCandles', options);

export const listCandlesOptions = (options: Options<ListCandlesData>) => queryOptions<ListCandlesResponse, DefaultError, ListCandlesResponse, ReturnType<typeof listCandlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCandles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCandlesQueryKey(options)
});

export const listCandlesInfiniteQueryKey = (options: Options<ListCandlesData>): QueryKey<Options<ListCandlesData>> => createQueryKey('listCandles', options, true);

export const listCandlesInfiniteOptions = (options: Options<ListCandlesData>) => {
    const opts = infiniteQueryOptions<ListCandlesResponse, DefaultError, InfiniteData<ListCandlesResponse>, QueryKey<Options<ListCandlesData>>, string | Pick<QueryKey<Options<ListCandlesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListCandlesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listCandles({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCandlesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getPriceQueryKey = (options: Options<GetPriceData>) => createQueryKey('getPrice', options);

export const getPriceOptions = (options: Options<GetPriceData>) => queryOptions<GetPriceResponse, DefaultError, GetPriceResponse, ReturnType<typeof getPriceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPrice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPriceQueryKey(options)
});

export const listPricesQueryKey = (options: Options<ListPricesData>) => createQueryKey('listPrices', options);

export const listPricesOptions = (options: Options<ListPricesData>) => queryOptions<ListPricesResponse, DefaultError, ListPricesResponse, ReturnType<typeof listPricesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPrices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPricesQueryKey(options)
});

export const getOrderBookQueryKey = (options: Options<GetOrderBookData>) => createQueryKey('getOrderBook', options);

export const getOrderBookOptions = (options: Options<GetOrderBookData>) => queryOptions<GetOrderBookResponse, DefaultError, GetOrderBookResponse, ReturnType<typeof getOrderBookQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderBook({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderBookQueryKey(options)
});

export const createBackfillMutation = (options?: Partial<Options<CreateBackfillData>>): UseMutationOptions<unknown, DefaultError, Options<CreateBackfillData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CreateBackfillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBackfill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkMarketDataQueryKey = (options: Options<CheckMarketDataData>) => createQueryKey('checkMarketData', options);

export const checkMarketDataOptions = (options: Options<CheckMarketDataData>) => queryOptions<CheckMarketDataResponse, DefaultError, CheckMarketDataResponse, ReturnType<typeof checkMarketDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkMarketData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkMarketDataQueryKey(options)
});

export const checkMarketDataInfiniteQueryKey = (options: Options<CheckMarketDataData>): QueryKey<Options<CheckMarketDataData>> => createQueryKey('checkMarketData', options, true);

export const checkMarketDataInfiniteOptions = (options: Options<CheckMarketDataData>) => {
    const opts = infiniteQueryOptions<CheckMarketDataResponse, DefaultError, InfiniteData<CheckMarketDataResponse>, QueryKey<Options<CheckMarketDataData>>, string | Pick<QueryKey<Options<CheckMarketDataData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CheckMarketDataData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await checkMarketData({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: checkMarketDataInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getMarketDataStatusQueryKey = (options?: Options<GetMarketDataStatusData>) => createQueryKey('getMarketDataStatus', options);

export const getMarketDataStatusOptions = (options?: Options<GetMarketDataStatusData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getMarketDataStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketDataStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketDataStatusQueryKey(options)
});

export const startMarketDataMutation = (options?: Partial<Options<StartMarketDataData>>): UseMutationOptions<unknown, DefaultError, Options<StartMarketDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<StartMarketDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startMarketData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stopMarketDataMutation = (options?: Partial<Options<StopMarketDataData>>): UseMutationOptions<unknown, DefaultError, Options<StopMarketDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<StopMarketDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopMarketData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEconomicEventsQueryKey = (options?: Options<ListEconomicEventsData>) => createQueryKey('listEconomicEvents', options);

export const listEconomicEventsOptions = (options?: Options<ListEconomicEventsData>) => queryOptions<ListEconomicEventsResponse, DefaultError, ListEconomicEventsResponse, ReturnType<typeof listEconomicEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEconomicEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEconomicEventsQueryKey(options)
});

export const runAnalysisAgentsMutation = (options?: Partial<Options<RunAnalysisAgentsData>>): UseMutationOptions<RunAnalysisAgentsResponse, DefaultError, Options<RunAnalysisAgentsData>> => {
    const mutationOptions: UseMutationOptions<RunAnalysisAgentsResponse, DefaultError, Options<RunAnalysisAgentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runAnalysisAgents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAgentStatusQueryKey = (options?: Options<GetAgentStatusData>) => createQueryKey('getAgentStatus', options);

export const getAgentStatusOptions = (options?: Options<GetAgentStatusData>) => queryOptions<GetAgentStatusResponse, DefaultError, GetAgentStatusResponse, ReturnType<typeof getAgentStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAgentStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAgentStatusQueryKey(options)
});

export const setAgentEnabledMutation = (options?: Partial<Options<SetAgentEnabledData>>): UseMutationOptions<SetAgentEnabledResponse, DefaultError, Options<SetAgentEnabledData>> => {
    const mutationOptions: UseMutationOptions<SetAgentEnabledResponse, DefaultError, Options<SetAgentEnabledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setAgentEnabled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCurrentSessionQueryKey = (options?: Options<GetCurrentSessionData>) => createQueryKey('getCurrentSession', options);

export const getCurrentSessionOptions = (options?: Options<GetCurrentSessionData>) => queryOptions<GetCurrentSessionResponse, DefaultError, GetCurrentSessionResponse, ReturnType<typeof getCurrentSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCurrentSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCurrentSessionQueryKey(options)
});

export const getSessionTimesQueryKey = (options?: Options<GetSessionTimesData>) => createQueryKey('getSessionTimes', options);

export const getSessionTimesOptions = (options?: Options<GetSessionTimesData>) => queryOptions<GetSessionTimesResponse, DefaultError, GetSessionTimesResponse, ReturnType<typeof getSessionTimesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSessionTimes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSessionTimesQueryKey(options)
});

export const calculateOrbMutation = (options?: Partial<Options<CalculateOrbData>>): UseMutationOptions<CalculateOrbResponse, DefaultError, Options<CalculateOrbData>> => {
    const mutationOptions: UseMutationOptions<CalculateOrbResponse, DefaultError, Options<CalculateOrbData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await calculateOrb({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSessionStatsMutation = (options?: Partial<Options<GetSessionStatsData>>): UseMutationOptions<GetSessionStatsResponse, DefaultError, Options<GetSessionStatsData>> => {
    const mutationOptions: UseMutationOptions<GetSessionStatsResponse, DefaultError, Options<GetSessionStatsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getSessionStats({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyzeOrderBookMutation = (options?: Partial<Options<AnalyzeOrderBookData>>): UseMutationOptions<AnalyzeOrderBookResponse, DefaultError, Options<AnalyzeOrderBookData>> => {
    const mutationOptions: UseMutationOptions<AnalyzeOrderBookResponse, DefaultError, Options<AnalyzeOrderBookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyzeOrderBook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generateOrderBookHeatmapMutation = (options?: Partial<Options<GenerateOrderBookHeatmapData>>): UseMutationOptions<GenerateOrderBookHeatmapResponse, DefaultError, Options<GenerateOrderBookHeatmapData>> => {
    const mutationOptions: UseMutationOptions<GenerateOrderBookHeatmapResponse, DefaultError, Options<GenerateOrderBookHeatmapData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateOrderBookHeatmap({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyzeConfluenceMutation = (options?: Partial<Options<AnalyzeConfluenceData>>): UseMutationOptions<AnalyzeConfluenceResponse, DefaultError, Options<AnalyzeConfluenceData>> => {
    const mutationOptions: UseMutationOptions<AnalyzeConfluenceResponse, DefaultError, Options<AnalyzeConfluenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyzeConfluence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyzeConfluenceFromSignalsMutation = (options?: Partial<Options<AnalyzeConfluenceFromSignalsData>>): UseMutationOptions<AnalyzeConfluenceFromSignalsResponse, DefaultError, Options<AnalyzeConfluenceFromSignalsData>> => {
    const mutationOptions: UseMutationOptions<AnalyzeConfluenceFromSignalsResponse, DefaultError, Options<AnalyzeConfluenceFromSignalsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyzeConfluenceFromSignals({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDiscoverySummaryQueryKey = (options?: Options<GetDiscoverySummaryData>) => createQueryKey('getDiscoverySummary', options);

export const getDiscoverySummaryOptions = (options?: Options<GetDiscoverySummaryData>) => queryOptions<GetDiscoverySummaryResponse, DefaultError, GetDiscoverySummaryResponse, ReturnType<typeof getDiscoverySummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDiscoverySummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDiscoverySummaryQueryKey(options)
});

export const runStrategyDiscoveryWorkflowMutation = (options?: Partial<Options<RunStrategyDiscoveryWorkflowData>>): UseMutationOptions<RunStrategyDiscoveryWorkflowResponse, DefaultError, Options<RunStrategyDiscoveryWorkflowData>> => {
    const mutationOptions: UseMutationOptions<RunStrategyDiscoveryWorkflowResponse, DefaultError, Options<RunStrategyDiscoveryWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runStrategyDiscoveryWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const validateStrategyDefinitionMutation = (options?: Partial<Options<ValidateStrategyDefinitionData>>): UseMutationOptions<ValidateStrategyDefinitionResponse, DefaultError, Options<ValidateStrategyDefinitionData>> => {
    const mutationOptions: UseMutationOptions<ValidateStrategyDefinitionResponse, DefaultError, Options<ValidateStrategyDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateStrategyDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStrategyDefinitionsQueryKey = (options?: Options<ListStrategyDefinitionsData>) => createQueryKey('listStrategyDefinitions', options);

export const listStrategyDefinitionsOptions = (options?: Options<ListStrategyDefinitionsData>) => queryOptions<ListStrategyDefinitionsResponse, DefaultError, ListStrategyDefinitionsResponse, ReturnType<typeof listStrategyDefinitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyDefinitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyDefinitionsQueryKey(options)
});

export const listStrategyDefinitionsInfiniteQueryKey = (options?: Options<ListStrategyDefinitionsData>): QueryKey<Options<ListStrategyDefinitionsData>> => createQueryKey('listStrategyDefinitions', options, true);

export const listStrategyDefinitionsInfiniteOptions = (options?: Options<ListStrategyDefinitionsData>) => {
    const opts = infiniteQueryOptions<ListStrategyDefinitionsResponse, DefaultError, InfiniteData<ListStrategyDefinitionsResponse>, QueryKey<Options<ListStrategyDefinitionsData>>, string | Pick<QueryKey<Options<ListStrategyDefinitionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyDefinitionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyDefinitions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyDefinitionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const upsertStrategyDefinitionMutation = (options?: Partial<Options<UpsertStrategyDefinitionData>>): UseMutationOptions<UpsertStrategyDefinitionResponse, DefaultError, Options<UpsertStrategyDefinitionData>> => {
    const mutationOptions: UseMutationOptions<UpsertStrategyDefinitionResponse, DefaultError, Options<UpsertStrategyDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertStrategyDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createStrategyDefinitionValidationRunMutation = (options?: Partial<Options<CreateStrategyDefinitionValidationRunData>>): UseMutationOptions<CreateStrategyDefinitionValidationRunResponse, DefaultError, Options<CreateStrategyDefinitionValidationRunData>> => {
    const mutationOptions: UseMutationOptions<CreateStrategyDefinitionValidationRunResponse, DefaultError, Options<CreateStrategyDefinitionValidationRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStrategyDefinitionValidationRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const importFinanceStrategyCorpusMutation = (options?: Partial<Options<ImportFinanceStrategyCorpusData>>): UseMutationOptions<ImportFinanceStrategyCorpusResponse, DefaultError, Options<ImportFinanceStrategyCorpusData>> => {
    const mutationOptions: UseMutationOptions<ImportFinanceStrategyCorpusResponse, DefaultError, Options<ImportFinanceStrategyCorpusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importFinanceStrategyCorpus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStrategyDefinitionQueryKey = (options: Options<GetStrategyDefinitionData>) => createQueryKey('getStrategyDefinition', options);

export const getStrategyDefinitionOptions = (options: Options<GetStrategyDefinitionData>) => queryOptions<GetStrategyDefinitionResponse, DefaultError, GetStrategyDefinitionResponse, ReturnType<typeof getStrategyDefinitionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStrategyDefinition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStrategyDefinitionQueryKey(options)
});

export const listStrategyDefinitionEvaluationsQueryKey = (options: Options<ListStrategyDefinitionEvaluationsData>) => createQueryKey('listStrategyDefinitionEvaluations', options);

export const listStrategyDefinitionEvaluationsOptions = (options: Options<ListStrategyDefinitionEvaluationsData>) => queryOptions<ListStrategyDefinitionEvaluationsResponse, DefaultError, ListStrategyDefinitionEvaluationsResponse, ReturnType<typeof listStrategyDefinitionEvaluationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyDefinitionEvaluations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyDefinitionEvaluationsQueryKey(options)
});

export const listStrategyDefinitionEvaluationsInfiniteQueryKey = (options: Options<ListStrategyDefinitionEvaluationsData>): QueryKey<Options<ListStrategyDefinitionEvaluationsData>> => createQueryKey('listStrategyDefinitionEvaluations', options, true);

export const listStrategyDefinitionEvaluationsInfiniteOptions = (options: Options<ListStrategyDefinitionEvaluationsData>) => {
    const opts = infiniteQueryOptions<ListStrategyDefinitionEvaluationsResponse, DefaultError, InfiniteData<ListStrategyDefinitionEvaluationsResponse>, QueryKey<Options<ListStrategyDefinitionEvaluationsData>>, string | Pick<QueryKey<Options<ListStrategyDefinitionEvaluationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyDefinitionEvaluationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyDefinitionEvaluations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyDefinitionEvaluationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createStrategyDefinitionEvaluationMutation = (options?: Partial<Options<CreateStrategyDefinitionEvaluationData>>): UseMutationOptions<CreateStrategyDefinitionEvaluationResponse, DefaultError, Options<CreateStrategyDefinitionEvaluationData>> => {
    const mutationOptions: UseMutationOptions<CreateStrategyDefinitionEvaluationResponse, DefaultError, Options<CreateStrategyDefinitionEvaluationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStrategyDefinitionEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const validateStrategyBucketDefinitionMutation = (options?: Partial<Options<ValidateStrategyBucketDefinitionData>>): UseMutationOptions<ValidateStrategyBucketDefinitionResponse, DefaultError, Options<ValidateStrategyBucketDefinitionData>> => {
    const mutationOptions: UseMutationOptions<ValidateStrategyBucketDefinitionResponse, DefaultError, Options<ValidateStrategyBucketDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateStrategyBucketDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStrategyBucketDefinitionsQueryKey = (options?: Options<ListStrategyBucketDefinitionsData>) => createQueryKey('listStrategyBucketDefinitions', options);

export const listStrategyBucketDefinitionsOptions = (options?: Options<ListStrategyBucketDefinitionsData>) => queryOptions<ListStrategyBucketDefinitionsResponse, DefaultError, ListStrategyBucketDefinitionsResponse, ReturnType<typeof listStrategyBucketDefinitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyBucketDefinitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyBucketDefinitionsQueryKey(options)
});

export const listStrategyBucketDefinitionsInfiniteQueryKey = (options?: Options<ListStrategyBucketDefinitionsData>): QueryKey<Options<ListStrategyBucketDefinitionsData>> => createQueryKey('listStrategyBucketDefinitions', options, true);

export const listStrategyBucketDefinitionsInfiniteOptions = (options?: Options<ListStrategyBucketDefinitionsData>) => {
    const opts = infiniteQueryOptions<ListStrategyBucketDefinitionsResponse, DefaultError, InfiniteData<ListStrategyBucketDefinitionsResponse>, QueryKey<Options<ListStrategyBucketDefinitionsData>>, string | Pick<QueryKey<Options<ListStrategyBucketDefinitionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyBucketDefinitionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyBucketDefinitions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyBucketDefinitionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const upsertStrategyBucketDefinitionMutation = (options?: Partial<Options<UpsertStrategyBucketDefinitionData>>): UseMutationOptions<UpsertStrategyBucketDefinitionResponse, DefaultError, Options<UpsertStrategyBucketDefinitionData>> => {
    const mutationOptions: UseMutationOptions<UpsertStrategyBucketDefinitionResponse, DefaultError, Options<UpsertStrategyBucketDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertStrategyBucketDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStrategyBucketEvaluationsQueryKey = (options: Options<ListStrategyBucketEvaluationsData>) => createQueryKey('listStrategyBucketEvaluations', options);

export const listStrategyBucketEvaluationsOptions = (options: Options<ListStrategyBucketEvaluationsData>) => queryOptions<ListStrategyBucketEvaluationsResponse, DefaultError, ListStrategyBucketEvaluationsResponse, ReturnType<typeof listStrategyBucketEvaluationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyBucketEvaluations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyBucketEvaluationsQueryKey(options)
});

export const listStrategyBucketEvaluationsInfiniteQueryKey = (options: Options<ListStrategyBucketEvaluationsData>): QueryKey<Options<ListStrategyBucketEvaluationsData>> => createQueryKey('listStrategyBucketEvaluations', options, true);

export const listStrategyBucketEvaluationsInfiniteOptions = (options: Options<ListStrategyBucketEvaluationsData>) => {
    const opts = infiniteQueryOptions<ListStrategyBucketEvaluationsResponse, DefaultError, InfiniteData<ListStrategyBucketEvaluationsResponse>, QueryKey<Options<ListStrategyBucketEvaluationsData>>, string | Pick<QueryKey<Options<ListStrategyBucketEvaluationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyBucketEvaluationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyBucketEvaluations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyBucketEvaluationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getStrategyBucketDefinitionQueryKey = (options: Options<GetStrategyBucketDefinitionData>) => createQueryKey('getStrategyBucketDefinition', options);

export const getStrategyBucketDefinitionOptions = (options: Options<GetStrategyBucketDefinitionData>) => queryOptions<GetStrategyBucketDefinitionResponse, DefaultError, GetStrategyBucketDefinitionResponse, ReturnType<typeof getStrategyBucketDefinitionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStrategyBucketDefinition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStrategyBucketDefinitionQueryKey(options)
});

export const patchStrategyBucketDefinitionMutation = (options?: Partial<Options<PatchStrategyBucketDefinitionData>>): UseMutationOptions<PatchStrategyBucketDefinitionResponse, DefaultError, Options<PatchStrategyBucketDefinitionData>> => {
    const mutationOptions: UseMutationOptions<PatchStrategyBucketDefinitionResponse, DefaultError, Options<PatchStrategyBucketDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchStrategyBucketDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dispatchStrategyBucketBacktestMutation = (options?: Partial<Options<DispatchStrategyBucketBacktestData>>): UseMutationOptions<DispatchStrategyBucketBacktestResponse, DefaultError, Options<DispatchStrategyBucketBacktestData>> => {
    const mutationOptions: UseMutationOptions<DispatchStrategyBucketBacktestResponse, DefaultError, Options<DispatchStrategyBucketBacktestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dispatchStrategyBucketBacktest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createStrategyBucketEvaluationMutation = (options?: Partial<Options<CreateStrategyBucketEvaluationData>>): UseMutationOptions<CreateStrategyBucketEvaluationResponse, DefaultError, Options<CreateStrategyBucketEvaluationData>> => {
    const mutationOptions: UseMutationOptions<CreateStrategyBucketEvaluationResponse, DefaultError, Options<CreateStrategyBucketEvaluationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStrategyBucketEvaluation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const validateStrategyExtensionDescriptorMutation = (options?: Partial<Options<ValidateStrategyExtensionDescriptorData>>): UseMutationOptions<ValidateStrategyExtensionDescriptorResponse, DefaultError, Options<ValidateStrategyExtensionDescriptorData>> => {
    const mutationOptions: UseMutationOptions<ValidateStrategyExtensionDescriptorResponse, DefaultError, Options<ValidateStrategyExtensionDescriptorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateStrategyExtensionDescriptor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStrategyExtensionDescriptorsQueryKey = (options?: Options<ListStrategyExtensionDescriptorsData>) => createQueryKey('listStrategyExtensionDescriptors', options);

export const listStrategyExtensionDescriptorsOptions = (options?: Options<ListStrategyExtensionDescriptorsData>) => queryOptions<ListStrategyExtensionDescriptorsResponse, DefaultError, ListStrategyExtensionDescriptorsResponse, ReturnType<typeof listStrategyExtensionDescriptorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyExtensionDescriptors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyExtensionDescriptorsQueryKey(options)
});

export const listStrategyExtensionDescriptorsInfiniteQueryKey = (options?: Options<ListStrategyExtensionDescriptorsData>): QueryKey<Options<ListStrategyExtensionDescriptorsData>> => createQueryKey('listStrategyExtensionDescriptors', options, true);

export const listStrategyExtensionDescriptorsInfiniteOptions = (options?: Options<ListStrategyExtensionDescriptorsData>) => {
    const opts = infiniteQueryOptions<ListStrategyExtensionDescriptorsResponse, DefaultError, InfiniteData<ListStrategyExtensionDescriptorsResponse>, QueryKey<Options<ListStrategyExtensionDescriptorsData>>, string | Pick<QueryKey<Options<ListStrategyExtensionDescriptorsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyExtensionDescriptorsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyExtensionDescriptors({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyExtensionDescriptorsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const upsertStrategyExtensionDescriptorMutation = (options?: Partial<Options<UpsertStrategyExtensionDescriptorData>>): UseMutationOptions<UpsertStrategyExtensionDescriptorResponse, DefaultError, Options<UpsertStrategyExtensionDescriptorData>> => {
    const mutationOptions: UseMutationOptions<UpsertStrategyExtensionDescriptorResponse, DefaultError, Options<UpsertStrategyExtensionDescriptorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertStrategyExtensionDescriptor({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resolveStrategyAdaptersMutation = (options?: Partial<Options<ResolveStrategyAdaptersData>>): UseMutationOptions<ResolveStrategyAdaptersResponse, DefaultError, Options<ResolveStrategyAdaptersData>> => {
    const mutationOptions: UseMutationOptions<ResolveStrategyAdaptersResponse, DefaultError, Options<ResolveStrategyAdaptersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveStrategyAdapters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStrategyAdapterResolutionsQueryKey = (options?: Options<ListStrategyAdapterResolutionsData>) => createQueryKey('listStrategyAdapterResolutions', options);

export const listStrategyAdapterResolutionsOptions = (options?: Options<ListStrategyAdapterResolutionsData>) => queryOptions<ListStrategyAdapterResolutionsResponse, DefaultError, ListStrategyAdapterResolutionsResponse, ReturnType<typeof listStrategyAdapterResolutionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyAdapterResolutions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyAdapterResolutionsQueryKey(options)
});

export const listStrategyAdapterResolutionsInfiniteQueryKey = (options?: Options<ListStrategyAdapterResolutionsData>): QueryKey<Options<ListStrategyAdapterResolutionsData>> => createQueryKey('listStrategyAdapterResolutions', options, true);

export const listStrategyAdapterResolutionsInfiniteOptions = (options?: Options<ListStrategyAdapterResolutionsData>) => {
    const opts = infiniteQueryOptions<ListStrategyAdapterResolutionsResponse, DefaultError, InfiniteData<ListStrategyAdapterResolutionsResponse>, QueryKey<Options<ListStrategyAdapterResolutionsData>>, string | Pick<QueryKey<Options<ListStrategyAdapterResolutionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyAdapterResolutionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyAdapterResolutions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyAdapterResolutionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createStrategyAdapterResolutionMutation = (options?: Partial<Options<CreateStrategyAdapterResolutionData>>): UseMutationOptions<CreateStrategyAdapterResolutionResponse, DefaultError, Options<CreateStrategyAdapterResolutionData>> => {
    const mutationOptions: UseMutationOptions<CreateStrategyAdapterResolutionResponse, DefaultError, Options<CreateStrategyAdapterResolutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStrategyAdapterResolution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFinanceDataBlockersQueryKey = (options?: Options<ListFinanceDataBlockersData>) => createQueryKey('listFinanceDataBlockers', options);

export const listFinanceDataBlockersOptions = (options?: Options<ListFinanceDataBlockersData>) => queryOptions<ListFinanceDataBlockersResponse, DefaultError, ListFinanceDataBlockersResponse, ReturnType<typeof listFinanceDataBlockersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceDataBlockers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceDataBlockersQueryKey(options)
});

export const listFinanceDataBlockersInfiniteQueryKey = (options?: Options<ListFinanceDataBlockersData>): QueryKey<Options<ListFinanceDataBlockersData>> => createQueryKey('listFinanceDataBlockers', options, true);

export const listFinanceDataBlockersInfiniteOptions = (options?: Options<ListFinanceDataBlockersData>) => {
    const opts = infiniteQueryOptions<ListFinanceDataBlockersResponse, DefaultError, InfiniteData<ListFinanceDataBlockersResponse>, QueryKey<Options<ListFinanceDataBlockersData>>, string | Pick<QueryKey<Options<ListFinanceDataBlockersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFinanceDataBlockersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFinanceDataBlockers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFinanceDataBlockersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const upsertFinanceDataBlockerMutation = (options?: Partial<Options<UpsertFinanceDataBlockerData>>): UseMutationOptions<UpsertFinanceDataBlockerResponse, DefaultError, Options<UpsertFinanceDataBlockerData>> => {
    const mutationOptions: UseMutationOptions<UpsertFinanceDataBlockerResponse, DefaultError, Options<UpsertFinanceDataBlockerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertFinanceDataBlocker({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTopSourcesQueryKey = (options?: Options<ListTopSourcesData>) => createQueryKey('listTopSources', options);

export const listTopSourcesOptions = (options?: Options<ListTopSourcesData>) => queryOptions<ListTopSourcesResponse, DefaultError, ListTopSourcesResponse, ReturnType<typeof listTopSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTopSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTopSourcesQueryKey(options)
});

export const listSourcesQueryKey = (options?: Options<ListSourcesData>) => createQueryKey('listSources', options);

export const listSourcesOptions = (options?: Options<ListSourcesData>) => queryOptions<ListSourcesResponse, DefaultError, ListSourcesResponse, ReturnType<typeof listSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSourcesQueryKey(options)
});

export const listSourcesInfiniteQueryKey = (options?: Options<ListSourcesData>): QueryKey<Options<ListSourcesData>> => createQueryKey('listSources', options, true);

export const listSourcesInfiniteOptions = (options?: Options<ListSourcesData>) => {
    const opts = infiniteQueryOptions<ListSourcesResponse, DefaultError, InfiniteData<ListSourcesResponse>, QueryKey<Options<ListSourcesData>>, string | Pick<QueryKey<Options<ListSourcesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSourcesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSources({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSourcesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createSourceMutation = (options?: Partial<Options<CreateSourceData>>): UseMutationOptions<CreateSourceResponse, DefaultError, Options<CreateSourceData>> => {
    const mutationOptions: UseMutationOptions<CreateSourceResponse, DefaultError, Options<CreateSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSourceQueryKey = (options: Options<GetSourceData>) => createQueryKey('getSource', options);

export const getSourceOptions = (options: Options<GetSourceData>) => queryOptions<GetSourceResponse, DefaultError, GetSourceResponse, ReturnType<typeof getSourceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSource({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSourceQueryKey(options)
});

export const getContentStatsQueryKey = (options?: Options<GetContentStatsData>) => createQueryKey('getContentStats', options);

export const getContentStatsOptions = (options?: Options<GetContentStatsData>) => queryOptions<GetContentStatsResponse, DefaultError, GetContentStatsResponse, ReturnType<typeof getContentStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentStatsQueryKey(options)
});

export const listHarvestedContentQueryKey = (options?: Options<ListHarvestedContentData>) => createQueryKey('listHarvestedContent', options);

export const listHarvestedContentOptions = (options?: Options<ListHarvestedContentData>) => queryOptions<ListHarvestedContentResponse, DefaultError, ListHarvestedContentResponse, ReturnType<typeof listHarvestedContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listHarvestedContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listHarvestedContentQueryKey(options)
});

export const listHarvestedContentInfiniteQueryKey = (options?: Options<ListHarvestedContentData>): QueryKey<Options<ListHarvestedContentData>> => createQueryKey('listHarvestedContent', options, true);

export const listHarvestedContentInfiniteOptions = (options?: Options<ListHarvestedContentData>) => {
    const opts = infiniteQueryOptions<ListHarvestedContentResponse, DefaultError, InfiniteData<ListHarvestedContentResponse>, QueryKey<Options<ListHarvestedContentData>>, string | Pick<QueryKey<Options<ListHarvestedContentData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListHarvestedContentData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listHarvestedContent({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listHarvestedContentInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getContentDetailsQueryKey = (options: Options<GetContentDetailsData>) => createQueryKey('getContentDetails', options);

export const getContentDetailsOptions = (options: Options<GetContentDetailsData>) => queryOptions<GetContentDetailsResponse, DefaultError, GetContentDetailsResponse, ReturnType<typeof getContentDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentDetailsQueryKey(options)
});

export const listApprovedStrategiesQueryKey = (options?: Options<ListApprovedStrategiesData>) => createQueryKey('listApprovedStrategies', options);

export const listApprovedStrategiesOptions = (options?: Options<ListApprovedStrategiesData>) => queryOptions<ListApprovedStrategiesResponse, DefaultError, ListApprovedStrategiesResponse, ReturnType<typeof listApprovedStrategiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listApprovedStrategies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listApprovedStrategiesQueryKey(options)
});

export const getStrategyDiscoveryStatsQueryKey = (options?: Options<GetStrategyDiscoveryStatsData>) => createQueryKey('getStrategyDiscoveryStats', options);

export const getStrategyDiscoveryStatsOptions = (options?: Options<GetStrategyDiscoveryStatsData>) => queryOptions<GetStrategyDiscoveryStatsResponse, DefaultError, GetStrategyDiscoveryStatsResponse, ReturnType<typeof getStrategyDiscoveryStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStrategyDiscoveryStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStrategyDiscoveryStatsQueryKey(options)
});

export const listDiscoveredStrategiesQueryKey = (options?: Options<ListDiscoveredStrategiesData>) => createQueryKey('listDiscoveredStrategies', options);

export const listDiscoveredStrategiesOptions = (options?: Options<ListDiscoveredStrategiesData>) => queryOptions<ListDiscoveredStrategiesResponse, DefaultError, ListDiscoveredStrategiesResponse, ReturnType<typeof listDiscoveredStrategiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDiscoveredStrategies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDiscoveredStrategiesQueryKey(options)
});

export const listDiscoveredStrategiesInfiniteQueryKey = (options?: Options<ListDiscoveredStrategiesData>): QueryKey<Options<ListDiscoveredStrategiesData>> => createQueryKey('listDiscoveredStrategies', options, true);

export const listDiscoveredStrategiesInfiniteOptions = (options?: Options<ListDiscoveredStrategiesData>) => {
    const opts = infiniteQueryOptions<ListDiscoveredStrategiesResponse, DefaultError, InfiniteData<ListDiscoveredStrategiesResponse>, QueryKey<Options<ListDiscoveredStrategiesData>>, string | Pick<QueryKey<Options<ListDiscoveredStrategiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListDiscoveredStrategiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listDiscoveredStrategies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDiscoveredStrategiesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getDiscoveredStrategyQueryKey = (options: Options<GetDiscoveredStrategyData>) => createQueryKey('getDiscoveredStrategy', options);

export const getDiscoveredStrategyOptions = (options: Options<GetDiscoveredStrategyData>) => queryOptions<GetDiscoveredStrategyResponse, DefaultError, GetDiscoveredStrategyResponse, ReturnType<typeof getDiscoveredStrategyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDiscoveredStrategy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDiscoveredStrategyQueryKey(options)
});

export const updateDiscoveredStrategyStatusMutation = (options?: Partial<Options<UpdateDiscoveredStrategyStatusData>>): UseMutationOptions<UpdateDiscoveredStrategyStatusResponse, DefaultError, Options<UpdateDiscoveredStrategyStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateDiscoveredStrategyStatusResponse, DefaultError, Options<UpdateDiscoveredStrategyStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDiscoveredStrategyStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssetSentimentQueryKey = (options: Options<GetAssetSentimentData>) => createQueryKey('getAssetSentiment', options);

export const getAssetSentimentOptions = (options: Options<GetAssetSentimentData>) => queryOptions<GetAssetSentimentResponse, DefaultError, GetAssetSentimentResponse, ReturnType<typeof getAssetSentimentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAssetSentiment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAssetSentimentQueryKey(options)
});

export const getSignalAccuracyQueryKey = (options?: Options<GetSignalAccuracyData>) => createQueryKey('getSignalAccuracy', options);

export const getSignalAccuracyOptions = (options?: Options<GetSignalAccuracyData>) => queryOptions<GetSignalAccuracyResponse, DefaultError, GetSignalAccuracyResponse, ReturnType<typeof getSignalAccuracyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSignalAccuracy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSignalAccuracyQueryKey(options)
});

export const getSignalActivityQueryKey = (options?: Options<GetSignalActivityData>) => createQueryKey('getSignalActivity', options);

export const getSignalActivityOptions = (options?: Options<GetSignalActivityData>) => queryOptions<GetSignalActivityResponse, DefaultError, GetSignalActivityResponse, ReturnType<typeof getSignalActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSignalActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSignalActivityQueryKey(options)
});

export const listSignalsQueryKey = (options?: Options<ListSignalsData>) => createQueryKey('listSignals', options);

export const listSignalsOptions = (options?: Options<ListSignalsData>) => queryOptions<ListSignalsResponse, DefaultError, ListSignalsResponse, ReturnType<typeof listSignalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSignals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSignalsQueryKey(options)
});

export const testTradingViewWebhookMutation = (options?: Partial<Options<TestTradingViewWebhookData>>): UseMutationOptions<TestTradingViewWebhookResponse, DefaultError, Options<TestTradingViewWebhookData>> => {
    const mutationOptions: UseMutationOptions<TestTradingViewWebhookResponse, DefaultError, Options<TestTradingViewWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testTradingViewWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generatePineScriptMutation = (options?: Partial<Options<GeneratePineScriptData>>): UseMutationOptions<GeneratePineScriptResponse, DefaultError, Options<GeneratePineScriptData>> => {
    const mutationOptions: UseMutationOptions<GeneratePineScriptResponse, DefaultError, Options<GeneratePineScriptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generatePineScript({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTradingViewConfigQueryKey = (options?: Options<GetTradingViewConfigData>) => createQueryKey('getTradingViewConfig', options);

export const getTradingViewConfigOptions = (options?: Options<GetTradingViewConfigData>) => queryOptions<GetTradingViewConfigResponse, DefaultError, GetTradingViewConfigResponse, ReturnType<typeof getTradingViewConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTradingViewConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTradingViewConfigQueryKey(options)
});

export const rotateTradingViewTokenMutation = (options?: Partial<Options<RotateTradingViewTokenData>>): UseMutationOptions<RotateTradingViewTokenResponse, DefaultError, Options<RotateTradingViewTokenData>> => {
    const mutationOptions: UseMutationOptions<RotateTradingViewTokenResponse, DefaultError, Options<RotateTradingViewTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rotateTradingViewToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const receiveTradingViewAlertMutation = (options?: Partial<Options<ReceiveTradingViewAlertData>>): UseMutationOptions<ReceiveTradingViewAlertResponse, DefaultError, Options<ReceiveTradingViewAlertData>> => {
    const mutationOptions: UseMutationOptions<ReceiveTradingViewAlertResponse, DefaultError, Options<ReceiveTradingViewAlertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await receiveTradingViewAlert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWatchlistQueryKey = (options?: Options<ListWatchlistData>) => createQueryKey('listWatchlist', options);

export const listWatchlistOptions = (options?: Options<ListWatchlistData>) => queryOptions<ListWatchlistResponse, DefaultError, ListWatchlistResponse, ReturnType<typeof listWatchlistQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWatchlist({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWatchlistQueryKey(options)
});

export const addToWatchlistMutation = (options?: Partial<Options<AddToWatchlistData>>): UseMutationOptions<AddToWatchlistResponse, DefaultError, Options<AddToWatchlistData>> => {
    const mutationOptions: UseMutationOptions<AddToWatchlistResponse, DefaultError, Options<AddToWatchlistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addToWatchlist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removeFromWatchlistMutation = (options?: Partial<Options<RemoveFromWatchlistData>>): UseMutationOptions<RemoveFromWatchlistResponse, DefaultError, Options<RemoveFromWatchlistData>> => {
    const mutationOptions: UseMutationOptions<RemoveFromWatchlistResponse, DefaultError, Options<RemoveFromWatchlistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeFromWatchlist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWatchlistEntryQueryKey = (options: Options<GetWatchlistEntryData>) => createQueryKey('getWatchlistEntry', options);

export const getWatchlistEntryOptions = (options: Options<GetWatchlistEntryData>) => queryOptions<GetWatchlistEntryResponse, DefaultError, GetWatchlistEntryResponse, ReturnType<typeof getWatchlistEntryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWatchlistEntry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWatchlistEntryQueryKey(options)
});

export const listAnalysesQueryKey = (options: Options<ListAnalysesData>) => createQueryKey('listAnalyses', options);

export const listAnalysesOptions = (options: Options<ListAnalysesData>) => queryOptions<ListAnalysesResponse, DefaultError, ListAnalysesResponse, ReturnType<typeof listAnalysesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAnalyses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAnalysesQueryKey(options)
});

export const getAnalysisQueryKey = (options: Options<GetAnalysisData>) => createQueryKey('getAnalysis', options);

export const getAnalysisOptions = (options: Options<GetAnalysisData>) => queryOptions<GetAnalysisResponse, DefaultError, GetAnalysisResponse, ReturnType<typeof getAnalysisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAnalysis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAnalysisQueryKey(options)
});

export const analyzeTickerAdHocMutation = (options?: Partial<Options<AnalyzeTickerAdHocData>>): UseMutationOptions<AnalyzeTickerAdHocResponse, DefaultError, Options<AnalyzeTickerAdHocData>> => {
    const mutationOptions: UseMutationOptions<AnalyzeTickerAdHocResponse, DefaultError, Options<AnalyzeTickerAdHocData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyzeTickerAdHoc({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const comparePortfoliosQueryKey = (options: Options<ComparePortfoliosData>) => createQueryKey('comparePortfolios', options);

export const comparePortfoliosOptions = (options: Options<ComparePortfoliosData>) => queryOptions<ComparePortfoliosResponse, DefaultError, ComparePortfoliosResponse, ReturnType<typeof comparePortfoliosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await comparePortfolios({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: comparePortfoliosQueryKey(options)
});

export const getRiskProfilesQueryKey = (options?: Options<GetRiskProfilesData>) => createQueryKey('getRiskProfiles', options);

export const getRiskProfilesOptions = (options?: Options<GetRiskProfilesData>) => queryOptions<GetRiskProfilesResponse, DefaultError, GetRiskProfilesResponse, ReturnType<typeof getRiskProfilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRiskProfiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRiskProfilesQueryKey(options)
});

export const listPortfoliosQueryKey = (options?: Options<ListPortfoliosData>) => createQueryKey('listPortfolios', options);

export const listPortfoliosOptions = (options?: Options<ListPortfoliosData>) => queryOptions<ListPortfoliosResponse, DefaultError, ListPortfoliosResponse, ReturnType<typeof listPortfoliosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortfolios({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortfoliosQueryKey(options)
});

export const createPortfolioMutation = (options?: Partial<Options<CreatePortfolioData>>): UseMutationOptions<CreatePortfolioResponse, DefaultError, Options<CreatePortfolioData>> => {
    const mutationOptions: UseMutationOptions<CreatePortfolioResponse, DefaultError, Options<CreatePortfolioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPortfolio({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPortfolioQueryKey = (options: Options<GetPortfolioData>) => createQueryKey('getPortfolio', options);

export const getPortfolioOptions = (options: Options<GetPortfolioData>) => queryOptions<GetPortfolioResponse, DefaultError, GetPortfolioResponse, ReturnType<typeof getPortfolioQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortfolio({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioQueryKey(options)
});

export const updatePortfolioMutation = (options?: Partial<Options<UpdatePortfolioData>>): UseMutationOptions<UpdatePortfolioResponse, DefaultError, Options<UpdatePortfolioData>> => {
    const mutationOptions: UseMutationOptions<UpdatePortfolioResponse, DefaultError, Options<UpdatePortfolioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePortfolio({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPerformanceMetricsQueryKey = (options: Options<GetPerformanceMetricsData>) => createQueryKey('getPerformanceMetrics', options);

export const getPerformanceMetricsOptions = (options: Options<GetPerformanceMetricsData>) => queryOptions<GetPerformanceMetricsResponse, DefaultError, GetPerformanceMetricsResponse, ReturnType<typeof getPerformanceMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPerformanceMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPerformanceMetricsQueryKey(options)
});

export const listPortfolioSnapshotsQueryKey = (options: Options<ListPortfolioSnapshotsData>) => createQueryKey('listPortfolioSnapshots', options);

export const listPortfolioSnapshotsOptions = (options: Options<ListPortfolioSnapshotsData>) => queryOptions<ListPortfolioSnapshotsResponse, DefaultError, ListPortfolioSnapshotsResponse, ReturnType<typeof listPortfolioSnapshotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPortfolioSnapshots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPortfolioSnapshotsQueryKey(options)
});

export const getPortfolioSnapshotQueryKey = (options: Options<GetPortfolioSnapshotData>) => createQueryKey('getPortfolioSnapshot', options);

export const getPortfolioSnapshotOptions = (options: Options<GetPortfolioSnapshotData>) => queryOptions<GetPortfolioSnapshotResponse, DefaultError, GetPortfolioSnapshotResponse, ReturnType<typeof getPortfolioSnapshotQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortfolioSnapshot({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioSnapshotQueryKey(options)
});

export const getRecommendationQueryKey = (options: Options<GetRecommendationData>) => createQueryKey('getRecommendation', options);

export const getRecommendationOptions = (options: Options<GetRecommendationData>) => queryOptions<GetRecommendationResponse, DefaultError, GetRecommendationResponse, ReturnType<typeof getRecommendationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecommendation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecommendationQueryKey(options)
});

export const approveRecommendationMutation = (options?: Partial<Options<ApproveRecommendationData>>): UseMutationOptions<ApproveRecommendationResponse, DefaultError, Options<ApproveRecommendationData>> => {
    const mutationOptions: UseMutationOptions<ApproveRecommendationResponse, DefaultError, Options<ApproveRecommendationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approveRecommendation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectRecommendationMutation = (options?: Partial<Options<RejectRecommendationData>>): UseMutationOptions<RejectRecommendationResponse, DefaultError, Options<RejectRecommendationData>> => {
    const mutationOptions: UseMutationOptions<RejectRecommendationResponse, DefaultError, Options<RejectRecommendationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectRecommendation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listHoldingsQueryKey = (options: Options<ListHoldingsData>) => createQueryKey('listHoldings', options);

export const listHoldingsOptions = (options: Options<ListHoldingsData>) => queryOptions<ListHoldingsResponse, DefaultError, ListHoldingsResponse, ReturnType<typeof listHoldingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listHoldings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listHoldingsQueryKey(options)
});

export const createHoldingMutation = (options?: Partial<Options<CreateHoldingData>>): UseMutationOptions<CreateHoldingResponse, DefaultError, Options<CreateHoldingData>> => {
    const mutationOptions: UseMutationOptions<CreateHoldingResponse, DefaultError, Options<CreateHoldingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createHolding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteHoldingMutation = (options?: Partial<Options<DeleteHoldingData>>): UseMutationOptions<DeleteHoldingResponse, DefaultError, Options<DeleteHoldingData>> => {
    const mutationOptions: UseMutationOptions<DeleteHoldingResponse, DefaultError, Options<DeleteHoldingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteHolding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateHoldingMutation = (options?: Partial<Options<UpdateHoldingData>>): UseMutationOptions<UpdateHoldingResponse, DefaultError, Options<UpdateHoldingData>> => {
    const mutationOptions: UseMutationOptions<UpdateHoldingResponse, DefaultError, Options<UpdateHoldingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateHolding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listContractEventsQueryKey = (options?: Options<ListContractEventsData>) => createQueryKey('listContractEvents', options);

export const listContractEventsOptions = (options?: Options<ListContractEventsData>) => queryOptions<ListContractEventsResponse, DefaultError, ListContractEventsResponse, ReturnType<typeof listContractEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContractEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContractEventsQueryKey(options)
});

export const getContractHealthQueryKey = (options?: Options<GetContractHealthData>) => createQueryKey('getContractHealth', options);

export const getContractHealthOptions = (options?: Options<GetContractHealthData>) => queryOptions<GetContractHealthResponse, DefaultError, GetContractHealthResponse, ReturnType<typeof getContractHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContractHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContractHealthQueryKey(options)
});

export const applyContractResolutionMutation = (options?: Partial<Options<ApplyContractResolutionData>>): UseMutationOptions<ApplyContractResolutionResponse, DefaultError, Options<ApplyContractResolutionData>> => {
    const mutationOptions: UseMutationOptions<ApplyContractResolutionResponse, DefaultError, Options<ApplyContractResolutionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await applyContractResolution({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkAlertPriceMutation = (options?: Partial<Options<CheckAlertPriceData>>): UseMutationOptions<CheckAlertPriceResponse, DefaultError, Options<CheckAlertPriceData>> => {
    const mutationOptions: UseMutationOptions<CheckAlertPriceResponse, DefaultError, Options<CheckAlertPriceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkAlertPrice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAlertsBySymbolQueryKey = (options: Options<ListAlertsBySymbolData>) => createQueryKey('listAlertsBySymbol', options);

export const listAlertsBySymbolOptions = (options: Options<ListAlertsBySymbolData>) => queryOptions<ListAlertsBySymbolResponse, DefaultError, ListAlertsBySymbolResponse, ReturnType<typeof listAlertsBySymbolQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAlertsBySymbol({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAlertsBySymbolQueryKey(options)
});

export const listAlertsQueryKey = (options?: Options<ListAlertsData>) => createQueryKey('listAlerts', options);

export const listAlertsOptions = (options?: Options<ListAlertsData>) => queryOptions<ListAlertsResponse, DefaultError, ListAlertsResponse, ReturnType<typeof listAlertsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAlerts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAlertsQueryKey(options)
});

export const createAlertMutation = (options?: Partial<Options<CreateAlertData>>): UseMutationOptions<CreateAlertResponse, DefaultError, Options<CreateAlertData>> => {
    const mutationOptions: UseMutationOptions<CreateAlertResponse, DefaultError, Options<CreateAlertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAlert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteAlertMutation = (options?: Partial<Options<DeleteAlertData>>): UseMutationOptions<DeleteAlertResponse, DefaultError, Options<DeleteAlertData>> => {
    const mutationOptions: UseMutationOptions<DeleteAlertResponse, DefaultError, Options<DeleteAlertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAlert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setAlertEnabledMutation = (options?: Partial<Options<SetAlertEnabledData>>): UseMutationOptions<SetAlertEnabledResponse, DefaultError, Options<SetAlertEnabledData>> => {
    const mutationOptions: UseMutationOptions<SetAlertEnabledResponse, DefaultError, Options<SetAlertEnabledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setAlertEnabled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resetAlertMutation = (options?: Partial<Options<ResetAlertData>>): UseMutationOptions<ResetAlertResponse, DefaultError, Options<ResetAlertData>> => {
    const mutationOptions: UseMutationOptions<ResetAlertResponse, DefaultError, Options<ResetAlertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetAlert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAlertRulesQueryKey = (options?: Options<ListAlertRulesData>) => createQueryKey('listAlertRules', options);

export const listAlertRulesOptions = (options?: Options<ListAlertRulesData>) => queryOptions<ListAlertRulesResponse, DefaultError, ListAlertRulesResponse, ReturnType<typeof listAlertRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAlertRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAlertRulesQueryKey(options)
});

export const createAlertRuleMutation = (options?: Partial<Options<CreateAlertRuleData>>): UseMutationOptions<CreateAlertRuleResponse, DefaultError, Options<CreateAlertRuleData>> => {
    const mutationOptions: UseMutationOptions<CreateAlertRuleResponse, DefaultError, Options<CreateAlertRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAlertRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteAlertRuleMutation = (options?: Partial<Options<DeleteAlertRuleData>>): UseMutationOptions<DeleteAlertRuleResponse, DefaultError, Options<DeleteAlertRuleData>> => {
    const mutationOptions: UseMutationOptions<DeleteAlertRuleResponse, DefaultError, Options<DeleteAlertRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAlertRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAlertRuleQueryKey = (options: Options<GetAlertRuleData>) => createQueryKey('getAlertRule', options);

export const getAlertRuleOptions = (options: Options<GetAlertRuleData>) => queryOptions<GetAlertRuleResponse, DefaultError, GetAlertRuleResponse, ReturnType<typeof getAlertRuleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAlertRule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAlertRuleQueryKey(options)
});

export const updateAlertRuleMutation = (options?: Partial<Options<UpdateAlertRuleData>>): UseMutationOptions<UpdateAlertRuleResponse, DefaultError, Options<UpdateAlertRuleData>> => {
    const mutationOptions: UseMutationOptions<UpdateAlertRuleResponse, DefaultError, Options<UpdateAlertRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAlertRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMarketEventReactionTypesQueryKey = (options?: Options<ListMarketEventReactionTypesData>) => createQueryKey('listMarketEventReactionTypes', options);

export const listMarketEventReactionTypesOptions = (options?: Options<ListMarketEventReactionTypesData>) => queryOptions<ListMarketEventReactionTypesResponse, DefaultError, ListMarketEventReactionTypesResponse, ReturnType<typeof listMarketEventReactionTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMarketEventReactionTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMarketEventReactionTypesQueryKey(options)
});

export const listMarketEventReactionsQueryKey = (options?: Options<ListMarketEventReactionsData>) => createQueryKey('listMarketEventReactions', options);

export const listMarketEventReactionsOptions = (options?: Options<ListMarketEventReactionsData>) => queryOptions<ListMarketEventReactionsResponse, DefaultError, ListMarketEventReactionsResponse, ReturnType<typeof listMarketEventReactionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMarketEventReactions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMarketEventReactionsQueryKey(options)
});

export const createMarketEventReactionMutation = (options?: Partial<Options<CreateMarketEventReactionData>>): UseMutationOptions<CreateMarketEventReactionResponse, DefaultError, Options<CreateMarketEventReactionData>> => {
    const mutationOptions: UseMutationOptions<CreateMarketEventReactionResponse, DefaultError, Options<CreateMarketEventReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMarketEventReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMarketEventReactionMutation = (options?: Partial<Options<DeleteMarketEventReactionData>>): UseMutationOptions<DeleteMarketEventReactionResponse, DefaultError, Options<DeleteMarketEventReactionData>> => {
    const mutationOptions: UseMutationOptions<DeleteMarketEventReactionResponse, DefaultError, Options<DeleteMarketEventReactionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMarketEventReaction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWalletWatchesQueryKey = (options?: Options<ListWalletWatchesData>) => createQueryKey('listWalletWatches', options);

export const listWalletWatchesOptions = (options?: Options<ListWalletWatchesData>) => queryOptions<ListWalletWatchesResponse, DefaultError, ListWalletWatchesResponse, ReturnType<typeof listWalletWatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWalletWatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWalletWatchesQueryKey(options)
});

export const createWalletWatchMutation = (options?: Partial<Options<CreateWalletWatchData>>): UseMutationOptions<CreateWalletWatchResponse, DefaultError, Options<CreateWalletWatchData>> => {
    const mutationOptions: UseMutationOptions<CreateWalletWatchResponse, DefaultError, Options<CreateWalletWatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWalletWatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteWalletWatchMutation = (options?: Partial<Options<DeleteWalletWatchData>>): UseMutationOptions<DeleteWalletWatchResponse, DefaultError, Options<DeleteWalletWatchData>> => {
    const mutationOptions: UseMutationOptions<DeleteWalletWatchResponse, DefaultError, Options<DeleteWalletWatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteWalletWatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWalletWatchQueryKey = (options: Options<GetWalletWatchData>) => createQueryKey('getWalletWatch', options);

export const getWalletWatchOptions = (options: Options<GetWalletWatchData>) => queryOptions<GetWalletWatchResponse, DefaultError, GetWalletWatchResponse, ReturnType<typeof getWalletWatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWalletWatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWalletWatchQueryKey(options)
});

export const listFinanceStrategyRunsQueryKey = (options?: Options<ListFinanceStrategyRunsData>) => createQueryKey('listFinanceStrategyRuns', options);

export const listFinanceStrategyRunsOptions = (options?: Options<ListFinanceStrategyRunsData>) => queryOptions<ListFinanceStrategyRunsResponse, DefaultError, ListFinanceStrategyRunsResponse, ReturnType<typeof listFinanceStrategyRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceStrategyRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceStrategyRunsQueryKey(options)
});

export const listFinanceStrategyRunsInfiniteQueryKey = (options?: Options<ListFinanceStrategyRunsData>): QueryKey<Options<ListFinanceStrategyRunsData>> => createQueryKey('listFinanceStrategyRuns', options, true);

export const listFinanceStrategyRunsInfiniteOptions = (options?: Options<ListFinanceStrategyRunsData>) => {
    const opts = infiniteQueryOptions<ListFinanceStrategyRunsResponse, DefaultError, InfiniteData<ListFinanceStrategyRunsResponse>, QueryKey<Options<ListFinanceStrategyRunsData>>, string | Pick<QueryKey<Options<ListFinanceStrategyRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFinanceStrategyRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFinanceStrategyRuns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFinanceStrategyRunsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createFinanceStrategyRunMutation = (options?: Partial<Options<CreateFinanceStrategyRunData>>): UseMutationOptions<CreateFinanceStrategyRunResponse, DefaultError, Options<CreateFinanceStrategyRunData>> => {
    const mutationOptions: UseMutationOptions<CreateFinanceStrategyRunResponse, DefaultError, Options<CreateFinanceStrategyRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFinanceStrategyRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFinanceStrategyRunRequestsQueryKey = (options?: Options<ListFinanceStrategyRunRequestsData>) => createQueryKey('listFinanceStrategyRunRequests', options);

export const listFinanceStrategyRunRequestsOptions = (options?: Options<ListFinanceStrategyRunRequestsData>) => queryOptions<ListFinanceStrategyRunRequestsResponse, DefaultError, ListFinanceStrategyRunRequestsResponse, ReturnType<typeof listFinanceStrategyRunRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceStrategyRunRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceStrategyRunRequestsQueryKey(options)
});

export const listFinanceStrategyRunRequestsInfiniteQueryKey = (options?: Options<ListFinanceStrategyRunRequestsData>): QueryKey<Options<ListFinanceStrategyRunRequestsData>> => createQueryKey('listFinanceStrategyRunRequests', options, true);

export const listFinanceStrategyRunRequestsInfiniteOptions = (options?: Options<ListFinanceStrategyRunRequestsData>) => {
    const opts = infiniteQueryOptions<ListFinanceStrategyRunRequestsResponse, DefaultError, InfiniteData<ListFinanceStrategyRunRequestsResponse>, QueryKey<Options<ListFinanceStrategyRunRequestsData>>, string | Pick<QueryKey<Options<ListFinanceStrategyRunRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFinanceStrategyRunRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFinanceStrategyRunRequests({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFinanceStrategyRunRequestsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createFinanceStrategyRunRequestMutation = (options?: Partial<Options<CreateFinanceStrategyRunRequestData>>): UseMutationOptions<CreateFinanceStrategyRunRequestResponse, DefaultError, Options<CreateFinanceStrategyRunRequestData>> => {
    const mutationOptions: UseMutationOptions<CreateFinanceStrategyRunRequestResponse, DefaultError, Options<CreateFinanceStrategyRunRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFinanceStrategyRunRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFinanceStrategyRunRequestQueryKey = (options: Options<GetFinanceStrategyRunRequestData>) => createQueryKey('getFinanceStrategyRunRequest', options);

export const getFinanceStrategyRunRequestOptions = (options: Options<GetFinanceStrategyRunRequestData>) => queryOptions<GetFinanceStrategyRunRequestResponse, DefaultError, GetFinanceStrategyRunRequestResponse, ReturnType<typeof getFinanceStrategyRunRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceStrategyRunRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceStrategyRunRequestQueryKey(options)
});

export const getFinanceStrategyRunQueryKey = (options: Options<GetFinanceStrategyRunData>) => createQueryKey('getFinanceStrategyRun', options);

export const getFinanceStrategyRunOptions = (options: Options<GetFinanceStrategyRunData>) => queryOptions<GetFinanceStrategyRunResponse, DefaultError, GetFinanceStrategyRunResponse, ReturnType<typeof getFinanceStrategyRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceStrategyRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceStrategyRunQueryKey(options)
});

export const getStrategyRunResultQueryKey = (options: Options<GetStrategyRunResultData>) => createQueryKey('getStrategyRunResult', options);

export const getStrategyRunResultOptions = (options: Options<GetStrategyRunResultData>) => queryOptions<GetStrategyRunResultResponse, DefaultError, GetStrategyRunResultResponse, ReturnType<typeof getStrategyRunResultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStrategyRunResult({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStrategyRunResultQueryKey(options)
});

export const getStrategyRunArtifactQueryKey = (options: Options<GetStrategyRunArtifactData>) => createQueryKey('getStrategyRunArtifact', options);

export const getStrategyRunArtifactOptions = (options: Options<GetStrategyRunArtifactData>) => queryOptions<GetStrategyRunArtifactResponse, DefaultError, GetStrategyRunArtifactResponse, ReturnType<typeof getStrategyRunArtifactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStrategyRunArtifact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStrategyRunArtifactQueryKey(options)
});

export const getStrategyRunArtifactInfiniteQueryKey = (options: Options<GetStrategyRunArtifactData>): QueryKey<Options<GetStrategyRunArtifactData>> => createQueryKey('getStrategyRunArtifact', options, true);

export const getStrategyRunArtifactInfiniteOptions = (options: Options<GetStrategyRunArtifactData>) => {
    const opts = infiniteQueryOptions<GetStrategyRunArtifactResponse, DefaultError, InfiniteData<GetStrategyRunArtifactResponse>, QueryKey<Options<GetStrategyRunArtifactData>>, string | Pick<QueryKey<Options<GetStrategyRunArtifactData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetStrategyRunArtifactData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getStrategyRunArtifact({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStrategyRunArtifactInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getStrategyRunAnalyticsQueryKey = (options: Options<GetStrategyRunAnalyticsData>) => createQueryKey('getStrategyRunAnalytics', options);

export const getStrategyRunAnalyticsOptions = (options: Options<GetStrategyRunAnalyticsData>) => queryOptions<GetStrategyRunAnalyticsResponse, DefaultError, GetStrategyRunAnalyticsResponse, ReturnType<typeof getStrategyRunAnalyticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStrategyRunAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStrategyRunAnalyticsQueryKey(options)
});

export const listStrategyDefinitionGroupsQueryKey = (options?: Options<ListStrategyDefinitionGroupsData>) => createQueryKey('listStrategyDefinitionGroups', options);

export const listStrategyDefinitionGroupsOptions = (options?: Options<ListStrategyDefinitionGroupsData>) => queryOptions<ListStrategyDefinitionGroupsResponse, DefaultError, ListStrategyDefinitionGroupsResponse, ReturnType<typeof listStrategyDefinitionGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyDefinitionGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyDefinitionGroupsQueryKey(options)
});

export const listStrategyDefinitionGroupsInfiniteQueryKey = (options?: Options<ListStrategyDefinitionGroupsData>): QueryKey<Options<ListStrategyDefinitionGroupsData>> => createQueryKey('listStrategyDefinitionGroups', options, true);

export const listStrategyDefinitionGroupsInfiniteOptions = (options?: Options<ListStrategyDefinitionGroupsData>) => {
    const opts = infiniteQueryOptions<ListStrategyDefinitionGroupsResponse, DefaultError, InfiniteData<ListStrategyDefinitionGroupsResponse>, QueryKey<Options<ListStrategyDefinitionGroupsData>>, number | null | Pick<QueryKey<Options<ListStrategyDefinitionGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyDefinitionGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyDefinitionGroups({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyDefinitionGroupsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listStrategyDefinitionSummariesQueryKey = (options?: Options<ListStrategyDefinitionSummariesData>) => createQueryKey('listStrategyDefinitionSummaries', options);

export const listStrategyDefinitionSummariesOptions = (options?: Options<ListStrategyDefinitionSummariesData>) => queryOptions<ListStrategyDefinitionSummariesResponse, DefaultError, ListStrategyDefinitionSummariesResponse, ReturnType<typeof listStrategyDefinitionSummariesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyDefinitionSummaries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyDefinitionSummariesQueryKey(options)
});

export const listStrategyDefinitionSummariesInfiniteQueryKey = (options?: Options<ListStrategyDefinitionSummariesData>): QueryKey<Options<ListStrategyDefinitionSummariesData>> => createQueryKey('listStrategyDefinitionSummaries', options, true);

export const listStrategyDefinitionSummariesInfiniteOptions = (options?: Options<ListStrategyDefinitionSummariesData>) => {
    const opts = infiniteQueryOptions<ListStrategyDefinitionSummariesResponse, DefaultError, InfiniteData<ListStrategyDefinitionSummariesResponse>, QueryKey<Options<ListStrategyDefinitionSummariesData>>, number | null | Pick<QueryKey<Options<ListStrategyDefinitionSummariesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyDefinitionSummariesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyDefinitionSummaries({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyDefinitionSummariesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listStrategyDefinitionRunsQueryKey = (options: Options<ListStrategyDefinitionRunsData>) => createQueryKey('listStrategyDefinitionRuns', options);

export const listStrategyDefinitionRunsOptions = (options: Options<ListStrategyDefinitionRunsData>) => queryOptions<ListStrategyDefinitionRunsResponse, DefaultError, ListStrategyDefinitionRunsResponse, ReturnType<typeof listStrategyDefinitionRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStrategyDefinitionRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStrategyDefinitionRunsQueryKey(options)
});

export const listStrategyDefinitionRunsInfiniteQueryKey = (options: Options<ListStrategyDefinitionRunsData>): QueryKey<Options<ListStrategyDefinitionRunsData>> => createQueryKey('listStrategyDefinitionRuns', options, true);

export const listStrategyDefinitionRunsInfiniteOptions = (options: Options<ListStrategyDefinitionRunsData>) => {
    const opts = infiniteQueryOptions<ListStrategyDefinitionRunsResponse, DefaultError, InfiniteData<ListStrategyDefinitionRunsResponse>, QueryKey<Options<ListStrategyDefinitionRunsData>>, string | Pick<QueryKey<Options<ListStrategyDefinitionRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStrategyDefinitionRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStrategyDefinitionRuns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStrategyDefinitionRunsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createStrategyDefinitionRunMutation = (options?: Partial<Options<CreateStrategyDefinitionRunData>>): UseMutationOptions<CreateStrategyDefinitionRunResponse, CreateStrategyDefinitionRunError, Options<CreateStrategyDefinitionRunData>> => {
    const mutationOptions: UseMutationOptions<CreateStrategyDefinitionRunResponse, CreateStrategyDefinitionRunError, Options<CreateStrategyDefinitionRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStrategyDefinitionRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const amendStrategyDefinitionParametersMutation = (options?: Partial<Options<AmendStrategyDefinitionParametersData>>): UseMutationOptions<AmendStrategyDefinitionParametersResponse, DefaultError, Options<AmendStrategyDefinitionParametersData>> => {
    const mutationOptions: UseMutationOptions<AmendStrategyDefinitionParametersResponse, DefaultError, Options<AmendStrategyDefinitionParametersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await amendStrategyDefinitionParameters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const forkStrategyDefinitionMutation = (options?: Partial<Options<ForkStrategyDefinitionData>>): UseMutationOptions<ForkStrategyDefinitionResponse, DefaultError, Options<ForkStrategyDefinitionData>> => {
    const mutationOptions: UseMutationOptions<ForkStrategyDefinitionResponse, DefaultError, Options<ForkStrategyDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await forkStrategyDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFinanceStrategyTemplatesQueryKey = (options?: Options<ListFinanceStrategyTemplatesData>) => createQueryKey('listFinanceStrategyTemplates', options);

export const listFinanceStrategyTemplatesOptions = (options?: Options<ListFinanceStrategyTemplatesData>) => queryOptions<ListFinanceStrategyTemplatesResponse, DefaultError, ListFinanceStrategyTemplatesResponse, ReturnType<typeof listFinanceStrategyTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceStrategyTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceStrategyTemplatesQueryKey(options)
});

export const getFinanceStrategyTemplateQueryKey = (options: Options<GetFinanceStrategyTemplateData>) => createQueryKey('getFinanceStrategyTemplate', options);

export const getFinanceStrategyTemplateOptions = (options: Options<GetFinanceStrategyTemplateData>) => queryOptions<GetFinanceStrategyTemplateResponse, DefaultError, GetFinanceStrategyTemplateResponse, ReturnType<typeof getFinanceStrategyTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceStrategyTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceStrategyTemplateQueryKey(options)
});

export const previewFinanceStrategyTemplateMutation = (options?: Partial<Options<PreviewFinanceStrategyTemplateData>>): UseMutationOptions<PreviewFinanceStrategyTemplateResponse, DefaultError, Options<PreviewFinanceStrategyTemplateData>> => {
    const mutationOptions: UseMutationOptions<PreviewFinanceStrategyTemplateResponse, DefaultError, Options<PreviewFinanceStrategyTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewFinanceStrategyTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enqueueFinanceStrategyTemplateRunMutation = (options?: Partial<Options<EnqueueFinanceStrategyTemplateRunData>>): UseMutationOptions<EnqueueFinanceStrategyTemplateRunResponse, DefaultError, Options<EnqueueFinanceStrategyTemplateRunData>> => {
    const mutationOptions: UseMutationOptions<EnqueueFinanceStrategyTemplateRunResponse, DefaultError, Options<EnqueueFinanceStrategyTemplateRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enqueueFinanceStrategyTemplateRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFinanceProviderUnlockPromptsQueryKey = (options?: Options<ListFinanceProviderUnlockPromptsData>) => createQueryKey('listFinanceProviderUnlockPrompts', options);

export const listFinanceProviderUnlockPromptsOptions = (options?: Options<ListFinanceProviderUnlockPromptsData>) => queryOptions<ListFinanceProviderUnlockPromptsResponse, DefaultError, ListFinanceProviderUnlockPromptsResponse, ReturnType<typeof listFinanceProviderUnlockPromptsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceProviderUnlockPrompts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceProviderUnlockPromptsQueryKey(options)
});

export const listFinanceProviderUnlockPromptsInfiniteQueryKey = (options?: Options<ListFinanceProviderUnlockPromptsData>): QueryKey<Options<ListFinanceProviderUnlockPromptsData>> => createQueryKey('listFinanceProviderUnlockPrompts', options, true);

export const listFinanceProviderUnlockPromptsInfiniteOptions = (options?: Options<ListFinanceProviderUnlockPromptsData>) => {
    const opts = infiniteQueryOptions<ListFinanceProviderUnlockPromptsResponse, DefaultError, InfiniteData<ListFinanceProviderUnlockPromptsResponse>, QueryKey<Options<ListFinanceProviderUnlockPromptsData>>, string | Pick<QueryKey<Options<ListFinanceProviderUnlockPromptsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFinanceProviderUnlockPromptsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFinanceProviderUnlockPrompts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFinanceProviderUnlockPromptsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getFinanceProviderUnlockPromptQueryKey = (options: Options<GetFinanceProviderUnlockPromptData>) => createQueryKey('getFinanceProviderUnlockPrompt', options);

export const getFinanceProviderUnlockPromptOptions = (options: Options<GetFinanceProviderUnlockPromptData>) => queryOptions<GetFinanceProviderUnlockPromptResponse, DefaultError, GetFinanceProviderUnlockPromptResponse, ReturnType<typeof getFinanceProviderUnlockPromptQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceProviderUnlockPrompt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceProviderUnlockPromptQueryKey(options)
});

export const listFinanceStrategyCostModelsQueryKey = (options?: Options<ListFinanceStrategyCostModelsData>) => createQueryKey('listFinanceStrategyCostModels', options);

export const listFinanceStrategyCostModelsOptions = (options?: Options<ListFinanceStrategyCostModelsData>) => queryOptions<ListFinanceStrategyCostModelsResponse, DefaultError, ListFinanceStrategyCostModelsResponse, ReturnType<typeof listFinanceStrategyCostModelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceStrategyCostModels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceStrategyCostModelsQueryKey(options)
});

export const listFinanceStrategyCostModelsInfiniteQueryKey = (options?: Options<ListFinanceStrategyCostModelsData>): QueryKey<Options<ListFinanceStrategyCostModelsData>> => createQueryKey('listFinanceStrategyCostModels', options, true);

export const listFinanceStrategyCostModelsInfiniteOptions = (options?: Options<ListFinanceStrategyCostModelsData>) => {
    const opts = infiniteQueryOptions<ListFinanceStrategyCostModelsResponse, DefaultError, InfiniteData<ListFinanceStrategyCostModelsResponse>, QueryKey<Options<ListFinanceStrategyCostModelsData>>, string | Pick<QueryKey<Options<ListFinanceStrategyCostModelsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFinanceStrategyCostModelsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFinanceStrategyCostModels({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFinanceStrategyCostModelsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createFinanceStrategyCostModelMutation = (options?: Partial<Options<CreateFinanceStrategyCostModelData>>): UseMutationOptions<CreateFinanceStrategyCostModelResponse, DefaultError, Options<CreateFinanceStrategyCostModelData>> => {
    const mutationOptions: UseMutationOptions<CreateFinanceStrategyCostModelResponse, DefaultError, Options<CreateFinanceStrategyCostModelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFinanceStrategyCostModel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFinanceStrategyCostModelQueryKey = (options: Options<GetFinanceStrategyCostModelData>) => createQueryKey('getFinanceStrategyCostModel', options);

export const getFinanceStrategyCostModelOptions = (options: Options<GetFinanceStrategyCostModelData>) => queryOptions<GetFinanceStrategyCostModelResponse, DefaultError, GetFinanceStrategyCostModelResponse, ReturnType<typeof getFinanceStrategyCostModelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceStrategyCostModel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceStrategyCostModelQueryKey(options)
});

export const listFinanceStrategyLifecycleTransitionsQueryKey = (options?: Options<ListFinanceStrategyLifecycleTransitionsData>) => createQueryKey('listFinanceStrategyLifecycleTransitions', options);

export const listFinanceStrategyLifecycleTransitionsOptions = (options?: Options<ListFinanceStrategyLifecycleTransitionsData>) => queryOptions<ListFinanceStrategyLifecycleTransitionsResponse, DefaultError, ListFinanceStrategyLifecycleTransitionsResponse, ReturnType<typeof listFinanceStrategyLifecycleTransitionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceStrategyLifecycleTransitions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceStrategyLifecycleTransitionsQueryKey(options)
});

export const listFinanceStrategyLifecycleTransitionsInfiniteQueryKey = (options?: Options<ListFinanceStrategyLifecycleTransitionsData>): QueryKey<Options<ListFinanceStrategyLifecycleTransitionsData>> => createQueryKey('listFinanceStrategyLifecycleTransitions', options, true);

export const listFinanceStrategyLifecycleTransitionsInfiniteOptions = (options?: Options<ListFinanceStrategyLifecycleTransitionsData>) => {
    const opts = infiniteQueryOptions<ListFinanceStrategyLifecycleTransitionsResponse, DefaultError, InfiniteData<ListFinanceStrategyLifecycleTransitionsResponse>, QueryKey<Options<ListFinanceStrategyLifecycleTransitionsData>>, string | Pick<QueryKey<Options<ListFinanceStrategyLifecycleTransitionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFinanceStrategyLifecycleTransitionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFinanceStrategyLifecycleTransitions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFinanceStrategyLifecycleTransitionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createFinanceStrategyLifecycleTransitionMutation = (options?: Partial<Options<CreateFinanceStrategyLifecycleTransitionData>>): UseMutationOptions<CreateFinanceStrategyLifecycleTransitionResponse, DefaultError, Options<CreateFinanceStrategyLifecycleTransitionData>> => {
    const mutationOptions: UseMutationOptions<CreateFinanceStrategyLifecycleTransitionResponse, DefaultError, Options<CreateFinanceStrategyLifecycleTransitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFinanceStrategyLifecycleTransition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const commitFinanceStrategyLifecycleTransitionMutation = (options?: Partial<Options<CommitFinanceStrategyLifecycleTransitionData>>): UseMutationOptions<CommitFinanceStrategyLifecycleTransitionResponse, DefaultError, Options<CommitFinanceStrategyLifecycleTransitionData>> => {
    const mutationOptions: UseMutationOptions<CommitFinanceStrategyLifecycleTransitionResponse, DefaultError, Options<CommitFinanceStrategyLifecycleTransitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await commitFinanceStrategyLifecycleTransition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFinanceArtifactPreviewQueryKey = (options: Options<GetFinanceArtifactPreviewData>) => createQueryKey('getFinanceArtifactPreview', options);

export const getFinanceArtifactPreviewOptions = (options: Options<GetFinanceArtifactPreviewData>) => queryOptions<GetFinanceArtifactPreviewResponse, DefaultError, GetFinanceArtifactPreviewResponse, ReturnType<typeof getFinanceArtifactPreviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceArtifactPreview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceArtifactPreviewQueryKey(options)
});

export const listFinanceResearchWorkflowsQueryKey = (options?: Options<ListFinanceResearchWorkflowsData>) => createQueryKey('listFinanceResearchWorkflows', options);

export const listFinanceResearchWorkflowsOptions = (options?: Options<ListFinanceResearchWorkflowsData>) => queryOptions<ListFinanceResearchWorkflowsResponse, DefaultError, ListFinanceResearchWorkflowsResponse, ReturnType<typeof listFinanceResearchWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceResearchWorkflows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceResearchWorkflowsQueryKey(options)
});

export const startFinanceResearchWorkflowRunMutation = (options?: Partial<Options<StartFinanceResearchWorkflowRunData>>): UseMutationOptions<StartFinanceResearchWorkflowRunResponse, DefaultError, Options<StartFinanceResearchWorkflowRunData>> => {
    const mutationOptions: UseMutationOptions<StartFinanceResearchWorkflowRunResponse, DefaultError, Options<StartFinanceResearchWorkflowRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startFinanceResearchWorkflowRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFinancePlannerRecommendationsQueryKey = (options?: Options<ListFinancePlannerRecommendationsData>) => createQueryKey('listFinancePlannerRecommendations', options);

export const listFinancePlannerRecommendationsOptions = (options?: Options<ListFinancePlannerRecommendationsData>) => queryOptions<ListFinancePlannerRecommendationsResponse, DefaultError, ListFinancePlannerRecommendationsResponse, ReturnType<typeof listFinancePlannerRecommendationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinancePlannerRecommendations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinancePlannerRecommendationsQueryKey(options)
});

export const getFinanceBucketCompositionQueryKey = (options?: Options<GetFinanceBucketCompositionData>) => createQueryKey('getFinanceBucketComposition', options);

export const getFinanceBucketCompositionOptions = (options?: Options<GetFinanceBucketCompositionData>) => queryOptions<GetFinanceBucketCompositionResponse, DefaultError, GetFinanceBucketCompositionResponse, ReturnType<typeof getFinanceBucketCompositionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceBucketComposition({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceBucketCompositionQueryKey(options)
});

export const applyFinanceBucketDecisionMutation = (options?: Partial<Options<ApplyFinanceBucketDecisionData>>): UseMutationOptions<ApplyFinanceBucketDecisionResponse, DefaultError, Options<ApplyFinanceBucketDecisionData>> => {
    const mutationOptions: UseMutationOptions<ApplyFinanceBucketDecisionResponse, DefaultError, Options<ApplyFinanceBucketDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await applyFinanceBucketDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const proposeFinanceBucketReweightMutation = (options?: Partial<Options<ProposeFinanceBucketReweightData>>): UseMutationOptions<ProposeFinanceBucketReweightResponse, DefaultError, Options<ProposeFinanceBucketReweightData>> => {
    const mutationOptions: UseMutationOptions<ProposeFinanceBucketReweightResponse, DefaultError, Options<ProposeFinanceBucketReweightData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await proposeFinanceBucketReweight({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFinanceIndicatorDecisionsQueryKey = (options?: Options<ListFinanceIndicatorDecisionsData>) => createQueryKey('listFinanceIndicatorDecisions', options);

export const listFinanceIndicatorDecisionsOptions = (options?: Options<ListFinanceIndicatorDecisionsData>) => queryOptions<ListFinanceIndicatorDecisionsResponse, DefaultError, ListFinanceIndicatorDecisionsResponse, ReturnType<typeof listFinanceIndicatorDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceIndicatorDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceIndicatorDecisionsQueryKey(options)
});

export const enqueueFinanceIndicatorDecisionMutation = (options?: Partial<Options<EnqueueFinanceIndicatorDecisionData>>): UseMutationOptions<EnqueueFinanceIndicatorDecisionResponse, DefaultError, Options<EnqueueFinanceIndicatorDecisionData>> => {
    const mutationOptions: UseMutationOptions<EnqueueFinanceIndicatorDecisionResponse, DefaultError, Options<EnqueueFinanceIndicatorDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enqueueFinanceIndicatorDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFinanceIndicatorDecisionQueryKey = (options: Options<GetFinanceIndicatorDecisionData>) => createQueryKey('getFinanceIndicatorDecision', options);

export const getFinanceIndicatorDecisionOptions = (options: Options<GetFinanceIndicatorDecisionData>) => queryOptions<GetFinanceIndicatorDecisionResponse, DefaultError, GetFinanceIndicatorDecisionResponse, ReturnType<typeof getFinanceIndicatorDecisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceIndicatorDecision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceIndicatorDecisionQueryKey(options)
});

export const listFinanceStrategyDecisionsQueryKey = (options?: Options<ListFinanceStrategyDecisionsData>) => createQueryKey('listFinanceStrategyDecisions', options);

export const listFinanceStrategyDecisionsOptions = (options?: Options<ListFinanceStrategyDecisionsData>) => queryOptions<ListFinanceStrategyDecisionsResponse, DefaultError, ListFinanceStrategyDecisionsResponse, ReturnType<typeof listFinanceStrategyDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceStrategyDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceStrategyDecisionsQueryKey(options)
});

export const getFinanceStrategyDecisionQueryKey = (options: Options<GetFinanceStrategyDecisionData>) => createQueryKey('getFinanceStrategyDecision', options);

export const getFinanceStrategyDecisionOptions = (options: Options<GetFinanceStrategyDecisionData>) => queryOptions<GetFinanceStrategyDecisionResponse, DefaultError, GetFinanceStrategyDecisionResponse, ReturnType<typeof getFinanceStrategyDecisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceStrategyDecision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceStrategyDecisionQueryKey(options)
});

export const evaluateFinanceStrategyDecisionMutation = (options?: Partial<Options<EvaluateFinanceStrategyDecisionData>>): UseMutationOptions<EvaluateFinanceStrategyDecisionResponse, DefaultError, Options<EvaluateFinanceStrategyDecisionData>> => {
    const mutationOptions: UseMutationOptions<EvaluateFinanceStrategyDecisionResponse, DefaultError, Options<EvaluateFinanceStrategyDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await evaluateFinanceStrategyDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const evaluateFinanceStrategyDefinitionMutation = (options?: Partial<Options<EvaluateFinanceStrategyDefinitionData>>): UseMutationOptions<EvaluateFinanceStrategyDefinitionResponse, DefaultError, Options<EvaluateFinanceStrategyDefinitionData>> => {
    const mutationOptions: UseMutationOptions<EvaluateFinanceStrategyDefinitionResponse, DefaultError, Options<EvaluateFinanceStrategyDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await evaluateFinanceStrategyDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFinanceOperationsSummaryQueryKey = (options?: Options<GetFinanceOperationsSummaryData>) => createQueryKey('getFinanceOperationsSummary', options);

export const getFinanceOperationsSummaryOptions = (options?: Options<GetFinanceOperationsSummaryData>) => queryOptions<GetFinanceOperationsSummaryResponse, DefaultError, GetFinanceOperationsSummaryResponse, ReturnType<typeof getFinanceOperationsSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceOperationsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceOperationsSummaryQueryKey(options)
});

export const lookupFinanceCommandOptionsQueryKey = (options: Options<LookupFinanceCommandOptionsData>) => createQueryKey('lookupFinanceCommandOptions', options);

export const lookupFinanceCommandOptionsOptions = (options: Options<LookupFinanceCommandOptionsData>) => queryOptions<LookupFinanceCommandOptionsResponse, DefaultError, LookupFinanceCommandOptionsResponse, ReturnType<typeof lookupFinanceCommandOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await lookupFinanceCommandOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: lookupFinanceCommandOptionsQueryKey(options)
});

export const listFinanceConversationPersonasQueryKey = (options?: Options<ListFinanceConversationPersonasData>) => createQueryKey('listFinanceConversationPersonas', options);

export const listFinanceConversationPersonasOptions = (options?: Options<ListFinanceConversationPersonasData>) => queryOptions<ListFinanceConversationPersonasResponse, DefaultError, ListFinanceConversationPersonasResponse, ReturnType<typeof listFinanceConversationPersonasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceConversationPersonas({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceConversationPersonasQueryKey(options)
});

export const previewFinanceIndicatorImportMutation = (options?: Partial<Options<PreviewFinanceIndicatorImportData>>): UseMutationOptions<PreviewFinanceIndicatorImportResponse, DefaultError, Options<PreviewFinanceIndicatorImportData>> => {
    const mutationOptions: UseMutationOptions<PreviewFinanceIndicatorImportResponse, DefaultError, Options<PreviewFinanceIndicatorImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewFinanceIndicatorImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const transpileFinanceIndicatorImportMutation = (options?: Partial<Options<TranspileFinanceIndicatorImportData>>): UseMutationOptions<TranspileFinanceIndicatorImportResponse, DefaultError, Options<TranspileFinanceIndicatorImportData>> => {
    const mutationOptions: UseMutationOptions<TranspileFinanceIndicatorImportResponse, DefaultError, Options<TranspileFinanceIndicatorImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transpileFinanceIndicatorImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFinanceIndicatorsQueryKey = (options?: Options<ListFinanceIndicatorsData>) => createQueryKey('listFinanceIndicators', options);

export const listFinanceIndicatorsOptions = (options?: Options<ListFinanceIndicatorsData>) => queryOptions<ListFinanceIndicatorsResponse, DefaultError, ListFinanceIndicatorsResponse, ReturnType<typeof listFinanceIndicatorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceIndicators({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceIndicatorsQueryKey(options)
});

export const applyFinanceIndicatorPromotionMutation = (options?: Partial<Options<ApplyFinanceIndicatorPromotionData>>): UseMutationOptions<ApplyFinanceIndicatorPromotionResponse, DefaultError, Options<ApplyFinanceIndicatorPromotionData>> => {
    const mutationOptions: UseMutationOptions<ApplyFinanceIndicatorPromotionResponse, DefaultError, Options<ApplyFinanceIndicatorPromotionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await applyFinanceIndicatorPromotion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createTickerResearchNoteMutation = (options?: Partial<Options<CreateTickerResearchNoteData>>): UseMutationOptions<CreateTickerResearchNoteResponse, DefaultError, Options<CreateTickerResearchNoteData>> => {
    const mutationOptions: UseMutationOptions<CreateTickerResearchNoteResponse, DefaultError, Options<CreateTickerResearchNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTickerResearchNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listVarEstimatesQueryKey = (options?: Options<ListVarEstimatesData>) => createQueryKey('listVarEstimates', options);

export const listVarEstimatesOptions = (options?: Options<ListVarEstimatesData>) => queryOptions<ListVarEstimatesResponse, DefaultError, ListVarEstimatesResponse, ReturnType<typeof listVarEstimatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listVarEstimates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listVarEstimatesQueryKey(options)
});

export const listVarEstimatesInfiniteQueryKey = (options?: Options<ListVarEstimatesData>): QueryKey<Options<ListVarEstimatesData>> => createQueryKey('listVarEstimates', options, true);

export const listVarEstimatesInfiniteOptions = (options?: Options<ListVarEstimatesData>) => {
    const opts = infiniteQueryOptions<ListVarEstimatesResponse, DefaultError, InfiniteData<ListVarEstimatesResponse>, QueryKey<Options<ListVarEstimatesData>>, string | Pick<QueryKey<Options<ListVarEstimatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListVarEstimatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listVarEstimates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listVarEstimatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listVarBacktestsQueryKey = (options?: Options<ListVarBacktestsData>) => createQueryKey('listVarBacktests', options);

export const listVarBacktestsOptions = (options?: Options<ListVarBacktestsData>) => queryOptions<ListVarBacktestsResponse, DefaultError, ListVarBacktestsResponse, ReturnType<typeof listVarBacktestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listVarBacktests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listVarBacktestsQueryKey(options)
});

export const listVarBacktestsInfiniteQueryKey = (options?: Options<ListVarBacktestsData>): QueryKey<Options<ListVarBacktestsData>> => createQueryKey('listVarBacktests', options, true);

export const listVarBacktestsInfiniteOptions = (options?: Options<ListVarBacktestsData>) => {
    const opts = infiniteQueryOptions<ListVarBacktestsResponse, DefaultError, InfiniteData<ListVarBacktestsResponse>, QueryKey<Options<ListVarBacktestsData>>, string | Pick<QueryKey<Options<ListVarBacktestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListVarBacktestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listVarBacktests({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listVarBacktestsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getVarEstimateQueryKey = (options: Options<GetVarEstimateData>) => createQueryKey('getVarEstimate', options);

export const getVarEstimateOptions = (options: Options<GetVarEstimateData>) => queryOptions<GetVarEstimateResponse, DefaultError, GetVarEstimateResponse, ReturnType<typeof getVarEstimateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getVarEstimate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getVarEstimateQueryKey(options)
});

export const listVarComponentsQueryKey = (options: Options<ListVarComponentsData>) => createQueryKey('listVarComponents', options);

export const listVarComponentsOptions = (options: Options<ListVarComponentsData>) => queryOptions<ListVarComponentsResponse, DefaultError, ListVarComponentsResponse, ReturnType<typeof listVarComponentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listVarComponents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listVarComponentsQueryKey(options)
});

export const listStressScenariosQueryKey = (options?: Options<ListStressScenariosData>) => createQueryKey('listStressScenarios', options);

export const listStressScenariosOptions = (options?: Options<ListStressScenariosData>) => queryOptions<ListStressScenariosResponse, DefaultError, ListStressScenariosResponse, ReturnType<typeof listStressScenariosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStressScenarios({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStressScenariosQueryKey(options)
});

export const getStressScenarioQueryKey = (options: Options<GetStressScenarioData>) => createQueryKey('getStressScenario', options);

export const getStressScenarioOptions = (options: Options<GetStressScenarioData>) => queryOptions<GetStressScenarioResponse, DefaultError, GetStressScenarioResponse, ReturnType<typeof getStressScenarioQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStressScenario({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStressScenarioQueryKey(options)
});

export const listStressResultsQueryKey = (options?: Options<ListStressResultsData>) => createQueryKey('listStressResults', options);

export const listStressResultsOptions = (options?: Options<ListStressResultsData>) => queryOptions<ListStressResultsResponse, DefaultError, ListStressResultsResponse, ReturnType<typeof listStressResultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStressResults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStressResultsQueryKey(options)
});

export const listStressResultsInfiniteQueryKey = (options?: Options<ListStressResultsData>): QueryKey<Options<ListStressResultsData>> => createQueryKey('listStressResults', options, true);

export const listStressResultsInfiniteOptions = (options?: Options<ListStressResultsData>) => {
    const opts = infiniteQueryOptions<ListStressResultsResponse, DefaultError, InfiniteData<ListStressResultsResponse>, QueryKey<Options<ListStressResultsData>>, string | Pick<QueryKey<Options<ListStressResultsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStressResultsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStressResults({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStressResultsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getStressResultQueryKey = (options: Options<GetStressResultData>) => createQueryKey('getStressResult', options);

export const getStressResultOptions = (options: Options<GetStressResultData>) => queryOptions<GetStressResultResponse, DefaultError, GetStressResultResponse, ReturnType<typeof getStressResultQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStressResult({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStressResultQueryKey(options)
});

export const listAttributionRunsQueryKey = (options?: Options<ListAttributionRunsData>) => createQueryKey('listAttributionRuns', options);

export const listAttributionRunsOptions = (options?: Options<ListAttributionRunsData>) => queryOptions<ListAttributionRunsResponse, DefaultError, ListAttributionRunsResponse, ReturnType<typeof listAttributionRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAttributionRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAttributionRunsQueryKey(options)
});

export const listAttributionRunsInfiniteQueryKey = (options?: Options<ListAttributionRunsData>): QueryKey<Options<ListAttributionRunsData>> => createQueryKey('listAttributionRuns', options, true);

export const listAttributionRunsInfiniteOptions = (options?: Options<ListAttributionRunsData>) => {
    const opts = infiniteQueryOptions<ListAttributionRunsResponse, DefaultError, InfiniteData<ListAttributionRunsResponse>, QueryKey<Options<ListAttributionRunsData>>, string | Pick<QueryKey<Options<ListAttributionRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAttributionRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAttributionRuns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAttributionRunsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getAttributionRunQueryKey = (options: Options<GetAttributionRunData>) => createQueryKey('getAttributionRun', options);

export const getAttributionRunOptions = (options: Options<GetAttributionRunData>) => queryOptions<GetAttributionRunResponse, DefaultError, GetAttributionRunResponse, ReturnType<typeof getAttributionRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAttributionRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAttributionRunQueryKey(options)
});

export const listAttributionEffectsQueryKey = (options: Options<ListAttributionEffectsData>) => createQueryKey('listAttributionEffects', options);

export const listAttributionEffectsOptions = (options: Options<ListAttributionEffectsData>) => queryOptions<ListAttributionEffectsResponse, DefaultError, ListAttributionEffectsResponse, ReturnType<typeof listAttributionEffectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAttributionEffects({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAttributionEffectsQueryKey(options)
});

export const listTcaScorecardsQueryKey = (options: Options<ListTcaScorecardsData>) => createQueryKey('listTcaScorecards', options);

export const listTcaScorecardsOptions = (options: Options<ListTcaScorecardsData>) => queryOptions<ListTcaScorecardsResponse, DefaultError, ListTcaScorecardsResponse, ReturnType<typeof listTcaScorecardsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTcaScorecards({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTcaScorecardsQueryKey(options)
});

export const listCrowdingScoresQueryKey = (options?: Options<ListCrowdingScoresData>) => createQueryKey('listCrowdingScores', options);

export const listCrowdingScoresOptions = (options?: Options<ListCrowdingScoresData>) => queryOptions<ListCrowdingScoresResponse, DefaultError, ListCrowdingScoresResponse, ReturnType<typeof listCrowdingScoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCrowdingScores({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCrowdingScoresQueryKey(options)
});

export const listCapitalAllocationsQueryKey = (options?: Options<ListCapitalAllocationsData>) => createQueryKey('listCapitalAllocations', options);

export const listCapitalAllocationsOptions = (options?: Options<ListCapitalAllocationsData>) => queryOptions<ListCapitalAllocationsResponse, DefaultError, ListCapitalAllocationsResponse, ReturnType<typeof listCapitalAllocationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCapitalAllocations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCapitalAllocationsQueryKey(options)
});

export const listCapitalAllocationsInfiniteQueryKey = (options?: Options<ListCapitalAllocationsData>): QueryKey<Options<ListCapitalAllocationsData>> => createQueryKey('listCapitalAllocations', options, true);

export const listCapitalAllocationsInfiniteOptions = (options?: Options<ListCapitalAllocationsData>) => {
    const opts = infiniteQueryOptions<ListCapitalAllocationsResponse, DefaultError, InfiniteData<ListCapitalAllocationsResponse>, QueryKey<Options<ListCapitalAllocationsData>>, string | Pick<QueryKey<Options<ListCapitalAllocationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListCapitalAllocationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listCapitalAllocations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCapitalAllocationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getCapitalAllocationQueryKey = (options: Options<GetCapitalAllocationData>) => createQueryKey('getCapitalAllocation', options);

export const getCapitalAllocationOptions = (options: Options<GetCapitalAllocationData>) => queryOptions<GetCapitalAllocationResponse, DefaultError, GetCapitalAllocationResponse, ReturnType<typeof getCapitalAllocationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCapitalAllocation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCapitalAllocationQueryKey(options)
});

export const listCapitalAllocationSleevesQueryKey = (options: Options<ListCapitalAllocationSleevesData>) => createQueryKey('listCapitalAllocationSleeves', options);

export const listCapitalAllocationSleevesOptions = (options: Options<ListCapitalAllocationSleevesData>) => queryOptions<ListCapitalAllocationSleevesResponse, DefaultError, ListCapitalAllocationSleevesResponse, ReturnType<typeof listCapitalAllocationSleevesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCapitalAllocationSleeves({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCapitalAllocationSleevesQueryKey(options)
});

export const submitCapitalAllocationMutation = (options?: Partial<Options<SubmitCapitalAllocationData>>): UseMutationOptions<SubmitCapitalAllocationResponse, DefaultError, Options<SubmitCapitalAllocationData>> => {
    const mutationOptions: UseMutationOptions<SubmitCapitalAllocationResponse, DefaultError, Options<SubmitCapitalAllocationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitCapitalAllocation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCapacityCurvesQueryKey = (options?: Options<ListCapacityCurvesData>) => createQueryKey('listCapacityCurves', options);

export const listCapacityCurvesOptions = (options?: Options<ListCapacityCurvesData>) => queryOptions<ListCapacityCurvesResponse, DefaultError, ListCapacityCurvesResponse, ReturnType<typeof listCapacityCurvesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCapacityCurves({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCapacityCurvesQueryKey(options)
});

export const listCapacityCurvesInfiniteQueryKey = (options?: Options<ListCapacityCurvesData>): QueryKey<Options<ListCapacityCurvesData>> => createQueryKey('listCapacityCurves', options, true);

export const listCapacityCurvesInfiniteOptions = (options?: Options<ListCapacityCurvesData>) => {
    const opts = infiniteQueryOptions<ListCapacityCurvesResponse, DefaultError, InfiniteData<ListCapacityCurvesResponse>, QueryKey<Options<ListCapacityCurvesData>>, string | Pick<QueryKey<Options<ListCapacityCurvesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListCapacityCurvesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listCapacityCurves({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCapacityCurvesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getCapacityCurveQueryKey = (options: Options<GetCapacityCurveData>) => createQueryKey('getCapacityCurve', options);

export const getCapacityCurveOptions = (options: Options<GetCapacityCurveData>) => queryOptions<GetCapacityCurveResponse, DefaultError, GetCapacityCurveResponse, ReturnType<typeof getCapacityCurveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCapacityCurve({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCapacityCurveQueryKey(options)
});

export const getTradingAccountQueryKey = (options: Options<GetTradingAccountData>) => createQueryKey('getTradingAccount', options);

export const getTradingAccountOptions = (options: Options<GetTradingAccountData>) => queryOptions<GetTradingAccountResponse, DefaultError, GetTradingAccountResponse, ReturnType<typeof getTradingAccountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTradingAccount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTradingAccountQueryKey(options)
});

export const createDepositMutation = (options?: Partial<Options<CreateDepositData>>): UseMutationOptions<CreateDepositResponse, DefaultError, Options<CreateDepositData>> => {
    const mutationOptions: UseMutationOptions<CreateDepositResponse, DefaultError, Options<CreateDepositData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDeposit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createWithdrawalMutation = (options?: Partial<Options<CreateWithdrawalData>>): UseMutationOptions<CreateWithdrawalResponse, DefaultError, Options<CreateWithdrawalData>> => {
    const mutationOptions: UseMutationOptions<CreateWithdrawalResponse, DefaultError, Options<CreateWithdrawalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWithdrawal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createAdjustmentMutation = (options?: Partial<Options<CreateAdjustmentData>>): UseMutationOptions<CreateAdjustmentResponse, DefaultError, Options<CreateAdjustmentData>> => {
    const mutationOptions: UseMutationOptions<CreateAdjustmentResponse, DefaultError, Options<CreateAdjustmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAdjustment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAccountFxCashQueryKey = (options: Options<GetAccountFxCashData>) => createQueryKey('getAccountFxCash', options);

export const getAccountFxCashOptions = (options: Options<GetAccountFxCashData>) => queryOptions<GetAccountFxCashResponse, DefaultError, GetAccountFxCashResponse, ReturnType<typeof getAccountFxCashQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountFxCash({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountFxCashQueryKey(options)
});

export const listPositionLotsQueryKey = (options: Options<ListPositionLotsData>) => createQueryKey('listPositionLots', options);

export const listPositionLotsOptions = (options: Options<ListPositionLotsData>) => queryOptions<ListPositionLotsResponse, DefaultError, ListPositionLotsResponse, ReturnType<typeof listPositionLotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPositionLots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPositionLotsQueryKey(options)
});

export const listPositionLotsInfiniteQueryKey = (options: Options<ListPositionLotsData>): QueryKey<Options<ListPositionLotsData>> => createQueryKey('listPositionLots', options, true);

export const listPositionLotsInfiniteOptions = (options: Options<ListPositionLotsData>) => {
    const opts = infiniteQueryOptions<ListPositionLotsResponse, DefaultError, InfiniteData<ListPositionLotsResponse>, QueryKey<Options<ListPositionLotsData>>, string | Pick<QueryKey<Options<ListPositionLotsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPositionLotsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPositionLots({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPositionLotsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listLotDisposalsQueryKey = (options: Options<ListLotDisposalsData>) => createQueryKey('listLotDisposals', options);

export const listLotDisposalsOptions = (options: Options<ListLotDisposalsData>) => queryOptions<ListLotDisposalsResponse, DefaultError, ListLotDisposalsResponse, ReturnType<typeof listLotDisposalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listLotDisposals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listLotDisposalsQueryKey(options)
});

export const listLotDisposalsInfiniteQueryKey = (options: Options<ListLotDisposalsData>): QueryKey<Options<ListLotDisposalsData>> => createQueryKey('listLotDisposals', options, true);

export const listLotDisposalsInfiniteOptions = (options: Options<ListLotDisposalsData>) => {
    const opts = infiniteQueryOptions<ListLotDisposalsResponse, DefaultError, InfiniteData<ListLotDisposalsResponse>, QueryKey<Options<ListLotDisposalsData>>, string | Pick<QueryKey<Options<ListLotDisposalsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListLotDisposalsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listLotDisposals({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLotDisposalsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listBookSnapshotsQueryKey = (options: Options<ListBookSnapshotsData>) => createQueryKey('listBookSnapshots', options);

export const listBookSnapshotsOptions = (options: Options<ListBookSnapshotsData>) => queryOptions<ListBookSnapshotsResponse, DefaultError, ListBookSnapshotsResponse, ReturnType<typeof listBookSnapshotsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBookSnapshots({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBookSnapshotsQueryKey(options)
});

export const listBookSnapshotsInfiniteQueryKey = (options: Options<ListBookSnapshotsData>): QueryKey<Options<ListBookSnapshotsData>> => createQueryKey('listBookSnapshots', options, true);

export const listBookSnapshotsInfiniteOptions = (options: Options<ListBookSnapshotsData>) => {
    const opts = infiniteQueryOptions<ListBookSnapshotsResponse, DefaultError, InfiniteData<ListBookSnapshotsResponse>, QueryKey<Options<ListBookSnapshotsData>>, string | Pick<QueryKey<Options<ListBookSnapshotsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListBookSnapshotsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listBookSnapshots({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBookSnapshotsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const dtiOperatorKillSwitchMutation = (options?: Partial<Options<DtiOperatorKillSwitchData>>): UseMutationOptions<DtiOperatorKillSwitchResponse, DefaultError, Options<DtiOperatorKillSwitchData>> => {
    const mutationOptions: UseMutationOptions<DtiOperatorKillSwitchResponse, DefaultError, Options<DtiOperatorKillSwitchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dtiOperatorKillSwitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dtiOperatorResumeMutation = (options?: Partial<Options<DtiOperatorResumeData>>): UseMutationOptions<DtiOperatorResumeResponse, DefaultError, Options<DtiOperatorResumeData>> => {
    const mutationOptions: UseMutationOptions<DtiOperatorResumeResponse, DefaultError, Options<DtiOperatorResumeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dtiOperatorResume({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createDiscretionaryRunMutation = (options?: Partial<Options<CreateDiscretionaryRunData>>): UseMutationOptions<CreateDiscretionaryRunResponse, DefaultError, Options<CreateDiscretionaryRunData>> => {
    const mutationOptions: UseMutationOptions<CreateDiscretionaryRunResponse, DefaultError, Options<CreateDiscretionaryRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDiscretionaryRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIntelSourceStyleProfileQueryKey = (options: Options<GetIntelSourceStyleProfileData>) => createQueryKey('getIntelSourceStyleProfile', options);

export const getIntelSourceStyleProfileOptions = (options: Options<GetIntelSourceStyleProfileData>) => queryOptions<GetIntelSourceStyleProfileResponse, DefaultError, GetIntelSourceStyleProfileResponse, ReturnType<typeof getIntelSourceStyleProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIntelSourceStyleProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIntelSourceStyleProfileQueryKey(options)
});

export const getIntelSourceViewConfirmationQueryKey = (options: Options<GetIntelSourceViewConfirmationData>) => createQueryKey('getIntelSourceViewConfirmation', options);

export const getIntelSourceViewConfirmationOptions = (options: Options<GetIntelSourceViewConfirmationData>) => queryOptions<GetIntelSourceViewConfirmationResponse, DefaultError, GetIntelSourceViewConfirmationResponse, ReturnType<typeof getIntelSourceViewConfirmationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIntelSourceViewConfirmation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIntelSourceViewConfirmationQueryKey(options)
});

export const getFinanceAuditLedgerChainQueryKey = (options?: Options<GetFinanceAuditLedgerChainData>) => createQueryKey('getFinanceAuditLedgerChain', options);

export const getFinanceAuditLedgerChainOptions = (options?: Options<GetFinanceAuditLedgerChainData>) => queryOptions<GetFinanceAuditLedgerChainResponse, DefaultError, GetFinanceAuditLedgerChainResponse, ReturnType<typeof getFinanceAuditLedgerChainQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceAuditLedgerChain({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceAuditLedgerChainQueryKey(options)
});

export const getFinanceAuditLedgerOrderHistoryQueryKey = (options: Options<GetFinanceAuditLedgerOrderHistoryData>) => createQueryKey('getFinanceAuditLedgerOrderHistory', options);

export const getFinanceAuditLedgerOrderHistoryOptions = (options: Options<GetFinanceAuditLedgerOrderHistoryData>) => queryOptions<GetFinanceAuditLedgerOrderHistoryResponse, DefaultError, GetFinanceAuditLedgerOrderHistoryResponse, ReturnType<typeof getFinanceAuditLedgerOrderHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceAuditLedgerOrderHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceAuditLedgerOrderHistoryQueryKey(options)
});

export const getFinanceAuditLedgerHeadQueryKey = (options?: Options<GetFinanceAuditLedgerHeadData>) => createQueryKey('getFinanceAuditLedgerHead', options);

export const getFinanceAuditLedgerHeadOptions = (options?: Options<GetFinanceAuditLedgerHeadData>) => queryOptions<GetFinanceAuditLedgerHeadResponse, DefaultError, GetFinanceAuditLedgerHeadResponse, ReturnType<typeof getFinanceAuditLedgerHeadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceAuditLedgerHead({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceAuditLedgerHeadQueryKey(options)
});

export const verifyFinanceAuditLedgerChainQueryKey = (options?: Options<VerifyFinanceAuditLedgerChainData>) => createQueryKey('verifyFinanceAuditLedgerChain', options);

export const verifyFinanceAuditLedgerChainOptions = (options?: Options<VerifyFinanceAuditLedgerChainData>) => queryOptions<VerifyFinanceAuditLedgerChainResponse, DefaultError, VerifyFinanceAuditLedgerChainResponse, ReturnType<typeof verifyFinanceAuditLedgerChainQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await verifyFinanceAuditLedgerChain({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: verifyFinanceAuditLedgerChainQueryKey(options)
});

export const listExecutionDeploymentsQueryKey = (options?: Options<ListExecutionDeploymentsData>) => createQueryKey('listExecutionDeployments', options);

export const listExecutionDeploymentsOptions = (options?: Options<ListExecutionDeploymentsData>) => queryOptions<ListExecutionDeploymentsResponse, DefaultError, ListExecutionDeploymentsResponse, ReturnType<typeof listExecutionDeploymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExecutionDeployments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExecutionDeploymentsQueryKey(options)
});

export const listExecutionDeploymentsInfiniteQueryKey = (options?: Options<ListExecutionDeploymentsData>): QueryKey<Options<ListExecutionDeploymentsData>> => createQueryKey('listExecutionDeployments', options, true);

export const listExecutionDeploymentsInfiniteOptions = (options?: Options<ListExecutionDeploymentsData>) => {
    const opts = infiniteQueryOptions<ListExecutionDeploymentsResponse, DefaultError, InfiniteData<ListExecutionDeploymentsResponse>, QueryKey<Options<ListExecutionDeploymentsData>>, string | Pick<QueryKey<Options<ListExecutionDeploymentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListExecutionDeploymentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listExecutionDeployments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listExecutionDeploymentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createExecutionDeploymentMutation = (options?: Partial<Options<CreateExecutionDeploymentData>>): UseMutationOptions<CreateExecutionDeploymentResponse, DefaultError, Options<CreateExecutionDeploymentData>> => {
    const mutationOptions: UseMutationOptions<CreateExecutionDeploymentResponse, DefaultError, Options<CreateExecutionDeploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExecutionDeployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutionDeploymentQueryKey = (options: Options<GetExecutionDeploymentData>) => createQueryKey('getExecutionDeployment', options);

export const getExecutionDeploymentOptions = (options: Options<GetExecutionDeploymentData>) => queryOptions<GetExecutionDeploymentResponse, DefaultError, GetExecutionDeploymentResponse, ReturnType<typeof getExecutionDeploymentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutionDeployment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutionDeploymentQueryKey(options)
});

export const getPortfolioValuationQueryKey = (options: Options<GetPortfolioValuationData>) => createQueryKey('getPortfolioValuation', options);

export const getPortfolioValuationOptions = (options: Options<GetPortfolioValuationData>) => queryOptions<GetPortfolioValuationResponse, DefaultError, GetPortfolioValuationResponse, ReturnType<typeof getPortfolioValuationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPortfolioValuation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPortfolioValuationQueryKey(options)
});

export const getPositionValuationQueryKey = (options: Options<GetPositionValuationData>) => createQueryKey('getPositionValuation', options);

export const getPositionValuationOptions = (options: Options<GetPositionValuationData>) => queryOptions<GetPositionValuationResponse, DefaultError, GetPositionValuationResponse, ReturnType<typeof getPositionValuationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPositionValuation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPositionValuationQueryKey(options)
});

export const listFinanceModelLineageQueryKey = (options?: Options<ListFinanceModelLineageData>) => createQueryKey('listFinanceModelLineage', options);

export const listFinanceModelLineageOptions = (options?: Options<ListFinanceModelLineageData>) => queryOptions<ListFinanceModelLineageResponse, DefaultError, ListFinanceModelLineageResponse, ReturnType<typeof listFinanceModelLineageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFinanceModelLineage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFinanceModelLineageQueryKey(options)
});

export const listFinanceModelLineageInfiniteQueryKey = (options?: Options<ListFinanceModelLineageData>): QueryKey<Options<ListFinanceModelLineageData>> => createQueryKey('listFinanceModelLineage', options, true);

export const listFinanceModelLineageInfiniteOptions = (options?: Options<ListFinanceModelLineageData>) => {
    const opts = infiniteQueryOptions<ListFinanceModelLineageResponse, DefaultError, InfiniteData<ListFinanceModelLineageResponse>, QueryKey<Options<ListFinanceModelLineageData>>, number | null | Pick<QueryKey<Options<ListFinanceModelLineageData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFinanceModelLineageData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFinanceModelLineage({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFinanceModelLineageInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getFinanceModelLineageHistoryQueryKey = (options: Options<GetFinanceModelLineageHistoryData>) => createQueryKey('getFinanceModelLineageHistory', options);

export const getFinanceModelLineageHistoryOptions = (options: Options<GetFinanceModelLineageHistoryData>) => queryOptions<GetFinanceModelLineageHistoryResponse, DefaultError, GetFinanceModelLineageHistoryResponse, ReturnType<typeof getFinanceModelLineageHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceModelLineageHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceModelLineageHistoryQueryKey(options)
});

export const getFinanceModelLineageQueryKey = (options: Options<GetFinanceModelLineageData>) => createQueryKey('getFinanceModelLineage', options);

export const getFinanceModelLineageOptions = (options: Options<GetFinanceModelLineageData>) => queryOptions<GetFinanceModelLineageResponse, DefaultError, GetFinanceModelLineageResponse, ReturnType<typeof getFinanceModelLineageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceModelLineage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceModelLineageQueryKey(options)
});

export const getFinanceModelLineageGraphQueryKey = (options: Options<GetFinanceModelLineageGraphData>) => createQueryKey('getFinanceModelLineageGraph', options);

export const getFinanceModelLineageGraphOptions = (options: Options<GetFinanceModelLineageGraphData>) => queryOptions<GetFinanceModelLineageGraphResponse, DefaultError, GetFinanceModelLineageGraphResponse, ReturnType<typeof getFinanceModelLineageGraphQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceModelLineageGraph({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceModelLineageGraphQueryKey(options)
});

export const getFinanceKgRegimeProfileQueryKey = (options: Options<GetFinanceKgRegimeProfileData>) => createQueryKey('getFinanceKgRegimeProfile', options);

export const getFinanceKgRegimeProfileOptions = (options: Options<GetFinanceKgRegimeProfileData>) => queryOptions<GetFinanceKgRegimeProfileResponse, DefaultError, GetFinanceKgRegimeProfileResponse, ReturnType<typeof getFinanceKgRegimeProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceKgRegimeProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceKgRegimeProfileQueryKey(options)
});

export const getFinanceKgNodeEdgesQueryKey = (options: Options<GetFinanceKgNodeEdgesData>) => createQueryKey('getFinanceKgNodeEdges', options);

export const getFinanceKgNodeEdgesOptions = (options: Options<GetFinanceKgNodeEdgesData>) => queryOptions<GetFinanceKgNodeEdgesResponse, DefaultError, GetFinanceKgNodeEdgesResponse, ReturnType<typeof getFinanceKgNodeEdgesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFinanceKgNodeEdges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFinanceKgNodeEdgesQueryKey(options)
});

export const searchFinanceKgQueryKey = (options: Options<SearchFinanceKgData>) => createQueryKey('searchFinanceKg', options);

export const searchFinanceKgOptions = (options: Options<SearchFinanceKgData>) => queryOptions<SearchFinanceKgResponse, DefaultError, SearchFinanceKgResponse, ReturnType<typeof searchFinanceKgQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchFinanceKg({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchFinanceKgQueryKey(options)
});

export const listBrokerCredentialsQueryKey = (options?: Options<ListBrokerCredentialsData>) => createQueryKey('listBrokerCredentials', options);

export const listBrokerCredentialsOptions = (options?: Options<ListBrokerCredentialsData>) => queryOptions<ListBrokerCredentialsResponse, DefaultError, ListBrokerCredentialsResponse, ReturnType<typeof listBrokerCredentialsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBrokerCredentials({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBrokerCredentialsQueryKey(options)
});

export const createBrokerCredentialMutation = (options?: Partial<Options<CreateBrokerCredentialData>>): UseMutationOptions<CreateBrokerCredentialResponse, DefaultError, Options<CreateBrokerCredentialData>> => {
    const mutationOptions: UseMutationOptions<CreateBrokerCredentialResponse, DefaultError, Options<CreateBrokerCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBrokerCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteBrokerCredentialMutation = (options?: Partial<Options<DeleteBrokerCredentialData>>): UseMutationOptions<DeleteBrokerCredentialResponse, DefaultError, Options<DeleteBrokerCredentialData>> => {
    const mutationOptions: UseMutationOptions<DeleteBrokerCredentialResponse, DefaultError, Options<DeleteBrokerCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteBrokerCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBrokerCredentialQueryKey = (options: Options<GetBrokerCredentialData>) => createQueryKey('getBrokerCredential', options);

export const getBrokerCredentialOptions = (options: Options<GetBrokerCredentialData>) => queryOptions<GetBrokerCredentialResponse, DefaultError, GetBrokerCredentialResponse, ReturnType<typeof getBrokerCredentialQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBrokerCredential({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBrokerCredentialQueryKey(options)
});

export const updateBrokerCredentialMutation = (options?: Partial<Options<UpdateBrokerCredentialData>>): UseMutationOptions<UpdateBrokerCredentialResponse, DefaultError, Options<UpdateBrokerCredentialData>> => {
    const mutationOptions: UseMutationOptions<UpdateBrokerCredentialResponse, DefaultError, Options<UpdateBrokerCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBrokerCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const verifyBrokerCredentialMutation = (options?: Partial<Options<VerifyBrokerCredentialData>>): UseMutationOptions<VerifyBrokerCredentialResponse, DefaultError, Options<VerifyBrokerCredentialData>> => {
    const mutationOptions: UseMutationOptions<VerifyBrokerCredentialResponse, DefaultError, Options<VerifyBrokerCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyBrokerCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listExecutionAlgosQueryKey = (options?: Options<ListExecutionAlgosData>) => createQueryKey('listExecutionAlgos', options);

export const listExecutionAlgosOptions = (options?: Options<ListExecutionAlgosData>) => queryOptions<ListExecutionAlgosResponse, DefaultError, ListExecutionAlgosResponse, ReturnType<typeof listExecutionAlgosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExecutionAlgos({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExecutionAlgosQueryKey(options)
});

export const createExecutionAlgoMutation = (options?: Partial<Options<CreateExecutionAlgoData>>): UseMutationOptions<CreateExecutionAlgoResponse, DefaultError, Options<CreateExecutionAlgoData>> => {
    const mutationOptions: UseMutationOptions<CreateExecutionAlgoResponse, DefaultError, Options<CreateExecutionAlgoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createExecutionAlgo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutionAlgoQueryKey = (options: Options<GetExecutionAlgoData>) => createQueryKey('getExecutionAlgo', options);

export const getExecutionAlgoOptions = (options: Options<GetExecutionAlgoData>) => queryOptions<GetExecutionAlgoResponse, DefaultError, GetExecutionAlgoResponse, ReturnType<typeof getExecutionAlgoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExecutionAlgo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExecutionAlgoQueryKey(options)
});

export const cancelExecutionAlgoMutation = (options?: Partial<Options<CancelExecutionAlgoData>>): UseMutationOptions<CancelExecutionAlgoResponse, DefaultError, Options<CancelExecutionAlgoData>> => {
    const mutationOptions: UseMutationOptions<CancelExecutionAlgoResponse, DefaultError, Options<CancelExecutionAlgoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelExecutionAlgo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pauseExecutionAlgoMutation = (options?: Partial<Options<PauseExecutionAlgoData>>): UseMutationOptions<PauseExecutionAlgoResponse, DefaultError, Options<PauseExecutionAlgoData>> => {
    const mutationOptions: UseMutationOptions<PauseExecutionAlgoResponse, DefaultError, Options<PauseExecutionAlgoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pauseExecutionAlgo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resumeExecutionAlgoMutation = (options?: Partial<Options<ResumeExecutionAlgoData>>): UseMutationOptions<ResumeExecutionAlgoResponse, DefaultError, Options<ResumeExecutionAlgoData>> => {
    const mutationOptions: UseMutationOptions<ResumeExecutionAlgoResponse, DefaultError, Options<ResumeExecutionAlgoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resumeExecutionAlgo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listForwardRunsQueryKey = (options?: Options<ListForwardRunsData>) => createQueryKey('listForwardRuns', options);

export const listForwardRunsOptions = (options?: Options<ListForwardRunsData>) => queryOptions<ListForwardRunsResponse, DefaultError, ListForwardRunsResponse, ReturnType<typeof listForwardRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listForwardRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listForwardRunsQueryKey(options)
});

export const listForwardRunsInfiniteQueryKey = (options?: Options<ListForwardRunsData>): QueryKey<Options<ListForwardRunsData>> => createQueryKey('listForwardRuns', options, true);

export const listForwardRunsInfiniteOptions = (options?: Options<ListForwardRunsData>) => {
    const opts = infiniteQueryOptions<ListForwardRunsResponse, DefaultError, InfiniteData<ListForwardRunsResponse>, QueryKey<Options<ListForwardRunsData>>, string | Pick<QueryKey<Options<ListForwardRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListForwardRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listForwardRuns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listForwardRunsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createSystematicForwardRunMutation = (options?: Partial<Options<CreateSystematicForwardRunData>>): UseMutationOptions<CreateSystematicForwardRunResponse, DefaultError, Options<CreateSystematicForwardRunData>> => {
    const mutationOptions: UseMutationOptions<CreateSystematicForwardRunResponse, DefaultError, Options<CreateSystematicForwardRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSystematicForwardRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createBucketForwardRunMutation = (options?: Partial<Options<CreateBucketForwardRunData>>): UseMutationOptions<CreateBucketForwardRunResponse, DefaultError, Options<CreateBucketForwardRunData>> => {
    const mutationOptions: UseMutationOptions<CreateBucketForwardRunResponse, DefaultError, Options<CreateBucketForwardRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBucketForwardRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getForwardRunQueryKey = (options: Options<GetForwardRunData>) => createQueryKey('getForwardRun', options);

export const getForwardRunOptions = (options: Options<GetForwardRunData>) => queryOptions<GetForwardRunResponse, DefaultError, GetForwardRunResponse, ReturnType<typeof getForwardRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getForwardRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getForwardRunQueryKey(options)
});

export const listShadowModeDaemonsQueryKey = (options?: Options<ListShadowModeDaemonsData>) => createQueryKey('listShadowModeDaemons', options);

export const listShadowModeDaemonsOptions = (options?: Options<ListShadowModeDaemonsData>) => queryOptions<ListShadowModeDaemonsResponse, DefaultError, ListShadowModeDaemonsResponse, ReturnType<typeof listShadowModeDaemonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listShadowModeDaemons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listShadowModeDaemonsQueryKey(options)
});

export const getShadowModeDaemonQueryKey = (options: Options<GetShadowModeDaemonData>) => createQueryKey('getShadowModeDaemon', options);

export const getShadowModeDaemonOptions = (options: Options<GetShadowModeDaemonData>) => queryOptions<GetShadowModeDaemonResponse, DefaultError, GetShadowModeDaemonResponse, ReturnType<typeof getShadowModeDaemonQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getShadowModeDaemon({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getShadowModeDaemonQueryKey(options)
});

export const updateShadowModeDaemonEnrollmentMutation = (options?: Partial<Options<UpdateShadowModeDaemonEnrollmentData>>): UseMutationOptions<UpdateShadowModeDaemonEnrollmentResponse, DefaultError, Options<UpdateShadowModeDaemonEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<UpdateShadowModeDaemonEnrollmentResponse, DefaultError, Options<UpdateShadowModeDaemonEnrollmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateShadowModeDaemonEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const certifyShadowModeDaemonMutation = (options?: Partial<Options<CertifyShadowModeDaemonData>>): UseMutationOptions<CertifyShadowModeDaemonResponse, DefaultError, Options<CertifyShadowModeDaemonData>> => {
    const mutationOptions: UseMutationOptions<CertifyShadowModeDaemonResponse, DefaultError, Options<CertifyShadowModeDaemonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await certifyShadowModeDaemon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const graduateShadowModeDaemonMutation = (options?: Partial<Options<GraduateShadowModeDaemonData>>): UseMutationOptions<GraduateShadowModeDaemonResponse, DefaultError, Options<GraduateShadowModeDaemonData>> => {
    const mutationOptions: UseMutationOptions<GraduateShadowModeDaemonResponse, DefaultError, Options<GraduateShadowModeDaemonData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await graduateShadowModeDaemon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectCodeOperationalMetricsQueryKey = (options: Options<GetProjectCodeOperationalMetricsData>) => createQueryKey('getProjectCodeOperationalMetrics', options);

export const getProjectCodeOperationalMetricsOptions = (options: Options<GetProjectCodeOperationalMetricsData>) => queryOptions<GetProjectCodeOperationalMetricsResponse, DefaultError, GetProjectCodeOperationalMetricsResponse, ReturnType<typeof getProjectCodeOperationalMetricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectCodeOperationalMetrics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectCodeOperationalMetricsQueryKey(options)
});

export const getProjectCodeWorkspaceQueryKey = (options: Options<GetProjectCodeWorkspaceData>) => createQueryKey('getProjectCodeWorkspace', options);

export const getProjectCodeWorkspaceOptions = (options: Options<GetProjectCodeWorkspaceData>) => queryOptions<GetProjectCodeWorkspaceResponse, DefaultError, GetProjectCodeWorkspaceResponse, ReturnType<typeof getProjectCodeWorkspaceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectCodeWorkspace({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectCodeWorkspaceQueryKey(options)
});

export const listProjectCodeRepositoryConnectionsQueryKey = (options: Options<ListProjectCodeRepositoryConnectionsData>) => createQueryKey('listProjectCodeRepositoryConnections', options);

export const listProjectCodeRepositoryConnectionsOptions = (options: Options<ListProjectCodeRepositoryConnectionsData>) => queryOptions<ListProjectCodeRepositoryConnectionsResponse, DefaultError, ListProjectCodeRepositoryConnectionsResponse, ReturnType<typeof listProjectCodeRepositoryConnectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectCodeRepositoryConnections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectCodeRepositoryConnectionsQueryKey(options)
});

export const createProjectCodeRepositoryConnectionMutation = (options?: Partial<Options<CreateProjectCodeRepositoryConnectionData>>): UseMutationOptions<CreateProjectCodeRepositoryConnectionResponse, DefaultError, Options<CreateProjectCodeRepositoryConnectionData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectCodeRepositoryConnectionResponse, DefaultError, Options<CreateProjectCodeRepositoryConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectCodeRepositoryConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enableProjectCodeWorkspaceMutation = (options?: Partial<Options<EnableProjectCodeWorkspaceData>>): UseMutationOptions<EnableProjectCodeWorkspaceResponse, DefaultError, Options<EnableProjectCodeWorkspaceData>> => {
    const mutationOptions: UseMutationOptions<EnableProjectCodeWorkspaceResponse, DefaultError, Options<EnableProjectCodeWorkspaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableProjectCodeWorkspace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectCodeCheckpointsQueryKey = (options: Options<ListProjectCodeCheckpointsData>) => createQueryKey('listProjectCodeCheckpoints', options);

export const listProjectCodeCheckpointsOptions = (options: Options<ListProjectCodeCheckpointsData>) => queryOptions<ListProjectCodeCheckpointsResponse, DefaultError, ListProjectCodeCheckpointsResponse, ReturnType<typeof listProjectCodeCheckpointsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectCodeCheckpoints({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectCodeCheckpointsQueryKey(options)
});

export const listProjectCodeCheckpointsInfiniteQueryKey = (options: Options<ListProjectCodeCheckpointsData>): QueryKey<Options<ListProjectCodeCheckpointsData>> => createQueryKey('listProjectCodeCheckpoints', options, true);

export const listProjectCodeCheckpointsInfiniteOptions = (options: Options<ListProjectCodeCheckpointsData>) => {
    const opts = infiniteQueryOptions<ListProjectCodeCheckpointsResponse, DefaultError, InfiniteData<ListProjectCodeCheckpointsResponse>, QueryKey<Options<ListProjectCodeCheckpointsData>>, string | Pick<QueryKey<Options<ListProjectCodeCheckpointsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListProjectCodeCheckpointsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listProjectCodeCheckpoints({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listProjectCodeCheckpointsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listProjectCodeWorkspaceOperationsQueryKey = (options: Options<ListProjectCodeWorkspaceOperationsData>) => createQueryKey('listProjectCodeWorkspaceOperations', options);

export const listProjectCodeWorkspaceOperationsOptions = (options: Options<ListProjectCodeWorkspaceOperationsData>) => queryOptions<ListProjectCodeWorkspaceOperationsResponse, DefaultError, ListProjectCodeWorkspaceOperationsResponse, ReturnType<typeof listProjectCodeWorkspaceOperationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectCodeWorkspaceOperations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectCodeWorkspaceOperationsQueryKey(options)
});

export const listProjectCodeWorkspaceOperationsInfiniteQueryKey = (options: Options<ListProjectCodeWorkspaceOperationsData>): QueryKey<Options<ListProjectCodeWorkspaceOperationsData>> => createQueryKey('listProjectCodeWorkspaceOperations', options, true);

export const listProjectCodeWorkspaceOperationsInfiniteOptions = (options: Options<ListProjectCodeWorkspaceOperationsData>) => {
    const opts = infiniteQueryOptions<ListProjectCodeWorkspaceOperationsResponse, DefaultError, InfiniteData<ListProjectCodeWorkspaceOperationsResponse>, QueryKey<Options<ListProjectCodeWorkspaceOperationsData>>, string | Pick<QueryKey<Options<ListProjectCodeWorkspaceOperationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListProjectCodeWorkspaceOperationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listProjectCodeWorkspaceOperations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listProjectCodeWorkspaceOperationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const materializeProjectChangeCodeMutation = (options?: Partial<Options<MaterializeProjectChangeCodeData>>): UseMutationOptions<MaterializeProjectChangeCodeResponse, DefaultError, Options<MaterializeProjectChangeCodeData>> => {
    const mutationOptions: UseMutationOptions<MaterializeProjectChangeCodeResponse, DefaultError, Options<MaterializeProjectChangeCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await materializeProjectChangeCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const openProjectChangeCodeReviewMutation = (options?: Partial<Options<OpenProjectChangeCodeReviewData>>): UseMutationOptions<OpenProjectChangeCodeReviewResponse, DefaultError, Options<OpenProjectChangeCodeReviewData>> => {
    const mutationOptions: UseMutationOptions<OpenProjectChangeCodeReviewResponse, DefaultError, Options<OpenProjectChangeCodeReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await openProjectChangeCodeReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rollbackProjectCodeCheckpointMutation = (options?: Partial<Options<RollbackProjectCodeCheckpointData>>): UseMutationOptions<RollbackProjectCodeCheckpointResponse, DefaultError, Options<RollbackProjectCodeCheckpointData>> => {
    const mutationOptions: UseMutationOptions<RollbackProjectCodeCheckpointResponse, DefaultError, Options<RollbackProjectCodeCheckpointData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rollbackProjectCodeCheckpoint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectCodeClientDatabaseQueryKey = (options: Options<GetProjectCodeClientDatabaseData>) => createQueryKey('getProjectCodeClientDatabase', options);

export const getProjectCodeClientDatabaseOptions = (options: Options<GetProjectCodeClientDatabaseData>) => queryOptions<GetProjectCodeClientDatabaseResponse, DefaultError, GetProjectCodeClientDatabaseResponse, ReturnType<typeof getProjectCodeClientDatabaseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectCodeClientDatabase({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectCodeClientDatabaseQueryKey(options)
});

export const configureProjectCodeClientDatabaseMutation = (options?: Partial<Options<ConfigureProjectCodeClientDatabaseData>>): UseMutationOptions<ConfigureProjectCodeClientDatabaseResponse, DefaultError, Options<ConfigureProjectCodeClientDatabaseData>> => {
    const mutationOptions: UseMutationOptions<ConfigureProjectCodeClientDatabaseResponse, DefaultError, Options<ConfigureProjectCodeClientDatabaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await configureProjectCodeClientDatabase({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectWorkstreamCodeTuningViewQueryKey = (options: Options<GetProjectWorkstreamCodeTuningViewData>) => createQueryKey('getProjectWorkstreamCodeTuningView', options);

export const getProjectWorkstreamCodeTuningViewOptions = (options: Options<GetProjectWorkstreamCodeTuningViewData>) => queryOptions<GetProjectWorkstreamCodeTuningViewResponse, DefaultError, GetProjectWorkstreamCodeTuningViewResponse, ReturnType<typeof getProjectWorkstreamCodeTuningViewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectWorkstreamCodeTuningView({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectWorkstreamCodeTuningViewQueryKey(options)
});

export const enableProjectWorkstreamCodeWorkforceMutation = (options?: Partial<Options<EnableProjectWorkstreamCodeWorkforceData>>): UseMutationOptions<EnableProjectWorkstreamCodeWorkforceResponse, DefaultError, Options<EnableProjectWorkstreamCodeWorkforceData>> => {
    const mutationOptions: UseMutationOptions<EnableProjectWorkstreamCodeWorkforceResponse, DefaultError, Options<EnableProjectWorkstreamCodeWorkforceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableProjectWorkstreamCodeWorkforce({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createProjectWorkstreamCodeGenerationRunMutation = (options?: Partial<Options<CreateProjectWorkstreamCodeGenerationRunData>>): UseMutationOptions<CreateProjectWorkstreamCodeGenerationRunResponse, DefaultError, Options<CreateProjectWorkstreamCodeGenerationRunData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectWorkstreamCodeGenerationRunResponse, DefaultError, Options<CreateProjectWorkstreamCodeGenerationRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectWorkstreamCodeGenerationRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProjectWorkstreamCodeReviewRequestsQueryKey = (options: Options<ListProjectWorkstreamCodeReviewRequestsData>) => createQueryKey('listProjectWorkstreamCodeReviewRequests', options);

export const listProjectWorkstreamCodeReviewRequestsOptions = (options: Options<ListProjectWorkstreamCodeReviewRequestsData>) => queryOptions<ListProjectWorkstreamCodeReviewRequestsResponse, DefaultError, ListProjectWorkstreamCodeReviewRequestsResponse, ReturnType<typeof listProjectWorkstreamCodeReviewRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProjectWorkstreamCodeReviewRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProjectWorkstreamCodeReviewRequestsQueryKey(options)
});

export const listProjectWorkstreamCodeReviewRequestsInfiniteQueryKey = (options: Options<ListProjectWorkstreamCodeReviewRequestsData>): QueryKey<Options<ListProjectWorkstreamCodeReviewRequestsData>> => createQueryKey('listProjectWorkstreamCodeReviewRequests', options, true);

export const listProjectWorkstreamCodeReviewRequestsInfiniteOptions = (options: Options<ListProjectWorkstreamCodeReviewRequestsData>) => {
    const opts = infiniteQueryOptions<ListProjectWorkstreamCodeReviewRequestsResponse, DefaultError, InfiniteData<ListProjectWorkstreamCodeReviewRequestsResponse>, QueryKey<Options<ListProjectWorkstreamCodeReviewRequestsData>>, string | Pick<QueryKey<Options<ListProjectWorkstreamCodeReviewRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListProjectWorkstreamCodeReviewRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listProjectWorkstreamCodeReviewRequests({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listProjectWorkstreamCodeReviewRequestsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createProjectWorkstreamCodeReviewRequestMutation = (options?: Partial<Options<CreateProjectWorkstreamCodeReviewRequestData>>): UseMutationOptions<CreateProjectWorkstreamCodeReviewRequestResponse, CreateProjectWorkstreamCodeReviewRequestError, Options<CreateProjectWorkstreamCodeReviewRequestData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectWorkstreamCodeReviewRequestResponse, CreateProjectWorkstreamCodeReviewRequestError, Options<CreateProjectWorkstreamCodeReviewRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectWorkstreamCodeReviewRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectWorkstreamCodeReviewRequestQueryKey = (options: Options<GetProjectWorkstreamCodeReviewRequestData>) => createQueryKey('getProjectWorkstreamCodeReviewRequest', options);

export const getProjectWorkstreamCodeReviewRequestOptions = (options: Options<GetProjectWorkstreamCodeReviewRequestData>) => queryOptions<GetProjectWorkstreamCodeReviewRequestResponse, DefaultError, GetProjectWorkstreamCodeReviewRequestResponse, ReturnType<typeof getProjectWorkstreamCodeReviewRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProjectWorkstreamCodeReviewRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProjectWorkstreamCodeReviewRequestQueryKey(options)
});

export const decideProjectWorkstreamCodeReviewRequestMutation = (options?: Partial<Options<DecideProjectWorkstreamCodeReviewRequestData>>): UseMutationOptions<DecideProjectWorkstreamCodeReviewRequestResponse, DecideProjectWorkstreamCodeReviewRequestError, Options<DecideProjectWorkstreamCodeReviewRequestData>> => {
    const mutationOptions: UseMutationOptions<DecideProjectWorkstreamCodeReviewRequestResponse, DecideProjectWorkstreamCodeReviewRequestError, Options<DecideProjectWorkstreamCodeReviewRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await decideProjectWorkstreamCodeReviewRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createProjectWorkstreamCodePreviewSessionMutation = (options?: Partial<Options<CreateProjectWorkstreamCodePreviewSessionData>>): UseMutationOptions<CreateProjectWorkstreamCodePreviewSessionResponse, CreateProjectWorkstreamCodePreviewSessionError, Options<CreateProjectWorkstreamCodePreviewSessionData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectWorkstreamCodePreviewSessionResponse, CreateProjectWorkstreamCodePreviewSessionError, Options<CreateProjectWorkstreamCodePreviewSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProjectWorkstreamCodePreviewSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const heartbeatProjectWorkstreamCodePreviewSessionMutation = (options?: Partial<Options<HeartbeatProjectWorkstreamCodePreviewSessionData>>): UseMutationOptions<HeartbeatProjectWorkstreamCodePreviewSessionResponse, HeartbeatProjectWorkstreamCodePreviewSessionError, Options<HeartbeatProjectWorkstreamCodePreviewSessionData>> => {
    const mutationOptions: UseMutationOptions<HeartbeatProjectWorkstreamCodePreviewSessionResponse, HeartbeatProjectWorkstreamCodePreviewSessionError, Options<HeartbeatProjectWorkstreamCodePreviewSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await heartbeatProjectWorkstreamCodePreviewSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const viewProjectWorkstreamCodePreviewSessionQueryKey = (options: Options<ViewProjectWorkstreamCodePreviewSessionData>) => createQueryKey('viewProjectWorkstreamCodePreviewSession', options);

export const viewProjectWorkstreamCodePreviewSessionOptions = (options: Options<ViewProjectWorkstreamCodePreviewSessionData>) => queryOptions<ViewProjectWorkstreamCodePreviewSessionResponse, ViewProjectWorkstreamCodePreviewSessionError, ViewProjectWorkstreamCodePreviewSessionResponse, ReturnType<typeof viewProjectWorkstreamCodePreviewSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await viewProjectWorkstreamCodePreviewSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: viewProjectWorkstreamCodePreviewSessionQueryKey(options)
});

export const deleteProjectWorkstreamCodePreviewSessionMutation = (options?: Partial<Options<DeleteProjectWorkstreamCodePreviewSessionData>>): UseMutationOptions<DeleteProjectWorkstreamCodePreviewSessionResponse, DefaultError, Options<DeleteProjectWorkstreamCodePreviewSessionData>> => {
    const mutationOptions: UseMutationOptions<DeleteProjectWorkstreamCodePreviewSessionResponse, DefaultError, Options<DeleteProjectWorkstreamCodePreviewSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProjectWorkstreamCodePreviewSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const acceptProjectWorkstreamCodeTuningVersionMutation = (options?: Partial<Options<AcceptProjectWorkstreamCodeTuningVersionData>>): UseMutationOptions<AcceptProjectWorkstreamCodeTuningVersionResponse, AcceptProjectWorkstreamCodeTuningVersionError, Options<AcceptProjectWorkstreamCodeTuningVersionData>> => {
    const mutationOptions: UseMutationOptions<AcceptProjectWorkstreamCodeTuningVersionResponse, AcceptProjectWorkstreamCodeTuningVersionError, Options<AcceptProjectWorkstreamCodeTuningVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptProjectWorkstreamCodeTuningVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGitHubCodeWorkspaceWebhookMutation = (options?: Partial<Options<HandleGitHubCodeWorkspaceWebhookData>>): UseMutationOptions<HandleGitHubCodeWorkspaceWebhookResponse, DefaultError, Options<HandleGitHubCodeWorkspaceWebhookData>> => {
    const mutationOptions: UseMutationOptions<HandleGitHubCodeWorkspaceWebhookResponse, DefaultError, Options<HandleGitHubCodeWorkspaceWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleGitHubCodeWorkspaceWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiListDecisionsQueryKey = (options?: Options<ApiListDecisionsData>) => createQueryKey('apiListDecisions', options);

/**
 * Requests waiting on a person (or recently decided)
 */
export const apiListDecisionsOptions = (options?: Options<ApiListDecisionsData>) => queryOptions<ApiListDecisionsResponse, ApiListDecisionsError, ApiListDecisionsResponse, ReturnType<typeof apiListDecisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiListDecisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiListDecisionsQueryKey(options)
});

/**
 * Approve a pending request as the key’s person
 *
 * The review rules apply: the key needs the policy the request asks of its reviewer, and the person who raised a request approves it only when its kind is self-approvable. `state` says what happened.
 */
export const apiApproveDecisionMutation = (options?: Partial<Options<ApiApproveDecisionData>>): UseMutationOptions<ApiApproveDecisionResponse, ApiApproveDecisionError, Options<ApiApproveDecisionData>> => {
    const mutationOptions: UseMutationOptions<ApiApproveDecisionResponse, ApiApproveDecisionError, Options<ApiApproveDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiApproveDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Turn down a pending request, with the reason
 */
export const apiRejectDecisionMutation = (options?: Partial<Options<ApiRejectDecisionData>>): UseMutationOptions<ApiRejectDecisionResponse, ApiRejectDecisionError, Options<ApiRejectDecisionData>> => {
    const mutationOptions: UseMutationOptions<ApiRejectDecisionResponse, ApiRejectDecisionError, Options<ApiRejectDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiRejectDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetWorkflowRunPartQueryKey = (options: Options<ApiGetWorkflowRunPartData>) => createQueryKey('apiGetWorkflowRunPart', options);

/**
 * One output part of a workflow run, whole (≤ 512 KB inline)
 */
export const apiGetWorkflowRunPartOptions = (options: Options<ApiGetWorkflowRunPartData>) => queryOptions<ApiGetWorkflowRunPartResponse, ApiGetWorkflowRunPartError, ApiGetWorkflowRunPartResponse, ReturnType<typeof apiGetWorkflowRunPartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetWorkflowRunPart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetWorkflowRunPartQueryKey(options)
});

export const apiGetDashboardDataQueryKey = (options: Options<ApiGetDashboardDataData>) => createQueryKey('apiGetDashboardData', options);

/**
 * A dashboard with what each widget shows now
 */
export const apiGetDashboardDataOptions = (options: Options<ApiGetDashboardDataData>) => queryOptions<ApiGetDashboardDataResponse, ApiGetDashboardDataError, ApiGetDashboardDataResponse, ReturnType<typeof apiGetDashboardDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetDashboardData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetDashboardDataQueryKey(options)
});

export const apiListIntelSourcesQueryKey = (options?: Options<ApiListIntelSourcesData>) => createQueryKey('apiListIntelSources', options);

/**
 * The sources (channels, accounts, feeds) the organization knows, and whether it follows each
 */
export const apiListIntelSourcesOptions = (options?: Options<ApiListIntelSourcesData>) => queryOptions<ApiListIntelSourcesResponse, ApiListIntelSourcesError, ApiListIntelSourcesResponse, ReturnType<typeof apiListIntelSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiListIntelSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiListIntelSourcesQueryKey(options)
});

export const apiListIntelSourceItemsQueryKey = (options: Options<ApiListIntelSourceItemsData>) => createQueryKey('apiListIntelSourceItems', options);

/**
 * A source’s newest items (videos, posts, articles), each marked analysed or not
 */
export const apiListIntelSourceItemsOptions = (options: Options<ApiListIntelSourceItemsData>) => queryOptions<ApiListIntelSourceItemsResponse, ApiListIntelSourceItemsError, ApiListIntelSourceItemsResponse, ReturnType<typeof apiListIntelSourceItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiListIntelSourceItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiListIntelSourceItemsQueryKey(options)
});

/**
 * Withdraw a pending request the key’s person raised
 *
 * Only the person who raised a request may withdraw it, and only while it is pending; otherwise 400 with the reason (404 when nothing pending has that id).
 */
export const apiCancelDecisionMutation = (options?: Partial<Options<ApiCancelDecisionData>>): UseMutationOptions<ApiCancelDecisionResponse, ApiCancelDecisionError, Options<ApiCancelDecisionData>> => {
    const mutationOptions: UseMutationOptions<ApiCancelDecisionResponse, ApiCancelDecisionError, Options<ApiCancelDecisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiCancelDecision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiListStrategiesQueryKey = (options?: Options<ApiListStrategiesData>) => createQueryKey('apiListStrategies', options);

/**
 * The organization’s strategies
 */
export const apiListStrategiesOptions = (options?: Options<ApiListStrategiesData>) => queryOptions<ApiListStrategiesResponse, ApiListStrategiesError, ApiListStrategiesResponse, ReturnType<typeof apiListStrategiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiListStrategies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiListStrategiesQueryKey(options)
});

export const apiGetStrategyQueryKey = (options: Options<ApiGetStrategyData>) => createQueryKey('apiGetStrategy', options);

/**
 * One strategy: its metrics, definition, parameters, readiness and per-regime results
 */
export const apiGetStrategyOptions = (options: Options<ApiGetStrategyData>) => queryOptions<ApiGetStrategyResponse, ApiGetStrategyError, ApiGetStrategyResponse, ReturnType<typeof apiGetStrategyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetStrategy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetStrategyQueryKey(options)
});

export const apiListStrategyBucketsQueryKey = (options?: Options<ApiListStrategyBucketsData>) => createQueryKey('apiListStrategyBuckets', options);

/**
 * The organization’s strategy buckets
 */
export const apiListStrategyBucketsOptions = (options?: Options<ApiListStrategyBucketsData>) => queryOptions<ApiListStrategyBucketsResponse, ApiListStrategyBucketsError, ApiListStrategyBucketsResponse, ReturnType<typeof apiListStrategyBucketsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiListStrategyBuckets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiListStrategyBucketsQueryKey(options)
});

export const apiGetStrategyBucketQueryKey = (options: Options<ApiGetStrategyBucketData>) => createQueryKey('apiGetStrategyBucket', options);

/**
 * One bucket: its legs, their weights and each leg’s latest backtest
 */
export const apiGetStrategyBucketOptions = (options: Options<ApiGetStrategyBucketData>) => queryOptions<ApiGetStrategyBucketResponse, ApiGetStrategyBucketError, ApiGetStrategyBucketResponse, ReturnType<typeof apiGetStrategyBucketQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetStrategyBucket({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetStrategyBucketQueryKey(options)
});

export const apiCompareBacktestsQueryKey = (options: Options<ApiCompareBacktestsData>) => createQueryKey('apiCompareBacktests', options);

/**
 * Two to five simulations side by side, with the leader of each column
 */
export const apiCompareBacktestsOptions = (options: Options<ApiCompareBacktestsData>) => queryOptions<ApiCompareBacktestsResponse, ApiCompareBacktestsError, ApiCompareBacktestsResponse, ReturnType<typeof apiCompareBacktestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiCompareBacktests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiCompareBacktestsQueryKey(options)
});

export const apiListMarketRegimesQueryKey = (options: Options<ApiListMarketRegimesData>) => createQueryKey('apiListMarketRegimes', options);

/**
 * The current market regime of each symbol
 */
export const apiListMarketRegimesOptions = (options: Options<ApiListMarketRegimesData>) => queryOptions<ApiListMarketRegimesResponse, ApiListMarketRegimesError, ApiListMarketRegimesResponse, ReturnType<typeof apiListMarketRegimesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiListMarketRegimes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiListMarketRegimesQueryKey(options)
});

export const apiListBacktestsQueryKey = (options?: Options<ApiListBacktestsData>) => createQueryKey('apiListBacktests', options);

/**
 * Simulations on record, newest first (one strategy’s, or the organization’s)
 */
export const apiListBacktestsOptions = (options?: Options<ApiListBacktestsData>) => queryOptions<ApiListBacktestsResponse, ApiListBacktestsError, ApiListBacktestsResponse, ReturnType<typeof apiListBacktestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiListBacktests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiListBacktestsQueryKey(options)
});

/**
 * Queue a research-only simulation of a strategy
 *
 * Answers 202 with the queued request (`requestId`), or the finished run (`run.id`) when the same simulation already ran. Send an `Idempotency-Key` to make a retry safe. At most 10 a minute per key.
 */
export const apiCreateBacktestMutation = (options?: Partial<Options<ApiCreateBacktestData>>): UseMutationOptions<ApiCreateBacktestResponse, ApiCreateBacktestError, Options<ApiCreateBacktestData>> => {
    const mutationOptions: UseMutationOptions<ApiCreateBacktestResponse, ApiCreateBacktestError, Options<ApiCreateBacktestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await apiCreateBacktest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiGetBacktestQueryKey = (options: Options<ApiGetBacktestData>) => createQueryKey('apiGetBacktest', options);

/**
 * One simulation: its window, full statistics, scores and series sizes
 */
export const apiGetBacktestOptions = (options: Options<ApiGetBacktestData>) => queryOptions<ApiGetBacktestResponse, ApiGetBacktestError, ApiGetBacktestResponse, ReturnType<typeof apiGetBacktestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetBacktest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetBacktestQueryKey(options)
});

export const apiListBacktestSeriesQueryKey = (options: Options<ApiListBacktestSeriesData>) => createQueryKey('apiListBacktestSeries', options);

/**
 * One page of a simulation's series (equity, trades, regimes, drawdown_series, buy_hold_equity, oos_returns_series)
 */
export const apiListBacktestSeriesOptions = (options: Options<ApiListBacktestSeriesData>) => queryOptions<ApiListBacktestSeriesResponse, ApiListBacktestSeriesError, ApiListBacktestSeriesResponse, ReturnType<typeof apiListBacktestSeriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiListBacktestSeries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiListBacktestSeriesQueryKey(options)
});

export const apiListBacktestSeriesInfiniteQueryKey = (options: Options<ApiListBacktestSeriesData>): QueryKey<Options<ApiListBacktestSeriesData>> => createQueryKey('apiListBacktestSeries', options, true);

/**
 * One page of a simulation's series (equity, trades, regimes, drawdown_series, buy_hold_equity, oos_returns_series)
 */
export const apiListBacktestSeriesInfiniteOptions = (options: Options<ApiListBacktestSeriesData>) => {
    const opts = infiniteQueryOptions<ApiListBacktestSeriesResponse, ApiListBacktestSeriesError, InfiniteData<ApiListBacktestSeriesResponse>, QueryKey<Options<ApiListBacktestSeriesData>>, string | Pick<QueryKey<Options<ApiListBacktestSeriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiListBacktestSeriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiListBacktestSeries({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiListBacktestSeriesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const apiGetBacktestAnalyticsQueryKey = (options: Options<ApiGetBacktestAnalyticsData>) => createQueryKey('apiGetBacktestAnalytics', options);

/**
 * A simulation’s full analysis, computed once per run (the same as the platform’s Strategy Tester)
 */
export const apiGetBacktestAnalyticsOptions = (options: Options<ApiGetBacktestAnalyticsData>) => queryOptions<ApiGetBacktestAnalyticsResponse, ApiGetBacktestAnalyticsError, ApiGetBacktestAnalyticsResponse, ReturnType<typeof apiGetBacktestAnalyticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetBacktestAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetBacktestAnalyticsQueryKey(options)
});

export const apiGetCandlesQueryKey = (options: Options<ApiGetCandlesData>) => createQueryKey('apiGetCandles', options);

/**
 * A window of stored OHLCV bars for a chart ([from, to), newest page first in time order)
 *
 * `countback` bars ending before `to`, or up to `limit` in [`from`, `to`) (≤ 5000). `paging.next` pages back in time; `meta.nextTime` is where older bars resume. `format=columnar` answers TradingView UDF columns {s,t,o,h,l,c,v,nextTime}. The key needs data access.
 */
export const apiGetCandlesOptions = (options: Options<ApiGetCandlesData>) => queryOptions<ApiGetCandlesResponse, ApiGetCandlesError, ApiGetCandlesResponse, ReturnType<typeof apiGetCandlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiGetCandles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiGetCandlesQueryKey(options)
});

export const apiGetCandlesInfiniteQueryKey = (options: Options<ApiGetCandlesData>): QueryKey<Options<ApiGetCandlesData>> => createQueryKey('apiGetCandles', options, true);

/**
 * A window of stored OHLCV bars for a chart ([from, to), newest page first in time order)
 *
 * `countback` bars ending before `to`, or up to `limit` in [`from`, `to`) (≤ 5000). `paging.next` pages back in time; `meta.nextTime` is where older bars resume. `format=columnar` answers TradingView UDF columns {s,t,o,h,l,c,v,nextTime}. The key needs data access.
 */
export const apiGetCandlesInfiniteOptions = (options: Options<ApiGetCandlesData>) => {
    const opts = infiniteQueryOptions<ApiGetCandlesResponse, ApiGetCandlesError, InfiniteData<ApiGetCandlesResponse>, QueryKey<Options<ApiGetCandlesData>>, string | Pick<QueryKey<Options<ApiGetCandlesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiGetCandlesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiGetCandles({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiGetCandlesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getMarketDataBackupQueryKey = (options?: Options<GetMarketDataBackupData>) => createQueryKey('getMarketDataBackup', options);

/**
 * Download the market database as a SQL backup
 *
 * One gzip’d plain-SQL file of the market tables: everything (the first load of an organization copy, into an empty database) or, with `days`, the rows of the last N UTC days (upserted by primary key, so it loads over an existing copy). Restore with `gunzip -c file.sql.gz | psql "$URL"` into a database with the same migrations. The body streams and can be tens of GB. Needs data access.
 */
export const getMarketDataBackupOptions = (options?: Options<GetMarketDataBackupData>) => queryOptions<GetMarketDataBackupResponse, GetMarketDataBackupError, GetMarketDataBackupResponse, ReturnType<typeof getMarketDataBackupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketDataBackup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketDataBackupQueryKey(options)
});

/**
 * Get a worker's direct routes to the market data
 *
 * For a control plane that is not the platform: the routes one of its workers can read the market data on directly (nearest first: the same machine, its LAN, the private network), each with a short-lived token for the key's organization. An empty list means no route fits the worker's network. Needs data access.
 */
export const createMarketDataGrantsMutation = (options?: Partial<Options<CreateMarketDataGrantsData>>): UseMutationOptions<CreateMarketDataGrantsResponse, CreateMarketDataGrantsError, Options<CreateMarketDataGrantsData>> => {
    const mutationOptions: UseMutationOptions<CreateMarketDataGrantsResponse, CreateMarketDataGrantsError, Options<CreateMarketDataGrantsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMarketDataGrants({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketDataCoverageQueryKey = (options?: Options<GetMarketDataCoverageData>) => createQueryKey('getMarketDataCoverage', options);

/**
 * The market tables' coverage
 *
 * First and last row and row count of every market series (per symbol and bar size for the candles), as the platform's market database service computed them (hourly). For a control plane that is not the platform: it reads this instead of counting the shared market database itself. Needs data access.
 */
export const getMarketDataCoverageOptions = (options?: Options<GetMarketDataCoverageData>) => queryOptions<GetMarketDataCoverageResponse, GetMarketDataCoverageError, GetMarketDataCoverageResponse, ReturnType<typeof getMarketDataCoverageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketDataCoverage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketDataCoverageQueryKey(options)
});
